{
  "schemaVersion": 2,
  "source": "src/core/palettes/thread-list.csv",
  "generatedBy": "scripts/build-palette.mjs",
  "brands": [
    {
      "id": "anchor",
      "name": "Anchor",
      "provenance": "measured",
      "note": "Colours and names as supplied for Anchor."
    },
    {
      "id": "ariadna",
      "name": "Ariadna",
      "provenance": "measured",
      "note": "Colours and names as supplied for Ariadna."
    },
    {
      "id": "cosmo",
      "name": "Cosmo",
      "provenance": "measured",
      "note": "Colours and names as supplied for Cosmo."
    },
    {
      "id": "cxc",
      "name": "CXC",
      "provenance": "measured",
      "note": "Colours and names as supplied for CXC."
    },
    {
      "id": "dmc",
      "name": "DMC",
      "provenance": "measured",
      "note": "Colours and names as supplied for DMC."
    },
    {
      "id": "finca",
      "name": "Finca",
      "provenance": "measured",
      "note": "Colours and names as supplied for Finca."
    },
    {
      "id": "madeira",
      "name": "Madeira",
      "provenance": "measured",
      "note": "Colours and names as supplied for Madeira."
    },
    {
      "id": "sullivans",
      "name": "Sullivans",
      "provenance": "measured",
      "note": "Colours and names as supplied for Sullivans."
    }
  ],
  "counts": {
    "rows": 3338,
    "skipped": 0,
    "duplicates": 0,
    "brands": 8,
    "threads": 3338,
    "distinctColours": 2830
  },
  "threads": [
    {
      "id": "anchor:403",
      "brandId": "anchor",
      "reference": "403",
      "name": "Black",
      "hex": "#000000",
      "rgb": [
        0,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:134",
      "brandId": "anchor",
      "reference": "134",
      "name": "Sky Blue Ultra Dark",
      "hex": "#000040",
      "rgb": [
        0,
        0,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:862",
      "brandId": "anchor",
      "reference": "862",
      "name": "Fern Green Very Dark",
      "hex": "#002a1b",
      "rgb": [
        0,
        42,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:149",
      "brandId": "anchor",
      "reference": "149",
      "name": "Navy Blue Medium Dark",
      "hex": "#02024f",
      "rgb": [
        2,
        2,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:127",
      "brandId": "anchor",
      "reference": "127",
      "name": "Navy Blue Very Dark",
      "hex": "#05002a",
      "rgb": [
        5,
        0,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:152",
      "brandId": "anchor",
      "reference": "152",
      "name": "Navy Blue Ultra Very Dark",
      "hex": "#080031",
      "rgb": [
        8,
        0,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:150",
      "brandId": "anchor",
      "reference": "150",
      "name": "Navy Blue Dark",
      "hex": "#09094c",
      "rgb": [
        9,
        9,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1089",
      "brandId": "anchor",
      "reference": "1089",
      "name": "Electric Blue Medium",
      "hex": "#09a5b4",
      "rgb": [
        9,
        165,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:923",
      "brandId": "anchor",
      "reference": "923",
      "name": "Christmas Green Very Dark",
      "hex": "#0a3c01",
      "rgb": [
        10,
        60,
        1
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:133",
      "brandId": "anchor",
      "reference": "133",
      "name": "Sky Blue Very Dark",
      "hex": "#0b1858",
      "rgb": [
        11,
        24,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1068",
      "brandId": "anchor",
      "reference": "1068",
      "name": "Teal",
      "hex": "#0c5360",
      "rgb": [
        12,
        83,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:148",
      "brandId": "anchor",
      "reference": "148",
      "name": "Navy Blue Medium",
      "hex": "#0e204b",
      "rgb": [
        14,
        32,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1044",
      "brandId": "anchor",
      "reference": "1044",
      "name": "Pistachio Green Ultra Very Dark",
      "hex": "#112e00",
      "rgb": [
        17,
        46,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:164",
      "brandId": "anchor",
      "reference": "164",
      "name": "Baby Blue Ultra Very Dark",
      "hex": "#12354b",
      "rgb": [
        18,
        53,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1090",
      "brandId": "anchor",
      "reference": "1090",
      "name": "Electric Blue Light",
      "hex": "#13bfe0",
      "rgb": [
        19,
        191,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:143",
      "brandId": "anchor",
      "reference": "143",
      "name": "Royal Blue Dark",
      "hex": "#162c51",
      "rgb": [
        22,
        44,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:230",
      "brandId": "anchor",
      "reference": "230",
      "name": "Emerald Green",
      "hex": "#163729",
      "rgb": [
        22,
        55,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:170",
      "brandId": "anchor",
      "reference": "170",
      "name": "Blue Green Very Dark",
      "hex": "#163d48",
      "rgb": [
        22,
        61,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:879",
      "brandId": "anchor",
      "reference": "879",
      "name": "Sea Foam Green Ultra Very Dark",
      "hex": "#193428",
      "rgb": [
        25,
        52,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:123",
      "brandId": "anchor",
      "reference": "123",
      "name": "Blue Purple Dark",
      "hex": "#1b183a",
      "rgb": [
        27,
        24,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:878",
      "brandId": "anchor",
      "reference": "878",
      "name": "Sea Foam Green Very Dark",
      "hex": "#1b3d30",
      "rgb": [
        27,
        61,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1036",
      "brandId": "anchor",
      "reference": "1036",
      "name": "Antique Blue Ultra Very Dark",
      "hex": "#1d254c",
      "rgb": [
        29,
        37,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:212",
      "brandId": "anchor",
      "reference": "212",
      "name": "Jade Very Dark",
      "hex": "#1d3f2a",
      "rgb": [
        29,
        63,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:410",
      "brandId": "anchor",
      "reference": "410",
      "name": "Electric Blue Dark",
      "hex": "#1d58a0",
      "rgb": [
        29,
        88,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:236",
      "brandId": "anchor",
      "reference": "236",
      "name": "Pewter Grey Very Dark",
      "hex": "#1f1f1f",
      "rgb": [
        31,
        31,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:683",
      "brandId": "anchor",
      "reference": "683",
      "name": "Misty Green Ultra Very Dark",
      "hex": "#1f2f27",
      "rgb": [
        31,
        47,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:147",
      "brandId": "anchor",
      "reference": "147",
      "name": "Navy Blue Medium Light",
      "hex": "#203056",
      "rgb": [
        32,
        48,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:229",
      "brandId": "anchor",
      "reference": "229",
      "name": "Christmas Green Dark",
      "hex": "#204f16",
      "rgb": [
        32,
        79,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1066",
      "brandId": "anchor",
      "reference": "1066",
      "name": "Teal Medium",
      "hex": "#216b7a",
      "rgb": [
        33,
        107,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:246",
      "brandId": "anchor",
      "reference": "246",
      "name": "Pistachio Green Very Dark",
      "hex": "#223915",
      "rgb": [
        34,
        57,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:218",
      "brandId": "anchor",
      "reference": "218",
      "name": "Misty Green Very Dark",
      "hex": "#223d2e",
      "rgb": [
        34,
        61,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:211",
      "brandId": "anchor",
      "reference": "211",
      "name": "Jade Dark",
      "hex": "#234d34",
      "rgb": [
        35,
        77,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:188",
      "brandId": "anchor",
      "reference": "188",
      "name": "Turquoise Dark",
      "hex": "#246253",
      "rgb": [
        36,
        98,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:941",
      "brandId": "anchor",
      "reference": "941",
      "name": "Cornflower Blue Medium",
      "hex": "#252949",
      "rgb": [
        37,
        41,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:139",
      "brandId": "anchor",
      "reference": "139",
      "name": "Delft Very Dark",
      "hex": "#253156",
      "rgb": [
        37,
        49,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:189",
      "brandId": "anchor",
      "reference": "189",
      "name": "Turquoise Very Dark",
      "hex": "#26443c",
      "rgb": [
        38,
        68,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:162",
      "brandId": "anchor",
      "reference": "162",
      "name": "Baby Blue Very Dark",
      "hex": "#265673",
      "rgb": [
        38,
        86,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:269",
      "brandId": "anchor",
      "reference": "269",
      "name": "Avocado Green Very Dark",
      "hex": "#282e0f",
      "rgb": [
        40,
        46,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1041",
      "brandId": "anchor",
      "reference": "1041",
      "name": "Beaver Grey Ultra Dark",
      "hex": "#2a2824",
      "rgb": [
        42,
        40,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:178",
      "brandId": "anchor",
      "reference": "178",
      "name": "Cornflower Blue Very D",
      "hex": "#2b1d53",
      "rgb": [
        43,
        29,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:142",
      "brandId": "anchor",
      "reference": "142",
      "name": "Royal Blue Medium",
      "hex": "#2c4a7c",
      "rgb": [
        44,
        74,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:228",
      "brandId": "anchor",
      "reference": "228",
      "name": "Christmas Green Medium",
      "hex": "#2c5d22",
      "rgb": [
        44,
        93,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1076",
      "brandId": "anchor",
      "reference": "1076",
      "name": "Jade",
      "hex": "#2c897b",
      "rgb": [
        44,
        137,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:922",
      "brandId": "anchor",
      "reference": "922",
      "name": "Antique Blue Dark",
      "hex": "#2d313b",
      "rgb": [
        45,
        49,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:979",
      "brandId": "anchor",
      "reference": "979",
      "name": "Blue Very Dark",
      "hex": "#2d3a4b",
      "rgb": [
        45,
        58,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:169",
      "brandId": "anchor",
      "reference": "169",
      "name": "Blue Green Dark",
      "hex": "#2d4f59",
      "rgb": [
        45,
        79,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:846",
      "brandId": "anchor",
      "reference": "846",
      "name": "Khaki Green Dark",
      "hex": "#2e2b1a",
      "rgb": [
        46,
        43,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:217",
      "brandId": "anchor",
      "reference": "217",
      "name": "Misty Green Dark",
      "hex": "#2e4c3c",
      "rgb": [
        46,
        76,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:263",
      "brandId": "anchor",
      "reference": "263",
      "name": "Loden Green Dark",
      "hex": "#2f3720",
      "rgb": [
        47,
        55,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:210",
      "brandId": "anchor",
      "reference": "210",
      "name": "Jade Medium Dark",
      "hex": "#2f583f",
      "rgb": [
        47,
        88,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:382",
      "brandId": "anchor",
      "reference": "382",
      "name": "Black Brown Very Dark",
      "hex": "#301400",
      "rgb": [
        48,
        20,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:273",
      "brandId": "anchor",
      "reference": "273",
      "name": "Beaver Grey Very Dark",
      "hex": "#302d28",
      "rgb": [
        48,
        45,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1035",
      "brandId": "anchor",
      "reference": "1035",
      "name": "Antique Blue Very Dark",
      "hex": "#303546",
      "rgb": [
        48,
        53,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:102",
      "brandId": "anchor",
      "reference": "102",
      "name": "Lavender Ultra Very Dark",
      "hex": "#310331",
      "rgb": [
        49,
        3,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:851",
      "brandId": "anchor",
      "reference": "851",
      "name": "Grey Blue Ultra Very Dark",
      "hex": "#334051",
      "rgb": [
        51,
        64,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:245",
      "brandId": "anchor",
      "reference": "245",
      "name": "Pistachio Green Dark",
      "hex": "#344e24",
      "rgb": [
        52,
        78,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:877",
      "brandId": "anchor",
      "reference": "877",
      "name": "Sea Foam Green Dark",
      "hex": "#345b4a",
      "rgb": [
        52,
        91,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:905",
      "brandId": "anchor",
      "reference": "905",
      "name": "Brown Grey Dark",
      "hex": "#35271b",
      "rgb": [
        53,
        39,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:401",
      "brandId": "anchor",
      "reference": "401",
      "name": "Shell Grey Very Dark",
      "hex": "#352c2a",
      "rgb": [
        53,
        44,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:72",
      "brandId": "anchor",
      "reference": "72",
      "name": "Dusty Plum Ultra Very Dark",
      "hex": "#36011e",
      "rgb": [
        54,
        1,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:381",
      "brandId": "anchor",
      "reference": "381",
      "name": "Black Brown Dark",
      "hex": "#361a06",
      "rgb": [
        54,
        26,
        6
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1050",
      "brandId": "anchor",
      "reference": "1050",
      "name": "Mocha Brown Dark",
      "hex": "#361f0c",
      "rgb": [
        54,
        31,
        12
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:132",
      "brandId": "anchor",
      "reference": "132",
      "name": "Sky Blue Dark",
      "hex": "#363e67",
      "rgb": [
        54,
        62,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:187",
      "brandId": "anchor",
      "reference": "187",
      "name": "Turquoise Medium",
      "hex": "#368b78",
      "rgb": [
        54,
        139,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:681",
      "brandId": "anchor",
      "reference": "681",
      "name": "Green Grey",
      "hex": "#37361f",
      "rgb": [
        55,
        54,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:940",
      "brandId": "anchor",
      "reference": "940",
      "name": "Delft Dark",
      "hex": "#373d63",
      "rgb": [
        55,
        61,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:861",
      "brandId": "anchor",
      "reference": "861",
      "name": "Fern Green Dark",
      "hex": "#394131",
      "rgb": [
        57,
        65,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:177",
      "brandId": "anchor",
      "reference": "177",
      "name": "Cornflower Blue Dark",
      "hex": "#3a2d61",
      "rgb": [
        58,
        45,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:400",
      "brandId": "anchor",
      "reference": "400",
      "name": "Pewter Grey Dark",
      "hex": "#3a3a3a",
      "rgb": [
        58,
        58,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:216",
      "brandId": "anchor",
      "reference": "216",
      "name": "Misty Green Medium",
      "hex": "#3a5d40",
      "rgb": [
        58,
        93,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:227",
      "brandId": "anchor",
      "reference": "227",
      "name": "Christmas Green",
      "hex": "#3a742d",
      "rgb": [
        58,
        116,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:122",
      "brandId": "anchor",
      "reference": "122",
      "name": "Blue Purple Medium",
      "hex": "#3f3d5a",
      "rgb": [
        63,
        61,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:8581",
      "brandId": "anchor",
      "reference": "8581",
      "name": "Beaver Grey Medium",
      "hex": "#403e3a",
      "rgb": [
        64,
        62,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:268",
      "brandId": "anchor",
      "reference": "268",
      "name": "Avocado Green Dark",
      "hex": "#414c1b",
      "rgb": [
        65,
        76,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:779",
      "brandId": "anchor",
      "reference": "779",
      "name": "Grey Blue Very Dark",
      "hex": "#415268",
      "rgb": [
        65,
        82,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:112",
      "brandId": "anchor",
      "reference": "112",
      "name": "Lavender Very Dark",
      "hex": "#421f4e",
      "rgb": [
        66,
        31,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:380",
      "brandId": "anchor",
      "reference": "380",
      "name": "Black Brown Medium Dark",
      "hex": "#42220a",
      "rgb": [
        66,
        34,
        10
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:873",
      "brandId": "anchor",
      "reference": "873",
      "name": "Antique Violet Dark",
      "hex": "#422539",
      "rgb": [
        66,
        37,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:906",
      "brandId": "anchor",
      "reference": "906",
      "name": "Hazelnut Brown Dark",
      "hex": "#422c14",
      "rgb": [
        66,
        44,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:146",
      "brandId": "anchor",
      "reference": "146",
      "name": "Navy Blue Light",
      "hex": "#425580",
      "rgb": [
        66,
        85,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:845",
      "brandId": "anchor",
      "reference": "845",
      "name": "Khaki Green Medium Dark",
      "hex": "#443e24",
      "rgb": [
        68,
        62,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1040",
      "brandId": "anchor",
      "reference": "1040",
      "name": "Beaver Grey Dark",
      "hex": "#45423f",
      "rgb": [
        69,
        66,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:258",
      "brandId": "anchor",
      "reference": "258",
      "name": "Forest Green Very Dark",
      "hex": "#454f01",
      "rgb": [
        69,
        79,
        1
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1074",
      "brandId": "anchor",
      "reference": "1074",
      "name": "Jade Medium",
      "hex": "#45a89a",
      "rgb": [
        69,
        168,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:137",
      "brandId": "anchor",
      "reference": "137",
      "name": "Delft Medium Dark",
      "hex": "#465380",
      "rgb": [
        70,
        83,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:978",
      "brandId": "anchor",
      "reference": "978",
      "name": "Blue Dark",
      "hex": "#46576b",
      "rgb": [
        70,
        87,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:244",
      "brandId": "anchor",
      "reference": "244",
      "name": "Pistachio Green Medium",
      "hex": "#475c3b",
      "rgb": [
        71,
        92,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:856",
      "brandId": "anchor",
      "reference": "856",
      "name": "Yellow Green Medium",
      "hex": "#484020",
      "rgb": [
        72,
        64,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:235",
      "brandId": "anchor",
      "reference": "235",
      "name": "Pewter Grey",
      "hex": "#484848",
      "rgb": [
        72,
        72,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:70",
      "brandId": "anchor",
      "reference": "70",
      "name": "Dusty Plum Very Dark",
      "hex": "#490029",
      "rgb": [
        73,
        0,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:924",
      "brandId": "anchor",
      "reference": "924",
      "name": "Yellow Green Very Dark",
      "hex": "#493f0d",
      "rgb": [
        73,
        63,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:262",
      "brandId": "anchor",
      "reference": "262",
      "name": "Laurel Green Dark",
      "hex": "#495136",
      "rgb": [
        73,
        81,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:239",
      "brandId": "anchor",
      "reference": "239",
      "name": "Chartreuse Very Dark",
      "hex": "#4a8626",
      "rgb": [
        74,
        134,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:101",
      "brandId": "anchor",
      "reference": "101",
      "name": "Violet Very Dark",
      "hex": "#4b143b",
      "rgb": [
        75,
        20,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1072",
      "brandId": "anchor",
      "reference": "1072",
      "name": "Jade Medium Light",
      "hex": "#4baf87",
      "rgb": [
        75,
        175,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:360",
      "brandId": "anchor",
      "reference": "360",
      "name": "Black Brown Medium",
      "hex": "#4c270c",
      "rgb": [
        76,
        39,
        12
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:281",
      "brandId": "anchor",
      "reference": "281",
      "name": "Yellow Green Dark",
      "hex": "#4c4416",
      "rgb": [
        76,
        68,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:904",
      "brandId": "anchor",
      "reference": "904",
      "name": "Brown Grey Medium",
      "hex": "#4d3927",
      "rgb": [
        77,
        57,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:277",
      "brandId": "anchor",
      "reference": "277",
      "name": "Gold Dark",
      "hex": "#4e3008",
      "rgb": [
        78,
        48,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:872",
      "brandId": "anchor",
      "reference": "872",
      "name": "Antique Violet Medium Dark",
      "hex": "#4e3948",
      "rgb": [
        78,
        57,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:205",
      "brandId": "anchor",
      "reference": "205",
      "name": "Emerald Green Light",
      "hex": "#4e7152",
      "rgb": [
        78,
        113,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:209",
      "brandId": "anchor",
      "reference": "209",
      "name": "Jade Medium",
      "hex": "#4f8866",
      "rgb": [
        79,
        136,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:936",
      "brandId": "anchor",
      "reference": "936",
      "name": "Dusty Flesh Very Dark",
      "hex": "#503329",
      "rgb": [
        80,
        51,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:860",
      "brandId": "anchor",
      "reference": "860",
      "name": "Fern Green Medium",
      "hex": "#505b47",
      "rgb": [
        80,
        91,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:267",
      "brandId": "anchor",
      "reference": "267",
      "name": "Avocado Green Medium",
      "hex": "#525e27",
      "rgb": [
        82,
        94,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:119",
      "brandId": "anchor",
      "reference": "119",
      "name": "Blue Violet Dark",
      "hex": "#533872",
      "rgb": [
        83,
        56,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:131",
      "brandId": "anchor",
      "reference": "131",
      "name": "Sky Blue Medium",
      "hex": "#535d86",
      "rgb": [
        83,
        93,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1034",
      "brandId": "anchor",
      "reference": "1034",
      "name": "Antique Blue Medium Dark",
      "hex": "#535e73",
      "rgb": [
        83,
        94,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:215",
      "brandId": "anchor",
      "reference": "215",
      "name": "Misty Green Light",
      "hex": "#537b5a",
      "rgb": [
        83,
        123,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:359",
      "brandId": "anchor",
      "reference": "359",
      "name": "Coffee Very Dark",
      "hex": "#552f14",
      "rgb": [
        85,
        47,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:375",
      "brandId": "anchor",
      "reference": "375",
      "name": "Hazelnut Brown Medium",
      "hex": "#55330e",
      "rgb": [
        85,
        51,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1086",
      "brandId": "anchor",
      "reference": "1086",
      "name": "Taupe Medium Dark",
      "hex": "#553d34",
      "rgb": [
        85,
        61,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:393",
      "brandId": "anchor",
      "reference": "393",
      "name": "Beige Grey Ultra Very Dark",
      "hex": "#55493d",
      "rgb": [
        85,
        73,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:257",
      "brandId": "anchor",
      "reference": "257",
      "name": "Forest Green Dark",
      "hex": "#576301",
      "rgb": [
        87,
        99,
        1
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:977",
      "brandId": "anchor",
      "reference": "977",
      "name": "Blue Medium",
      "hex": "#576a83",
      "rgb": [
        87,
        106,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:161",
      "brandId": "anchor",
      "reference": "161",
      "name": "Baby Blue Dark",
      "hex": "#57819c",
      "rgb": [
        87,
        129,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:921",
      "brandId": "anchor",
      "reference": "921",
      "name": "Antique Blue Medium",
      "hex": "#586172",
      "rgb": [
        88,
        97,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:876",
      "brandId": "anchor",
      "reference": "876",
      "name": "Sea Foam Green Medium",
      "hex": "#587167",
      "rgb": [
        88,
        113,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:352",
      "brandId": "anchor",
      "reference": "352",
      "name": "Copper Very Dark",
      "hex": "#59280e",
      "rgb": [
        89,
        40,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:897",
      "brandId": "anchor",
      "reference": "897",
      "name": "Shell Pink Very Dark",
      "hex": "#5a0200",
      "rgb": [
        90,
        2,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:243",
      "brandId": "anchor",
      "reference": "243",
      "name": "Pistachio Green Medium Dark",
      "hex": "#5a734a",
      "rgb": [
        90,
        115,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:357",
      "brandId": "anchor",
      "reference": "357",
      "name": "Chocolate Dark",
      "hex": "#5b2c11",
      "rgb": [
        91,
        44,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:226",
      "brandId": "anchor",
      "reference": "226",
      "name": "Christmas Green Light",
      "hex": "#5b8542",
      "rgb": [
        91,
        133,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1064",
      "brandId": "anchor",
      "reference": "1064",
      "name": "Teal Medium Light",
      "hex": "#5ba3b2",
      "rgb": [
        91,
        163,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:889",
      "brandId": "anchor",
      "reference": "889",
      "name": "Drab Brown Very Dark",
      "hex": "#5c3a18",
      "rgb": [
        92,
        58,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:898",
      "brandId": "anchor",
      "reference": "898",
      "name": "Drab Brown Dark",
      "hex": "#5c4736",
      "rgb": [
        92,
        71,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:111",
      "brandId": "anchor",
      "reference": "111",
      "name": "Lavender Dark",
      "hex": "#5d2c6e",
      "rgb": [
        93,
        44,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:871",
      "brandId": "anchor",
      "reference": "871",
      "name": "Antique Violet Medium",
      "hex": "#5d4556",
      "rgb": [
        93,
        69,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:844",
      "brandId": "anchor",
      "reference": "844",
      "name": "Khaki Green Medium",
      "hex": "#5e5837",
      "rgb": [
        94,
        88,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1028",
      "brandId": "anchor",
      "reference": "1028",
      "name": "Dusty Plum Dark",
      "hex": "#5f0137",
      "rgb": [
        95,
        1,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:168",
      "brandId": "anchor",
      "reference": "168",
      "name": "Blue Green Medium",
      "hex": "#5f858f",
      "rgb": [
        95,
        133,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:850",
      "brandId": "anchor",
      "reference": "850",
      "name": "Grey Blue Dark",
      "hex": "#606d74",
      "rgb": [
        96,
        109,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1029",
      "brandId": "anchor",
      "reference": "1029",
      "name": "Plum Dark",
      "hex": "#611440",
      "rgb": [
        97,
        20,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:903",
      "brandId": "anchor",
      "reference": "903",
      "name": "Brown Grey Medium",
      "hex": "#614f40",
      "rgb": [
        97,
        79,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:358",
      "brandId": "anchor",
      "reference": "358",
      "name": "Coffee Dark",
      "hex": "#62391b",
      "rgb": [
        98,
        57,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:371",
      "brandId": "anchor",
      "reference": "371",
      "name": "Coffee Medium Dark",
      "hex": "#633a1b",
      "rgb": [
        99,
        58,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:176",
      "brandId": "anchor",
      "reference": "176",
      "name": "Cornflower Blue Medium",
      "hex": "#635f95",
      "rgb": [
        99,
        95,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:256",
      "brandId": "anchor",
      "reference": "256",
      "name": "Forest Green Medium",
      "hex": "#637201",
      "rgb": [
        99,
        114,
        1
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:100",
      "brandId": "anchor",
      "reference": "100",
      "name": "Violet Dark",
      "hex": "#642d55",
      "rgb": [
        100,
        45,
        85
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:399",
      "brandId": "anchor",
      "reference": "399",
      "name": "Steel Grey Light",
      "hex": "#646263",
      "rgb": [
        100,
        98,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1039",
      "brandId": "anchor",
      "reference": "1039",
      "name": "Baby Blue Medium Dark",
      "hex": "#6493b0",
      "rgb": [
        100,
        147,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:351",
      "brandId": "anchor",
      "reference": "351",
      "name": "Copper Dark",
      "hex": "#66330e",
      "rgb": [
        102,
        51,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:939",
      "brandId": "anchor",
      "reference": "939",
      "name": "Blue Grey",
      "hex": "#666d7b",
      "rgb": [
        102,
        109,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:208",
      "brandId": "anchor",
      "reference": "208",
      "name": "Jade Light",
      "hex": "#669e7c",
      "rgb": [
        102,
        158,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1019",
      "brandId": "anchor",
      "reference": "1019",
      "name": "Antique Mauve Dark",
      "hex": "#682734",
      "rgb": [
        104,
        39,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:972",
      "brandId": "anchor",
      "reference": "972",
      "name": "Dusty Violet Very Dark",
      "hex": "#682f35",
      "rgb": [
        104,
        47,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:121",
      "brandId": "anchor",
      "reference": "121",
      "name": "Blue Purple Light",
      "hex": "#686e8c",
      "rgb": [
        104,
        110,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:186",
      "brandId": "anchor",
      "reference": "186",
      "name": "Turquoise Light",
      "hex": "#69b5a3",
      "rgb": [
        105,
        181,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:204",
      "brandId": "anchor",
      "reference": "204",
      "name": "Emerald Green Very Light",
      "hex": "#6a996f",
      "rgb": [
        106,
        153,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:242",
      "brandId": "anchor",
      "reference": "242",
      "name": "Pistachio Green Medium",
      "hex": "#6b8d58",
      "rgb": [
        107,
        141,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:433",
      "brandId": "anchor",
      "reference": "433",
      "name": "Electric Blue Medium",
      "hex": "#6badff",
      "rgb": [
        107,
        173,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:374",
      "brandId": "anchor",
      "reference": "374",
      "name": "Tan Dark",
      "hex": "#6d4213",
      "rgb": [
        109,
        66,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1088",
      "brandId": "anchor",
      "reference": "1088",
      "name": "Taupe Very Dark",
      "hex": "#6d491e",
      "rgb": [
        109,
        73,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:233",
      "brandId": "anchor",
      "reference": "233",
      "name": "Shell Grey Dark",
      "hex": "#6d615e",
      "rgb": [
        109,
        97,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:238",
      "brandId": "anchor",
      "reference": "238",
      "name": "Chartreuse",
      "hex": "#6d9a3b",
      "rgb": [
        109,
        154,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:896",
      "brandId": "anchor",
      "reference": "896",
      "name": "Shell Pink",
      "hex": "#6e3335",
      "rgb": [
        110,
        51,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:45",
      "brandId": "anchor",
      "reference": "45",
      "name": "Garnet Very Dark",
      "hex": "#6f2531",
      "rgb": [
        111,
        37,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:859",
      "brandId": "anchor",
      "reference": "859",
      "name": "Fern Green Light",
      "hex": "#6f7d63",
      "rgb": [
        111,
        125,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:69",
      "brandId": "anchor",
      "reference": "69",
      "name": "Dusty Plum Medium Dark",
      "hex": "#700040",
      "rgb": [
        112,
        0,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:94",
      "brandId": "anchor",
      "reference": "94",
      "name": "Purple Dark",
      "hex": "#700c63",
      "rgb": [
        112,
        12,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:832",
      "brandId": "anchor",
      "reference": "832",
      "name": "Drab Brown Medium",
      "hex": "#705741",
      "rgb": [
        112,
        87,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:855",
      "brandId": "anchor",
      "reference": "855",
      "name": "Avocado Medium",
      "hex": "#70633e",
      "rgb": [
        112,
        99,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:355",
      "brandId": "anchor",
      "reference": "355",
      "name": "Chocolate Medium Dark",
      "hex": "#713f22",
      "rgb": [
        113,
        63,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:266",
      "brandId": "anchor",
      "reference": "266",
      "name": "Avocado Green Light",
      "hex": "#718036",
      "rgb": [
        113,
        128,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:65",
      "brandId": "anchor",
      "reference": "65",
      "name": "Cerise Ultra Very Dark",
      "hex": "#721944",
      "rgb": [
        114,
        25,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:365",
      "brandId": "anchor",
      "reference": "365",
      "name": "Golden Brown Medium",
      "hex": "#744817",
      "rgb": [
        116,
        72,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:255",
      "brandId": "anchor",
      "reference": "255",
      "name": "Forest Green Light",
      "hex": "#748505",
      "rgb": [
        116,
        133,
        5
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1030",
      "brandId": "anchor",
      "reference": "1030",
      "name": "Blue Violet Medium",
      "hex": "#7567a3",
      "rgb": [
        117,
        103,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:136",
      "brandId": "anchor",
      "reference": "136",
      "name": "Delft Medium",
      "hex": "#7582a8",
      "rgb": [
        117,
        130,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1046",
      "brandId": "anchor",
      "reference": "1046",
      "name": "Golden Brown Medium Dark",
      "hex": "#774a1a",
      "rgb": [
        119,
        74,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:944",
      "brandId": "anchor",
      "reference": "944",
      "name": "Tan Very Dark",
      "hex": "#783a0d",
      "rgb": [
        120,
        58,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1007",
      "brandId": "anchor",
      "reference": "1007",
      "name": "Flesh Very Dark",
      "hex": "#784f42",
      "rgb": [
        120,
        79,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:145",
      "brandId": "anchor",
      "reference": "145",
      "name": "Navy Blue Very Light",
      "hex": "#7884a4",
      "rgb": [
        120,
        132,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1018",
      "brandId": "anchor",
      "reference": "1018",
      "name": "Antique Mauve Light",
      "hex": "#79454f",
      "rgb": [
        121,
        69,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:225",
      "brandId": "anchor",
      "reference": "225",
      "name": "Christmas Green Very Light",
      "hex": "#79a45e",
      "rgb": [
        121,
        164,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1005",
      "brandId": "anchor",
      "reference": "1005",
      "name": "Christmas Red Ultra Very Dark",
      "hex": "#7b0200",
      "rgb": [
        123,
        2,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:370",
      "brandId": "anchor",
      "reference": "370",
      "name": "Coffee Medium",
      "hex": "#7b471f",
      "rgb": [
        123,
        71,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:854",
      "brandId": "anchor",
      "reference": "854",
      "name": "Avocado Light",
      "hex": "#7b7052",
      "rgb": [
        123,
        112,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:99",
      "brandId": "anchor",
      "reference": "99",
      "name": "Violet Medium Dark",
      "hex": "#7c3969",
      "rgb": [
        124,
        57,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:110",
      "brandId": "anchor",
      "reference": "110",
      "name": "Lavender Medium",
      "hex": "#7c4a8d",
      "rgb": [
        124,
        74,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:89",
      "brandId": "anchor",
      "reference": "89",
      "name": "Mauve Dark",
      "hex": "#7d074d",
      "rgb": [
        125,
        7,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:310",
      "brandId": "anchor",
      "reference": "310",
      "name": "Topaz Very Dark",
      "hex": "#7d3b00",
      "rgb": [
        125,
        59,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:843",
      "brandId": "anchor",
      "reference": "843",
      "name": "Khaki Green Medium Light",
      "hex": "#7d754c",
      "rgb": [
        125,
        117,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:22",
      "brandId": "anchor",
      "reference": "22",
      "name": "Garnet",
      "hex": "#7e0520",
      "rgb": [
        126,
        5,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:907",
      "brandId": "anchor",
      "reference": "907",
      "name": "Gold Medium",
      "hex": "#7e5b27",
      "rgb": [
        126,
        91,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:849",
      "brandId": "anchor",
      "reference": "849",
      "name": "Grey Blue Medium",
      "hex": "#7f8381",
      "rgb": [
        127,
        131,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:78",
      "brandId": "anchor",
      "reference": "78",
      "name": "Plum Medium Dark",
      "hex": "#80294e",
      "rgb": [
        128,
        41,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:392",
      "brandId": "anchor",
      "reference": "392",
      "name": "Beige Grey Dark",
      "hex": "#806e5d",
      "rgb": [
        128,
        110,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:280",
      "brandId": "anchor",
      "reference": "280",
      "name": "Yellow Green",
      "hex": "#807138",
      "rgb": [
        128,
        113,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:900",
      "brandId": "anchor",
      "reference": "900",
      "name": "Beaver Grey Light",
      "hex": "#807e79",
      "rgb": [
        128,
        126,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:920",
      "brandId": "anchor",
      "reference": "920",
      "name": "Antique Blue Medium Light",
      "hex": "#808b99",
      "rgb": [
        128,
        139,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:118",
      "brandId": "anchor",
      "reference": "118",
      "name": "Blue Violet Light",
      "hex": "#8175ad",
      "rgb": [
        129,
        117,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:44",
      "brandId": "anchor",
      "reference": "44",
      "name": "Garnet Dark",
      "hex": "#822d3c",
      "rgb": [
        130,
        45,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:261",
      "brandId": "anchor",
      "reference": "261",
      "name": "Laurel Green Medium",
      "hex": "#828f67",
      "rgb": [
        130,
        143,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:970",
      "brandId": "anchor",
      "reference": "970",
      "name": "Dusty Violet Dark",
      "hex": "#834e50",
      "rgb": [
        131,
        78,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1070",
      "brandId": "anchor",
      "reference": "1070",
      "name": "Jade Light",
      "hex": "#83cfb4",
      "rgb": [
        131,
        207,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:130",
      "brandId": "anchor",
      "reference": "130",
      "name": "Sky Blue",
      "hex": "#859abe",
      "rgb": [
        133,
        154,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:241",
      "brandId": "anchor",
      "reference": "241",
      "name": "Pistachio Green",
      "hex": "#85ac6e",
      "rgb": [
        133,
        172,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1004",
      "brandId": "anchor",
      "reference": "1004",
      "name": "Orange Spice Very Dark",
      "hex": "#863a1a",
      "rgb": [
        134,
        58,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:43",
      "brandId": "anchor",
      "reference": "43",
      "name": "Garnet Medium",
      "hex": "#882639",
      "rgb": [
        136,
        38,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:39",
      "brandId": "anchor",
      "reference": "39",
      "name": "Dusty Pink Dark",
      "hex": "#882e3c",
      "rgb": [
        136,
        46,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:373",
      "brandId": "anchor",
      "reference": "373",
      "name": "Tan Medium Dark",
      "hex": "#88623a",
      "rgb": [
        136,
        98,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:888",
      "brandId": "anchor",
      "reference": "888",
      "name": "Hazelnut Brown Light",
      "hex": "#886940",
      "rgb": [
        136,
        105,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:976",
      "brandId": "anchor",
      "reference": "976",
      "name": "Blue Light",
      "hex": "#8897ab",
      "rgb": [
        136,
        151,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:167",
      "brandId": "anchor",
      "reference": "167",
      "name": "Blue Green Light",
      "hex": "#88bdca",
      "rgb": [
        136,
        189,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1062",
      "brandId": "anchor",
      "reference": "1062",
      "name": "Teal Light",
      "hex": "#88c3cf",
      "rgb": [
        136,
        195,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1049",
      "brandId": "anchor",
      "reference": "1049",
      "name": "Copper Medium Dark",
      "hex": "#894a1c",
      "rgb": [
        137,
        74,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:398",
      "brandId": "anchor",
      "reference": "398",
      "name": "Pearl Grey",
      "hex": "#89888a",
      "rgb": [
        137,
        136,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1038",
      "brandId": "anchor",
      "reference": "1038",
      "name": "Baby Blue Medium",
      "hex": "#89b0c8",
      "rgb": [
        137,
        176,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:369",
      "brandId": "anchor",
      "reference": "369",
      "name": "Coffee Medium Light",
      "hex": "#8b5d3c",
      "rgb": [
        139,
        93,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:341",
      "brandId": "anchor",
      "reference": "341",
      "name": "Mahogany Dark",
      "hex": "#8c310f",
      "rgb": [
        140,
        49,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:265",
      "brandId": "anchor",
      "reference": "265",
      "name": "Avocado Green Very Light",
      "hex": "#8c9e47",
      "rgb": [
        140,
        158,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:59",
      "brandId": "anchor",
      "reference": "59",
      "name": "Pink Mauve Ultra Very Dark",
      "hex": "#8d0142",
      "rgb": [
        141,
        1,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:884",
      "brandId": "anchor",
      "reference": "884",
      "name": "Antique Mahogany Dark",
      "hex": "#8d4c37",
      "rgb": [
        141,
        76,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:870",
      "brandId": "anchor",
      "reference": "870",
      "name": "Antique Violet Light",
      "hex": "#8d6e83",
      "rgb": [
        141,
        110,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:175",
      "brandId": "anchor",
      "reference": "175",
      "name": "Cornflower Blue Light",
      "hex": "#8d9ec3",
      "rgb": [
        141,
        158,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1025",
      "brandId": "anchor",
      "reference": "1025",
      "name": "Dusty Rose Dark",
      "hex": "#8e2731",
      "rgb": [
        142,
        39,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:232",
      "brandId": "anchor",
      "reference": "232",
      "name": "Shell Grey Medium",
      "hex": "#8e807f",
      "rgb": [
        142,
        128,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:185",
      "brandId": "anchor",
      "reference": "185",
      "name": "Turquoise Very Light",
      "hex": "#8ed1c1",
      "rgb": [
        142,
        209,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1006",
      "brandId": "anchor",
      "reference": "1006",
      "name": "Dusty Rose Very Dark",
      "hex": "#8f1800",
      "rgb": [
        143,
        24,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:5975",
      "brandId": "anchor",
      "reference": "5975",
      "name": "Terracotta Dark",
      "hex": "#8f381a",
      "rgb": [
        143,
        56,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:203",
      "brandId": "anchor",
      "reference": "203",
      "name": "Emerald Green Ultra Very Light",
      "hex": "#8fc095",
      "rgb": [
        143,
        192,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1033",
      "brandId": "anchor",
      "reference": "1033",
      "name": "Antique Blue",
      "hex": "#909aae",
      "rgb": [
        144,
        154,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1027",
      "brandId": "anchor",
      "reference": "1027",
      "name": "Shell Pink Medium Dark",
      "hex": "#914e4c",
      "rgb": [
        145,
        78,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1085",
      "brandId": "anchor",
      "reference": "1085",
      "name": "Taupe Dark",
      "hex": "#917452",
      "rgb": [
        145,
        116,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:853",
      "brandId": "anchor",
      "reference": "853",
      "name": "Avocado Very Light",
      "hex": "#91886b",
      "rgb": [
        145,
        136,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1014",
      "brandId": "anchor",
      "reference": "1014",
      "name": "Mahogany Very Dark",
      "hex": "#922700",
      "rgb": [
        146,
        39,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:92",
      "brandId": "anchor",
      "reference": "92",
      "name": "Purple Medium",
      "hex": "#924c89",
      "rgb": [
        146,
        76,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:379",
      "brandId": "anchor",
      "reference": "379",
      "name": "Dusty Flesh Dark",
      "hex": "#92685a",
      "rgb": [
        146,
        104,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:899",
      "brandId": "anchor",
      "reference": "899",
      "name": "Brown Grey Light",
      "hex": "#938375",
      "rgb": [
        147,
        131,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:349",
      "brandId": "anchor",
      "reference": "349",
      "name": "Chocolate Medium",
      "hex": "#945731",
      "rgb": [
        148,
        87,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:875",
      "brandId": "anchor",
      "reference": "875",
      "name": "Sea Foam Green Light",
      "hex": "#94b4a6",
      "rgb": [
        148,
        180,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1015",
      "brandId": "anchor",
      "reference": "1015",
      "name": "Mahogany Ultra Very Dark",
      "hex": "#961815",
      "rgb": [
        150,
        24,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:214",
      "brandId": "anchor",
      "reference": "214",
      "name": "Misty Green Very Light",
      "hex": "#96b39b",
      "rgb": [
        150,
        179,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:77",
      "brandId": "anchor",
      "reference": "77",
      "name": "Plum Medium",
      "hex": "#97345e",
      "rgb": [
        151,
        52,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:309",
      "brandId": "anchor",
      "reference": "309",
      "name": "Topaz Medium Dark",
      "hex": "#974400",
      "rgb": [
        151,
        68,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:98",
      "brandId": "anchor",
      "reference": "98",
      "name": "Violet Medium Light",
      "hex": "#975284",
      "rgb": [
        151,
        82,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:20",
      "brandId": "anchor",
      "reference": "20",
      "name": "Garnet Light",
      "hex": "#99112e",
      "rgb": [
        153,
        17,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:140",
      "brandId": "anchor",
      "reference": "140",
      "name": "Royal Blue Light",
      "hex": "#99b4d7",
      "rgb": [
        153,
        180,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1092",
      "brandId": "anchor",
      "reference": "1092",
      "name": "Teal Light",
      "hex": "#99d8d2",
      "rgb": [
        153,
        216,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:109",
      "brandId": "anchor",
      "reference": "109",
      "name": "Lavender Light",
      "hex": "#9b69ac",
      "rgb": [
        155,
        105,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:848",
      "brandId": "anchor",
      "reference": "848",
      "name": "Grey Blue Light",
      "hex": "#9ca29e",
      "rgb": [
        156,
        162,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:88",
      "brandId": "anchor",
      "reference": "88",
      "name": "Mauve Medium",
      "hex": "#9d2f6e",
      "rgb": [
        157,
        47,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:340",
      "brandId": "anchor",
      "reference": "340",
      "name": "Mahogany Medium Dark",
      "hex": "#9e3812",
      "rgb": [
        158,
        56,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:254",
      "brandId": "anchor",
      "reference": "254",
      "name": "Forest Green Very Light",
      "hex": "#9ea668",
      "rgb": [
        158,
        166,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1096",
      "brandId": "anchor",
      "reference": "1096",
      "name": "Blue Grey Light",
      "hex": "#9fb3c1",
      "rgb": [
        159,
        179,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:129",
      "brandId": "anchor",
      "reference": "129",
      "name": "Sky Blue Light",
      "hex": "#9fb4d8",
      "rgb": [
        159,
        180,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:160",
      "brandId": "anchor",
      "reference": "160",
      "name": "Baby Blue",
      "hex": "#9fc8e2",
      "rgb": [
        159,
        200,
        226
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:901",
      "brandId": "anchor",
      "reference": "901",
      "name": "Old Gold Dark",
      "hex": "#a05f00",
      "rgb": [
        160,
        95,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:206",
      "brandId": "anchor",
      "reference": "206",
      "name": "Jade Very Light",
      "hex": "#a0cdb1",
      "rgb": [
        160,
        205,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:378",
      "brandId": "anchor",
      "reference": "378",
      "name": "Dusty Flesh Medium",
      "hex": "#a27567",
      "rgb": [
        162,
        117,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:63",
      "brandId": "anchor",
      "reference": "63",
      "name": "Cerise",
      "hex": "#a32c64",
      "rgb": [
        163,
        44,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:76",
      "brandId": "anchor",
      "reference": "76",
      "name": "Plum Medium Light",
      "hex": "#a34663",
      "rgb": [
        163,
        70,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:914",
      "brandId": "anchor",
      "reference": "914",
      "name": "Flesh Dark",
      "hex": "#a36b5b",
      "rgb": [
        163,
        107,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1017",
      "brandId": "anchor",
      "reference": "1017",
      "name": "Antique Mauve Medium",
      "hex": "#a46e79",
      "rgb": [
        164,
        110,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:945",
      "brandId": "anchor",
      "reference": "945",
      "name": "Yellow Green Very Light",
      "hex": "#a4975e",
      "rgb": [
        164,
        151,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:47",
      "brandId": "anchor",
      "reference": "47",
      "name": "Christmas Red",
      "hex": "#a51c00",
      "rgb": [
        165,
        28,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:943",
      "brandId": "anchor",
      "reference": "943",
      "name": "Tan Medium",
      "hex": "#a57148",
      "rgb": [
        165,
        113,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1045",
      "brandId": "anchor",
      "reference": "1045",
      "name": "Golden Brown Medium Light",
      "hex": "#a5753c",
      "rgb": [
        165,
        117,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:240",
      "brandId": "anchor",
      "reference": "240",
      "name": "Pistachio Green Light",
      "hex": "#a5bf96",
      "rgb": [
        165,
        191,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:831",
      "brandId": "anchor",
      "reference": "831",
      "name": "Drab Brown Light",
      "hex": "#a69380",
      "rgb": [
        166,
        147,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:144",
      "brandId": "anchor",
      "reference": "144",
      "name": "Navy Blue Ultra Very Light",
      "hex": "#a6bdd9",
      "rgb": [
        166,
        189,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1001",
      "brandId": "anchor",
      "reference": "1001",
      "name": "Golden Brown",
      "hex": "#a75327",
      "rgb": [
        167,
        83,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:274",
      "brandId": "anchor",
      "reference": "274",
      "name": "Grey Blue Very Light",
      "hex": "#a7b2b5",
      "rgb": [
        167,
        178,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:97",
      "brandId": "anchor",
      "reference": "97",
      "name": "Violet Light",
      "hex": "#a86896",
      "rgb": [
        168,
        104,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1084",
      "brandId": "anchor",
      "reference": "1084",
      "name": "Taupe",
      "hex": "#a98966",
      "rgb": [
        169,
        137,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:391",
      "brandId": "anchor",
      "reference": "391",
      "name": "Beige Grey Medium",
      "hex": "#aa9e92",
      "rgb": [
        170,
        158,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:279",
      "brandId": "anchor",
      "reference": "279",
      "name": "Lime Green",
      "hex": "#ab9b47",
      "rgb": [
        171,
        155,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:68",
      "brandId": "anchor",
      "reference": "68",
      "name": "Dusty Plum Medium",
      "hex": "#ac396f",
      "rgb": [
        172,
        57,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1024",
      "brandId": "anchor",
      "reference": "1024",
      "name": "Dusty Rose Medium",
      "hex": "#ac444d",
      "rgb": [
        172,
        68,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1048",
      "brandId": "anchor",
      "reference": "1048",
      "name": "Copper Medium",
      "hex": "#ac6735",
      "rgb": [
        172,
        103,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:928",
      "brandId": "anchor",
      "reference": "928",
      "name": "Blue Green Very Light",
      "hex": "#acdae6",
      "rgb": [
        172,
        218,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:264",
      "brandId": "anchor",
      "reference": "264",
      "name": "Avocado Green Ultra Very Light",
      "hex": "#adbb85",
      "rgb": [
        173,
        187,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:19",
      "brandId": "anchor",
      "reference": "19",
      "name": "Pink Bright Ultra Very",
      "hex": "#ae1a3c",
      "rgb": [
        174,
        26,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:159",
      "brandId": "anchor",
      "reference": "159",
      "name": "Baby Blue Light",
      "hex": "#b0d4e9",
      "rgb": [
        176,
        212,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1003",
      "brandId": "anchor",
      "reference": "1003",
      "name": "Salmon",
      "hex": "#b15824",
      "rgb": [
        177,
        88,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:308",
      "brandId": "anchor",
      "reference": "308",
      "name": "Topaz Medium",
      "hex": "#b25c07",
      "rgb": [
        178,
        92,
        7
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:874",
      "brandId": "anchor",
      "reference": "874",
      "name": "Gold Very Light",
      "hex": "#b39360",
      "rgb": [
        179,
        147,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:339",
      "brandId": "anchor",
      "reference": "339",
      "name": "Mahogany",
      "hex": "#b44a22",
      "rgb": [
        180,
        74,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:869",
      "brandId": "anchor",
      "reference": "869",
      "name": "Antique Violet Very Light",
      "hex": "#b4a2ae",
      "rgb": [
        180,
        162,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:253",
      "brandId": "anchor",
      "reference": "253",
      "name": "Forest Green Ultra Very Light",
      "hex": "#b4bb8e",
      "rgb": [
        180,
        187,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:362",
      "brandId": "anchor",
      "reference": "362",
      "name": "Tan Medium Light",
      "hex": "#b58e63",
      "rgb": [
        181,
        142,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:108",
      "brandId": "anchor",
      "reference": "108",
      "name": "Lavender Very Light",
      "hex": "#b58ec3",
      "rgb": [
        181,
        142,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:260",
      "brandId": "anchor",
      "reference": "260",
      "name": "Laurel Green Light",
      "hex": "#b5c19b",
      "rgb": [
        181,
        193,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:13",
      "brandId": "anchor",
      "reference": "13",
      "name": "Coral Dark",
      "hex": "#b60800",
      "rgb": [
        182,
        8,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:38",
      "brandId": "anchor",
      "reference": "38",
      "name": "Dusty Pink",
      "hex": "#b64758",
      "rgb": [
        182,
        71,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:326",
      "brandId": "anchor",
      "reference": "326",
      "name": "Orange Spice Dark",
      "hex": "#b64c1f",
      "rgb": [
        182,
        76,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1008",
      "brandId": "anchor",
      "reference": "1008",
      "name": "Flesh Medium",
      "hex": "#b68571",
      "rgb": [
        182,
        133,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:117",
      "brandId": "anchor",
      "reference": "117",
      "name": "Blue Violet Very Light",
      "hex": "#b6c3e5",
      "rgb": [
        182,
        195,
        229
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1032",
      "brandId": "anchor",
      "reference": "1032",
      "name": "Antique Blue Very Light",
      "hex": "#b6c7d5",
      "rgb": [
        182,
        199,
        213
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1013",
      "brandId": "anchor",
      "reference": "1013",
      "name": "Terracotta",
      "hex": "#b8674c",
      "rgb": [
        184,
        103,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:847",
      "brandId": "anchor",
      "reference": "847",
      "name": "Grey Blue Ultra Very Light",
      "hex": "#b8c3c6",
      "rgb": [
        184,
        195,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:895",
      "brandId": "anchor",
      "reference": "895",
      "name": "Shell Pink Medium",
      "hex": "#b97472",
      "rgb": [
        185,
        116,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:363",
      "brandId": "anchor",
      "reference": "363",
      "name": "Golden Brown Light",
      "hex": "#b98347",
      "rgb": [
        185,
        131,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:343",
      "brandId": "anchor",
      "reference": "343",
      "name": "Antique Blue Light",
      "hex": "#b9c0cd",
      "rgb": [
        185,
        192,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:42",
      "brandId": "anchor",
      "reference": "42",
      "name": "Rose Very Dark",
      "hex": "#bb4059",
      "rgb": [
        187,
        64,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:368",
      "brandId": "anchor",
      "reference": "368",
      "name": "Coffee",
      "hex": "#bb8f6e",
      "rgb": [
        187,
        143,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1060",
      "brandId": "anchor",
      "reference": "1060",
      "name": "Teal Ultra Light",
      "hex": "#bbe3ea",
      "rgb": [
        187,
        227,
        234
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:887",
      "brandId": "anchor",
      "reference": "887",
      "name": "Yellow Beige Medium",
      "hex": "#bcae84",
      "rgb": [
        188,
        174,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:858",
      "brandId": "anchor",
      "reference": "858",
      "name": "Fern Green Very Light",
      "hex": "#bcc9b1",
      "rgb": [
        188,
        201,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:231",
      "brandId": "anchor",
      "reference": "231",
      "name": "Shell Grey Light",
      "hex": "#bdaaa7",
      "rgb": [
        189,
        170,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:120",
      "brandId": "anchor",
      "reference": "120",
      "name": "Blue Purple Very Light",
      "hex": "#bfcfe9",
      "rgb": [
        191,
        207,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1023",
      "brandId": "anchor",
      "reference": "1023",
      "name": "Dusty Rose",
      "hex": "#c1606a",
      "rgb": [
        193,
        96,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:969",
      "brandId": "anchor",
      "reference": "969",
      "name": "Dusty Violet Medium",
      "hex": "#c18c8d",
      "rgb": [
        193,
        140,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:90",
      "brandId": "anchor",
      "reference": "90",
      "name": "Purple Light",
      "hex": "#c197b5",
      "rgb": [
        193,
        151,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:234",
      "brandId": "anchor",
      "reference": "234",
      "name": "Pearl Grey Very Light",
      "hex": "#c1bfc4",
      "rgb": [
        193,
        191,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:372",
      "brandId": "anchor",
      "reference": "372",
      "name": "Tan",
      "hex": "#c29f6c",
      "rgb": [
        194,
        159,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:128",
      "brandId": "anchor",
      "reference": "128",
      "name": "Sky Blue Very Light",
      "hex": "#c2d6f8",
      "rgb": [
        194,
        214,
        248
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:29",
      "brandId": "anchor",
      "reference": "29",
      "name": "Baby Pink Ultra Very Dark",
      "hex": "#c31e37",
      "rgb": [
        195,
        30,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:87",
      "brandId": "anchor",
      "reference": "87",
      "name": "Mauve",
      "hex": "#c34b99",
      "rgb": [
        195,
        75,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:62",
      "brandId": "anchor",
      "reference": "62",
      "name": "Cerise Light",
      "hex": "#c34c84",
      "rgb": [
        195,
        76,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:890",
      "brandId": "anchor",
      "reference": "890",
      "name": "Old Gold Medium",
      "hex": "#c38531",
      "rgb": [
        195,
        133,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:388",
      "brandId": "anchor",
      "reference": "388",
      "name": "Beige Brown Light",
      "hex": "#c3b1a7",
      "rgb": [
        195,
        177,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:956",
      "brandId": "anchor",
      "reference": "956",
      "name": "Yellow Green Ultra Very Light",
      "hex": "#c4bc96",
      "rgb": [
        196,
        188,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:842",
      "brandId": "anchor",
      "reference": "842",
      "name": "Khaki Green Light",
      "hex": "#c4be9c",
      "rgb": [
        196,
        190,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:213",
      "brandId": "anchor",
      "reference": "213",
      "name": "Misty Green Ultra Very Light",
      "hex": "#c5c7b6",
      "rgb": [
        197,
        199,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:975",
      "brandId": "anchor",
      "reference": "975",
      "name": "Blue Very Light",
      "hex": "#c5cdd6",
      "rgb": [
        197,
        205,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:41",
      "brandId": "anchor",
      "reference": "41",
      "name": "Rose Dark",
      "hex": "#c64e67",
      "rgb": [
        198,
        78,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:9046",
      "brandId": "anchor",
      "reference": "9046",
      "name": "Christmas Red Bright",
      "hex": "#c82300",
      "rgb": [
        200,
        35,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:883",
      "brandId": "anchor",
      "reference": "883",
      "name": "Antique Mahogany",
      "hex": "#c8755a",
      "rgb": [
        200,
        117,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:9159",
      "brandId": "anchor",
      "reference": "9159",
      "name": "Baby Blue Very Light",
      "hex": "#c8f1ff",
      "rgb": [
        200,
        241,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:96",
      "brandId": "anchor",
      "reference": "96",
      "name": "Violet Very Light",
      "hex": "#c98cb8",
      "rgb": [
        201,
        140,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:334",
      "brandId": "anchor",
      "reference": "334",
      "name": "Orange Red Very Dark",
      "hex": "#ca3c00",
      "rgb": [
        202,
        60,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1016",
      "brandId": "anchor",
      "reference": "1016",
      "name": "Antique Mauve Very Light",
      "hex": "#ca97a1",
      "rgb": [
        202,
        151,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1082",
      "brandId": "anchor",
      "reference": "1082",
      "name": "Taupe Medium Light",
      "hex": "#caae8c",
      "rgb": [
        202,
        174,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:338",
      "brandId": "anchor",
      "reference": "338",
      "name": "Mahogany Light",
      "hex": "#cc6144",
      "rgb": [
        204,
        97,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:852",
      "brandId": "anchor",
      "reference": "852",
      "name": "Avocado Ultra Very Light",
      "hex": "#ccc2a5",
      "rgb": [
        204,
        194,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:830",
      "brandId": "anchor",
      "reference": "830",
      "name": "Drab Brown Very Light",
      "hex": "#ccc3bc",
      "rgb": [
        204,
        195,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:35",
      "brandId": "anchor",
      "reference": "35",
      "name": "Pink Bright Dark",
      "hex": "#ce4060",
      "rgb": [
        206,
        64,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:894",
      "brandId": "anchor",
      "reference": "894",
      "name": "Shell Pink Medium Light",
      "hex": "#d19291",
      "rgb": [
        209,
        146,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:158",
      "brandId": "anchor",
      "reference": "158",
      "name": "Baby Blue Ultra Very Light",
      "hex": "#d1f3f5",
      "rgb": [
        209,
        243,
        245
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:335",
      "brandId": "anchor",
      "reference": "335",
      "name": "Orange Red",
      "hex": "#d23918",
      "rgb": [
        210,
        57,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:57",
      "brandId": "anchor",
      "reference": "57",
      "name": "Pink Mauve Medium Dark",
      "hex": "#d24a8a",
      "rgb": [
        210,
        74,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1031",
      "brandId": "anchor",
      "reference": "1031",
      "name": "Antique Blue Ultra Very Light",
      "hex": "#d2e0f0",
      "rgb": [
        210,
        224,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:46",
      "brandId": "anchor",
      "reference": "46",
      "name": "Christmas Red Light",
      "hex": "#d32400",
      "rgb": [
        211,
        36,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:868",
      "brandId": "anchor",
      "reference": "868",
      "name": "Peach Flesh",
      "hex": "#d38670",
      "rgb": [
        211,
        134,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:347",
      "brandId": "anchor",
      "reference": "347",
      "name": "Chocolate Light",
      "hex": "#d3a580",
      "rgb": [
        211,
        165,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:886",
      "brandId": "anchor",
      "reference": "886",
      "name": "Yellow Beige Light",
      "hex": "#d3c3a7",
      "rgb": [
        211,
        195,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1098",
      "brandId": "anchor",
      "reference": "1098",
      "name": "Red",
      "hex": "#d41829",
      "rgb": [
        212,
        24,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:333",
      "brandId": "anchor",
      "reference": "333",
      "name": "Orange Very Dark",
      "hex": "#d44805",
      "rgb": [
        212,
        72,
        5
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:397",
      "brandId": "anchor",
      "reference": "397",
      "name": "Pearl Grey Ultra Very Light",
      "hex": "#d5d4c9",
      "rgb": [
        213,
        212,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:307",
      "brandId": "anchor",
      "reference": "307",
      "name": "Topaz Light",
      "hex": "#d68017",
      "rgb": [
        214,
        128,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:893",
      "brandId": "anchor",
      "reference": "893",
      "name": "Shell Pink Light",
      "hex": "#d7aaa8",
      "rgb": [
        215,
        170,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:342",
      "brandId": "anchor",
      "reference": "342",
      "name": "Lavender Ultra Very Light",
      "hex": "#d7b3e0",
      "rgb": [
        215,
        179,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:278",
      "brandId": "anchor",
      "reference": "278",
      "name": "Lime Green Light",
      "hex": "#d7cf6d",
      "rgb": [
        215,
        207,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1037",
      "brandId": "anchor",
      "reference": "1037",
      "name": "Blue Ultra Very Light",
      "hex": "#d7e5ea",
      "rgb": [
        215,
        229,
        234
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1042",
      "brandId": "anchor",
      "reference": "1042",
      "name": "Sea Foam Green Very Light",
      "hex": "#d7f0d6",
      "rgb": [
        215,
        240,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:11",
      "brandId": "anchor",
      "reference": "11",
      "name": "Coral Medium",
      "hex": "#d8574f",
      "rgb": [
        216,
        87,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:4146",
      "brandId": "anchor",
      "reference": "4146",
      "name": "Flesh Light",
      "hex": "#d89d8c",
      "rgb": [
        216,
        157,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:942",
      "brandId": "anchor",
      "reference": "942",
      "name": "Tan Light",
      "hex": "#d9ab82",
      "rgb": [
        217,
        171,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:367",
      "brandId": "anchor",
      "reference": "367",
      "name": "Coffee Light",
      "hex": "#d9b490",
      "rgb": [
        217,
        180,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:95",
      "brandId": "anchor",
      "reference": "95",
      "name": "Violet Ultra Very Light",
      "hex": "#d9bbdd",
      "rgb": [
        217,
        187,
        221
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:387",
      "brandId": "anchor",
      "reference": "387",
      "name": "Beige Brown Very Light",
      "hex": "#dad2c1",
      "rgb": [
        218,
        210,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1043",
      "brandId": "anchor",
      "reference": "1043",
      "name": "Pistachio Green Very Light",
      "hex": "#daf6ca",
      "rgb": [
        218,
        246,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:28",
      "brandId": "anchor",
      "reference": "28",
      "name": "Baby Pink Very Dark",
      "hex": "#db3e56",
      "rgb": [
        219,
        62,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:390",
      "brandId": "anchor",
      "reference": "390",
      "name": "Beige Grey Light",
      "hex": "#dbd6c9",
      "rgb": [
        219,
        214,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1002",
      "brandId": "anchor",
      "reference": "1002",
      "name": "Golden Brown Very Light",
      "hex": "#dd7841",
      "rgb": [
        221,
        120,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1047",
      "brandId": "anchor",
      "reference": "1047",
      "name": "Copper Light",
      "hex": "#dd9a6e",
      "rgb": [
        221,
        154,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:60",
      "brandId": "anchor",
      "reference": "60",
      "name": "Cerise Ultra Very Light",
      "hex": "#dd9cb4",
      "rgb": [
        221,
        156,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:324",
      "brandId": "anchor",
      "reference": "324",
      "name": "Orange Spice Medium",
      "hex": "#de6734",
      "rgb": [
        222,
        103,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:337",
      "brandId": "anchor",
      "reference": "337",
      "name": "Mahogany Very Light",
      "hex": "#e07b5e",
      "rgb": [
        224,
        123,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:778",
      "brandId": "anchor",
      "reference": "778",
      "name": "Flesh Very Light",
      "hex": "#e0b49d",
      "rgb": [
        224,
        180,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:332",
      "brandId": "anchor",
      "reference": "332",
      "name": "Orange Dark",
      "hex": "#e1520e",
      "rgb": [
        225,
        82,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:54",
      "brandId": "anchor",
      "reference": "54",
      "name": "Pink Very Dark",
      "hex": "#e1527d",
      "rgb": [
        225,
        82,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:366",
      "brandId": "anchor",
      "reference": "366",
      "name": "Coffee Very Light",
      "hex": "#e1c6ad",
      "rgb": [
        225,
        198,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1022",
      "brandId": "anchor",
      "reference": "1022",
      "name": "Dusty Rose Light",
      "hex": "#e3818b",
      "rgb": [
        227,
        129,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1021",
      "brandId": "anchor",
      "reference": "1021",
      "name": "Dusty Rose Very Light",
      "hex": "#e3939b",
      "rgb": [
        227,
        147,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:881",
      "brandId": "anchor",
      "reference": "881",
      "name": "Cream Dark",
      "hex": "#e3bb92",
      "rgb": [
        227,
        187,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:925",
      "brandId": "anchor",
      "reference": "925",
      "name": "Yellow Green Very Dark",
      "hex": "#e45634",
      "rgb": [
        228,
        86,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:376",
      "brandId": "anchor",
      "reference": "376",
      "name": "Dusty Flesh Light",
      "hex": "#e4bdb0",
      "rgb": [
        228,
        189,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:304",
      "brandId": "anchor",
      "reference": "304",
      "name": "Burnt Orange",
      "hex": "#e58300",
      "rgb": [
        229,
        131,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1201",
      "brandId": "anchor",
      "reference": "1201",
      "name": "Desert Sand Light",
      "hex": "#e5ac8d",
      "rgb": [
        229,
        172,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:880",
      "brandId": "anchor",
      "reference": "880",
      "name": "Cream Medium",
      "hex": "#e5c0a4",
      "rgb": [
        229,
        192,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:75",
      "brandId": "anchor",
      "reference": "75",
      "name": "Plum Light",
      "hex": "#e68ba8",
      "rgb": [
        230,
        139,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:9575",
      "brandId": "anchor",
      "reference": "9575",
      "name": "Terracotta Light",
      "hex": "#e68e71",
      "rgb": [
        230,
        142,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:882",
      "brandId": "anchor",
      "reference": "882",
      "name": "Antique Mahogany Light",
      "hex": "#e69e85",
      "rgb": [
        230,
        158,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:361",
      "brandId": "anchor",
      "reference": "361",
      "name": "Tan Very Light",
      "hex": "#e7c197",
      "rgb": [
        231,
        193,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:316",
      "brandId": "anchor",
      "reference": "316",
      "name": "Tangerine Dark",
      "hex": "#e86027",
      "rgb": [
        232,
        96,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:323",
      "brandId": "anchor",
      "reference": "323",
      "name": "Orange Spice Light",
      "hex": "#e87d4f",
      "rgb": [
        232,
        125,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:10",
      "brandId": "anchor",
      "reference": "10",
      "name": "Coral Light",
      "hex": "#e97c75",
      "rgb": [
        233,
        124,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:933",
      "brandId": "anchor",
      "reference": "933",
      "name": "Dusty Flesh Very Light",
      "hex": "#e9d6c7",
      "rgb": [
        233,
        214,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:276",
      "brandId": "anchor",
      "reference": "276",
      "name": "Coffee Ultra Very Light",
      "hex": "#e9debe",
      "rgb": [
        233,
        222,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:259",
      "brandId": "anchor",
      "reference": "259",
      "name": "Laurel Green Very Light",
      "hex": "#e9f8c7",
      "rgb": [
        233,
        248,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:86",
      "brandId": "anchor",
      "reference": "86",
      "name": "Mauve Medium Light",
      "hex": "#ea7bce",
      "rgb": [
        234,
        123,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:311",
      "brandId": "anchor",
      "reference": "311",
      "name": "Tangerine Very Light",
      "hex": "#eab069",
      "rgb": [
        234,
        176,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:27",
      "brandId": "anchor",
      "reference": "27",
      "name": "Baby Pink Dark",
      "hex": "#eb596e",
      "rgb": [
        235,
        89,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1080",
      "brandId": "anchor",
      "reference": "1080",
      "name": "Taupe Ultra Light",
      "hex": "#ebc7a3",
      "rgb": [
        235,
        199,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:9",
      "brandId": "anchor",
      "reference": "9",
      "name": "Coral Very Light",
      "hex": "#ec887d",
      "rgb": [
        236,
        136,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:25",
      "brandId": "anchor",
      "reference": "25",
      "name": "Baby Pink",
      "hex": "#ec9eae",
      "rgb": [
        236,
        158,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:31",
      "brandId": "anchor",
      "reference": "31",
      "name": "Pink Bright Light",
      "hex": "#ee7c8d",
      "rgb": [
        238,
        124,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:40",
      "brandId": "anchor",
      "reference": "40",
      "name": "Rose",
      "hex": "#ef708a",
      "rgb": [
        239,
        112,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:74",
      "brandId": "anchor",
      "reference": "74",
      "name": "Plum Very Light",
      "hex": "#efa1bb",
      "rgb": [
        239,
        161,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:885",
      "brandId": "anchor",
      "reference": "885",
      "name": "Yellow Beige Very Light",
      "hex": "#efe4c7",
      "rgb": [
        239,
        228,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:66",
      "brandId": "anchor",
      "reference": "66",
      "name": "Dusty Plum Light",
      "hex": "#f08bbb",
      "rgb": [
        240,
        139,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:36",
      "brandId": "anchor",
      "reference": "36",
      "name": "Pink Bright Very Light",
      "hex": "#f092a0",
      "rgb": [
        240,
        146,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:271",
      "brandId": "anchor",
      "reference": "271",
      "name": "Baby Pink Ultra Very L",
      "hex": "#f0cfcf",
      "rgb": [
        240,
        207,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1011",
      "brandId": "anchor",
      "reference": "1011",
      "name": "Peach Flesh Very Light",
      "hex": "#f0dac4",
      "rgb": [
        240,
        218,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:291",
      "brandId": "anchor",
      "reference": "291",
      "name": "Canary Yellow Bright",
      "hex": "#f1b007",
      "rgb": [
        241,
        176,
        7
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:297",
      "brandId": "anchor",
      "reference": "297",
      "name": "Golden Yellow Medium",
      "hex": "#f1b10a",
      "rgb": [
        241,
        177,
        10
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1012",
      "brandId": "anchor",
      "reference": "1012",
      "name": "Flesh",
      "hex": "#f1bba4",
      "rgb": [
        241,
        187,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:26",
      "brandId": "anchor",
      "reference": "26",
      "name": "Baby Pink Medium",
      "hex": "#f27c88",
      "rgb": [
        242,
        124,
        136
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1020",
      "brandId": "anchor",
      "reference": "1020",
      "name": "Dusty Rose Ultra Very Light",
      "hex": "#f2b7bc",
      "rgb": [
        242,
        183,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1026",
      "brandId": "anchor",
      "reference": "1026",
      "name": "Dusty Violet Very Light",
      "hex": "#f2d2d3",
      "rgb": [
        242,
        210,
        211
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:103",
      "brandId": "anchor",
      "reference": "103",
      "name": "Purple Very Light",
      "hex": "#f2d7ea",
      "rgb": [
        242,
        215,
        234
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:306",
      "brandId": "anchor",
      "reference": "306",
      "name": "Gold",
      "hex": "#f39d35",
      "rgb": [
        243,
        157,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:336",
      "brandId": "anchor",
      "reference": "336",
      "name": "Mahogany Ultra Very Light",
      "hex": "#f39e7e",
      "rgb": [
        243,
        158,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:926",
      "brandId": "anchor",
      "reference": "926",
      "name": "Beige Brown Ultra Very Light",
      "hex": "#f3ecdf",
      "rgb": [
        243,
        236,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:49",
      "brandId": "anchor",
      "reference": "49",
      "name": "Pink Light",
      "hex": "#f4aec5",
      "rgb": [
        244,
        174,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:968",
      "brandId": "anchor",
      "reference": "968",
      "name": "Dusty Violet Light",
      "hex": "#f4c0c1",
      "rgb": [
        244,
        192,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:892",
      "brandId": "anchor",
      "reference": "892",
      "name": "Shell Pink Very Light",
      "hex": "#f4dbcf",
      "rgb": [
        244,
        219,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:330",
      "brandId": "anchor",
      "reference": "330",
      "name": "Orange",
      "hex": "#f66f1e",
      "rgb": [
        246,
        111,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:314",
      "brandId": "anchor",
      "reference": "314",
      "name": "Tangerine Medium",
      "hex": "#f68033",
      "rgb": [
        246,
        128,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:295",
      "brandId": "anchor",
      "reference": "295",
      "name": "Golden Yellow Medium Light",
      "hex": "#f6ce42",
      "rgb": [
        246,
        206,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:313",
      "brandId": "anchor",
      "reference": "313",
      "name": "Tangerine Light",
      "hex": "#f79759",
      "rgb": [
        247,
        151,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:298",
      "brandId": "anchor",
      "reference": "298",
      "name": "Golden Yellow Dark",
      "hex": "#f7a613",
      "rgb": [
        247,
        166,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:891",
      "brandId": "anchor",
      "reference": "891",
      "name": "Old Gold Light",
      "hex": "#f7c168",
      "rgb": [
        247,
        193,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:293",
      "brandId": "anchor",
      "reference": "293",
      "name": "Golden Yellow Light",
      "hex": "#f8d86c",
      "rgb": [
        248,
        216,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:55",
      "brandId": "anchor",
      "reference": "55",
      "name": "Pink Mauve Light",
      "hex": "#f99cc8",
      "rgb": [
        249,
        156,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:33",
      "brandId": "anchor",
      "reference": "33",
      "name": "Pink Bright",
      "hex": "#fa7995",
      "rgb": [
        250,
        121,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:289",
      "brandId": "anchor",
      "reference": "289",
      "name": "Lemon Medium",
      "hex": "#fae555",
      "rgb": [
        250,
        229,
        85
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:386",
      "brandId": "anchor",
      "reference": "386",
      "name": "Yellow Ultra Very Light",
      "hex": "#faf4c9",
      "rgb": [
        250,
        244,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:2",
      "brandId": "anchor",
      "reference": "2",
      "name": "White",
      "hex": "#fafafa",
      "rgb": [
        250,
        250,
        250
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:329",
      "brandId": "anchor",
      "reference": "329",
      "name": "Peach Dark",
      "hex": "#fb7846",
      "rgb": [
        251,
        120,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:328",
      "brandId": "anchor",
      "reference": "328",
      "name": "Peach Medium",
      "hex": "#fb8366",
      "rgb": [
        251,
        131,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:24",
      "brandId": "anchor",
      "reference": "24",
      "name": "Baby Pink Light",
      "hex": "#fba8ab",
      "rgb": [
        251,
        168,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:52",
      "brandId": "anchor",
      "reference": "52",
      "name": "Pink Dark",
      "hex": "#fc7da3",
      "rgb": [
        252,
        125,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1094",
      "brandId": "anchor",
      "reference": "1094",
      "name": "Pink Medium Light",
      "hex": "#fc9ec5",
      "rgb": [
        252,
        158,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:290",
      "brandId": "anchor",
      "reference": "290",
      "name": "Lemon Dark",
      "hex": "#fcc318",
      "rgb": [
        252,
        195,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:300",
      "brandId": "anchor",
      "reference": "300",
      "name": "Yellow Very Light",
      "hex": "#fce6ab",
      "rgb": [
        252,
        230,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:8",
      "brandId": "anchor",
      "reference": "8",
      "name": "Peach Light",
      "hex": "#fdac90",
      "rgb": [
        253,
        172,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:48",
      "brandId": "anchor",
      "reference": "48",
      "name": "Pink Very Light",
      "hex": "#fdbcd1",
      "rgb": [
        253,
        188,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:305",
      "brandId": "anchor",
      "reference": "305",
      "name": "Topaz Very Light",
      "hex": "#fdc868",
      "rgb": [
        253,
        200,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:23",
      "brandId": "anchor",
      "reference": "23",
      "name": "Baby Pink Very Light",
      "hex": "#fdc8c9",
      "rgb": [
        253,
        200,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:303",
      "brandId": "anchor",
      "reference": "303",
      "name": "Burnt Orange Medium",
      "hex": "#ff9413",
      "rgb": [
        255,
        148,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:50",
      "brandId": "anchor",
      "reference": "50",
      "name": "Pink",
      "hex": "#ff9fbc",
      "rgb": [
        255,
        159,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:85",
      "brandId": "anchor",
      "reference": "85",
      "name": "Mauve Very Light",
      "hex": "#fface9",
      "rgb": [
        255,
        172,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:302",
      "brandId": "anchor",
      "reference": "302",
      "name": "Burnt Orange Light",
      "hex": "#ffb552",
      "rgb": [
        255,
        181,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:6",
      "brandId": "anchor",
      "reference": "6",
      "name": "Peach Very Light",
      "hex": "#ffc2b1",
      "rgb": [
        255,
        194,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:73",
      "brandId": "anchor",
      "reference": "73",
      "name": "Plum Ultra Very Light",
      "hex": "#ffc5d7",
      "rgb": [
        255,
        197,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:301",
      "brandId": "anchor",
      "reference": "301",
      "name": "Burnt Orange Very Light",
      "hex": "#ffcd7c",
      "rgb": [
        255,
        205,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1010",
      "brandId": "anchor",
      "reference": "1010",
      "name": "Copper Very Light",
      "hex": "#ffdabb",
      "rgb": [
        255,
        218,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1009",
      "brandId": "anchor",
      "reference": "1009",
      "name": "Cream",
      "hex": "#ffe3c7",
      "rgb": [
        255,
        227,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:292",
      "brandId": "anchor",
      "reference": "292",
      "name": "Golden Brown Very Light",
      "hex": "#ffe88f",
      "rgb": [
        255,
        232,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:288",
      "brandId": "anchor",
      "reference": "288",
      "name": "Lemon Light",
      "hex": "#fff472",
      "rgb": [
        255,
        244,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:275",
      "brandId": "anchor",
      "reference": "275",
      "name": "Off White",
      "hex": "#fff8ce",
      "rgb": [
        255,
        248,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "anchor:1",
      "brandId": "anchor",
      "reference": "1",
      "name": "White Bright",
      "hex": "#ffffff",
      "rgb": [
        255,
        255,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1819",
      "brandId": "ariadna",
      "reference": "1819",
      "name": "black",
      "hex": "#000000",
      "rgb": [
        0,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1618",
      "brandId": "ariadna",
      "reference": "1618",
      "name": "blue ultra dark",
      "hex": "#005a82",
      "rgb": [
        0,
        90,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1668",
      "brandId": "ariadna",
      "reference": "1668",
      "name": "soiled emerald ultra dark",
      "hex": "#006431",
      "rgb": [
        0,
        100,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1644",
      "brandId": "ariadna",
      "reference": "1644",
      "name": "marine very dark",
      "hex": "#006464",
      "rgb": [
        0,
        100,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1682",
      "brandId": "ariadna",
      "reference": "1682",
      "name": "green dark",
      "hex": "#008c46",
      "rgb": [
        0,
        140,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1620A",
      "brandId": "ariadna",
      "reference": "1620A",
      "name": "electric blue dark",
      "hex": "#008dd2",
      "rgb": [
        0,
        141,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1662",
      "brandId": "ariadna",
      "reference": "1662",
      "name": "turquoise green very dark",
      "hex": "#009670",
      "rgb": [
        0,
        150,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1667",
      "brandId": "ariadna",
      "reference": "1667",
      "name": "soiled emerald dark",
      "hex": "#00a064",
      "rgb": [
        0,
        160,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1666",
      "brandId": "ariadna",
      "reference": "1666",
      "name": "soiled emerald",
      "hex": "#00b478",
      "rgb": [
        0,
        180,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1655",
      "brandId": "ariadna",
      "reference": "1655",
      "name": "turquoise ultra dark",
      "hex": "#00b4c8",
      "rgb": [
        0,
        180,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1620",
      "brandId": "ariadna",
      "reference": "1620",
      "name": "blue dark",
      "hex": "#00b4d2",
      "rgb": [
        0,
        180,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1661",
      "brandId": "ariadna",
      "reference": "1661",
      "name": "turquoise green dark",
      "hex": "#00c896",
      "rgb": [
        0,
        200,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1660",
      "brandId": "ariadna",
      "reference": "1660",
      "name": "turquoise green",
      "hex": "#00dcaa",
      "rgb": [
        0,
        220,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1653",
      "brandId": "ariadna",
      "reference": "1653",
      "name": "turquoise dark",
      "hex": "#00dcd2",
      "rgb": [
        0,
        220,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1678",
      "brandId": "ariadna",
      "reference": "1678",
      "name": "aquamarine dark",
      "hex": "#028200",
      "rgb": [
        2,
        130,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1613",
      "brandId": "ariadna",
      "reference": "1613",
      "name": "blue ultra dark",
      "hex": "#055a96",
      "rgb": [
        5,
        90,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1612",
      "brandId": "ariadna",
      "reference": "1612",
      "name": "blue very dark",
      "hex": "#0896f9",
      "rgb": [
        8,
        150,
        249
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1654",
      "brandId": "ariadna",
      "reference": "1654",
      "name": "turquoise very dark",
      "hex": "#08cad2",
      "rgb": [
        8,
        202,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1689",
      "brandId": "ariadna",
      "reference": "1689",
      "name": "green ultra dark",
      "hex": "#0b4604",
      "rgb": [
        11,
        70,
        4
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1688",
      "brandId": "ariadna",
      "reference": "1688",
      "name": "green very dark",
      "hex": "#126408",
      "rgb": [
        18,
        100,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1657A",
      "brandId": "ariadna",
      "reference": "1657A",
      "name": "teal green dark",
      "hex": "#1a8280",
      "rgb": [
        26,
        130,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1687",
      "brandId": "ariadna",
      "reference": "1687",
      "name": "green dark",
      "hex": "#1b820a",
      "rgb": [
        27,
        130,
        10
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1626",
      "brandId": "ariadna",
      "reference": "1626",
      "name": "emerald green dark",
      "hex": "#1e1e50",
      "rgb": [
        30,
        30,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1606",
      "brandId": "ariadna",
      "reference": "1606",
      "name": "blue violet ultra dark",
      "hex": "#1e1e78",
      "rgb": [
        30,
        30,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1629",
      "brandId": "ariadna",
      "reference": "1629",
      "name": "navy blue",
      "hex": "#213882",
      "rgb": [
        33,
        56,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1674",
      "brandId": "ariadna",
      "reference": "1674",
      "name": "soiled green dark",
      "hex": "#27502e",
      "rgb": [
        39,
        80,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1627",
      "brandId": "ariadna",
      "reference": "1627",
      "name": "emerald green very dark",
      "hex": "#28285a",
      "rgb": [
        40,
        40,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1630",
      "brandId": "ariadna",
      "reference": "1630",
      "name": "navy blue ultra dark",
      "hex": "#2a2d50",
      "rgb": [
        42,
        45,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1786",
      "brandId": "ariadna",
      "reference": "1786",
      "name": "black browne",
      "hex": "#2d1a09",
      "rgb": [
        45,
        26,
        9
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1714",
      "brandId": "ariadna",
      "reference": "1714",
      "name": "olive green ultra dark",
      "hex": "#315025",
      "rgb": [
        49,
        80,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1701",
      "brandId": "ariadna",
      "reference": "1701",
      "name": "parrot green ultra dark",
      "hex": "#318229",
      "rgb": [
        49,
        130,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1642",
      "brandId": "ariadna",
      "reference": "1642",
      "name": "sea green",
      "hex": "#329b91",
      "rgb": [
        50,
        155,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1664A",
      "brandId": "ariadna",
      "reference": "1664A",
      "name": "jade dark",
      "hex": "#338c68",
      "rgb": [
        51,
        140,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1643",
      "brandId": "ariadna",
      "reference": "1643",
      "name": "sea blue dark",
      "hex": "#358c8c",
      "rgb": [
        53,
        140,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1782",
      "brandId": "ariadna",
      "reference": "1782",
      "name": "golden brown ultra dark",
      "hex": "#372720",
      "rgb": [
        55,
        39,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1624",
      "brandId": "ariadna",
      "reference": "1624",
      "name": "cornflower blue dark",
      "hex": "#3764b1",
      "rgb": [
        55,
        100,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1658",
      "brandId": "ariadna",
      "reference": "1658",
      "name": "sea green",
      "hex": "#38c896",
      "rgb": [
        56,
        200,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1638A",
      "brandId": "ariadna",
      "reference": "1638A",
      "name": "antique blue very dark",
      "hex": "#3b618c",
      "rgb": [
        59,
        97,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1625",
      "brandId": "ariadna",
      "reference": "1625",
      "name": "cornflower blue very dark",
      "hex": "#3c3c8f",
      "rgb": [
        60,
        60,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1638",
      "brandId": "ariadna",
      "reference": "1638",
      "name": "antique blue ultra dark",
      "hex": "#3c5a6e",
      "rgb": [
        60,
        90,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1672",
      "brandId": "ariadna",
      "reference": "1672",
      "name": "turquoise ultra very dark",
      "hex": "#3c643c",
      "rgb": [
        60,
        100,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1617",
      "brandId": "ariadna",
      "reference": "1617",
      "name": "blue very dark",
      "hex": "#408bb6",
      "rgb": [
        64,
        139,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1649",
      "brandId": "ariadna",
      "reference": "1649",
      "name": "gray green ultra dark",
      "hex": "#414d50",
      "rgb": [
        65,
        77,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1636",
      "brandId": "ariadna",
      "reference": "1636",
      "name": "steel grey dark",
      "hex": "#41505d",
      "rgb": [
        65,
        80,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1700",
      "brandId": "ariadna",
      "reference": "1700",
      "name": "parrot green very dark",
      "hex": "#41b430",
      "rgb": [
        65,
        180,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1707",
      "brandId": "ariadna",
      "reference": "1707",
      "name": "khaki green very dark",
      "hex": "#42521a",
      "rgb": [
        66,
        82,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1733",
      "brandId": "ariadna",
      "reference": "1733",
      "name": "hazelnut ultra dark",
      "hex": "#461e0a",
      "rgb": [
        70,
        30,
        10
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1794",
      "brandId": "ariadna",
      "reference": "1794",
      "name": "chocolate",
      "hex": "#46321e",
      "rgb": [
        70,
        50,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1648",
      "brandId": "ariadna",
      "reference": "1648",
      "name": "gray green dark",
      "hex": "#466364",
      "rgb": [
        70,
        99,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1694",
      "brandId": "ariadna",
      "reference": "1694",
      "name": "avocado green dark",
      "hex": "#466432",
      "rgb": [
        70,
        100,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1628",
      "brandId": "ariadna",
      "reference": "1628",
      "name": "royal blue",
      "hex": "#466acc",
      "rgb": [
        70,
        106,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1589",
      "brandId": "ariadna",
      "reference": "1589",
      "name": "violet ultra dark",
      "hex": "#471173",
      "rgb": [
        71,
        17,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1774",
      "brandId": "ariadna",
      "reference": "1774",
      "name": "desert sand ultra dark",
      "hex": "#4b1414",
      "rgb": [
        75,
        20,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1800",
      "brandId": "ariadna",
      "reference": "1800",
      "name": "brown grey very dark",
      "hex": "#4b461e",
      "rgb": [
        75,
        70,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1671A",
      "brandId": "ariadna",
      "reference": "1671A",
      "name": "jade very dark",
      "hex": "#4d897c",
      "rgb": [
        77,
        137,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1785",
      "brandId": "ariadna",
      "reference": "1785",
      "name": "cocoa ultra dark",
      "hex": "#503217",
      "rgb": [
        80,
        50,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1762",
      "brandId": "ariadna",
      "reference": "1762",
      "name": "antique violet medium",
      "hex": "#503737",
      "rgb": [
        80,
        55,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1609",
      "brandId": "ariadna",
      "reference": "1609",
      "name": "blue violet very dark",
      "hex": "#504696",
      "rgb": [
        80,
        70,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1616",
      "brandId": "ariadna",
      "reference": "1616",
      "name": "blue dark",
      "hex": "#50a0c8",
      "rgb": [
        80,
        160,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1818",
      "brandId": "ariadna",
      "reference": "1818",
      "name": "graphite dark",
      "hex": "#535050",
      "rgb": [
        83,
        80,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1637",
      "brandId": "ariadna",
      "reference": "1637",
      "name": "antique blue",
      "hex": "#53788c",
      "rgb": [
        83,
        120,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1652",
      "brandId": "ariadna",
      "reference": "1652",
      "name": "turquoise",
      "hex": "#53e6e6",
      "rgb": [
        83,
        230,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1588",
      "brandId": "ariadna",
      "reference": "1588",
      "name": "violet very dark",
      "hex": "#591396",
      "rgb": [
        89,
        19,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1686B",
      "brandId": "ariadna",
      "reference": "1686B",
      "name": "forest green dark",
      "hex": "#5ba872",
      "rgb": [
        91,
        168,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1781",
      "brandId": "ariadna",
      "reference": "1781",
      "name": "golden brown very dark",
      "hex": "#5e3422",
      "rgb": [
        94,
        52,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1704A",
      "brandId": "ariadna",
      "reference": "1704A",
      "name": "pine green dark",
      "hex": "#5f7548",
      "rgb": [
        95,
        117,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1773",
      "brandId": "ariadna",
      "reference": "1773",
      "name": "desert sand very dark",
      "hex": "#64321a",
      "rgb": [
        100,
        50,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1789",
      "brandId": "ariadna",
      "reference": "1789",
      "name": "drab brown dark",
      "hex": "#64502b",
      "rgb": [
        100,
        80,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1799",
      "brandId": "ariadna",
      "reference": "1799",
      "name": "brown grey dark",
      "hex": "#646432",
      "rgb": [
        100,
        100,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1693",
      "brandId": "ariadna",
      "reference": "1693",
      "name": "avocado green",
      "hex": "#648228",
      "rgb": [
        100,
        130,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1671",
      "brandId": "ariadna",
      "reference": "1671",
      "name": "thyme dark",
      "hex": "#649664",
      "rgb": [
        100,
        150,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1686",
      "brandId": "ariadna",
      "reference": "1686",
      "name": "green",
      "hex": "#64b428",
      "rgb": [
        100,
        180,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1619",
      "brandId": "ariadna",
      "reference": "1619",
      "name": "sky blue",
      "hex": "#64dcff",
      "rgb": [
        100,
        220,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1584",
      "brandId": "ariadna",
      "reference": "1584",
      "name": "plum dark",
      "hex": "#693d65",
      "rgb": [
        105,
        61,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1598A",
      "brandId": "ariadna",
      "reference": "1598A",
      "name": "fuchsia very dark",
      "hex": "#6b0678",
      "rgb": [
        107,
        6,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1681",
      "brandId": "ariadna",
      "reference": "1681",
      "name": "green",
      "hex": "#6ca844",
      "rgb": [
        108,
        168,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1744",
      "brandId": "ariadna",
      "reference": "1744",
      "name": "mahogany dark",
      "hex": "#6e1e05",
      "rgb": [
        110,
        30,
        5
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1817",
      "brandId": "ariadna",
      "reference": "1817",
      "name": "graphite",
      "hex": "#6e645f",
      "rgb": [
        110,
        100,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1713",
      "brandId": "ariadna",
      "reference": "1713",
      "name": "olive green dark",
      "hex": "#6e7828",
      "rgb": [
        110,
        120,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1633",
      "brandId": "ariadna",
      "reference": "1633",
      "name": "antique blue dark",
      "hex": "#6e878c",
      "rgb": [
        110,
        135,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1580",
      "brandId": "ariadna",
      "reference": "1580",
      "name": "antique violet dark",
      "hex": "#704f70",
      "rgb": [
        112,
        79,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1784",
      "brandId": "ariadna",
      "reference": "1784",
      "name": "cocoa very dark",
      "hex": "#734b28",
      "rgb": [
        115,
        75,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1605",
      "brandId": "ariadna",
      "reference": "1605",
      "name": "blue violet dark",
      "hex": "#755abe",
      "rgb": [
        117,
        90,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1573",
      "brandId": "ariadna",
      "reference": "1573",
      "name": "mauve ultra dark",
      "hex": "#782832",
      "rgb": [
        120,
        40,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1772",
      "brandId": "ariadna",
      "reference": "1772",
      "name": "desert sand dark",
      "hex": "#783c28",
      "rgb": [
        120,
        60,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1718",
      "brandId": "ariadna",
      "reference": "1718",
      "name": "golden olive ultra dark",
      "hex": "#786e32",
      "rgb": [
        120,
        110,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1677",
      "brandId": "ariadna",
      "reference": "1677",
      "name": "aquamarine medium",
      "hex": "#78e6a0",
      "rgb": [
        120,
        230,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1583",
      "brandId": "ariadna",
      "reference": "1583",
      "name": "antique rose dark",
      "hex": "#7a5b77",
      "rgb": [
        122,
        91,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1734",
      "brandId": "ariadna",
      "reference": "1734",
      "name": "red copper very dark",
      "hex": "#7d1419",
      "rgb": [
        125,
        20,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1808",
      "brandId": "ariadna",
      "reference": "1808",
      "name": "beaver grey dark",
      "hex": "#7d6e4b",
      "rgb": [
        125,
        110,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1608A",
      "brandId": "ariadna",
      "reference": "1608A",
      "name": "blueberry dark",
      "hex": "#7d74a8",
      "rgb": [
        125,
        116,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1794A",
      "brandId": "ariadna",
      "reference": "1794A",
      "name": "driftwood dark",
      "hex": "#807568",
      "rgb": [
        128,
        117,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1751",
      "brandId": "ariadna",
      "reference": "1751",
      "name": "terracotta very dark",
      "hex": "#821e28",
      "rgb": [
        130,
        30,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1590",
      "brandId": "ariadna",
      "reference": "1590",
      "name": "violet very dark",
      "hex": "#823273",
      "rgb": [
        130,
        50,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1732",
      "brandId": "ariadna",
      "reference": "1732",
      "name": "hazelnut brown dark",
      "hex": "#82501b",
      "rgb": [
        130,
        80,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1812",
      "brandId": "ariadna",
      "reference": "1812",
      "name": "pewter grey dark",
      "hex": "#828064",
      "rgb": [
        130,
        128,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1706",
      "brandId": "ariadna",
      "reference": "1706",
      "name": "khaki green dark",
      "hex": "#828233",
      "rgb": [
        130,
        130,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1615",
      "brandId": "ariadna",
      "reference": "1615",
      "name": "blue",
      "hex": "#82b4ff",
      "rgb": [
        130,
        180,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1699",
      "brandId": "ariadna",
      "reference": "1699",
      "name": "fern green dark",
      "hex": "#82e637",
      "rgb": [
        130,
        230,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1657",
      "brandId": "ariadna",
      "reference": "1657",
      "name": "turquoise green light",
      "hex": "#82fadc",
      "rgb": [
        130,
        250,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1712",
      "brandId": "ariadna",
      "reference": "1712",
      "name": "olive green medium",
      "hex": "#848200",
      "rgb": [
        132,
        130,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1751A",
      "brandId": "ariadna",
      "reference": "1751A",
      "name": "rosewood medium",
      "hex": "#854b57",
      "rgb": [
        133,
        75,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1623",
      "brandId": "ariadna",
      "reference": "1623",
      "name": "cornflower blue light",
      "hex": "#85aad6",
      "rgb": [
        133,
        170,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1717",
      "brandId": "ariadna",
      "reference": "1717",
      "name": "golden olive dark",
      "hex": "#868628",
      "rgb": [
        134,
        134,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1557",
      "brandId": "ariadna",
      "reference": "1557",
      "name": "garnet dark",
      "hex": "#872f3b",
      "rgb": [
        135,
        47,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1571",
      "brandId": "ariadna",
      "reference": "1571",
      "name": "mauve",
      "hex": "#8a1a5b",
      "rgb": [
        138,
        26,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1608C",
      "brandId": "ariadna",
      "reference": "1608C",
      "name": "lavender blue dark",
      "hex": "#8aa1ed",
      "rgb": [
        138,
        161,
        237
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1759",
      "brandId": "ariadna",
      "reference": "1759",
      "name": "red chestnut dark",
      "hex": "#8c0014",
      "rgb": [
        140,
        0,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1803",
      "brandId": "ariadna",
      "reference": "1803",
      "name": "olive gray",
      "hex": "#8c9650",
      "rgb": [
        140,
        150,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1635",
      "brandId": "ariadna",
      "reference": "1635",
      "name": "steel grey light",
      "hex": "#8c9696",
      "rgb": [
        140,
        150,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1647",
      "brandId": "ariadna",
      "reference": "1647",
      "name": "green grey",
      "hex": "#8ca09b",
      "rgb": [
        140,
        160,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1634",
      "brandId": "ariadna",
      "reference": "1634",
      "name": "antique blue light",
      "hex": "#8ca0aa",
      "rgb": [
        140,
        160,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1659",
      "brandId": "ariadna",
      "reference": "1659",
      "name": "sea green light",
      "hex": "#8cdcb4",
      "rgb": [
        140,
        220,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1676",
      "brandId": "ariadna",
      "reference": "1676",
      "name": "aquamarine",
      "hex": "#8ce6aa",
      "rgb": [
        140,
        230,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1591",
      "brandId": "ariadna",
      "reference": "1591",
      "name": "violet",
      "hex": "#8e448e",
      "rgb": [
        142,
        68,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1579A",
      "brandId": "ariadna",
      "reference": "1579A",
      "name": "antique mauve very dark",
      "hex": "#8f4261",
      "rgb": [
        143,
        66,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1572",
      "brandId": "ariadna",
      "reference": "1572",
      "name": "mauve dark",
      "hex": "#910944",
      "rgb": [
        145,
        9,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1731",
      "brandId": "ariadna",
      "reference": "1731",
      "name": "hazelnut",
      "hex": "#91521b",
      "rgb": [
        145,
        82,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1585",
      "brandId": "ariadna",
      "reference": "1585",
      "name": "plum",
      "hex": "#915d8c",
      "rgb": [
        145,
        93,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1651",
      "brandId": "ariadna",
      "reference": "1651",
      "name": "light turquoise",
      "hex": "#91f5ff",
      "rgb": [
        145,
        245,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1691A",
      "brandId": "ariadna",
      "reference": "1691A",
      "name": "moss green dark",
      "hex": "#94b552",
      "rgb": [
        148,
        181,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1594",
      "brandId": "ariadna",
      "reference": "1594",
      "name": "heather very dark",
      "hex": "#954075",
      "rgb": [
        149,
        64,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1758",
      "brandId": "ariadna",
      "reference": "1758",
      "name": "red chestnut medium",
      "hex": "#962128",
      "rgb": [
        150,
        33,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1743",
      "brandId": "ariadna",
      "reference": "1743",
      "name": "mahogany medium",
      "hex": "#96370e",
      "rgb": [
        150,
        55,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1771",
      "brandId": "ariadna",
      "reference": "1771",
      "name": "desert sand",
      "hex": "#966450",
      "rgb": [
        150,
        100,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1725",
      "brandId": "ariadna",
      "reference": "1725",
      "name": "olive brown ultra dark",
      "hex": "#966e1a",
      "rgb": [
        150,
        110,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1793",
      "brandId": "ariadna",
      "reference": "1793",
      "name": "gray chocolate",
      "hex": "#96824b",
      "rgb": [
        150,
        130,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1816",
      "brandId": "ariadna",
      "reference": "1816",
      "name": "steel dark",
      "hex": "#96918c",
      "rgb": [
        150,
        145,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1685",
      "brandId": "ariadna",
      "reference": "1685",
      "name": "green light",
      "hex": "#96aa4a",
      "rgb": [
        150,
        170,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1670",
      "brandId": "ariadna",
      "reference": "1670",
      "name": "thyme",
      "hex": "#96b482",
      "rgb": [
        150,
        180,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1680",
      "brandId": "ariadna",
      "reference": "1680",
      "name": "christmas green light",
      "hex": "#96c65a",
      "rgb": [
        150,
        198,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1665",
      "brandId": "ariadna",
      "reference": "1665",
      "name": "soiled emerald light",
      "hex": "#96dcb4",
      "rgb": [
        150,
        220,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1611",
      "brandId": "ariadna",
      "reference": "1611",
      "name": "blue light",
      "hex": "#96dcf0",
      "rgb": [
        150,
        220,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1626B",
      "brandId": "ariadna",
      "reference": "1626B",
      "name": "ash blue",
      "hex": "#98a6d1",
      "rgb": [
        152,
        166,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1762A",
      "brandId": "ariadna",
      "reference": "1762A",
      "name": "cocoa medium",
      "hex": "#996d7b",
      "rgb": [
        153,
        109,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1641",
      "brandId": "ariadna",
      "reference": "1641",
      "name": "sea green light",
      "hex": "#9dc2c2",
      "rgb": [
        157,
        194,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1566",
      "brandId": "ariadna",
      "reference": "1566",
      "name": "raspberry dark",
      "hex": "#9e0b3a",
      "rgb": [
        158,
        11,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1780",
      "brandId": "ariadna",
      "reference": "1780",
      "name": "golden brown dark",
      "hex": "#a05028",
      "rgb": [
        160,
        80,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1788",
      "brandId": "ariadna",
      "reference": "1788",
      "name": "drab brown medium",
      "hex": "#a08c3c",
      "rgb": [
        160,
        140,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1792",
      "brandId": "ariadna",
      "reference": "1792",
      "name": "gray chocolate",
      "hex": "#a0965a",
      "rgb": [
        160,
        150,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1797",
      "brandId": "ariadna",
      "reference": "1797",
      "name": "beige grey dark",
      "hex": "#a09664",
      "rgb": [
        160,
        150,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1798",
      "brandId": "ariadna",
      "reference": "1798",
      "name": "beige grey very dark",
      "hex": "#a0995a",
      "rgb": [
        160,
        153,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1686A",
      "brandId": "ariadna",
      "reference": "1686A",
      "name": "forest green",
      "hex": "#a0cf9b",
      "rgb": [
        160,
        207,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1664",
      "brandId": "ariadna",
      "reference": "1664",
      "name": "peas",
      "hex": "#a0f5aa",
      "rgb": [
        160,
        245,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1635A",
      "brandId": "ariadna",
      "reference": "1635A",
      "name": "steel grey medium",
      "hex": "#a5aec7",
      "rgb": [
        165,
        174,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1614",
      "brandId": "ariadna",
      "reference": "1614",
      "name": "blue light",
      "hex": "#a5c8f5",
      "rgb": [
        165,
        200,
        245
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1556",
      "brandId": "ariadna",
      "reference": "1556",
      "name": "garnet medium",
      "hex": "#a63544",
      "rgb": [
        166,
        53,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1608",
      "brandId": "ariadna",
      "reference": "1608",
      "name": "blue violet",
      "hex": "#a680ca",
      "rgb": [
        166,
        128,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1742",
      "brandId": "ariadna",
      "reference": "1742",
      "name": "mahogany",
      "hex": "#aa3e0e",
      "rgb": [
        170,
        62,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1716",
      "brandId": "ariadna",
      "reference": "1716",
      "name": "golden olive",
      "hex": "#aa9634",
      "rgb": [
        170,
        150,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1763",
      "brandId": "ariadna",
      "reference": "1763",
      "name": "antique violet",
      "hex": "#aa968c",
      "rgb": [
        170,
        150,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1804",
      "brandId": "ariadna",
      "reference": "1804",
      "name": "olive gray light",
      "hex": "#aab46e",
      "rgb": [
        170,
        180,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1802",
      "brandId": "ariadna",
      "reference": "1802",
      "name": "olive gray medium",
      "hex": "#aab482",
      "rgb": [
        170,
        180,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1640",
      "brandId": "ariadna",
      "reference": "1640",
      "name": "sea green very light",
      "hex": "#aadce1",
      "rgb": [
        170,
        220,
        225
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1585A",
      "brandId": "ariadna",
      "reference": "1585A",
      "name": "plum medium",
      "hex": "#ab7bbd",
      "rgb": [
        171,
        123,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1811",
      "brandId": "ariadna",
      "reference": "1811",
      "name": "pewter grey",
      "hex": "#aba79e",
      "rgb": [
        171,
        167,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1794B",
      "brandId": "ariadna",
      "reference": "1794B",
      "name": "beige grey ultra dark",
      "hex": "#ada090",
      "rgb": [
        173,
        160,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1592",
      "brandId": "ariadna",
      "reference": "1592",
      "name": "violet light",
      "hex": "#af71ab",
      "rgb": [
        175,
        113,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1750",
      "brandId": "ariadna",
      "reference": "1750",
      "name": "terracotta dark",
      "hex": "#b0403a",
      "rgb": [
        176,
        64,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1608B",
      "brandId": "ariadna",
      "reference": "1608B",
      "name": "lavender",
      "hex": "#b0bbeb",
      "rgb": [
        176,
        187,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1632",
      "brandId": "ariadna",
      "reference": "1632",
      "name": "antique blue very light",
      "hex": "#b0c3d4",
      "rgb": [
        176,
        195,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1577",
      "brandId": "ariadna",
      "reference": "1577",
      "name": "shell pink medium",
      "hex": "#b37586",
      "rgb": [
        179,
        117,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1757",
      "brandId": "ariadna",
      "reference": "1757",
      "name": "red chestnut",
      "hex": "#b43c3c",
      "rgb": [
        180,
        60,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1724",
      "brandId": "ariadna",
      "reference": "1724",
      "name": "olive brown very dark",
      "hex": "#b48c32",
      "rgb": [
        180,
        140,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1807",
      "brandId": "ariadna",
      "reference": "1807",
      "name": "beaver grey medium",
      "hex": "#b4a78c",
      "rgb": [
        180,
        167,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1705",
      "brandId": "ariadna",
      "reference": "1705",
      "name": "khaki green",
      "hex": "#b4b464",
      "rgb": [
        180,
        180,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1604",
      "brandId": "ariadna",
      "reference": "1604",
      "name": "blue violet light",
      "hex": "#b4b4d2",
      "rgb": [
        180,
        180,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1635C",
      "brandId": "ariadna",
      "reference": "1635C",
      "name": "pewter grey medium",
      "hex": "#b4c6cf",
      "rgb": [
        180,
        198,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1692",
      "brandId": "ariadna",
      "reference": "1692",
      "name": "avocado green light",
      "hex": "#b4c85a",
      "rgb": [
        180,
        200,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1622",
      "brandId": "ariadna",
      "reference": "1622",
      "name": "cornflower very light",
      "hex": "#b4c8f5",
      "rgb": [
        180,
        200,
        245
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1698",
      "brandId": "ariadna",
      "reference": "1698",
      "name": "parrot green",
      "hex": "#b4e600",
      "rgb": [
        180,
        230,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1740",
      "brandId": "ariadna",
      "reference": "1740",
      "name": "honey dark",
      "hex": "#b65b12",
      "rgb": [
        182,
        91,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1595",
      "brandId": "ariadna",
      "reference": "1595",
      "name": "heather dark",
      "hex": "#b85893",
      "rgb": [
        184,
        88,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1783",
      "brandId": "ariadna",
      "reference": "1783",
      "name": "cocoa",
      "hex": "#b99f87",
      "rgb": [
        185,
        159,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1770",
      "brandId": "ariadna",
      "reference": "1770",
      "name": "desert sand light",
      "hex": "#be8264",
      "rgb": [
        190,
        130,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1752",
      "brandId": "ariadna",
      "reference": "1752",
      "name": "rosewood dark",
      "hex": "#be826e",
      "rgb": [
        190,
        130,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1684",
      "brandId": "ariadna",
      "reference": "1684",
      "name": "green very light",
      "hex": "#bed25a",
      "rgb": [
        190,
        210,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1650",
      "brandId": "ariadna",
      "reference": "1650",
      "name": "heather very light",
      "hex": "#beffff",
      "rgb": [
        190,
        255,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1555C",
      "brandId": "ariadna",
      "reference": "1555C",
      "name": "salmon pink very dark",
      "hex": "#bf4949",
      "rgb": [
        191,
        73,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1548",
      "brandId": "ariadna",
      "reference": "1548",
      "name": "christmas red",
      "hex": "#c20000",
      "rgb": [
        194,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1563",
      "brandId": "ariadna",
      "reference": "1563",
      "name": "raspberry",
      "hex": "#c24065",
      "rgb": [
        194,
        64,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1530",
      "brandId": "ariadna",
      "reference": "1530",
      "name": "apricot ultra dark",
      "hex": "#c33204",
      "rgb": [
        195,
        50,
        4
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1741",
      "brandId": "ariadna",
      "reference": "1741",
      "name": "mahogany light",
      "hex": "#c35a1e",
      "rgb": [
        195,
        90,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1561",
      "brandId": "ariadna",
      "reference": "1561",
      "name": "cranberry dark",
      "hex": "#c7002e",
      "rgb": [
        199,
        0,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1529",
      "brandId": "ariadna",
      "reference": "1529",
      "name": "apricot very dark",
      "hex": "#c83c00",
      "rgb": [
        200,
        60,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1760",
      "brandId": "ariadna",
      "reference": "1760",
      "name": "soiled coral",
      "hex": "#c84b50",
      "rgb": [
        200,
        75,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1779",
      "brandId": "ariadna",
      "reference": "1779",
      "name": "golden brown medium",
      "hex": "#c8782d",
      "rgb": [
        200,
        120,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1729",
      "brandId": "ariadna",
      "reference": "1729",
      "name": "old gold very dark",
      "hex": "#c88c46",
      "rgb": [
        200,
        140,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1778",
      "brandId": "ariadna",
      "reference": "1778",
      "name": "golden brown",
      "hex": "#c8a064",
      "rgb": [
        200,
        160,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1711",
      "brandId": "ariadna",
      "reference": "1711",
      "name": "olive green",
      "hex": "#c8be50",
      "rgb": [
        200,
        190,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1815",
      "brandId": "ariadna",
      "reference": "1815",
      "name": "steel",
      "hex": "#c8beaf",
      "rgb": [
        200,
        190,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1704",
      "brandId": "ariadna",
      "reference": "1704",
      "name": "khaki green light",
      "hex": "#c8c882",
      "rgb": [
        200,
        200,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1646",
      "brandId": "ariadna",
      "reference": "1646",
      "name": "grey green light",
      "hex": "#c8d2c8",
      "rgb": [
        200,
        210,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1697",
      "brandId": "ariadna",
      "reference": "1697",
      "name": "parrot green light",
      "hex": "#c8ff32",
      "rgb": [
        200,
        255,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1555",
      "brandId": "ariadna",
      "reference": "1555",
      "name": "christmas red dark",
      "hex": "#c92b55",
      "rgb": [
        201,
        43,
        85
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1576",
      "brandId": "ariadna",
      "reference": "1576",
      "name": "shell pink",
      "hex": "#c991a6",
      "rgb": [
        201,
        145,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1582",
      "brandId": "ariadna",
      "reference": "1582",
      "name": "antique violet light",
      "hex": "#c9b1c1",
      "rgb": [
        201,
        177,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1673",
      "brandId": "ariadna",
      "reference": "1673",
      "name": "soiled green",
      "hex": "#c9da96",
      "rgb": [
        201,
        218,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1553",
      "brandId": "ariadna",
      "reference": "1553",
      "name": "light red",
      "hex": "#cc2f2f",
      "rgb": [
        204,
        47,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1574",
      "brandId": "ariadna",
      "reference": "1574",
      "name": "shell pink dark",
      "hex": "#cc7882",
      "rgb": [
        204,
        120,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1610",
      "brandId": "ariadna",
      "reference": "1610",
      "name": "blue very light",
      "hex": "#cdf0ff",
      "rgb": [
        205,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1639",
      "brandId": "ariadna",
      "reference": "1639",
      "name": "sea green ultra light",
      "hex": "#cdf0ff",
      "rgb": [
        205,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1588A",
      "brandId": "ariadna",
      "reference": "1588A",
      "name": "lavender dark",
      "hex": "#ce96e3",
      "rgb": [
        206,
        150,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1569",
      "brandId": "ariadna",
      "reference": "1569",
      "name": "cyclamen pink dark",
      "hex": "#cf0079",
      "rgb": [
        207,
        0,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1565A",
      "brandId": "ariadna",
      "reference": "1565A",
      "name": "raspberry medium",
      "hex": "#cf6c7b",
      "rgb": [
        207,
        108,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1579",
      "brandId": "ariadna",
      "reference": "1579",
      "name": "antique rose",
      "hex": "#cf93b2",
      "rgb": [
        207,
        147,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1801A",
      "brandId": "ariadna",
      "reference": "1801A",
      "name": "brown grey light",
      "hex": "#d1d6c7",
      "rgb": [
        209,
        214,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1535",
      "brandId": "ariadna",
      "reference": "1535",
      "name": "red copper dark",
      "hex": "#d26414",
      "rgb": [
        210,
        100,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1679",
      "brandId": "ariadna",
      "reference": "1679",
      "name": "aquamarine light",
      "hex": "#d2fac8",
      "rgb": [
        210,
        250,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1570",
      "brandId": "ariadna",
      "reference": "1570",
      "name": "mauve light",
      "hex": "#d47fb1",
      "rgb": [
        212,
        127,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1756",
      "brandId": "ariadna",
      "reference": "1756",
      "name": "red chestnut light",
      "hex": "#d78c6e",
      "rgb": [
        215,
        140,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1669",
      "brandId": "ariadna",
      "reference": "1669",
      "name": "thyme light",
      "hex": "#d7e2b4",
      "rgb": [
        215,
        226,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1542",
      "brandId": "ariadna",
      "reference": "1542",
      "name": "coral dark",
      "hex": "#d9091d",
      "rgb": [
        217,
        9,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1554",
      "brandId": "ariadna",
      "reference": "1554",
      "name": "red",
      "hex": "#d91515",
      "rgb": [
        217,
        21,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1586",
      "brandId": "ariadna",
      "reference": "1586",
      "name": "plum light",
      "hex": "#d9b0d5",
      "rgb": [
        217,
        176,
        213
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1763A",
      "brandId": "ariadna",
      "reference": "1763A",
      "name": "cocoa light",
      "hex": "#d9c1c9",
      "rgb": [
        217,
        193,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1626A",
      "brandId": "ariadna",
      "reference": "1626A",
      "name": "light blue grey",
      "hex": "#d9e2ff",
      "rgb": [
        217,
        226,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1691D",
      "brandId": "ariadna",
      "reference": "1691D",
      "name": "moss green",
      "hex": "#d9eb63",
      "rgb": [
        217,
        235,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1528",
      "brandId": "ariadna",
      "reference": "1528",
      "name": "apricot dark",
      "hex": "#dc5014",
      "rgb": [
        220,
        80,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1738",
      "brandId": "ariadna",
      "reference": "1738",
      "name": "brick red dark",
      "hex": "#dc6428",
      "rgb": [
        220,
        100,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1534",
      "brandId": "ariadna",
      "reference": "1534",
      "name": "red copper medium",
      "hex": "#dc781e",
      "rgb": [
        220,
        120,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1596",
      "brandId": "ariadna",
      "reference": "1596",
      "name": "heather",
      "hex": "#dc80b4",
      "rgb": [
        220,
        128,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1761",
      "brandId": "ariadna",
      "reference": "1761",
      "name": "soiled coral light",
      "hex": "#dc8264",
      "rgb": [
        220,
        130,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1728",
      "brandId": "ariadna",
      "reference": "1728",
      "name": "old gold dark",
      "hex": "#dca04a",
      "rgb": [
        220,
        160,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1769",
      "brandId": "ariadna",
      "reference": "1769",
      "name": "flesh-coloured very dark",
      "hex": "#dca57d",
      "rgb": [
        220,
        165,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1719",
      "brandId": "ariadna",
      "reference": "1719",
      "name": "olive brown light",
      "hex": "#dcbe64",
      "rgb": [
        220,
        190,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1764",
      "brandId": "ariadna",
      "reference": "1764",
      "name": "antique violet light",
      "hex": "#dcc8b4",
      "rgb": [
        220,
        200,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1710",
      "brandId": "ariadna",
      "reference": "1710",
      "name": "olive green light",
      "hex": "#dcd264",
      "rgb": [
        220,
        210,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1691",
      "brandId": "ariadna",
      "reference": "1691",
      "name": "avocado green very light",
      "hex": "#dcdc6e",
      "rgb": [
        220,
        220,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1703",
      "brandId": "ariadna",
      "reference": "1703",
      "name": "khaki green light",
      "hex": "#dcdc82",
      "rgb": [
        220,
        220,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1787",
      "brandId": "ariadna",
      "reference": "1787",
      "name": "drab brown light",
      "hex": "#dce6a0",
      "rgb": [
        220,
        230,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1645",
      "brandId": "ariadna",
      "reference": "1645",
      "name": "grey green very light",
      "hex": "#dcebdc",
      "rgb": [
        220,
        235,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1631",
      "brandId": "ariadna",
      "reference": "1631",
      "name": "antique blue ultra light",
      "hex": "#dcf0ff",
      "rgb": [
        220,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1714C",
      "brandId": "ariadna",
      "reference": "1714C",
      "name": "mustard medium",
      "hex": "#dde0a8",
      "rgb": [
        221,
        224,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1749",
      "brandId": "ariadna",
      "reference": "1749",
      "name": "terracotta medium",
      "hex": "#de9692",
      "rgb": [
        222,
        150,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1768",
      "brandId": "ariadna",
      "reference": "1768",
      "name": "flesh-coloured dark",
      "hex": "#deb487",
      "rgb": [
        222,
        180,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1782A",
      "brandId": "ariadna",
      "reference": "1782A",
      "name": "mocha beige medium",
      "hex": "#dec2a2",
      "rgb": [
        222,
        194,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1714B",
      "brandId": "ariadna",
      "reference": "1714B",
      "name": "mustard light",
      "hex": "#dee0ba",
      "rgb": [
        222,
        224,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1723",
      "brandId": "ariadna",
      "reference": "1723",
      "name": "olive brown dark",
      "hex": "#dfb136",
      "rgb": [
        223,
        177,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1663",
      "brandId": "ariadna",
      "reference": "1663",
      "name": "peas light",
      "hex": "#e0ffe3",
      "rgb": [
        224,
        255,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1607",
      "brandId": "ariadna",
      "reference": "1607",
      "name": "blue violet ultra light",
      "hex": "#e1c8fa",
      "rgb": [
        225,
        200,
        250
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1814",
      "brandId": "ariadna",
      "reference": "1814",
      "name": "steel light",
      "hex": "#e1dcc8",
      "rgb": [
        225,
        220,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1547",
      "brandId": "ariadna",
      "reference": "1547",
      "name": "christmas red light",
      "hex": "#e22b3c",
      "rgb": [
        226,
        43,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1541",
      "brandId": "ariadna",
      "reference": "1541",
      "name": "coral medium",
      "hex": "#e33d4e",
      "rgb": [
        227,
        61,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1634A",
      "brandId": "ariadna",
      "reference": "1634A",
      "name": "pearly",
      "hex": "#e4ecf7",
      "rgb": [
        228,
        236,
        247
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1621",
      "brandId": "ariadna",
      "reference": "1621",
      "name": "light cornflower blue",
      "hex": "#e5f0ff",
      "rgb": [
        229,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1599",
      "brandId": "ariadna",
      "reference": "1599",
      "name": "lilac very dark",
      "hex": "#e6217b",
      "rgb": [
        230,
        33,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1600",
      "brandId": "ariadna",
      "reference": "1600",
      "name": "lilac dark",
      "hex": "#e678b4",
      "rgb": [
        230,
        120,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1755",
      "brandId": "ariadna",
      "reference": "1755",
      "name": "rosewood",
      "hex": "#e6b49b",
      "rgb": [
        230,
        180,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1722",
      "brandId": "ariadna",
      "reference": "1722",
      "name": "olive brown",
      "hex": "#e6be3c",
      "rgb": [
        230,
        190,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1777",
      "brandId": "ariadna",
      "reference": "1777",
      "name": "golden brown light",
      "hex": "#e6cd96",
      "rgb": [
        230,
        205,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1715",
      "brandId": "ariadna",
      "reference": "1715",
      "name": "golden olive light",
      "hex": "#e6d264",
      "rgb": [
        230,
        210,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1806",
      "brandId": "ariadna",
      "reference": "1806",
      "name": "beaver grey",
      "hex": "#e6d7b4",
      "rgb": [
        230,
        215,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1801",
      "brandId": "ariadna",
      "reference": "1801",
      "name": "olive gray ultra light",
      "hex": "#e6e6be",
      "rgb": [
        230,
        230,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1644A",
      "brandId": "ariadna",
      "reference": "1644A",
      "name": "beaver grey very light",
      "hex": "#e7f0ec",
      "rgb": [
        231,
        240,
        236
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1540",
      "brandId": "ariadna",
      "reference": "1540",
      "name": "coral",
      "hex": "#e84555",
      "rgb": [
        232,
        69,
        85
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1539",
      "brandId": "ariadna",
      "reference": "1539",
      "name": "coral light",
      "hex": "#e8909d",
      "rgb": [
        232,
        144,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1565",
      "brandId": "ariadna",
      "reference": "1565",
      "name": "raspberry light",
      "hex": "#e897a2",
      "rgb": [
        232,
        151,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1810",
      "brandId": "ariadna",
      "reference": "1810",
      "name": "pewter grey light",
      "hex": "#e9e1d3",
      "rgb": [
        233,
        225,
        211
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1635B",
      "brandId": "ariadna",
      "reference": "1635B",
      "name": "mouse grey",
      "hex": "#e9eff2",
      "rgb": [
        233,
        239,
        242
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1691C",
      "brandId": "ariadna",
      "reference": "1691C",
      "name": "moss green light",
      "hex": "#e9f78f",
      "rgb": [
        233,
        247,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1698A",
      "brandId": "ariadna",
      "reference": "1698A",
      "name": "apple green light",
      "hex": "#eaffbf",
      "rgb": [
        234,
        255,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1560",
      "brandId": "ariadna",
      "reference": "1560",
      "name": "cranberry medium",
      "hex": "#eb4d87",
      "rgb": [
        235,
        77,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1546",
      "brandId": "ariadna",
      "reference": "1546",
      "name": "melon dark",
      "hex": "#eb677d",
      "rgb": [
        235,
        103,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1748",
      "brandId": "ariadna",
      "reference": "1748",
      "name": "terracotta",
      "hex": "#ebc2b9",
      "rgb": [
        235,
        194,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1581",
      "brandId": "ariadna",
      "reference": "1581",
      "name": "antique violet very light",
      "hex": "#ebe4e9",
      "rgb": [
        235,
        228,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1714A",
      "brandId": "ariadna",
      "reference": "1714A",
      "name": "yellow beige light",
      "hex": "#ebedca",
      "rgb": [
        235,
        237,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1796",
      "brandId": "ariadna",
      "reference": "1796",
      "name": "beige grey medium",
      "hex": "#ebf0c8",
      "rgb": [
        235,
        240,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1597",
      "brandId": "ariadna",
      "reference": "1597",
      "name": "light heather",
      "hex": "#eca4c2",
      "rgb": [
        236,
        164,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1587",
      "brandId": "ariadna",
      "reference": "1587",
      "name": "violet ultra light",
      "hex": "#ece1ed",
      "rgb": [
        236,
        225,
        237
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1568",
      "brandId": "ariadna",
      "reference": "1568",
      "name": "cyclamen pink",
      "hex": "#ed66b5",
      "rgb": [
        237,
        102,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1730A",
      "brandId": "ariadna",
      "reference": "1730A",
      "name": "bronze",
      "hex": "#edc58a",
      "rgb": [
        237,
        197,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1702",
      "brandId": "ariadna",
      "reference": "1702",
      "name": "khaki green ultra light",
      "hex": "#edf7d4",
      "rgb": [
        237,
        247,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1630A",
      "brandId": "ariadna",
      "reference": "1630A",
      "name": "baby blue ultra light",
      "hex": "#edfeff",
      "rgb": [
        237,
        254,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1737",
      "brandId": "ariadna",
      "reference": "1737",
      "name": "brick red",
      "hex": "#f08c28",
      "rgb": [
        240,
        140,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1601",
      "brandId": "ariadna",
      "reference": "1601",
      "name": "lilac",
      "hex": "#f096c8",
      "rgb": [
        240,
        150,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1739",
      "brandId": "ariadna",
      "reference": "1739",
      "name": "honey",
      "hex": "#f0aa23",
      "rgb": [
        240,
        170,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1593",
      "brandId": "ariadna",
      "reference": "1593",
      "name": "plum ultra light",
      "hex": "#f0b4d2",
      "rgb": [
        240,
        180,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1533",
      "brandId": "ariadna",
      "reference": "1533",
      "name": "red copper",
      "hex": "#f0b93c",
      "rgb": [
        240,
        185,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1575",
      "brandId": "ariadna",
      "reference": "1575",
      "name": "shell pink ultra very light",
      "hex": "#f0c9db",
      "rgb": [
        240,
        201,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1721",
      "brandId": "ariadna",
      "reference": "1721",
      "name": "olive brown very light",
      "hex": "#f0dc5a",
      "rgb": [
        240,
        220,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1813",
      "brandId": "ariadna",
      "reference": "1813",
      "name": "steel very light",
      "hex": "#f0f0e6",
      "rgb": [
        240,
        240,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1656",
      "brandId": "ariadna",
      "reference": "1656",
      "name": "turquoise green ultra light",
      "hex": "#f0fadc",
      "rgb": [
        240,
        250,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1675",
      "brandId": "ariadna",
      "reference": "1675",
      "name": "aquamarine very dark",
      "hex": "#f0ffd2",
      "rgb": [
        240,
        255,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1551",
      "brandId": "ariadna",
      "reference": "1551",
      "name": "pink dark",
      "hex": "#f2809b",
      "rgb": [
        242,
        128,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1569A",
      "brandId": "ariadna",
      "reference": "1569A",
      "name": "dusty rose medium",
      "hex": "#f2bdd1",
      "rgb": [
        242,
        189,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1578",
      "brandId": "ariadna",
      "reference": "1578",
      "name": "antique rose light",
      "hex": "#f2c9de",
      "rgb": [
        242,
        201,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1721A",
      "brandId": "ariadna",
      "reference": "1721A",
      "name": "straw yellow",
      "hex": "#f2e07b",
      "rgb": [
        242,
        224,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1753",
      "brandId": "ariadna",
      "reference": "1753",
      "name": "rosewood ultra light",
      "hex": "#f2e6d7",
      "rgb": [
        242,
        230,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1746",
      "brandId": "ariadna",
      "reference": "1746",
      "name": "terracotta very light",
      "hex": "#f2e7df",
      "rgb": [
        242,
        231,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1501",
      "brandId": "ariadna",
      "reference": "1501",
      "name": "lemon ultra light",
      "hex": "#f2efc9",
      "rgb": [
        242,
        239,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1580A",
      "brandId": "ariadna",
      "reference": "1580A",
      "name": "white violet",
      "hex": "#f4f0ff",
      "rgb": [
        244,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1736",
      "brandId": "ariadna",
      "reference": "1736",
      "name": "brick red very light",
      "hex": "#f5b450",
      "rgb": [
        245,
        180,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1747",
      "brandId": "ariadna",
      "reference": "1747",
      "name": "terracotta light",
      "hex": "#f5dfda",
      "rgb": [
        245,
        223,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1767",
      "brandId": "ariadna",
      "reference": "1767",
      "name": "flesh medium",
      "hex": "#f5e1c3",
      "rgb": [
        245,
        225,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1588B",
      "brandId": "ariadna",
      "reference": "1588B",
      "name": "lavender light",
      "hex": "#f5e2fc",
      "rgb": [
        245,
        226,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1720",
      "brandId": "ariadna",
      "reference": "1720",
      "name": "olive brown ultra light",
      "hex": "#f5eb78",
      "rgb": [
        245,
        235,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1809",
      "brandId": "ariadna",
      "reference": "1809",
      "name": "beige tin",
      "hex": "#f5ebc8",
      "rgb": [
        245,
        235,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1791",
      "brandId": "ariadna",
      "reference": "1791",
      "name": "mocha brown ultra very light",
      "hex": "#f5f0c8",
      "rgb": [
        245,
        240,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1805",
      "brandId": "ariadna",
      "reference": "1805",
      "name": "beaver grey light",
      "hex": "#f5f5d2",
      "rgb": [
        245,
        245,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1696",
      "brandId": "ariadna",
      "reference": "1696",
      "name": "parrot green very light",
      "hex": "#f5ff64",
      "rgb": [
        245,
        255,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1520",
      "brandId": "ariadna",
      "reference": "1520",
      "name": "tangerine",
      "hex": "#f66616",
      "rgb": [
        246,
        102,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1515",
      "brandId": "ariadna",
      "reference": "1515",
      "name": "orange light",
      "hex": "#f7ac2b",
      "rgb": [
        247,
        172,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1514",
      "brandId": "ariadna",
      "reference": "1514",
      "name": "orange very light",
      "hex": "#f7c733",
      "rgb": [
        247,
        199,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1517",
      "brandId": "ariadna",
      "reference": "1517",
      "name": "orange dark",
      "hex": "#fa8722",
      "rgb": [
        250,
        135,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1519",
      "brandId": "ariadna",
      "reference": "1519",
      "name": "tangerine light",
      "hex": "#fa8c46",
      "rgb": [
        250,
        140,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1527",
      "brandId": "ariadna",
      "reference": "1527",
      "name": "apricot",
      "hex": "#fa8c46",
      "rgb": [
        250,
        140,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1518",
      "brandId": "ariadna",
      "reference": "1518",
      "name": "tangerine very light",
      "hex": "#faa046",
      "rgb": [
        250,
        160,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1538",
      "brandId": "ariadna",
      "reference": "1538",
      "name": "salmon dark",
      "hex": "#faae9f",
      "rgb": [
        250,
        174,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1598",
      "brandId": "ariadna",
      "reference": "1598",
      "name": "heather very light",
      "hex": "#fabedc",
      "rgb": [
        250,
        190,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1726",
      "brandId": "ariadna",
      "reference": "1726",
      "name": "old gold medium",
      "hex": "#facd28",
      "rgb": [
        250,
        205,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1506",
      "brandId": "ariadna",
      "reference": "1506",
      "name": "lemon ultra dark",
      "hex": "#fadc28",
      "rgb": [
        250,
        220,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1766",
      "brandId": "ariadna",
      "reference": "1766",
      "name": "flesh-coloured",
      "hex": "#fae6c8",
      "rgb": [
        250,
        230,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1754",
      "brandId": "ariadna",
      "reference": "1754",
      "name": "rosewood light",
      "hex": "#fae6d2",
      "rgb": [
        250,
        230,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1505",
      "brandId": "ariadna",
      "reference": "1505",
      "name": "lemon very dark",
      "hex": "#faf000",
      "rgb": [
        250,
        240,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1776",
      "brandId": "ariadna",
      "reference": "1776",
      "name": "golden brown light",
      "hex": "#faf0c8",
      "rgb": [
        250,
        240,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1790",
      "brandId": "ariadna",
      "reference": "1790",
      "name": "ecru",
      "hex": "#faf5d2",
      "rgb": [
        250,
        245,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1745",
      "brandId": "ariadna",
      "reference": "1745",
      "name": "terracotta ultra light",
      "hex": "#faf6f0",
      "rgb": [
        250,
        246,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1507",
      "brandId": "ariadna",
      "reference": "1507",
      "name": "pastel yellow ultra light",
      "hex": "#faf8f0",
      "rgb": [
        250,
        248,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1504",
      "brandId": "ariadna",
      "reference": "1504",
      "name": "lemon dark",
      "hex": "#fafa00",
      "rgb": [
        250,
        250,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1509",
      "brandId": "ariadna",
      "reference": "1509",
      "name": "pastel yellow",
      "hex": "#fafa32",
      "rgb": [
        250,
        250,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1695",
      "brandId": "ariadna",
      "reference": "1695",
      "name": "parrot green ultra light",
      "hex": "#faffa1",
      "rgb": [
        250,
        255,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1526A",
      "brandId": "ariadna",
      "reference": "1526A",
      "name": "pumpkin pale",
      "hex": "#fbd0ad",
      "rgb": [
        251,
        208,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1587A",
      "brandId": "ariadna",
      "reference": "1587A",
      "name": "white lavender",
      "hex": "#fbf0ff",
      "rgb": [
        251,
        240,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1708",
      "brandId": "ariadna",
      "reference": "1708",
      "name": "faded olive",
      "hex": "#fbfab4",
      "rgb": [
        251,
        250,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1558",
      "brandId": "ariadna",
      "reference": "1558",
      "name": "cranberry ultra light",
      "hex": "#fcbdd0",
      "rgb": [
        252,
        189,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1536",
      "brandId": "ariadna",
      "reference": "1536",
      "name": "salmon light",
      "hex": "#fcd7d3",
      "rgb": [
        252,
        215,
        211
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1782B",
      "brandId": "ariadna",
      "reference": "1782B",
      "name": "beige brown ultra light",
      "hex": "#fcf3e8",
      "rgb": [
        252,
        243,
        232
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1535A",
      "brandId": "ariadna",
      "reference": "1535A",
      "name": "baby pink light",
      "hex": "#fdf7f9",
      "rgb": [
        253,
        247,
        249
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1500A",
      "brandId": "ariadna",
      "reference": "1500A",
      "name": "winter white",
      "hex": "#fdfbf8",
      "rgb": [
        253,
        251,
        248
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1523",
      "brandId": "ariadna",
      "reference": "1523",
      "name": "bright orange medium",
      "hex": "#ff6400",
      "rgb": [
        255,
        100,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1521",
      "brandId": "ariadna",
      "reference": "1521",
      "name": "tangerine dark",
      "hex": "#ff6424",
      "rgb": [
        255,
        100,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1552",
      "brandId": "ariadna",
      "reference": "1552",
      "name": "pink ultra dark",
      "hex": "#ff668a",
      "rgb": [
        255,
        102,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1522",
      "brandId": "ariadna",
      "reference": "1522",
      "name": "bright orange",
      "hex": "#ff6e1f",
      "rgb": [
        255,
        110,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1562",
      "brandId": "ariadna",
      "reference": "1562",
      "name": "cranberry",
      "hex": "#ff8aa3",
      "rgb": [
        255,
        138,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1516",
      "brandId": "ariadna",
      "reference": "1516",
      "name": "orange",
      "hex": "#ff9600",
      "rgb": [
        255,
        150,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1559",
      "brandId": "ariadna",
      "reference": "1559",
      "name": "cranberry light",
      "hex": "#ff99b8",
      "rgb": [
        255,
        153,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1511",
      "brandId": "ariadna",
      "reference": "1511",
      "name": "pastel yellow ultra dark",
      "hex": "#ffa028",
      "rgb": [
        255,
        160,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1567",
      "brandId": "ariadna",
      "reference": "1567",
      "name": "cyclamen pink light",
      "hex": "#ffa6da",
      "rgb": [
        255,
        166,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1550",
      "brandId": "ariadna",
      "reference": "1550",
      "name": "pink",
      "hex": "#ffb2d0",
      "rgb": [
        255,
        178,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1602",
      "brandId": "ariadna",
      "reference": "1602",
      "name": "light lilac",
      "hex": "#ffb4dc",
      "rgb": [
        255,
        180,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1545",
      "brandId": "ariadna",
      "reference": "1545",
      "name": "melon medium",
      "hex": "#ffb5c9",
      "rgb": [
        255,
        181,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1727",
      "brandId": "ariadna",
      "reference": "1727",
      "name": "old gold",
      "hex": "#ffbe41",
      "rgb": [
        255,
        190,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1510",
      "brandId": "ariadna",
      "reference": "1510",
      "name": "pastel yellow",
      "hex": "#ffc002",
      "rgb": [
        255,
        192,
        2
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1564",
      "brandId": "ariadna",
      "reference": "1564",
      "name": "raspberry ultra light",
      "hex": "#ffc4dc",
      "rgb": [
        255,
        196,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1566A",
      "brandId": "ariadna",
      "reference": "1566A",
      "name": "cranberry white",
      "hex": "#ffcce0",
      "rgb": [
        255,
        204,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1544",
      "brandId": "ariadna",
      "reference": "1544",
      "name": "melon",
      "hex": "#ffcfd4",
      "rgb": [
        255,
        207,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1555B",
      "brandId": "ariadna",
      "reference": "1555B",
      "name": "salmon pink",
      "hex": "#ffd1d1",
      "rgb": [
        255,
        209,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1526",
      "brandId": "ariadna",
      "reference": "1526",
      "name": "apricot light",
      "hex": "#ffd28c",
      "rgb": [
        255,
        210,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1537",
      "brandId": "ariadna",
      "reference": "1537",
      "name": "pink",
      "hex": "#ffdbc9",
      "rgb": [
        255,
        219,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1532",
      "brandId": "ariadna",
      "reference": "1532",
      "name": "red copper light",
      "hex": "#ffdc8c",
      "rgb": [
        255,
        220,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1603",
      "brandId": "ariadna",
      "reference": "1603",
      "name": "lilac very light",
      "hex": "#ffdce6",
      "rgb": [
        255,
        220,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1549",
      "brandId": "ariadna",
      "reference": "1549",
      "name": "pink light",
      "hex": "#ffdeef",
      "rgb": [
        255,
        222,
        239
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1543",
      "brandId": "ariadna",
      "reference": "1543",
      "name": "melon light",
      "hex": "#ffe3ef",
      "rgb": [
        255,
        227,
        239
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1555A",
      "brandId": "ariadna",
      "reference": "1555A",
      "name": "salmon pink light",
      "hex": "#ffe5e5",
      "rgb": [
        255,
        229,
        229
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1735",
      "brandId": "ariadna",
      "reference": "1735",
      "name": "brick red ultra light",
      "hex": "#ffe682",
      "rgb": [
        255,
        230,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1725A",
      "brandId": "ariadna",
      "reference": "1725A",
      "name": "old gold light",
      "hex": "#ffe6a3",
      "rgb": [
        255,
        230,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1525",
      "brandId": "ariadna",
      "reference": "1525",
      "name": "apricot very light",
      "hex": "#ffeee0",
      "rgb": [
        255,
        238,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1513",
      "brandId": "ariadna",
      "reference": "1513",
      "name": "sunny light",
      "hex": "#fff08c",
      "rgb": [
        255,
        240,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1531",
      "brandId": "ariadna",
      "reference": "1531",
      "name": "red copper very light",
      "hex": "#fff0b4",
      "rgb": [
        255,
        240,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1577A",
      "brandId": "ariadna",
      "reference": "1577A",
      "name": "apple blossom",
      "hex": "#fff0f6",
      "rgb": [
        255,
        240,
        246
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1709",
      "brandId": "ariadna",
      "reference": "1709",
      "name": "olive green very light",
      "hex": "#fff55a",
      "rgb": [
        255,
        245,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1730",
      "brandId": "ariadna",
      "reference": "1730",
      "name": "old gold ultra light",
      "hex": "#fff5aa",
      "rgb": [
        255,
        245,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1524",
      "brandId": "ariadna",
      "reference": "1524",
      "name": "apricot ultra light",
      "hex": "#fff5c8",
      "rgb": [
        255,
        245,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1508",
      "brandId": "ariadna",
      "reference": "1508",
      "name": "pastel yellow light",
      "hex": "#fffaaa",
      "rgb": [
        255,
        250,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1691B",
      "brandId": "ariadna",
      "reference": "1691B",
      "name": "tender green light",
      "hex": "#fffeba",
      "rgb": [
        255,
        254,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1503",
      "brandId": "ariadna",
      "reference": "1503",
      "name": "lemon",
      "hex": "#ffff62",
      "rgb": [
        255,
        255,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1512",
      "brandId": "ariadna",
      "reference": "1512",
      "name": "sunny ultra light",
      "hex": "#ffff94",
      "rgb": [
        255,
        255,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1502",
      "brandId": "ariadna",
      "reference": "1502",
      "name": "lemon light",
      "hex": "#ffff9f",
      "rgb": [
        255,
        255,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1690",
      "brandId": "ariadna",
      "reference": "1690",
      "name": "avocado green ultra light",
      "hex": "#ffffb4",
      "rgb": [
        255,
        255,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1683",
      "brandId": "ariadna",
      "reference": "1683",
      "name": "green ultra light",
      "hex": "#ffffc8",
      "rgb": [
        255,
        255,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1795",
      "brandId": "ariadna",
      "reference": "1795",
      "name": "gray beige",
      "hex": "#ffffdc",
      "rgb": [
        255,
        255,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1765",
      "brandId": "ariadna",
      "reference": "1765",
      "name": "flesh-coloured light",
      "hex": "#ffffe6",
      "rgb": [
        255,
        255,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1775",
      "brandId": "ariadna",
      "reference": "1775",
      "name": "golden brown ultra light",
      "hex": "#ffffe6",
      "rgb": [
        255,
        255,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "ariadna:1500",
      "brandId": "ariadna",
      "reference": "1500",
      "name": "white",
      "hex": "#ffffff",
      "rgb": [
        255,
        255,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:600",
      "brandId": "cosmo",
      "reference": "600",
      "name": "600",
      "hex": "#101113",
      "rgb": [
        16,
        17,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:602",
      "brandId": "cosmo",
      "reference": "602",
      "name": "602",
      "hex": "#15192e",
      "rgb": [
        21,
        25,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:669A",
      "brandId": "cosmo",
      "reference": "669A",
      "name": "669A",
      "hex": "#19192c",
      "rgb": [
        25,
        25,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:122",
      "brandId": "cosmo",
      "reference": "122",
      "name": "122",
      "hex": "#1c2c1b",
      "rgb": [
        28,
        44,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:169",
      "brandId": "cosmo",
      "reference": "169",
      "name": "169",
      "hex": "#1f203b",
      "rgb": [
        31,
        32,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:603",
      "brandId": "cosmo",
      "reference": "603",
      "name": "603",
      "hex": "#201823",
      "rgb": [
        32,
        24,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:537",
      "brandId": "cosmo",
      "reference": "537",
      "name": "537",
      "hex": "#214331",
      "rgb": [
        33,
        67,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:121",
      "brandId": "cosmo",
      "reference": "121",
      "name": "121",
      "hex": "#254628",
      "rgb": [
        37,
        70,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:538",
      "brandId": "cosmo",
      "reference": "538",
      "name": "538",
      "hex": "#26362c",
      "rgb": [
        38,
        54,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2030",
      "brandId": "cosmo",
      "reference": "2030",
      "name": "2030",
      "hex": "#281f24",
      "rgb": [
        40,
        31,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:168",
      "brandId": "cosmo",
      "reference": "168",
      "name": "168",
      "hex": "#282b54",
      "rgb": [
        40,
        43,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:4905",
      "brandId": "cosmo",
      "reference": "4905",
      "name": "4905",
      "hex": "#284d2c",
      "rgb": [
        40,
        77,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:667A",
      "brandId": "cosmo",
      "reference": "667A",
      "name": "667A",
      "hex": "#2a2a53",
      "rgb": [
        42,
        42,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:338",
      "brandId": "cosmo",
      "reference": "338",
      "name": "338",
      "hex": "#2a6337",
      "rgb": [
        42,
        99,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:312",
      "brandId": "cosmo",
      "reference": "312",
      "name": "312",
      "hex": "#2b2320",
      "rgb": [
        43,
        35,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:984",
      "brandId": "cosmo",
      "reference": "984",
      "name": "984",
      "hex": "#2b4a53",
      "rgb": [
        43,
        74,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:902",
      "brandId": "cosmo",
      "reference": "902",
      "name": "902",
      "hex": "#2c675d",
      "rgb": [
        44,
        103,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:218",
      "brandId": "cosmo",
      "reference": "218",
      "name": "218",
      "hex": "#2d2f5e",
      "rgb": [
        45,
        47,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:927",
      "brandId": "cosmo",
      "reference": "927",
      "name": "927",
      "hex": "#2d301b",
      "rgb": [
        45,
        48,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:216",
      "brandId": "cosmo",
      "reference": "216",
      "name": "216",
      "hex": "#2d3880",
      "rgb": [
        45,
        56,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:320",
      "brandId": "cosmo",
      "reference": "320",
      "name": "320",
      "hex": "#2d5333",
      "rgb": [
        45,
        83,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:601",
      "brandId": "cosmo",
      "reference": "601",
      "name": "601",
      "hex": "#2e2a31",
      "rgb": [
        46,
        42,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:668",
      "brandId": "cosmo",
      "reference": "668",
      "name": "668",
      "hex": "#2e2f52",
      "rgb": [
        46,
        47,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:167",
      "brandId": "cosmo",
      "reference": "167",
      "name": "167",
      "hex": "#2e4277",
      "rgb": [
        46,
        66,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:637",
      "brandId": "cosmo",
      "reference": "637",
      "name": "637",
      "hex": "#2f3f23",
      "rgb": [
        47,
        63,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2536A",
      "brandId": "cosmo",
      "reference": "2536A",
      "name": "2536A",
      "hex": "#2f5a44",
      "rgb": [
        47,
        90,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:376",
      "brandId": "cosmo",
      "reference": "376",
      "name": "376",
      "hex": "#2f5c83",
      "rgb": [
        47,
        92,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:846",
      "brandId": "cosmo",
      "reference": "846",
      "name": "846",
      "hex": "#306753",
      "rgb": [
        48,
        103,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:4792",
      "brandId": "cosmo",
      "reference": "4792",
      "name": "4792",
      "hex": "#31336d",
      "rgb": [
        49,
        51,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:276",
      "brandId": "cosmo",
      "reference": "276",
      "name": "276",
      "hex": "#31743d",
      "rgb": [
        49,
        116,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:156",
      "brandId": "cosmo",
      "reference": "156",
      "name": "156",
      "hex": "#323133",
      "rgb": [
        50,
        49,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2016",
      "brandId": "cosmo",
      "reference": "2016",
      "name": "2016",
      "hex": "#324227",
      "rgb": [
        50,
        66,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:636",
      "brandId": "cosmo",
      "reference": "636",
      "name": "636",
      "hex": "#324324",
      "rgb": [
        50,
        67,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2120",
      "brandId": "cosmo",
      "reference": "2120",
      "name": "2120",
      "hex": "#325930",
      "rgb": [
        50,
        89,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:329",
      "brandId": "cosmo",
      "reference": "329",
      "name": "329",
      "hex": "#326132",
      "rgb": [
        50,
        97,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2024",
      "brandId": "cosmo",
      "reference": "2024",
      "name": "2024",
      "hex": "#326683",
      "rgb": [
        50,
        102,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:735",
      "brandId": "cosmo",
      "reference": "735",
      "name": "735",
      "hex": "#334768",
      "rgb": [
        51,
        71,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:415A",
      "brandId": "cosmo",
      "reference": "415A",
      "name": "415A",
      "hex": "#3365b1",
      "rgb": [
        51,
        101,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:926",
      "brandId": "cosmo",
      "reference": "926",
      "name": "926",
      "hex": "#344223",
      "rgb": [
        52,
        66,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:247",
      "brandId": "cosmo",
      "reference": "247",
      "name": "247",
      "hex": "#351d21",
      "rgb": [
        53,
        29,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:557",
      "brandId": "cosmo",
      "reference": "557",
      "name": "557",
      "hex": "#352e56",
      "rgb": [
        53,
        46,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:665",
      "brandId": "cosmo",
      "reference": "665",
      "name": "665",
      "hex": "#353a7d",
      "rgb": [
        53,
        58,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:254",
      "brandId": "cosmo",
      "reference": "254",
      "name": "254",
      "hex": "#35588f",
      "rgb": [
        53,
        88,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:478",
      "brandId": "cosmo",
      "reference": "478",
      "name": "478",
      "hex": "#36313c",
      "rgb": [
        54,
        49,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:687",
      "brandId": "cosmo",
      "reference": "687",
      "name": "687",
      "hex": "#36381e",
      "rgb": [
        54,
        56,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2167",
      "brandId": "cosmo",
      "reference": "2167",
      "name": "2167",
      "hex": "#363d64",
      "rgb": [
        54,
        61,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:166",
      "brandId": "cosmo",
      "reference": "166",
      "name": "166",
      "hex": "#365186",
      "rgb": [
        54,
        81,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:900",
      "brandId": "cosmo",
      "reference": "900",
      "name": "900",
      "hex": "#367b6e",
      "rgb": [
        54,
        123,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2319",
      "brandId": "cosmo",
      "reference": "2319",
      "name": "2319",
      "hex": "#376541",
      "rgb": [
        55,
        101,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:275",
      "brandId": "cosmo",
      "reference": "275",
      "name": "275",
      "hex": "#377e3e",
      "rgb": [
        55,
        126,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:895",
      "brandId": "cosmo",
      "reference": "895",
      "name": "895",
      "hex": "#383633",
      "rgb": [
        56,
        54,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:635A",
      "brandId": "cosmo",
      "reference": "635A",
      "name": "635A",
      "hex": "#395029",
      "rgb": [
        57,
        80,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2027",
      "brandId": "cosmo",
      "reference": "2027",
      "name": "2027",
      "hex": "#3a67b4",
      "rgb": [
        58,
        103,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:477",
      "brandId": "cosmo",
      "reference": "477",
      "name": "477",
      "hex": "#3b2e37",
      "rgb": [
        59,
        46,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2214",
      "brandId": "cosmo",
      "reference": "2214",
      "name": "2214",
      "hex": "#3b54a1",
      "rgb": [
        59,
        84,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:328",
      "brandId": "cosmo",
      "reference": "328",
      "name": "328",
      "hex": "#3b6c36",
      "rgb": [
        59,
        108,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2664",
      "brandId": "cosmo",
      "reference": "2664",
      "name": "2664",
      "hex": "#3c438a",
      "rgb": [
        60,
        67,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:983",
      "brandId": "cosmo",
      "reference": "983",
      "name": "983",
      "hex": "#3c5e6a",
      "rgb": [
        60,
        94,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:845",
      "brandId": "cosmo",
      "reference": "845",
      "name": "845",
      "hex": "#3c7e61",
      "rgb": [
        60,
        126,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:375",
      "brandId": "cosmo",
      "reference": "375",
      "name": "375",
      "hex": "#3d748c",
      "rgb": [
        61,
        116,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2029",
      "brandId": "cosmo",
      "reference": "2029",
      "name": "2029",
      "hex": "#3e3a4e",
      "rgb": [
        62,
        58,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2019",
      "brandId": "cosmo",
      "reference": "2019",
      "name": "2019",
      "hex": "#3e637e",
      "rgb": [
        62,
        99,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:414A",
      "brandId": "cosmo",
      "reference": "414A",
      "name": "414A",
      "hex": "#3e79c1",
      "rgb": [
        62,
        121,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2311",
      "brandId": "cosmo",
      "reference": "2311",
      "name": "2311",
      "hex": "#40271e",
      "rgb": [
        64,
        39,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:556",
      "brandId": "cosmo",
      "reference": "556",
      "name": "556",
      "hex": "#403b71",
      "rgb": [
        64,
        59,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:274",
      "brandId": "cosmo",
      "reference": "274",
      "name": "274",
      "hex": "#40873d",
      "rgb": [
        64,
        135,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:120",
      "brandId": "cosmo",
      "reference": "120",
      "name": "120",
      "hex": "#416e36",
      "rgb": [
        65,
        110,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:337",
      "brandId": "cosmo",
      "reference": "337",
      "name": "337",
      "hex": "#418751",
      "rgb": [
        65,
        135,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:4311",
      "brandId": "cosmo",
      "reference": "4311",
      "name": "4311",
      "hex": "#422520",
      "rgb": [
        66,
        37,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:766",
      "brandId": "cosmo",
      "reference": "766",
      "name": "766",
      "hex": "#422d47",
      "rgb": [
        66,
        45,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:634",
      "brandId": "cosmo",
      "reference": "634",
      "name": "634",
      "hex": "#435e2e",
      "rgb": [
        67,
        94,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:718",
      "brandId": "cosmo",
      "reference": "718",
      "name": "718",
      "hex": "#443e2b",
      "rgb": [
        68,
        62,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:155",
      "brandId": "cosmo",
      "reference": "155",
      "name": "155",
      "hex": "#45454b",
      "rgb": [
        69,
        69,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:319",
      "brandId": "cosmo",
      "reference": "319",
      "name": "319",
      "hex": "#45754a",
      "rgb": [
        69,
        117,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:566",
      "brandId": "cosmo",
      "reference": "566",
      "name": "566",
      "hex": "#457a88",
      "rgb": [
        69,
        122,
        136
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:734",
      "brandId": "cosmo",
      "reference": "734",
      "name": "734",
      "hex": "#465f80",
      "rgb": [
        70,
        95,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:536A",
      "brandId": "cosmo",
      "reference": "536A",
      "name": "536A",
      "hex": "#466457",
      "rgb": [
        70,
        100,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2023",
      "brandId": "cosmo",
      "reference": "2023",
      "name": "2023",
      "hex": "#469fc6",
      "rgb": [
        70,
        159,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:369",
      "brandId": "cosmo",
      "reference": "369",
      "name": "369",
      "hex": "#474333",
      "rgb": [
        71,
        67,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2041",
      "brandId": "cosmo",
      "reference": "2041",
      "name": "2041",
      "hex": "#474639",
      "rgb": [
        71,
        70,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:287A",
      "brandId": "cosmo",
      "reference": "287A",
      "name": "287A",
      "hex": "#482a67",
      "rgb": [
        72,
        42,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:925",
      "brandId": "cosmo",
      "reference": "925",
      "name": "925",
      "hex": "#485930",
      "rgb": [
        72,
        89,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:526",
      "brandId": "cosmo",
      "reference": "526",
      "name": "526",
      "hex": "#4966b1",
      "rgb": [
        73,
        102,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:370",
      "brandId": "cosmo",
      "reference": "370",
      "name": "370",
      "hex": "#4a3e24",
      "rgb": [
        74,
        62,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:686",
      "brandId": "cosmo",
      "reference": "686",
      "name": "686",
      "hex": "#4a4c26",
      "rgb": [
        74,
        76,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:676",
      "brandId": "cosmo",
      "reference": "676",
      "name": "676",
      "hex": "#4a4f2b",
      "rgb": [
        74,
        79,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:327",
      "brandId": "cosmo",
      "reference": "327",
      "name": "327",
      "hex": "#4c8738",
      "rgb": [
        76,
        135,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:286",
      "brandId": "cosmo",
      "reference": "286",
      "name": "286",
      "hex": "#4d2a68",
      "rgb": [
        77,
        42,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:273",
      "brandId": "cosmo",
      "reference": "273",
      "name": "273",
      "hex": "#4d983e",
      "rgb": [
        77,
        152,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:899",
      "brandId": "cosmo",
      "reference": "899",
      "name": "899",
      "hex": "#4d9d8b",
      "rgb": [
        77,
        157,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:226",
      "brandId": "cosmo",
      "reference": "226",
      "name": "226",
      "hex": "#4f1426",
      "rgb": [
        79,
        20,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:765",
      "brandId": "cosmo",
      "reference": "765",
      "name": "765",
      "hex": "#4f3556",
      "rgb": [
        79,
        53,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2040",
      "brandId": "cosmo",
      "reference": "2040",
      "name": "2040",
      "hex": "#4f3d2e",
      "rgb": [
        79,
        61,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:311",
      "brandId": "cosmo",
      "reference": "311",
      "name": "311",
      "hex": "#4f4036",
      "rgb": [
        79,
        64,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:664A",
      "brandId": "cosmo",
      "reference": "664A",
      "name": "664A",
      "hex": "#4f569c",
      "rgb": [
        79,
        86,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:214",
      "brandId": "cosmo",
      "reference": "214",
      "name": "214",
      "hex": "#4f70b3",
      "rgb": [
        79,
        112,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:413",
      "brandId": "cosmo",
      "reference": "413",
      "name": "413",
      "hex": "#4f8bcd",
      "rgb": [
        79,
        139,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2014",
      "brandId": "cosmo",
      "reference": "2014",
      "name": "2014",
      "hex": "#505c2e",
      "rgb": [
        80,
        92,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2026",
      "brandId": "cosmo",
      "reference": "2026",
      "name": "2026",
      "hex": "#5087b0",
      "rgb": [
        80,
        135,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:633",
      "brandId": "cosmo",
      "reference": "633",
      "name": "633",
      "hex": "#517734",
      "rgb": [
        81,
        119,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:656",
      "brandId": "cosmo",
      "reference": "656",
      "name": "656",
      "hex": "#522022",
      "rgb": [
        82,
        32,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:525",
      "brandId": "cosmo",
      "reference": "525",
      "name": "525",
      "hex": "#5272b7",
      "rgb": [
        82,
        114,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2253",
      "brandId": "cosmo",
      "reference": "2253",
      "name": "2253",
      "hex": "#5281a9",
      "rgb": [
        82,
        129,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:826",
      "brandId": "cosmo",
      "reference": "826",
      "name": "826",
      "hex": "#535227",
      "rgb": [
        83,
        82,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2020",
      "brandId": "cosmo",
      "reference": "2020",
      "name": "2020",
      "hex": "#535656",
      "rgb": [
        83,
        86,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:176",
      "brandId": "cosmo",
      "reference": "176",
      "name": "176",
      "hex": "#544799",
      "rgb": [
        84,
        71,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2154",
      "brandId": "cosmo",
      "reference": "2154",
      "name": "2154",
      "hex": "#545358",
      "rgb": [
        84,
        83,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:844",
      "brandId": "cosmo",
      "reference": "844",
      "name": "844",
      "hex": "#54a181",
      "rgb": [
        84,
        161,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:266",
      "brandId": "cosmo",
      "reference": "266",
      "name": "266",
      "hex": "#553273",
      "rgb": [
        85,
        50,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:119",
      "brandId": "cosmo",
      "reference": "119",
      "name": "119",
      "hex": "#557535",
      "rgb": [
        85,
        117,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:555",
      "brandId": "cosmo",
      "reference": "555",
      "name": "555",
      "hex": "#564e88",
      "rgb": [
        86,
        78,
        136
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:336",
      "brandId": "cosmo",
      "reference": "336",
      "name": "336",
      "hex": "#56a265",
      "rgb": [
        86,
        162,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:310",
      "brandId": "cosmo",
      "reference": "310",
      "name": "310",
      "hex": "#573e2f",
      "rgb": [
        87,
        62,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:165A",
      "brandId": "cosmo",
      "reference": "165A",
      "name": "165A",
      "hex": "#5774a1",
      "rgb": [
        87,
        116,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:131",
      "brandId": "cosmo",
      "reference": "131",
      "name": "131",
      "hex": "#58251f",
      "rgb": [
        88,
        37,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:894",
      "brandId": "cosmo",
      "reference": "894",
      "name": "894",
      "hex": "#585550",
      "rgb": [
        88,
        85,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2535",
      "brandId": "cosmo",
      "reference": "2535",
      "name": "2535",
      "hex": "#588873",
      "rgb": [
        88,
        136,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2924",
      "brandId": "cosmo",
      "reference": "2924",
      "name": "2924",
      "hex": "#597037",
      "rgb": [
        89,
        112,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:982",
      "brandId": "cosmo",
      "reference": "982",
      "name": "982",
      "hex": "#597e89",
      "rgb": [
        89,
        126,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:253",
      "brandId": "cosmo",
      "reference": "253",
      "name": "253",
      "hex": "#598fb0",
      "rgb": [
        89,
        143,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:225",
      "brandId": "cosmo",
      "reference": "225",
      "name": "225",
      "hex": "#5a1526",
      "rgb": [
        90,
        21,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:374",
      "brandId": "cosmo",
      "reference": "374",
      "name": "374",
      "hex": "#5a99a6",
      "rgb": [
        90,
        153,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:675A",
      "brandId": "cosmo",
      "reference": "675A",
      "name": "675A",
      "hex": "#5b5f2a",
      "rgb": [
        91,
        95,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:564",
      "brandId": "cosmo",
      "reference": "564",
      "name": "564",
      "hex": "#5c9494",
      "rgb": [
        92,
        148,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2035",
      "brandId": "cosmo",
      "reference": "2035",
      "name": "2035",
      "hex": "#5e485a",
      "rgb": [
        94,
        72,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:685",
      "brandId": "cosmo",
      "reference": "685",
      "name": "685",
      "hex": "#5e6233",
      "rgb": [
        94,
        98,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:733",
      "brandId": "cosmo",
      "reference": "733",
      "name": "733",
      "hex": "#5e7e9d",
      "rgb": [
        94,
        126,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:335",
      "brandId": "cosmo",
      "reference": "335",
      "name": "335",
      "hex": "#5ead6d",
      "rgb": [
        94,
        173,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:175",
      "brandId": "cosmo",
      "reference": "175",
      "name": "175",
      "hex": "#5f50a3",
      "rgb": [
        95,
        80,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2038",
      "brandId": "cosmo",
      "reference": "2038",
      "name": "2038",
      "hex": "#605042",
      "rgb": [
        96,
        80,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:535",
      "brandId": "cosmo",
      "reference": "535",
      "name": "535",
      "hex": "#608c77",
      "rgb": [
        96,
        140,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:326",
      "brandId": "cosmo",
      "reference": "326",
      "name": "326",
      "hex": "#609c37",
      "rgb": [
        96,
        156,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:245",
      "brandId": "cosmo",
      "reference": "245",
      "name": "245",
      "hex": "#611921",
      "rgb": [
        97,
        25,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:386",
      "brandId": "cosmo",
      "reference": "386",
      "name": "386",
      "hex": "#61483d",
      "rgb": [
        97,
        72,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:476",
      "brandId": "cosmo",
      "reference": "476",
      "name": "476",
      "hex": "#614b58",
      "rgb": [
        97,
        75,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:717",
      "brandId": "cosmo",
      "reference": "717",
      "name": "717",
      "hex": "#615740",
      "rgb": [
        97,
        87,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2015",
      "brandId": "cosmo",
      "reference": "2015",
      "name": "2015",
      "hex": "#616e53",
      "rgb": [
        97,
        110,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:898",
      "brandId": "cosmo",
      "reference": "898",
      "name": "898",
      "hex": "#61ad9c",
      "rgb": [
        97,
        173,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:264",
      "brandId": "cosmo",
      "reference": "264",
      "name": "264",
      "hex": "#624283",
      "rgb": [
        98,
        66,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:776",
      "brandId": "cosmo",
      "reference": "776",
      "name": "776",
      "hex": "#635025",
      "rgb": [
        99,
        80,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2013",
      "brandId": "cosmo",
      "reference": "2013",
      "name": "2013",
      "hex": "#636d34",
      "rgb": [
        99,
        109,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:272",
      "brandId": "cosmo",
      "reference": "272",
      "name": "272",
      "hex": "#63aa44",
      "rgb": [
        99,
        170,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:716",
      "brandId": "cosmo",
      "reference": "716",
      "name": "716",
      "hex": "#645b46",
      "rgb": [
        100,
        91,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:663",
      "brandId": "cosmo",
      "reference": "663",
      "name": "663",
      "hex": "#646faf",
      "rgb": [
        100,
        111,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:437",
      "brandId": "cosmo",
      "reference": "437",
      "name": "437",
      "hex": "#651a28",
      "rgb": [
        101,
        26,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:285",
      "brandId": "cosmo",
      "reference": "285",
      "name": "285",
      "hex": "#653488",
      "rgb": [
        101,
        52,
        136
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:174",
      "brandId": "cosmo",
      "reference": "174",
      "name": "174",
      "hex": "#655aa9",
      "rgb": [
        101,
        90,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:318",
      "brandId": "cosmo",
      "reference": "318",
      "name": "318",
      "hex": "#659971",
      "rgb": [
        101,
        153,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:674",
      "brandId": "cosmo",
      "reference": "674",
      "name": "674",
      "hex": "#666d2d",
      "rgb": [
        102,
        109,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:265",
      "brandId": "cosmo",
      "reference": "265",
      "name": "265",
      "hex": "#673c84",
      "rgb": [
        103,
        60,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:632",
      "brandId": "cosmo",
      "reference": "632",
      "name": "632",
      "hex": "#688e38",
      "rgb": [
        104,
        142,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:154",
      "brandId": "cosmo",
      "reference": "154",
      "name": "154",
      "hex": "#696767",
      "rgb": [
        105,
        103,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:924",
      "brandId": "cosmo",
      "reference": "924",
      "name": "924",
      "hex": "#697e52",
      "rgb": [
        105,
        126,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:246",
      "brandId": "cosmo",
      "reference": "246",
      "name": "246",
      "hex": "#6b1828",
      "rgb": [
        107,
        24,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2118",
      "brandId": "cosmo",
      "reference": "2118",
      "name": "2118",
      "hex": "#6b8f42",
      "rgb": [
        107,
        143,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:164",
      "brandId": "cosmo",
      "reference": "164",
      "name": "164",
      "hex": "#6b93bf",
      "rgb": [
        107,
        147,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3311",
      "brandId": "cosmo",
      "reference": "3311",
      "name": "3311",
      "hex": "#6c372a",
      "rgb": [
        108,
        55,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:764",
      "brandId": "cosmo",
      "reference": "764",
      "name": "764",
      "hex": "#6c4d71",
      "rgb": [
        108,
        77,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:368",
      "brandId": "cosmo",
      "reference": "368",
      "name": "368",
      "hex": "#6c6454",
      "rgb": [
        108,
        100,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2028",
      "brandId": "cosmo",
      "reference": "2028",
      "name": "2028",
      "hex": "#6c677c",
      "rgb": [
        108,
        103,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:893",
      "brandId": "cosmo",
      "reference": "893",
      "name": "893",
      "hex": "#6c6c66",
      "rgb": [
        108,
        108,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2412",
      "brandId": "cosmo",
      "reference": "2412",
      "name": "2412",
      "hex": "#6cafe0",
      "rgb": [
        108,
        175,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:130",
      "brandId": "cosmo",
      "reference": "130",
      "name": "130",
      "hex": "#6d3022",
      "rgb": [
        109,
        48,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:263",
      "brandId": "cosmo",
      "reference": "263",
      "name": "263",
      "hex": "#6d4c93",
      "rgb": [
        109,
        76,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2039",
      "brandId": "cosmo",
      "reference": "2039",
      "name": "2039",
      "hex": "#6d5d43",
      "rgb": [
        109,
        93,
        67
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2033",
      "brandId": "cosmo",
      "reference": "2033",
      "name": "2033",
      "hex": "#6f3961",
      "rgb": [
        111,
        57,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:825",
      "brandId": "cosmo",
      "reference": "825",
      "name": "825",
      "hex": "#6f6b2c",
      "rgb": [
        111,
        107,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2245",
      "brandId": "cosmo",
      "reference": "2245",
      "name": "2245",
      "hex": "#711331",
      "rgb": [
        113,
        19,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:4300",
      "brandId": "cosmo",
      "reference": "4300",
      "name": "4300",
      "hex": "#71202b",
      "rgb": [
        113,
        32,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:435",
      "brandId": "cosmo",
      "reference": "435",
      "name": "435",
      "hex": "#713b48",
      "rgb": [
        113,
        59,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:578",
      "brandId": "cosmo",
      "reference": "578",
      "name": "578",
      "hex": "#714324",
      "rgb": [
        113,
        67,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2563",
      "brandId": "cosmo",
      "reference": "2563",
      "name": "2563",
      "hex": "#71ada8",
      "rgb": [
        113,
        173,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:284",
      "brandId": "cosmo",
      "reference": "284",
      "name": "284",
      "hex": "#723e94",
      "rgb": [
        114,
        62,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:775A",
      "brandId": "cosmo",
      "reference": "775A",
      "name": "775A",
      "hex": "#725727",
      "rgb": [
        114,
        87,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:843",
      "brandId": "cosmo",
      "reference": "843",
      "name": "843",
      "hex": "#73be9c",
      "rgb": [
        115,
        190,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:426",
      "brandId": "cosmo",
      "reference": "426",
      "name": "426",
      "hex": "#74473d",
      "rgb": [
        116,
        71,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2022",
      "brandId": "cosmo",
      "reference": "2022",
      "name": "2022",
      "hex": "#74cae6",
      "rgb": [
        116,
        202,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:655",
      "brandId": "cosmo",
      "reference": "655",
      "name": "655",
      "hex": "#75262f",
      "rgb": [
        117,
        38,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2012",
      "brandId": "cosmo",
      "reference": "2012",
      "name": "2012",
      "hex": "#75784d",
      "rgb": [
        117,
        120,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2981",
      "brandId": "cosmo",
      "reference": "2981",
      "name": "2981",
      "hex": "#75989d",
      "rgb": [
        117,
        152,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2310",
      "brandId": "cosmo",
      "reference": "2310",
      "name": "2310",
      "hex": "#76422b",
      "rgb": [
        118,
        66,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:384",
      "brandId": "cosmo",
      "reference": "384",
      "name": "384",
      "hex": "#765b51",
      "rgb": [
        118,
        91,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:118",
      "brandId": "cosmo",
      "reference": "118",
      "name": "118",
      "hex": "#769e45",
      "rgb": [
        118,
        158,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:373",
      "brandId": "cosmo",
      "reference": "373",
      "name": "373",
      "hex": "#77b8be",
      "rgb": [
        119,
        184,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:475",
      "brandId": "cosmo",
      "reference": "475",
      "name": "475",
      "hex": "#78646c",
      "rgb": [
        120,
        100,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:554",
      "brandId": "cosmo",
      "reference": "554",
      "name": "554",
      "hex": "#7868a2",
      "rgb": [
        120,
        104,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:715",
      "brandId": "cosmo",
      "reference": "715",
      "name": "715",
      "hex": "#786e5b",
      "rgb": [
        120,
        110,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:467",
      "brandId": "cosmo",
      "reference": "467",
      "name": "467",
      "hex": "#792224",
      "rgb": [
        121,
        34,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2317",
      "brandId": "cosmo",
      "reference": "2317",
      "name": "2317",
      "hex": "#79ab7f",
      "rgb": [
        121,
        171,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:153A",
      "brandId": "cosmo",
      "reference": "153A",
      "name": "153A",
      "hex": "#7a7a78",
      "rgb": [
        122,
        122,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2662",
      "brandId": "cosmo",
      "reference": "2662",
      "name": "2662",
      "hex": "#7a85b7",
      "rgb": [
        122,
        133,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2631",
      "brandId": "cosmo",
      "reference": "2631",
      "name": "2631",
      "hex": "#7a9f3d",
      "rgb": [
        122,
        159,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2003",
      "brandId": "cosmo",
      "reference": "2003",
      "name": "2003",
      "hex": "#7b235f",
      "rgb": [
        123,
        35,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2212",
      "brandId": "cosmo",
      "reference": "2212",
      "name": "2212",
      "hex": "#7ba2d2",
      "rgb": [
        123,
        162,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:236",
      "brandId": "cosmo",
      "reference": "236",
      "name": "236",
      "hex": "#7c474f",
      "rgb": [
        124,
        71,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2037",
      "brandId": "cosmo",
      "reference": "2037",
      "name": "2037",
      "hex": "#7c685f",
      "rgb": [
        124,
        104,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:173",
      "brandId": "cosmo",
      "reference": "173",
      "name": "173",
      "hex": "#7c73b7",
      "rgb": [
        124,
        115,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:283",
      "brandId": "cosmo",
      "reference": "283",
      "name": "283",
      "hex": "#7d4da2",
      "rgb": [
        125,
        77,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2025",
      "brandId": "cosmo",
      "reference": "2025",
      "name": "2025",
      "hex": "#7dabcb",
      "rgb": [
        125,
        171,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:325A",
      "brandId": "cosmo",
      "reference": "325A",
      "name": "325A",
      "hex": "#7dac3e",
      "rgb": [
        125,
        172,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:486",
      "brandId": "cosmo",
      "reference": "486",
      "name": "486",
      "hex": "#802064",
      "rgb": [
        128,
        32,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2018",
      "brandId": "cosmo",
      "reference": "2018",
      "name": "2018",
      "hex": "#809ba5",
      "rgb": [
        128,
        155,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:684",
      "brandId": "cosmo",
      "reference": "684",
      "name": "684",
      "hex": "#818751",
      "rgb": [
        129,
        135,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:732",
      "brandId": "cosmo",
      "reference": "732",
      "name": "732",
      "hex": "#819dbb",
      "rgb": [
        129,
        157,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:981A",
      "brandId": "cosmo",
      "reference": "981A",
      "name": "981A",
      "hex": "#819fa2",
      "rgb": [
        129,
        159,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2032",
      "brandId": "cosmo",
      "reference": "2032",
      "name": "2032",
      "hex": "#824877",
      "rgb": [
        130,
        72,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2224",
      "brandId": "cosmo",
      "reference": "2224",
      "name": "2224",
      "hex": "#841f4a",
      "rgb": [
        132,
        31,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:563",
      "brandId": "cosmo",
      "reference": "563",
      "name": "563",
      "hex": "#84b9b3",
      "rgb": [
        132,
        185,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:309",
      "brandId": "cosmo",
      "reference": "309",
      "name": "309",
      "hex": "#855430",
      "rgb": [
        133,
        84,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:577A",
      "brandId": "cosmo",
      "reference": "577A",
      "name": "577A",
      "hex": "#855b2a",
      "rgb": [
        133,
        91,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:892",
      "brandId": "cosmo",
      "reference": "892",
      "name": "892",
      "hex": "#858177",
      "rgb": [
        133,
        129,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:673",
      "brandId": "cosmo",
      "reference": "673",
      "name": "673",
      "hex": "#858f37",
      "rgb": [
        133,
        143,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:923",
      "brandId": "cosmo",
      "reference": "923",
      "name": "923",
      "hex": "#85996c",
      "rgb": [
        133,
        153,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:774",
      "brandId": "cosmo",
      "reference": "774",
      "name": "774",
      "hex": "#876c2b",
      "rgb": [
        135,
        108,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:763",
      "brandId": "cosmo",
      "reference": "763",
      "name": "763",
      "hex": "#88698a",
      "rgb": [
        136,
        105,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:823",
      "brandId": "cosmo",
      "reference": "823",
      "name": "823",
      "hex": "#888133",
      "rgb": [
        136,
        129,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2241",
      "brandId": "cosmo",
      "reference": "2241",
      "name": "2241",
      "hex": "#89212b",
      "rgb": [
        137,
        33,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2262",
      "brandId": "cosmo",
      "reference": "2262",
      "name": "2262",
      "hex": "#8961a8",
      "rgb": [
        137,
        97,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:367",
      "brandId": "cosmo",
      "reference": "367",
      "name": "367",
      "hex": "#89816b",
      "rgb": [
        137,
        129,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:534A",
      "brandId": "cosmo",
      "reference": "534A",
      "name": "534A",
      "hex": "#89a98c",
      "rgb": [
        137,
        169,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:576",
      "brandId": "cosmo",
      "reference": "576",
      "name": "576",
      "hex": "#8b6129",
      "rgb": [
        139,
        97,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:334",
      "brandId": "cosmo",
      "reference": "334",
      "name": "334",
      "hex": "#8bc895",
      "rgb": [
        139,
        200,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:897",
      "brandId": "cosmo",
      "reference": "897",
      "name": "897",
      "hex": "#8bcdbd",
      "rgb": [
        139,
        205,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:271",
      "brandId": "cosmo",
      "reference": "271",
      "name": "271",
      "hex": "#8dc64e",
      "rgb": [
        141,
        198,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:434",
      "brandId": "cosmo",
      "reference": "434",
      "name": "434",
      "hex": "#8e4e61",
      "rgb": [
        142,
        78,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2762",
      "brandId": "cosmo",
      "reference": "2762",
      "name": "2762",
      "hex": "#8e7193",
      "rgb": [
        142,
        113,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:553",
      "brandId": "cosmo",
      "reference": "553",
      "name": "553",
      "hex": "#8e83b8",
      "rgb": [
        142,
        131,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2172",
      "brandId": "cosmo",
      "reference": "2172",
      "name": "2172",
      "hex": "#8e87c2",
      "rgb": [
        142,
        135,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:631",
      "brandId": "cosmo",
      "reference": "631",
      "name": "631",
      "hex": "#8eaa4b",
      "rgb": [
        142,
        170,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:466",
      "brandId": "cosmo",
      "reference": "466",
      "name": "466",
      "hex": "#8f3234",
      "rgb": [
        143,
        50,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:235",
      "brandId": "cosmo",
      "reference": "235",
      "name": "235",
      "hex": "#8f6672",
      "rgb": [
        143,
        102,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:317",
      "brandId": "cosmo",
      "reference": "317",
      "name": "317",
      "hex": "#8fb98e",
      "rgb": [
        143,
        185,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:714",
      "brandId": "cosmo",
      "reference": "714",
      "name": "714",
      "hex": "#908773",
      "rgb": [
        144,
        135,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:372",
      "brandId": "cosmo",
      "reference": "372",
      "name": "372",
      "hex": "#90c6cf",
      "rgb": [
        144,
        198,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:224",
      "brandId": "cosmo",
      "reference": "224",
      "name": "224",
      "hex": "#91375b",
      "rgb": [
        145,
        55,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:242",
      "brandId": "cosmo",
      "reference": "242",
      "name": "242",
      "hex": "#921b36",
      "rgb": [
        146,
        27,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:383",
      "brandId": "cosmo",
      "reference": "383",
      "name": "383",
      "hex": "#927c6d",
      "rgb": [
        146,
        124,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:662",
      "brandId": "cosmo",
      "reference": "662",
      "name": "662",
      "hex": "#929ec5",
      "rgb": [
        146,
        158,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2017",
      "brandId": "cosmo",
      "reference": "2017",
      "name": "2017",
      "hex": "#92b7b8",
      "rgb": [
        146,
        183,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:252",
      "brandId": "cosmo",
      "reference": "252",
      "name": "252",
      "hex": "#92c2cf",
      "rgb": [
        146,
        194,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:152A",
      "brandId": "cosmo",
      "reference": "152A",
      "name": "152A",
      "hex": "#93918a",
      "rgb": [
        147,
        145,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:163",
      "brandId": "cosmo",
      "reference": "163",
      "name": "163",
      "hex": "#94b9d7",
      "rgb": [
        148,
        185,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2129",
      "brandId": "cosmo",
      "reference": "2129",
      "name": "2129",
      "hex": "#95432c",
      "rgb": [
        149,
        67,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:523",
      "brandId": "cosmo",
      "reference": "523",
      "name": "523",
      "hex": "#96b6da",
      "rgb": [
        150,
        182,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:891",
      "brandId": "cosmo",
      "reference": "891",
      "name": "891",
      "hex": "#979283",
      "rgb": [
        151,
        146,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:731",
      "brandId": "cosmo",
      "reference": "731",
      "name": "731",
      "hex": "#98b3c8",
      "rgb": [
        152,
        179,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:654",
      "brandId": "cosmo",
      "reference": "654",
      "name": "654",
      "hex": "#99465a",
      "rgb": [
        153,
        70,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2117",
      "brandId": "cosmo",
      "reference": "2117",
      "name": "2117",
      "hex": "#99b060",
      "rgb": [
        153,
        176,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:129",
      "brandId": "cosmo",
      "reference": "129",
      "name": "129",
      "hex": "#9a412b",
      "rgb": [
        154,
        65,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:706",
      "brandId": "cosmo",
      "reference": "706",
      "name": "706",
      "hex": "#9a5d26",
      "rgb": [
        154,
        93,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:308",
      "brandId": "cosmo",
      "reference": "308",
      "name": "308",
      "hex": "#9b6438",
      "rgb": [
        155,
        100,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:474",
      "brandId": "cosmo",
      "reference": "474",
      "name": "474",
      "hex": "#9b888d",
      "rgb": [
        155,
        136,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:412",
      "brandId": "cosmo",
      "reference": "412",
      "name": "412",
      "hex": "#9bd2ee",
      "rgb": [
        155,
        210,
        238
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:816A",
      "brandId": "cosmo",
      "reference": "816A",
      "name": "816A",
      "hex": "#9c2b54",
      "rgb": [
        156,
        43,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:762",
      "brandId": "cosmo",
      "reference": "762",
      "name": "762",
      "hex": "#9c849d",
      "rgb": [
        156,
        132,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:324",
      "brandId": "cosmo",
      "reference": "324",
      "name": "324",
      "hex": "#9cc448",
      "rgb": [
        156,
        196,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:371",
      "brandId": "cosmo",
      "reference": "371",
      "name": "371",
      "hex": "#9cc8c7",
      "rgb": [
        156,
        200,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:842",
      "brandId": "cosmo",
      "reference": "842",
      "name": "842",
      "hex": "#9dd5b7",
      "rgb": [
        157,
        213,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:485A",
      "brandId": "cosmo",
      "reference": "485A",
      "name": "485A",
      "hex": "#9e2679",
      "rgb": [
        158,
        38,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2223",
      "brandId": "cosmo",
      "reference": "2223",
      "name": "2223",
      "hex": "#9e3061",
      "rgb": [
        158,
        48,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:465",
      "brandId": "cosmo",
      "reference": "465",
      "name": "465",
      "hex": "#9e3f3d",
      "rgb": [
        158,
        63,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:425",
      "brandId": "cosmo",
      "reference": "425",
      "name": "425",
      "hex": "#a16d5b",
      "rgb": [
        161,
        109,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:773",
      "brandId": "cosmo",
      "reference": "773",
      "name": "773",
      "hex": "#a38b35",
      "rgb": [
        163,
        139,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:562",
      "brandId": "cosmo",
      "reference": "562",
      "name": "562",
      "hex": "#a3d1c2",
      "rgb": [
        163,
        209,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:858",
      "brandId": "cosmo",
      "reference": "858",
      "name": "858",
      "hex": "#a4232a",
      "rgb": [
        164,
        35,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:815",
      "brandId": "cosmo",
      "reference": "815",
      "name": "815",
      "hex": "#a42f5b",
      "rgb": [
        164,
        47,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:188",
      "brandId": "cosmo",
      "reference": "188",
      "name": "188",
      "hex": "#a43328",
      "rgb": [
        164,
        51,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2307",
      "brandId": "cosmo",
      "reference": "2307",
      "name": "2307",
      "hex": "#a47348",
      "rgb": [
        164,
        115,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:262",
      "brandId": "cosmo",
      "reference": "262",
      "name": "262",
      "hex": "#a580bc",
      "rgb": [
        165,
        128,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2036",
      "brandId": "cosmo",
      "reference": "2036",
      "name": "2036",
      "hex": "#a59087",
      "rgb": [
        165,
        144,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:822",
      "brandId": "cosmo",
      "reference": "822",
      "name": "822",
      "hex": "#a59a3e",
      "rgb": [
        165,
        154,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:484A",
      "brandId": "cosmo",
      "reference": "484A",
      "name": "484A",
      "hex": "#a63c8a",
      "rgb": [
        166,
        60,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:282",
      "brandId": "cosmo",
      "reference": "282",
      "name": "282",
      "hex": "#a674ba",
      "rgb": [
        166,
        116,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:172A",
      "brandId": "cosmo",
      "reference": "172A",
      "name": "172A",
      "hex": "#a69dce",
      "rgb": [
        166,
        157,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:533A",
      "brandId": "cosmo",
      "reference": "533A",
      "name": "533A",
      "hex": "#a6c49e",
      "rgb": [
        166,
        196,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:922",
      "brandId": "cosmo",
      "reference": "922",
      "name": "922",
      "hex": "#a7b88e",
      "rgb": [
        167,
        184,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:980",
      "brandId": "cosmo",
      "reference": "980",
      "name": "980",
      "hex": "#a7bfc0",
      "rgb": [
        167,
        191,
        192
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:108",
      "brandId": "cosmo",
      "reference": "108",
      "name": "108",
      "hex": "#a82231",
      "rgb": [
        168,
        34,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:552",
      "brandId": "cosmo",
      "reference": "552",
      "name": "552",
      "hex": "#a89ccb",
      "rgb": [
        168,
        156,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:316A",
      "brandId": "cosmo",
      "reference": "316A",
      "name": "316A",
      "hex": "#a9cba8",
      "rgb": [
        169,
        203,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2011",
      "brandId": "cosmo",
      "reference": "2011",
      "name": "2011",
      "hex": "#a9d150",
      "rgb": [
        169,
        209,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:896",
      "brandId": "cosmo",
      "reference": "896",
      "name": "896",
      "hex": "#a9dbd0",
      "rgb": [
        169,
        219,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:1241",
      "brandId": "cosmo",
      "reference": "1241",
      "name": "1241",
      "hex": "#aa163c",
      "rgb": [
        170,
        22,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:223",
      "brandId": "cosmo",
      "reference": "223",
      "name": "223",
      "hex": "#aa427b",
      "rgb": [
        170,
        66,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:653",
      "brandId": "cosmo",
      "reference": "653",
      "name": "653",
      "hex": "#aa6074",
      "rgb": [
        170,
        96,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:713",
      "brandId": "cosmo",
      "reference": "713",
      "name": "713",
      "hex": "#aaa290",
      "rgb": [
        170,
        162,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:117",
      "brandId": "cosmo",
      "reference": "117",
      "name": "117",
      "hex": "#aabe69",
      "rgb": [
        170,
        190,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:683",
      "brandId": "cosmo",
      "reference": "683",
      "name": "683",
      "hex": "#abae71",
      "rgb": [
        171,
        174,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2034",
      "brandId": "cosmo",
      "reference": "2034",
      "name": "2034",
      "hex": "#ac93a6",
      "rgb": [
        172,
        147,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:890",
      "brandId": "cosmo",
      "reference": "890",
      "name": "890",
      "hex": "#aca99c",
      "rgb": [
        172,
        169,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:346",
      "brandId": "cosmo",
      "reference": "346",
      "name": "346",
      "hex": "#ae2229",
      "rgb": [
        174,
        34,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:464",
      "brandId": "cosmo",
      "reference": "464",
      "name": "464",
      "hex": "#ae534f",
      "rgb": [
        174,
        83,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2031",
      "brandId": "cosmo",
      "reference": "2031",
      "name": "2031",
      "hex": "#ae6ba6",
      "rgb": [
        174,
        107,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:705A",
      "brandId": "cosmo",
      "reference": "705A",
      "name": "705A",
      "hex": "#ae6f29",
      "rgb": [
        174,
        111,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2021",
      "brandId": "cosmo",
      "reference": "2021",
      "name": "2021",
      "hex": "#aee2e9",
      "rgb": [
        174,
        226,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:162A",
      "brandId": "cosmo",
      "reference": "162A",
      "name": "162A",
      "hex": "#afc6d4",
      "rgb": [
        175,
        198,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:270",
      "brandId": "cosmo",
      "reference": "270",
      "name": "270",
      "hex": "#afd762",
      "rgb": [
        175,
        215,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:241A",
      "brandId": "cosmo",
      "reference": "241A",
      "name": "241A",
      "hex": "#b0202f",
      "rgb": [
        176,
        32,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:234",
      "brandId": "cosmo",
      "reference": "234",
      "name": "234",
      "hex": "#b08294",
      "rgb": [
        176,
        130,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:433",
      "brandId": "cosmo",
      "reference": "433",
      "name": "433",
      "hex": "#b16d8a",
      "rgb": [
        177,
        109,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:473",
      "brandId": "cosmo",
      "reference": "473",
      "name": "473",
      "hex": "#b19fa2",
      "rgb": [
        177,
        159,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:522",
      "brandId": "cosmo",
      "reference": "522",
      "name": "522",
      "hex": "#b1c9de",
      "rgb": [
        177,
        201,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:575A",
      "brandId": "cosmo",
      "reference": "575A",
      "name": "575A",
      "hex": "#b28034",
      "rgb": [
        178,
        128,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2151",
      "brandId": "cosmo",
      "reference": "2151",
      "name": "2151",
      "hex": "#b2ada3",
      "rgb": [
        178,
        173,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:671",
      "brandId": "cosmo",
      "reference": "671",
      "name": "671",
      "hex": "#b2af50",
      "rgb": [
        178,
        175,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:366",
      "brandId": "cosmo",
      "reference": "366",
      "name": "366",
      "hex": "#b2b194",
      "rgb": [
        178,
        177,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2002",
      "brandId": "cosmo",
      "reference": "2002",
      "name": "2002",
      "hex": "#b32370",
      "rgb": [
        179,
        35,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:107",
      "brandId": "cosmo",
      "reference": "107",
      "name": "107",
      "hex": "#b32b41",
      "rgb": [
        179,
        43,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:333",
      "brandId": "cosmo",
      "reference": "333",
      "name": "333",
      "hex": "#b3ddb3",
      "rgb": [
        179,
        221,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2009",
      "brandId": "cosmo",
      "reference": "2009",
      "name": "2009",
      "hex": "#b4ae3f",
      "rgb": [
        180,
        174,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:345",
      "brandId": "cosmo",
      "reference": "345",
      "name": "345",
      "hex": "#b6232a",
      "rgb": [
        182,
        35,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2242",
      "brandId": "cosmo",
      "reference": "2242",
      "name": "2242",
      "hex": "#b62d53",
      "rgb": [
        182,
        45,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:382",
      "brandId": "cosmo",
      "reference": "382",
      "name": "382",
      "hex": "#b69b91",
      "rgb": [
        182,
        155,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:857",
      "brandId": "cosmo",
      "reference": "857",
      "name": "857",
      "hex": "#b82931",
      "rgb": [
        184,
        41,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:772",
      "brandId": "cosmo",
      "reference": "772",
      "name": "772",
      "hex": "#b89b46",
      "rgb": [
        184,
        155,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:630A",
      "brandId": "cosmo",
      "reference": "630A",
      "name": "630A",
      "hex": "#b8cc78",
      "rgb": [
        184,
        204,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:506",
      "brandId": "cosmo",
      "reference": "506",
      "name": "506",
      "hex": "#b91d58",
      "rgb": [
        185,
        29,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:921",
      "brandId": "cosmo",
      "reference": "921",
      "name": "921",
      "hex": "#b9c8a3",
      "rgb": [
        185,
        200,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2251",
      "brandId": "cosmo",
      "reference": "2251",
      "name": "2251",
      "hex": "#b9dcdd",
      "rgb": [
        185,
        220,
        221
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:814",
      "brandId": "cosmo",
      "reference": "814",
      "name": "814",
      "hex": "#bb4170",
      "rgb": [
        187,
        65,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:483",
      "brandId": "cosmo",
      "reference": "483",
      "name": "483",
      "hex": "#bc4a9b",
      "rgb": [
        188,
        74,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:307",
      "brandId": "cosmo",
      "reference": "307",
      "name": "307",
      "hex": "#bc9769",
      "rgb": [
        188,
        151,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2424",
      "brandId": "cosmo",
      "reference": "2424",
      "name": "2424",
      "hex": "#bd856f",
      "rgb": [
        189,
        133,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:411",
      "brandId": "cosmo",
      "reference": "411",
      "name": "411",
      "hex": "#bde4f2",
      "rgb": [
        189,
        228,
        242
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:106",
      "brandId": "cosmo",
      "reference": "106",
      "name": "106",
      "hex": "#be374c",
      "rgb": [
        190,
        55,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:855",
      "brandId": "cosmo",
      "reference": "855",
      "name": "855",
      "hex": "#be3b39",
      "rgb": [
        190,
        59,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:128",
      "brandId": "cosmo",
      "reference": "128",
      "name": "128",
      "hex": "#be5f42",
      "rgb": [
        190,
        95,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:561",
      "brandId": "cosmo",
      "reference": "561",
      "name": "561",
      "hex": "#bee5d0",
      "rgb": [
        190,
        229,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:463",
      "brandId": "cosmo",
      "reference": "463",
      "name": "463",
      "hex": "#bf706b",
      "rgb": [
        191,
        112,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2323",
      "brandId": "cosmo",
      "reference": "2323",
      "name": "2323",
      "hex": "#bfd771",
      "rgb": [
        191,
        215,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:800",
      "brandId": "cosmo",
      "reference": "800",
      "name": "800",
      "hex": "#c02129",
      "rgb": [
        192,
        33,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:406",
      "brandId": "cosmo",
      "reference": "406",
      "name": "406",
      "hex": "#c03627",
      "rgb": [
        192,
        54,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:761",
      "brandId": "cosmo",
      "reference": "761",
      "name": "761",
      "hex": "#c0a9bc",
      "rgb": [
        192,
        169,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:821",
      "brandId": "cosmo",
      "reference": "821",
      "name": "821",
      "hex": "#c0b65b",
      "rgb": [
        192,
        182,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:730",
      "brandId": "cosmo",
      "reference": "730",
      "name": "730",
      "hex": "#c0d5de",
      "rgb": [
        192,
        213,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:704",
      "brandId": "cosmo",
      "reference": "704",
      "name": "704",
      "hex": "#c1782b",
      "rgb": [
        193,
        120,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2281",
      "brandId": "cosmo",
      "reference": "2281",
      "name": "2281",
      "hex": "#c19bc9",
      "rgb": [
        193,
        155,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:472",
      "brandId": "cosmo",
      "reference": "472",
      "name": "472",
      "hex": "#c1aeae",
      "rgb": [
        193,
        174,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:171A",
      "brandId": "cosmo",
      "reference": "171A",
      "name": "171A",
      "hex": "#c1bcdb",
      "rgb": [
        193,
        188,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:269",
      "brandId": "cosmo",
      "reference": "269",
      "name": "269",
      "hex": "#c2de70",
      "rgb": [
        194,
        222,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:187",
      "brandId": "cosmo",
      "reference": "187",
      "name": "187",
      "hex": "#c33f2c",
      "rgb": [
        195,
        63,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:574",
      "brandId": "cosmo",
      "reference": "574",
      "name": "574",
      "hex": "#c5984b",
      "rgb": [
        197,
        152,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2006",
      "brandId": "cosmo",
      "reference": "2006",
      "name": "2006",
      "hex": "#c5aa33",
      "rgb": [
        197,
        170,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:712",
      "brandId": "cosmo",
      "reference": "712",
      "name": "712",
      "hex": "#c5bfb2",
      "rgb": [
        197,
        191,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:703",
      "brandId": "cosmo",
      "reference": "703",
      "name": "703",
      "hex": "#c68030",
      "rgb": [
        198,
        128,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:261",
      "brandId": "cosmo",
      "reference": "261",
      "name": "261",
      "hex": "#c6a2cb",
      "rgb": [
        198,
        162,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2005",
      "brandId": "cosmo",
      "reference": "2005",
      "name": "2005",
      "hex": "#c6b244",
      "rgb": [
        198,
        178,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3115",
      "brandId": "cosmo",
      "reference": "3115",
      "name": "3115",
      "hex": "#c81b45",
      "rgb": [
        200,
        27,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:771",
      "brandId": "cosmo",
      "reference": "771",
      "name": "771",
      "hex": "#c8b060",
      "rgb": [
        200,
        176,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2222",
      "brandId": "cosmo",
      "reference": "2222",
      "name": "2222",
      "hex": "#c96899",
      "rgb": [
        201,
        104,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:380",
      "brandId": "cosmo",
      "reference": "380",
      "name": "380",
      "hex": "#c9b5ac",
      "rgb": [
        201,
        181,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:551",
      "brandId": "cosmo",
      "reference": "551",
      "name": "551",
      "hex": "#c9bcd8",
      "rgb": [
        201,
        188,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:344",
      "brandId": "cosmo",
      "reference": "344",
      "name": "344",
      "hex": "#ca2d32",
      "rgb": [
        202,
        45,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2186",
      "brandId": "cosmo",
      "reference": "2186",
      "name": "2186",
      "hex": "#cb5435",
      "rgb": [
        203,
        84,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:151",
      "brandId": "cosmo",
      "reference": "151",
      "name": "151",
      "hex": "#cbc4b3",
      "rgb": [
        203,
        196,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2652",
      "brandId": "cosmo",
      "reference": "2652",
      "name": "2652",
      "hex": "#cc7f91",
      "rgb": [
        204,
        127,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2010",
      "brandId": "cosmo",
      "reference": "2010",
      "name": "2010",
      "hex": "#ccde52",
      "rgb": [
        204,
        222,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:323",
      "brandId": "cosmo",
      "reference": "323",
      "name": "323",
      "hex": "#cce08b",
      "rgb": [
        204,
        224,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:505A",
      "brandId": "cosmo",
      "reference": "505A",
      "name": "505A",
      "hex": "#cd2c71",
      "rgb": [
        205,
        44,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:573",
      "brandId": "cosmo",
      "reference": "573",
      "name": "573",
      "hex": "#cdaa6d",
      "rgb": [
        205,
        170,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:521A",
      "brandId": "cosmo",
      "reference": "521A",
      "name": "521A",
      "hex": "#cde0e2",
      "rgb": [
        205,
        224,
        226
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:813",
      "brandId": "cosmo",
      "reference": "813",
      "name": "813",
      "hex": "#ce6b8b",
      "rgb": [
        206,
        107,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:233",
      "brandId": "cosmo",
      "reference": "233",
      "name": "233",
      "hex": "#cea7ae",
      "rgb": [
        206,
        167,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:629",
      "brandId": "cosmo",
      "reference": "629",
      "name": "629",
      "hex": "#ced78e",
      "rgb": [
        206,
        215,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:240",
      "brandId": "cosmo",
      "reference": "240",
      "name": "240",
      "hex": "#cf2448",
      "rgb": [
        207,
        36,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:116",
      "brandId": "cosmo",
      "reference": "116",
      "name": "116",
      "hex": "#d1dd8c",
      "rgb": [
        209,
        221,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:462",
      "brandId": "cosmo",
      "reference": "462",
      "name": "462",
      "hex": "#d28984",
      "rgb": [
        210,
        137,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:652",
      "brandId": "cosmo",
      "reference": "652",
      "name": "652",
      "hex": "#d296a3",
      "rgb": [
        210,
        150,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:682",
      "brandId": "cosmo",
      "reference": "682",
      "name": "682",
      "hex": "#d2d5a1",
      "rgb": [
        210,
        213,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:503",
      "brandId": "cosmo",
      "reference": "503",
      "name": "503",
      "hex": "#d33b92",
      "rgb": [
        211,
        59,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2835",
      "brandId": "cosmo",
      "reference": "2835",
      "name": "2835",
      "hex": "#d34668",
      "rgb": [
        211,
        70,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:424",
      "brandId": "cosmo",
      "reference": "424",
      "name": "424",
      "hex": "#d39d87",
      "rgb": [
        211,
        157,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:281",
      "brandId": "cosmo",
      "reference": "281",
      "name": "281",
      "hex": "#d3b2d5",
      "rgb": [
        211,
        178,
        213
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:365",
      "brandId": "cosmo",
      "reference": "365",
      "name": "365",
      "hex": "#d3d2bb",
      "rgb": [
        211,
        210,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:306",
      "brandId": "cosmo",
      "reference": "306",
      "name": "306",
      "hex": "#d4b592",
      "rgb": [
        212,
        181,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2573",
      "brandId": "cosmo",
      "reference": "2573",
      "name": "2573",
      "hex": "#d5a354",
      "rgb": [
        213,
        163,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:854",
      "brandId": "cosmo",
      "reference": "854",
      "name": "854",
      "hex": "#d65650",
      "rgb": [
        214,
        86,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:482",
      "brandId": "cosmo",
      "reference": "482",
      "name": "482",
      "hex": "#d677b9",
      "rgb": [
        214,
        119,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:432A",
      "brandId": "cosmo",
      "reference": "432A",
      "name": "432A",
      "hex": "#d69fb7",
      "rgb": [
        214,
        159,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:504",
      "brandId": "cosmo",
      "reference": "504",
      "name": "504",
      "hex": "#d73386",
      "rgb": [
        215,
        51,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:820",
      "brandId": "cosmo",
      "reference": "820",
      "name": "820",
      "hex": "#d7d27f",
      "rgb": [
        215,
        210,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2702",
      "brandId": "cosmo",
      "reference": "2702",
      "name": "2702",
      "hex": "#d89b31",
      "rgb": [
        216,
        155,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:711",
      "brandId": "cosmo",
      "reference": "711",
      "name": "711",
      "hex": "#d8d0bf",
      "rgb": [
        216,
        208,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2007",
      "brandId": "cosmo",
      "reference": "2007",
      "name": "2007",
      "hex": "#d8e266",
      "rgb": [
        216,
        226,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2211",
      "brandId": "cosmo",
      "reference": "2211",
      "name": "2211",
      "hex": "#d8e9df",
      "rgb": [
        216,
        233,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2115",
      "brandId": "cosmo",
      "reference": "2115",
      "name": "2115",
      "hex": "#d9225d",
      "rgb": [
        217,
        34,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:520",
      "brandId": "cosmo",
      "reference": "520",
      "name": "520",
      "hex": "#d9e1e5",
      "rgb": [
        217,
        225,
        229
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:405",
      "brandId": "cosmo",
      "reference": "405",
      "name": "405",
      "hex": "#da4125",
      "rgb": [
        218,
        65,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:186",
      "brandId": "cosmo",
      "reference": "186",
      "name": "186",
      "hex": "#da6746",
      "rgb": [
        218,
        103,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:127",
      "brandId": "cosmo",
      "reference": "127",
      "name": "127",
      "hex": "#da8765",
      "rgb": [
        218,
        135,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:431",
      "brandId": "cosmo",
      "reference": "431",
      "name": "431",
      "hex": "#daa5b7",
      "rgb": [
        218,
        165,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:232",
      "brandId": "cosmo",
      "reference": "232",
      "name": "232",
      "hex": "#dab6b7",
      "rgb": [
        218,
        182,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2004",
      "brandId": "cosmo",
      "reference": "2004",
      "name": "2004",
      "hex": "#dac654",
      "rgb": [
        218,
        198,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:410A",
      "brandId": "cosmo",
      "reference": "410A",
      "name": "410A",
      "hex": "#daeff6",
      "rgb": [
        218,
        239,
        246
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2105",
      "brandId": "cosmo",
      "reference": "2105",
      "name": "2105",
      "hex": "#db4f6e",
      "rgb": [
        219,
        79,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:834A",
      "brandId": "cosmo",
      "reference": "834A",
      "name": "834A",
      "hex": "#db6684",
      "rgb": [
        219,
        102,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:222",
      "brandId": "cosmo",
      "reference": "222",
      "name": "222",
      "hex": "#dc80ac",
      "rgb": [
        220,
        128,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:798",
      "brandId": "cosmo",
      "reference": "798",
      "name": "798",
      "hex": "#dd1f2c",
      "rgb": [
        221,
        31,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2343",
      "brandId": "cosmo",
      "reference": "2343",
      "name": "2343",
      "hex": "#dd3b3c",
      "rgb": [
        221,
        59,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:812",
      "brandId": "cosmo",
      "reference": "812",
      "name": "812",
      "hex": "#dd90a5",
      "rgb": [
        221,
        144,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:681",
      "brandId": "cosmo",
      "reference": "681",
      "name": "681",
      "hex": "#dee0b9",
      "rgb": [
        222,
        224,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:853",
      "brandId": "cosmo",
      "reference": "853",
      "name": "853",
      "hex": "#df726a",
      "rgb": [
        223,
        114,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:423",
      "brandId": "cosmo",
      "reference": "423",
      "name": "423",
      "hex": "#dfb5a0",
      "rgb": [
        223,
        181,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:206",
      "brandId": "cosmo",
      "reference": "206",
      "name": "206",
      "hex": "#e02c4f",
      "rgb": [
        224,
        44,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:1105",
      "brandId": "cosmo",
      "reference": "1105",
      "name": "1105",
      "hex": "#e06080",
      "rgb": [
        224,
        96,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:126A",
      "brandId": "cosmo",
      "reference": "126A",
      "name": "126A",
      "hex": "#e0a581",
      "rgb": [
        224,
        165,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:461",
      "brandId": "cosmo",
      "reference": "461",
      "name": "461",
      "hex": "#e1a29a",
      "rgb": [
        225,
        162,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:838",
      "brandId": "cosmo",
      "reference": "838",
      "name": "838",
      "hex": "#e22c33",
      "rgb": [
        226,
        44,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:343",
      "brandId": "cosmo",
      "reference": "343",
      "name": "343",
      "hex": "#e24945",
      "rgb": [
        226,
        73,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:305",
      "brandId": "cosmo",
      "reference": "305",
      "name": "305",
      "hex": "#e2c8a3",
      "rgb": [
        226,
        200,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2008",
      "brandId": "cosmo",
      "reference": "2008",
      "name": "2008",
      "hex": "#e3e73f",
      "rgb": [
        227,
        231,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:502",
      "brandId": "cosmo",
      "reference": "502",
      "name": "502",
      "hex": "#e45bab",
      "rgb": [
        228,
        91,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:105",
      "brandId": "cosmo",
      "reference": "105",
      "name": "105",
      "hex": "#e57f95",
      "rgb": [
        229,
        127,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:115A",
      "brandId": "cosmo",
      "reference": "115A",
      "name": "115A",
      "hex": "#e63270",
      "rgb": [
        230,
        50,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:404",
      "brandId": "cosmo",
      "reference": "404",
      "name": "404",
      "hex": "#e6532d",
      "rgb": [
        230,
        83,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:342",
      "brandId": "cosmo",
      "reference": "342",
      "name": "342",
      "hex": "#e66a5a",
      "rgb": [
        230,
        106,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2221",
      "brandId": "cosmo",
      "reference": "2221",
      "name": "2221",
      "hex": "#e79db9",
      "rgb": [
        231,
        157,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:572",
      "brandId": "cosmo",
      "reference": "572",
      "name": "572",
      "hex": "#e7cb98",
      "rgb": [
        231,
        203,
        152
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:1000",
      "brandId": "cosmo",
      "reference": "1000",
      "name": "1000",
      "hex": "#e7d6b6",
      "rgb": [
        231,
        214,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2001",
      "brandId": "cosmo",
      "reference": "2001",
      "name": "2001",
      "hex": "#e82670",
      "rgb": [
        232,
        38,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:758",
      "brandId": "cosmo",
      "reference": "758",
      "name": "758",
      "hex": "#e82d2a",
      "rgb": [
        232,
        45,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:205A",
      "brandId": "cosmo",
      "reference": "205A",
      "name": "205A",
      "hex": "#e8427a",
      "rgb": [
        232,
        66,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3185",
      "brandId": "cosmo",
      "reference": "3185",
      "name": "3185",
      "hex": "#e88f75",
      "rgb": [
        232,
        143,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:811",
      "brandId": "cosmo",
      "reference": "811",
      "name": "811",
      "hex": "#e8acbe",
      "rgb": [
        232,
        172,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2114",
      "brandId": "cosmo",
      "reference": "2114",
      "name": "2114",
      "hex": "#e93f82",
      "rgb": [
        233,
        63,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:836",
      "brandId": "cosmo",
      "reference": "836",
      "name": "836",
      "hex": "#e95359",
      "rgb": [
        233,
        83,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:211",
      "brandId": "cosmo",
      "reference": "211",
      "name": "211",
      "hex": "#e9f1ef",
      "rgb": [
        233,
        241,
        239
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:364",
      "brandId": "cosmo",
      "reference": "364",
      "name": "364",
      "hex": "#eae9d6",
      "rgb": [
        234,
        233,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:114",
      "brandId": "cosmo",
      "reference": "114",
      "name": "114",
      "hex": "#eb60a7",
      "rgb": [
        235,
        96,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:702",
      "brandId": "cosmo",
      "reference": "702",
      "name": "702",
      "hex": "#ebc546",
      "rgb": [
        235,
        197,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3651",
      "brandId": "cosmo",
      "reference": "3651",
      "name": "3651",
      "hex": "#ebc7c7",
      "rgb": [
        235,
        199,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:757",
      "brandId": "cosmo",
      "reference": "757",
      "name": "757",
      "hex": "#ec392b",
      "rgb": [
        236,
        57,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:445A",
      "brandId": "cosmo",
      "reference": "445A",
      "name": "445A",
      "hex": "#ec3f35",
      "rgb": [
        236,
        63,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2341",
      "brandId": "cosmo",
      "reference": "2341",
      "name": "2341",
      "hex": "#ec916f",
      "rgb": [
        236,
        145,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2185",
      "brandId": "cosmo",
      "reference": "2185",
      "name": "2185",
      "hex": "#eca189",
      "rgb": [
        236,
        161,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:754",
      "brandId": "cosmo",
      "reference": "754",
      "name": "754",
      "hex": "#ed5031",
      "rgb": [
        237,
        80,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:204",
      "brandId": "cosmo",
      "reference": "204",
      "name": "204",
      "hex": "#ed579e",
      "rgb": [
        237,
        87,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:501",
      "brandId": "cosmo",
      "reference": "501",
      "name": "501",
      "hex": "#ed8bc4",
      "rgb": [
        237,
        139,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:481A",
      "brandId": "cosmo",
      "reference": "481A",
      "name": "481A",
      "hex": "#edb3d7",
      "rgb": [
        237,
        179,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:203",
      "brandId": "cosmo",
      "reference": "203",
      "name": "203",
      "hex": "#ee68a4",
      "rgb": [
        238,
        104,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:147",
      "brandId": "cosmo",
      "reference": "147",
      "name": "147",
      "hex": "#ee6b2f",
      "rgb": [
        238,
        107,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:113",
      "brandId": "cosmo",
      "reference": "113",
      "name": "113",
      "hex": "#ee8abf",
      "rgb": [
        238,
        138,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:403",
      "brandId": "cosmo",
      "reference": "403",
      "name": "403",
      "hex": "#ef7447",
      "rgb": [
        239,
        116,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:104",
      "brandId": "cosmo",
      "reference": "104",
      "name": "104",
      "hex": "#efa3af",
      "rgb": [
        239,
        163,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2480",
      "brandId": "cosmo",
      "reference": "2480",
      "name": "2480",
      "hex": "#efb7d9",
      "rgb": [
        239,
        183,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:444A",
      "brandId": "cosmo",
      "reference": "444A",
      "name": "444A",
      "hex": "#f05144",
      "rgb": [
        240,
        81,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:443",
      "brandId": "cosmo",
      "reference": "443",
      "name": "443",
      "hex": "#f06051",
      "rgb": [
        240,
        96,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:851",
      "brandId": "cosmo",
      "reference": "851",
      "name": "851",
      "hex": "#f0b4ab",
      "rgb": [
        240,
        180,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:753",
      "brandId": "cosmo",
      "reference": "753",
      "name": "753",
      "hex": "#f1734d",
      "rgb": [
        241,
        115,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:499",
      "brandId": "cosmo",
      "reference": "499",
      "name": "499",
      "hex": "#f1a8d0",
      "rgb": [
        241,
        168,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:146",
      "brandId": "cosmo",
      "reference": "146",
      "name": "146",
      "hex": "#f27e36",
      "rgb": [
        242,
        126,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:354",
      "brandId": "cosmo",
      "reference": "354",
      "name": "354",
      "hex": "#f287bc",
      "rgb": [
        242,
        135,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:441",
      "brandId": "cosmo",
      "reference": "441",
      "name": "441",
      "hex": "#f28981",
      "rgb": [
        242,
        137,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2402",
      "brandId": "cosmo",
      "reference": "2402",
      "name": "2402",
      "hex": "#f29561",
      "rgb": [
        242,
        149,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:112",
      "brandId": "cosmo",
      "reference": "112",
      "name": "112",
      "hex": "#f2a5cc",
      "rgb": [
        242,
        165,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:353",
      "brandId": "cosmo",
      "reference": "353",
      "name": "353",
      "hex": "#f49dc7",
      "rgb": [
        244,
        157,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:833",
      "brandId": "cosmo",
      "reference": "833",
      "name": "833",
      "hex": "#f4a5bc",
      "rgb": [
        244,
        165,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:221",
      "brandId": "cosmo",
      "reference": "221",
      "name": "221",
      "hex": "#f4c1d9",
      "rgb": [
        244,
        193,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:103A",
      "brandId": "cosmo",
      "reference": "103A",
      "name": "103A",
      "hex": "#f4c7c9",
      "rgb": [
        244,
        199,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:480A",
      "brandId": "cosmo",
      "reference": "480A",
      "name": "480A",
      "hex": "#f4d6e3",
      "rgb": [
        244,
        214,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:701",
      "brandId": "cosmo",
      "reference": "701",
      "name": "701",
      "hex": "#f4d96a",
      "rgb": [
        244,
        217,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:100",
      "brandId": "cosmo",
      "reference": "100",
      "name": "100",
      "hex": "#f4f4f4",
      "rgb": [
        244,
        244,
        244
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:752",
      "brandId": "cosmo",
      "reference": "752",
      "name": "752",
      "hex": "#f5a080",
      "rgb": [
        245,
        160,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:1402",
      "brandId": "cosmo",
      "reference": "1402",
      "name": "1402",
      "hex": "#f5a966",
      "rgb": [
        245,
        169,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:185A",
      "brandId": "cosmo",
      "reference": "185A",
      "name": "185A",
      "hex": "#f5bd99",
      "rgb": [
        245,
        189,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:340",
      "brandId": "cosmo",
      "reference": "340",
      "name": "340",
      "hex": "#f5bd9a",
      "rgb": [
        245,
        189,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2111",
      "brandId": "cosmo",
      "reference": "2111",
      "name": "2111",
      "hex": "#f5c2da",
      "rgb": [
        245,
        194,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2500",
      "brandId": "cosmo",
      "reference": "2500",
      "name": "2500",
      "hex": "#f5f5f5",
      "rgb": [
        245,
        245,
        245
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:440",
      "brandId": "cosmo",
      "reference": "440",
      "name": "440",
      "hex": "#f6a6a1",
      "rgb": [
        246,
        166,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:145",
      "brandId": "cosmo",
      "reference": "145",
      "name": "145",
      "hex": "#f6a73a",
      "rgb": [
        246,
        167,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:750A",
      "brandId": "cosmo",
      "reference": "750A",
      "name": "750A",
      "hex": "#f6ac89",
      "rgb": [
        246,
        172,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:402",
      "brandId": "cosmo",
      "reference": "402",
      "name": "402",
      "hex": "#f6c28b",
      "rgb": [
        246,
        194,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:341",
      "brandId": "cosmo",
      "reference": "341",
      "name": "341",
      "hex": "#f6cca7",
      "rgb": [
        246,
        204,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:700",
      "brandId": "cosmo",
      "reference": "700",
      "name": "700",
      "hex": "#f6e47b",
      "rgb": [
        246,
        228,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:299",
      "brandId": "cosmo",
      "reference": "299",
      "name": "299",
      "hex": "#f6ef72",
      "rgb": [
        246,
        239,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2299",
      "brandId": "cosmo",
      "reference": "2299",
      "name": "2299",
      "hex": "#f6f054",
      "rgb": [
        246,
        240,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:220",
      "brandId": "cosmo",
      "reference": "220",
      "name": "220",
      "hex": "#f7dbe2",
      "rgb": [
        247,
        219,
        226
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:500",
      "brandId": "cosmo",
      "reference": "500",
      "name": "500",
      "hex": "#f7f7f7",
      "rgb": [
        247,
        247,
        247
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:144A",
      "brandId": "cosmo",
      "reference": "144A",
      "name": "144A",
      "hex": "#f8c354",
      "rgb": [
        248,
        195,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:832",
      "brandId": "cosmo",
      "reference": "832",
      "name": "832",
      "hex": "#f8d2dd",
      "rgb": [
        248,
        210,
        221
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:102",
      "brandId": "cosmo",
      "reference": "102",
      "name": "102",
      "hex": "#f8dfd7",
      "rgb": [
        248,
        223,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:351",
      "brandId": "cosmo",
      "reference": "351",
      "name": "351",
      "hex": "#f8dfd8",
      "rgb": [
        248,
        223,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3299",
      "brandId": "cosmo",
      "reference": "3299",
      "name": "3299",
      "hex": "#f8e524",
      "rgb": [
        248,
        229,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:352",
      "brandId": "cosmo",
      "reference": "352",
      "name": "352",
      "hex": "#f9d1df",
      "rgb": [
        249,
        209,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:111",
      "brandId": "cosmo",
      "reference": "111",
      "name": "111",
      "hex": "#f9e5e9",
      "rgb": [
        249,
        229,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:101",
      "brandId": "cosmo",
      "reference": "101",
      "name": "101",
      "hex": "#f9e9de",
      "rgb": [
        249,
        233,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:852",
      "brandId": "cosmo",
      "reference": "852",
      "name": "852",
      "hex": "#fa978f",
      "rgb": [
        250,
        151,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:302",
      "brandId": "cosmo",
      "reference": "302",
      "name": "302",
      "hex": "#fad532",
      "rgb": [
        250,
        213,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:143",
      "brandId": "cosmo",
      "reference": "143",
      "name": "143",
      "hex": "#fae376",
      "rgb": [
        250,
        227,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:300",
      "brandId": "cosmo",
      "reference": "300",
      "name": "300",
      "hex": "#faec4d",
      "rgb": [
        250,
        236,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:140",
      "brandId": "cosmo",
      "reference": "140",
      "name": "140",
      "hex": "#faf3d5",
      "rgb": [
        250,
        243,
        213
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2297",
      "brandId": "cosmo",
      "reference": "2297",
      "name": "2297",
      "hex": "#faf585",
      "rgb": [
        250,
        245,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:297",
      "brandId": "cosmo",
      "reference": "297",
      "name": "297",
      "hex": "#faf5b0",
      "rgb": [
        250,
        245,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:2301",
      "brandId": "cosmo",
      "reference": "2301",
      "name": "2301",
      "hex": "#fbd821",
      "rgb": [
        251,
        216,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:301",
      "brandId": "cosmo",
      "reference": "301",
      "name": "301",
      "hex": "#fbe339",
      "rgb": [
        251,
        227,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:142",
      "brandId": "cosmo",
      "reference": "142",
      "name": "142",
      "hex": "#fbed9a",
      "rgb": [
        251,
        237,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:298",
      "brandId": "cosmo",
      "reference": "298",
      "name": "298",
      "hex": "#fbf183",
      "rgb": [
        251,
        241,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:141",
      "brandId": "cosmo",
      "reference": "141",
      "name": "141",
      "hex": "#fbf6c7",
      "rgb": [
        251,
        246,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:3297",
      "brandId": "cosmo",
      "reference": "3297",
      "name": "3297",
      "hex": "#fbf8a4",
      "rgb": [
        251,
        248,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cosmo:110",
      "brandId": "cosmo",
      "reference": "110",
      "name": "110",
      "hex": "#fcfcf2",
      "rgb": [
        252,
        252,
        242
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3808",
      "brandId": "cxc",
      "reference": "3808",
      "name": "Turquoise ultra very dark",
      "hex": "#004757",
      "rgb": [
        0,
        71,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3818",
      "brandId": "cxc",
      "reference": "3818",
      "name": "Emerald Green ultra very dark",
      "hex": "#004f36",
      "rgb": [
        0,
        79,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3847",
      "brandId": "cxc",
      "reference": "3847",
      "name": "Teal Green dark",
      "hex": "#00504d",
      "rgb": [
        0,
        80,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3765",
      "brandId": "cxc",
      "reference": "3765",
      "name": "Very Dark Peacock Blue",
      "hex": "#005879",
      "rgb": [
        0,
        88,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:699",
      "brandId": "cxc",
      "reference": "699",
      "name": "Christmas Green",
      "hex": "#005f3d",
      "rgb": [
        0,
        95,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:909",
      "brandId": "cxc",
      "reference": "909",
      "name": "Emerald Green very dark",
      "hex": "#006540",
      "rgb": [
        0,
        101,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:995",
      "brandId": "cxc",
      "reference": "995",
      "name": "Electric Blue dark",
      "hex": "#006fbc",
      "rgb": [
        0,
        111,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:700",
      "brandId": "cxc",
      "reference": "700",
      "name": "Christmas Green bright",
      "hex": "#00703e",
      "rgb": [
        0,
        112,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:910",
      "brandId": "cxc",
      "reference": "910",
      "name": "Emerald Green dark",
      "hex": "#007a4b",
      "rgb": [
        0,
        122,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3843",
      "brandId": "cxc",
      "reference": "3843",
      "name": "Electric Blue",
      "hex": "#0081c7",
      "rgb": [
        0,
        129,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3850",
      "brandId": "cxc",
      "reference": "3850",
      "name": "Bright Green dark",
      "hex": "#00856b",
      "rgb": [
        0,
        133,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:911",
      "brandId": "cxc",
      "reference": "911",
      "name": "Emerald Green medium",
      "hex": "#008853",
      "rgb": [
        0,
        136,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3812",
      "brandId": "cxc",
      "reference": "3812",
      "name": "Sea Green very dark",
      "hex": "#00887c",
      "rgb": [
        0,
        136,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3844",
      "brandId": "cxc",
      "reference": "3844",
      "name": "Bright Turquoise dark",
      "hex": "#0089b2",
      "rgb": [
        0,
        137,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:943",
      "brandId": "cxc",
      "reference": "943",
      "name": "Aquamarine medium",
      "hex": "#008f79",
      "rgb": [
        0,
        143,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:996",
      "brandId": "cxc",
      "reference": "996",
      "name": "Electric Blue medium",
      "hex": "#0097e1",
      "rgb": [
        0,
        151,
        225
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:958",
      "brandId": "cxc",
      "reference": "958",
      "name": "Sea Green dark",
      "hex": "#009887",
      "rgb": [
        0,
        152,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3845",
      "brandId": "cxc",
      "reference": "3845",
      "name": "Bright Turquoise medium",
      "hex": "#009bbe",
      "rgb": [
        0,
        155,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3851",
      "brandId": "cxc",
      "reference": "3851",
      "name": "Bright Green light",
      "hex": "#009f82",
      "rgb": [
        0,
        159,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3846",
      "brandId": "cxc",
      "reference": "3846",
      "name": "Bright Turquoise light",
      "hex": "#00afd1",
      "rgb": [
        0,
        175,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:310",
      "brandId": "cxc",
      "reference": "310",
      "name": "Black",
      "hex": "#0c0c0c",
      "rgb": [
        12,
        12,
        12
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3842",
      "brandId": "cxc",
      "reference": "3842",
      "name": "Wedgewood dark",
      "hex": "#0d3e6b",
      "rgb": [
        13,
        62,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:991",
      "brandId": "cxc",
      "reference": "991",
      "name": "Aquamarine dark",
      "hex": "#0d5850",
      "rgb": [
        13,
        88,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3814",
      "brandId": "cxc",
      "reference": "3814",
      "name": "Aquamarine",
      "hex": "#0d7163",
      "rgb": [
        13,
        113,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:701",
      "brandId": "cxc",
      "reference": "701",
      "name": "Christmas Green light",
      "hex": "#0d7338",
      "rgb": [
        13,
        115,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3809",
      "brandId": "cxc",
      "reference": "3809",
      "name": "Turquoise very dark",
      "hex": "#135c6d",
      "rgb": [
        19,
        92,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3848",
      "brandId": "cxc",
      "reference": "3848",
      "name": "Teal Green medium",
      "hex": "#186d6a",
      "rgb": [
        24,
        109,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:939",
      "brandId": "cxc",
      "reference": "939",
      "name": "Navy Blue very dark",
      "hex": "#1b1b2c",
      "rgb": [
        27,
        27,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:890",
      "brandId": "cxc",
      "reference": "890",
      "name": "Pistachio Green ultra dark",
      "hex": "#1b3623",
      "rgb": [
        27,
        54,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:824",
      "brandId": "cxc",
      "reference": "824",
      "name": "Blue very dark",
      "hex": "#1b3e71",
      "rgb": [
        27,
        62,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:825",
      "brandId": "cxc",
      "reference": "825",
      "name": "Blue dark",
      "hex": "#1b4f86",
      "rgb": [
        27,
        79,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:806",
      "brandId": "cxc",
      "reference": "806",
      "name": "Peacock Blue Dark",
      "hex": "#1d6c87",
      "rgb": [
        29,
        108,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:820",
      "brandId": "cxc",
      "reference": "820",
      "name": "Royal Blue very dark",
      "hex": "#202063",
      "rgb": [
        32,
        32,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:823",
      "brandId": "cxc",
      "reference": "823",
      "name": "Navy Blue dark",
      "hex": "#20233a",
      "rgb": [
        32,
        35,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:336",
      "brandId": "cxc",
      "reference": "336",
      "name": "Navy Blue",
      "hex": "#202c4f",
      "rgb": [
        32,
        44,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:311",
      "brandId": "cxc",
      "reference": "311",
      "name": "Navy Blue medium",
      "hex": "#203050",
      "rgb": [
        32,
        48,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:803",
      "brandId": "cxc",
      "reference": "803",
      "name": "Baby Blue ultra very dark",
      "hex": "#203660",
      "rgb": [
        32,
        54,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3750",
      "brandId": "cxc",
      "reference": "3750",
      "name": "Antique Blue very dark",
      "hex": "#23384f",
      "rgb": [
        35,
        56,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:312",
      "brandId": "cxc",
      "reference": "312",
      "name": "Navy Blue light",
      "hex": "#23426f",
      "rgb": [
        35,
        66,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:517",
      "brandId": "cxc",
      "reference": "517",
      "name": "Wedgewood dark",
      "hex": "#236391",
      "rgb": [
        35,
        99,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:796",
      "brandId": "cxc",
      "reference": "796",
      "name": "Royal Blue dark",
      "hex": "#242b70",
      "rgb": [
        36,
        43,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:895",
      "brandId": "cxc",
      "reference": "895",
      "name": "Hunter Green very dark",
      "hex": "#253d25",
      "rgb": [
        37,
        61,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:500",
      "brandId": "cxc",
      "reference": "500",
      "name": "Blue Green very dark",
      "hex": "#253d36",
      "rgb": [
        37,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:319",
      "brandId": "cxc",
      "reference": "319",
      "name": "Pistachio Green very dark",
      "hex": "#25402c",
      "rgb": [
        37,
        64,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:986",
      "brandId": "cxc",
      "reference": "986",
      "name": "Forest Green very dark",
      "hex": "#25502c",
      "rgb": [
        37,
        80,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:797",
      "brandId": "cxc",
      "reference": "797",
      "name": "Royal Blue",
      "hex": "#293a7c",
      "rgb": [
        41,
        58,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:924",
      "brandId": "cxc",
      "reference": "924",
      "name": "Grey Green very dark",
      "hex": "#294247",
      "rgb": [
        41,
        66,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:561",
      "brandId": "cxc",
      "reference": "561",
      "name": "Jade very dark",
      "hex": "#295544",
      "rgb": [
        41,
        85,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3371",
      "brandId": "cxc",
      "reference": "3371",
      "name": "Black Brown",
      "hex": "#2b2421",
      "rgb": [
        43,
        36,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:505",
      "brandId": "cxc",
      "reference": "505",
      "name": "Jade Green",
      "hex": "#2c6142",
      "rgb": [
        44,
        97,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3760",
      "brandId": "cxc",
      "reference": "3760",
      "name": "Wedgewood (806)",
      "hex": "#2c6f99",
      "rgb": [
        44,
        111,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:791",
      "brandId": "cxc",
      "reference": "791",
      "name": "Cornflower Blue very dark",
      "hex": "#2e2960",
      "rgb": [
        46,
        41,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:934",
      "brandId": "cxc",
      "reference": "934",
      "name": "Black Avocado Green",
      "hex": "#2e3425",
      "rgb": [
        46,
        52,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:158",
      "brandId": "cxc",
      "reference": "158",
      "name": "Cornflower Blue medium",
      "hex": "#303065",
      "rgb": [
        48,
        48,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3799",
      "brandId": "cxc",
      "reference": "3799",
      "name": "Pewter Grey very dark",
      "hex": "#303438",
      "rgb": [
        48,
        52,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:930",
      "brandId": "cxc",
      "reference": "930",
      "name": "Antique Blue dark",
      "hex": "#30465a",
      "rgb": [
        48,
        70,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:826",
      "brandId": "cxc",
      "reference": "826",
      "name": "Blue medium",
      "hex": "#306ba1",
      "rgb": [
        48,
        107,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:912",
      "brandId": "cxc",
      "reference": "912",
      "name": "Emerald Green light",
      "hex": "#309c66",
      "rgb": [
        48,
        156,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:959",
      "brandId": "cxc",
      "reference": "959",
      "name": "Sea Green medium",
      "hex": "#30ad9d",
      "rgb": [
        48,
        173,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3345",
      "brandId": "cxc",
      "reference": "3345",
      "name": "Hunter Green dark",
      "hex": "#344a25",
      "rgb": [
        52,
        74,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:904",
      "brandId": "cxc",
      "reference": "904",
      "name": "Parrot Green very dark",
      "hex": "#345f25",
      "rgb": [
        52,
        95,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3810",
      "brandId": "cxc",
      "reference": "3810",
      "name": "Turquoise dark",
      "hex": "#347b8c",
      "rgb": [
        52,
        123,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:702",
      "brandId": "cxc",
      "reference": "702",
      "name": "Kelly Green",
      "hex": "#34853e",
      "rgb": [
        52,
        133,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:935",
      "brandId": "cxc",
      "reference": "935",
      "name": "Avocado Green dark",
      "hex": "#363d2c",
      "rgb": [
        54,
        61,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:501",
      "brandId": "cxc",
      "reference": "501",
      "name": "Blue Green dark",
      "hex": "#36544a",
      "rgb": [
        54,
        84,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:992",
      "brandId": "cxc",
      "reference": "992",
      "name": "Aquamarine medium",
      "hex": "#369380",
      "rgb": [
        54,
        147,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:154",
      "brandId": "cxc",
      "reference": "154",
      "name": "Grape very dark",
      "hex": "#38172b",
      "rgb": [
        56,
        23,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3815",
      "brandId": "cxc",
      "reference": "3815",
      "name": "Celadon Green dark",
      "hex": "#386a57",
      "rgb": [
        56,
        106,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:792",
      "brandId": "cxc",
      "reference": "792",
      "name": "Cornflower Blue dark",
      "hex": "#3a3e82",
      "rgb": [
        58,
        62,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:520",
      "brandId": "cxc",
      "reference": "520",
      "name": "Fern Green dark",
      "hex": "#3a4734",
      "rgb": [
        58,
        71,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:562",
      "brandId": "cxc",
      "reference": "562",
      "name": "Jade medium",
      "hex": "#3a7c5a",
      "rgb": [
        58,
        124,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:938",
      "brandId": "cxc",
      "reference": "938",
      "name": "Coffee Brown ultra dark",
      "hex": "#3d2923",
      "rgb": [
        61,
        41,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:844",
      "brandId": "cxc",
      "reference": "844",
      "name": "Beaver Grey ultra dark",
      "hex": "#3d3d36",
      "rgb": [
        61,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:413",
      "brandId": "cxc",
      "reference": "413",
      "name": "Pewter Grey dark",
      "hex": "#3d4247",
      "rgb": [
        61,
        66,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:798",
      "brandId": "cxc",
      "reference": "798",
      "name": "Delft Blue dark",
      "hex": "#3d5fa3",
      "rgb": [
        61,
        95,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:905",
      "brandId": "cxc",
      "reference": "905",
      "name": "Parrot Green dark",
      "hex": "#3d7123",
      "rgb": [
        61,
        113,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:518",
      "brandId": "cxc",
      "reference": "518",
      "name": "Wedgewood light",
      "hex": "#3d84a4",
      "rgb": [
        61,
        132,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:367",
      "brandId": "cxc",
      "reference": "367",
      "name": "Pistachio Green dark",
      "hex": "#406647",
      "rgb": [
        64,
        102,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:322",
      "brandId": "cxc",
      "reference": "322",
      "name": "Baby Blue dark",
      "hex": "#40669b",
      "rgb": [
        64,
        102,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3031",
      "brandId": "cxc",
      "reference": "3031",
      "name": "Mocha Brown very dark",
      "hex": "#422e25",
      "rgb": [
        66,
        46,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:936",
      "brandId": "cxc",
      "reference": "936",
      "name": "Avocado Green very dark",
      "hex": "#424423",
      "rgb": [
        66,
        68,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3362",
      "brandId": "cxc",
      "reference": "3362",
      "name": "Pine Green dark",
      "hex": "#424a33",
      "rgb": [
        66,
        74,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3768",
      "brandId": "cxc",
      "reference": "3768",
      "name": "Grey Green dark",
      "hex": "#425b61",
      "rgb": [
        66,
        91,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:987",
      "brandId": "cxc",
      "reference": "987",
      "name": "Forest Green dark",
      "hex": "#42663a",
      "rgb": [
        66,
        102,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:163",
      "brandId": "cxc",
      "reference": "163",
      "name": "Celadon Green medium",
      "hex": "#44715b",
      "rgb": [
        68,
        113,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3849",
      "brandId": "cxc",
      "reference": "3849",
      "name": "Teal Green light",
      "hex": "#44918d",
      "rgb": [
        68,
        145,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:838",
      "brandId": "cxc",
      "reference": "838",
      "name": "Beige Brown very dark",
      "hex": "#453029",
      "rgb": [
        69,
        48,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3021",
      "brandId": "cxc",
      "reference": "3021",
      "name": "Brown Grey very dark",
      "hex": "#46382e",
      "rgb": [
        70,
        56,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3051",
      "brandId": "cxc",
      "reference": "3051",
      "name": "Green Grey dark",
      "hex": "#464d2e",
      "rgb": [
        70,
        77,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:937",
      "brandId": "cxc",
      "reference": "937",
      "name": "Avocado Green medium",
      "hex": "#465429",
      "rgb": [
        70,
        84,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:550",
      "brandId": "cxc",
      "reference": "550",
      "name": "Violet very dark",
      "hex": "#47184b",
      "rgb": [
        71,
        24,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3807",
      "brandId": "cxc",
      "reference": "3807",
      "name": "Cornflower Blue",
      "hex": "#47548f",
      "rgb": [
        71,
        84,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:09",
      "brandId": "cxc",
      "reference": "09",
      "name": "Very Dark Cocoa",
      "hex": "#483837",
      "rgb": [
        72,
        56,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:29",
      "brandId": "cxc",
      "reference": "29",
      "name": "Eggplant",
      "hex": "#493c5e",
      "rgb": [
        73,
        60,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:898",
      "brandId": "cxc",
      "reference": "898",
      "name": "Coffee Brown very dark",
      "hex": "#4a2e23",
      "rgb": [
        74,
        46,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3838",
      "brandId": "cxc",
      "reference": "3838",
      "name": "Lavender Blue dark",
      "hex": "#4a5ca6",
      "rgb": [
        74,
        92,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:334",
      "brandId": "cxc",
      "reference": "334",
      "name": "Baby Blue medium",
      "hex": "#4a75a6",
      "rgb": [
        74,
        117,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:535",
      "brandId": "cxc",
      "reference": "535",
      "name": "Ash Grey very light",
      "hex": "#4b4b46",
      "rgb": [
        75,
        75,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3346",
      "brandId": "cxc",
      "reference": "3346",
      "name": "Hunter Green",
      "hex": "#4d6130",
      "rgb": [
        77,
        97,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:597",
      "brandId": "cxc",
      "reference": "597",
      "name": "Turquoise",
      "hex": "#4d929f",
      "rgb": [
        77,
        146,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:913",
      "brandId": "cxc",
      "reference": "913",
      "name": "Nile Green medium",
      "hex": "#4daf78",
      "rgb": [
        77,
        175,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:645",
      "brandId": "cxc",
      "reference": "645",
      "name": "Beaver Grey very dark",
      "hex": "#4e5847",
      "rgb": [
        78,
        88,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:333",
      "brandId": "cxc",
      "reference": "333",
      "name": "Blue Violet very dark",
      "hex": "#4f3687",
      "rgb": [
        79,
        54,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:317",
      "brandId": "cxc",
      "reference": "317",
      "name": "Pewter Grey",
      "hex": "#4f5460",
      "rgb": [
        79,
        84,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:161",
      "brandId": "cxc",
      "reference": "161",
      "name": "Grey Blue",
      "hex": "#4f5c85",
      "rgb": [
        79,
        92,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3781",
      "brandId": "cxc",
      "reference": "3781",
      "name": "Mocha Brown dark",
      "hex": "#503d2e",
      "rgb": [
        80,
        61,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3787",
      "brandId": "cxc",
      "reference": "3787",
      "name": "Brown Grey dark",
      "hex": "#50473d",
      "rgb": [
        80,
        71,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:931",
      "brandId": "cxc",
      "reference": "931",
      "name": "Antique Blue medium",
      "hex": "#536a82",
      "rgb": [
        83,
        106,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:799",
      "brandId": "cxc",
      "reference": "799",
      "name": "Delft Blue medium",
      "hex": "#537bb5",
      "rgb": [
        83,
        123,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3816",
      "brandId": "cxc",
      "reference": "3816",
      "name": "Celadon Green",
      "hex": "#53836f",
      "rgb": [
        83,
        131,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:779",
      "brandId": "cxc",
      "reference": "779",
      "name": "Cocoa dark",
      "hex": "#543836",
      "rgb": [
        84,
        56,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:793",
      "brandId": "cxc",
      "reference": "793",
      "name": "Cornflower Blue medium",
      "hex": "#546497",
      "rgb": [
        84,
        100,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:502",
      "brandId": "cxc",
      "reference": "502",
      "name": "Blue Green",
      "hex": "#547565",
      "rgb": [
        84,
        117,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:839",
      "brandId": "cxc",
      "reference": "839",
      "name": "Beige Brown dark",
      "hex": "#553d34",
      "rgb": [
        85,
        61,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:993",
      "brandId": "cxc",
      "reference": "993",
      "name": "Aquamarine light",
      "hex": "#55ab90",
      "rgb": [
        85,
        171,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:32",
      "brandId": "cxc",
      "reference": "32",
      "name": "Dark Blueberry",
      "hex": "#565385",
      "rgb": [
        86,
        83,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3857",
      "brandId": "cxc",
      "reference": "3857",
      "name": "Rosewood dark",
      "hex": "#572523",
      "rgb": [
        87,
        37,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:801",
      "brandId": "cxc",
      "reference": "801",
      "name": "Coffee Brown dark",
      "hex": "#573324",
      "rgb": [
        87,
        51,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:730",
      "brandId": "cxc",
      "reference": "730",
      "name": "Olive Green very dark",
      "hex": "#574d20",
      "rgb": [
        87,
        77,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:469",
      "brandId": "cxc",
      "reference": "469",
      "name": "Avocado Green",
      "hex": "#575f23",
      "rgb": [
        87,
        95,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:35",
      "brandId": "cxc",
      "reference": "35",
      "name": "Very Dark Fuchsia",
      "hex": "#58274b",
      "rgb": [
        88,
        39,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3766",
      "brandId": "cxc",
      "reference": "3766",
      "name": "Peacock Blue light",
      "hex": "#58a2b9",
      "rgb": [
        88,
        162,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:320",
      "brandId": "cxc",
      "reference": "320",
      "name": "Pistachio Green medium",
      "hex": "#5a7f5a",
      "rgb": [
        90,
        127,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:988",
      "brandId": "cxc",
      "reference": "988",
      "name": "Forest Green medium",
      "hex": "#5a8044",
      "rgb": [
        90,
        128,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:906",
      "brandId": "cxc",
      "reference": "906",
      "name": "Parrot Green medium",
      "hex": "#5a8b23",
      "rgb": [
        90,
        139,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:814",
      "brandId": "cxc",
      "reference": "814",
      "name": "Garnet dark",
      "hex": "#5b1325",
      "rgb": [
        91,
        19,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:902",
      "brandId": "cxc",
      "reference": "902",
      "name": "Garnet very dark",
      "hex": "#5b202e",
      "rgb": [
        91,
        32,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3834",
      "brandId": "cxc",
      "reference": "3834",
      "name": "Grape dark",
      "hex": "#5b294a",
      "rgb": [
        91,
        41,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3363",
      "brandId": "cxc",
      "reference": "3363",
      "name": "Pine Green medium",
      "hex": "#5b6b4a",
      "rgb": [
        91,
        107,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3839",
      "brandId": "cxc",
      "reference": "3839",
      "name": "Lavender Blue medium",
      "hex": "#5b70ae",
      "rgb": [
        91,
        112,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3740",
      "brandId": "cxc",
      "reference": "3740",
      "name": "Antique Violet dark",
      "hex": "#5c3e4d",
      "rgb": [
        92,
        62,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3011",
      "brandId": "cxc",
      "reference": "3011",
      "name": "Khaki Green dark",
      "hex": "#5c5830",
      "rgb": [
        92,
        88,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:580",
      "brandId": "cxc",
      "reference": "580",
      "name": "Moss Green dark",
      "hex": "#5c5f20",
      "rgb": [
        92,
        95,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:809",
      "brandId": "cxc",
      "reference": "809",
      "name": "Delft Blue",
      "hex": "#5c92bb",
      "rgb": [
        92,
        146,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:327",
      "brandId": "cxc",
      "reference": "327",
      "name": "Violet",
      "hex": "#5e2e5e",
      "rgb": [
        94,
        46,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:829",
      "brandId": "cxc",
      "reference": "829",
      "name": "Golden Olive very dark",
      "hex": "#5f4220",
      "rgb": [
        95,
        66,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3802",
      "brandId": "cxc",
      "reference": "3802",
      "name": "Antique Mauve very dark",
      "hex": "#602c36",
      "rgb": [
        96,
        44,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:610",
      "brandId": "cxc",
      "reference": "610",
      "name": "Drab Brown dark",
      "hex": "#604a30",
      "rgb": [
        96,
        74,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3746",
      "brandId": "cxc",
      "reference": "3746",
      "name": "Blue Violet dark",
      "hex": "#604f9f",
      "rgb": [
        96,
        79,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:703",
      "brandId": "cxc",
      "reference": "703",
      "name": "Chartreuse",
      "hex": "#60a746",
      "rgb": [
        96,
        167,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3790",
      "brandId": "cxc",
      "reference": "3790",
      "name": "Beige Grey ultra dark",
      "hex": "#614d3d",
      "rgb": [
        97,
        77,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:926",
      "brandId": "cxc",
      "reference": "926",
      "name": "Grey Green medium",
      "hex": "#617878",
      "rgb": [
        97,
        120,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:300",
      "brandId": "cxc",
      "reference": "300",
      "name": "Mahogany very dark",
      "hex": "#632e20",
      "rgb": [
        99,
        46,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:433",
      "brandId": "cxc",
      "reference": "433",
      "name": "Brown medium",
      "hex": "#643823",
      "rgb": [
        100,
        56,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:414",
      "brandId": "cxc",
      "reference": "414",
      "name": "Steel Grey dark",
      "hex": "#646b78",
      "rgb": [
        100,
        107,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:31",
      "brandId": "cxc",
      "reference": "31",
      "name": "Blueberry",
      "hex": "#65629d",
      "rgb": [
        101,
        98,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:160",
      "brandId": "cxc",
      "reference": "160",
      "name": "Grey Blue medium",
      "hex": "#66759c",
      "rgb": [
        102,
        117,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:04",
      "brandId": "cxc",
      "reference": "04",
      "name": "Dark Tin",
      "hex": "#676464",
      "rgb": [
        103,
        100,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:830",
      "brandId": "cxc",
      "reference": "830",
      "name": "Golden Olive dark",
      "hex": "#694b23",
      "rgb": [
        105,
        75,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:08",
      "brandId": "cxc",
      "reference": "08",
      "name": "Dark Driftwood",
      "hex": "#695b50",
      "rgb": [
        105,
        91,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:732",
      "brandId": "cxc",
      "reference": "732",
      "name": "Olive Green (731)",
      "hex": "#695c20",
      "rgb": [
        105,
        92,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:646",
      "brandId": "cxc",
      "reference": "646",
      "name": "Beaver Grey dark",
      "hex": "#696359",
      "rgb": [
        105,
        99,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3755",
      "brandId": "cxc",
      "reference": "3755",
      "name": "Baby Blue",
      "hex": "#6998c4",
      "rgb": [
        105,
        152,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3685",
      "brandId": "cxc",
      "reference": "3685",
      "name": "Mauve dark",
      "hex": "#6a1836",
      "rgb": [
        106,
        24,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:470",
      "brandId": "cxc",
      "reference": "470",
      "name": "Avocado Green light",
      "hex": "#6a7830",
      "rgb": [
        106,
        120,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:731",
      "brandId": "cxc",
      "reference": "731",
      "name": "Olive Green Dark",
      "hex": "#6b580b",
      "rgb": [
        107,
        88,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3347",
      "brandId": "cxc",
      "reference": "3347",
      "name": "Yellow Green medium",
      "hex": "#6b834a",
      "rgb": [
        107,
        131,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3837",
      "brandId": "cxc",
      "reference": "3837",
      "name": "Lavender ultra dark",
      "hex": "#6c3681",
      "rgb": [
        108,
        54,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:989",
      "brandId": "cxc",
      "reference": "989",
      "name": "Forest Green",
      "hex": "#6c9254",
      "rgb": [
        108,
        146,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:954",
      "brandId": "cxc",
      "reference": "954",
      "name": "Nile Green",
      "hex": "#6cbe87",
      "rgb": [
        108,
        190,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:221",
      "brandId": "cxc",
      "reference": "221",
      "name": "Shell Pink very dark",
      "hex": "#6d2329",
      "rgb": [
        109,
        35,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:807",
      "brandId": "cxc",
      "reference": "807",
      "name": "Peacock Blue dark",
      "hex": "#6d9dc7",
      "rgb": [
        109,
        157,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:563",
      "brandId": "cxc",
      "reference": "563",
      "name": "Jade light",
      "hex": "#6db18c",
      "rgb": [
        109,
        177,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:315",
      "brandId": "cxc",
      "reference": "315",
      "name": "Antique Mauve dark",
      "hex": "#6f3842",
      "rgb": [
        111,
        56,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3860",
      "brandId": "cxc",
      "reference": "3860",
      "name": "Cocoa",
      "hex": "#6f4f4b",
      "rgb": [
        111,
        79,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:815",
      "brandId": "cxc",
      "reference": "815",
      "name": "Garnet medium",
      "hex": "#700d23",
      "rgb": [
        112,
        13,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:869",
      "brandId": "cxc",
      "reference": "869",
      "name": "Hazelnut Brown very dark",
      "hex": "#704725",
      "rgb": [
        112,
        71,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:611",
      "brandId": "cxc",
      "reference": "611",
      "name": "Drab Brown",
      "hex": "#705a3d",
      "rgb": [
        112,
        90,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:169",
      "brandId": "cxc",
      "reference": "169",
      "name": "Pewter light",
      "hex": "#707a7a",
      "rgb": [
        112,
        122,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:794",
      "brandId": "cxc",
      "reference": "794",
      "name": "Cornflower Blue light",
      "hex": "#708ab8",
      "rgb": [
        112,
        138,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3835",
      "brandId": "cxc",
      "reference": "3835",
      "name": "Grape medium",
      "hex": "#714061",
      "rgb": [
        113,
        64,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3052",
      "brandId": "cxc",
      "reference": "3052",
      "name": "Green Grey medium",
      "hex": "#717c54",
      "rgb": [
        113,
        124,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:632",
      "brandId": "cxc",
      "reference": "632",
      "name": "Desert Sand ultra very dark",
      "hex": "#723d34",
      "rgb": [
        114,
        61,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3041",
      "brandId": "cxc",
      "reference": "3041",
      "name": "Antique Violet medium",
      "hex": "#725465",
      "rgb": [
        114,
        84,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:640",
      "brandId": "cxc",
      "reference": "640",
      "name": "Beige Grey very dark",
      "hex": "#72644f",
      "rgb": [
        114,
        100,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:522",
      "brandId": "cxc",
      "reference": "522",
      "name": "Fern Green",
      "hex": "#727d5f",
      "rgb": [
        114,
        125,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3022",
      "brandId": "cxc",
      "reference": "3022",
      "name": "Brown Grey medium",
      "hex": "#73725f",
      "rgb": [
        115,
        114,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:156",
      "brandId": "cxc",
      "reference": "156",
      "name": "Blue Violet medium light",
      "hex": "#737db3",
      "rgb": [
        115,
        125,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:07",
      "brandId": "cxc",
      "reference": "07",
      "name": "Driftwood",
      "hex": "#746256",
      "rgb": [
        116,
        98,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:400",
      "brandId": "cxc",
      "reference": "400",
      "name": "Mahogany dark",
      "hex": "#753321",
      "rgb": [
        117,
        51,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3858",
      "brandId": "cxc",
      "reference": "3858",
      "name": "Rosewood medium",
      "hex": "#753d36",
      "rgb": [
        117,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:932",
      "brandId": "cxc",
      "reference": "932",
      "name": "Antique Blue light",
      "hex": "#758fa6",
      "rgb": [
        117,
        143,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:964",
      "brandId": "cxc",
      "reference": "964",
      "name": "Sea Green light",
      "hex": "#75cdc1",
      "rgb": [
        117,
        205,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:915",
      "brandId": "cxc",
      "reference": "915",
      "name": "Plum dark",
      "hex": "#76003d",
      "rgb": [
        118,
        0,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:155",
      "brandId": "cxc",
      "reference": "155",
      "name": "Blue Violet medium dark",
      "hex": "#7665ab",
      "rgb": [
        118,
        101,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:777",
      "brandId": "cxc",
      "reference": "777",
      "name": "Raspberry very dark",
      "hex": "#780d2c",
      "rgb": [
        120,
        13,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:831",
      "brandId": "cxc",
      "reference": "831",
      "name": "Golden Olive medium",
      "hex": "#785c25",
      "rgb": [
        120,
        92,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:704",
      "brandId": "cxc",
      "reference": "704",
      "name": "Chartreuse bright",
      "hex": "#78ad44",
      "rgb": [
        120,
        173,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:519",
      "brandId": "cxc",
      "reference": "519",
      "name": "Sky Blue",
      "hex": "#78b1c8",
      "rgb": [
        120,
        177,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:975",
      "brandId": "cxc",
      "reference": "975",
      "name": "Golden Brown dark",
      "hex": "#793a20",
      "rgb": [
        121,
        58,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:581",
      "brandId": "cxc",
      "reference": "581",
      "name": "Moss Green",
      "hex": "#797b29",
      "rgb": [
        121,
        123,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:34",
      "brandId": "cxc",
      "reference": "34",
      "name": "Dark Fuchsia",
      "hex": "#7a3070",
      "rgb": [
        122,
        48,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:451",
      "brandId": "cxc",
      "reference": "451",
      "name": "Shell Grey dark",
      "hex": "#7a6c6c",
      "rgb": [
        122,
        108,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:598",
      "brandId": "cxc",
      "reference": "598",
      "name": "Turquoise light",
      "hex": "#7ab2b5",
      "rgb": [
        122,
        178,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3803",
      "brandId": "cxc",
      "reference": "3803",
      "name": "Mauve medium",
      "hex": "#7b2544",
      "rgb": [
        123,
        37,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:918",
      "brandId": "cxc",
      "reference": "918",
      "name": "Red Copper dark",
      "hex": "#7b2e23",
      "rgb": [
        123,
        46,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:552",
      "brandId": "cxc",
      "reference": "552",
      "name": "Violet medium",
      "hex": "#7b3881",
      "rgb": [
        123,
        56,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:368",
      "brandId": "cxc",
      "reference": "368",
      "name": "Pistachio Green light",
      "hex": "#7ba476",
      "rgb": [
        123,
        164,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3862",
      "brandId": "cxc",
      "reference": "3862",
      "name": "Mocha Beige dark",
      "hex": "#7c553e",
      "rgb": [
        124,
        85,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:340",
      "brandId": "cxc",
      "reference": "340",
      "name": "Blue Violet medium",
      "hex": "#7c76be",
      "rgb": [
        124,
        118,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3012",
      "brandId": "cxc",
      "reference": "3012",
      "name": "Khaki Green medium",
      "hex": "#7d7340",
      "rgb": [
        125,
        115,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:647",
      "brandId": "cxc",
      "reference": "647",
      "name": "Beaver Grey medium",
      "hex": "#7d7b70",
      "rgb": [
        125,
        123,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:840",
      "brandId": "cxc",
      "reference": "840",
      "name": "Beige Brown medium",
      "hex": "#7f5c4a",
      "rgb": [
        127,
        92,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:434",
      "brandId": "cxc",
      "reference": "434",
      "name": "Brown light",
      "hex": "#804625",
      "rgb": [
        128,
        70,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3726",
      "brandId": "cxc",
      "reference": "3726",
      "name": "Antique Mauve dark",
      "hex": "#804653",
      "rgb": [
        128,
        70,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:318",
      "brandId": "cxc",
      "reference": "318",
      "name": "Steel Grey light",
      "hex": "#808796",
      "rgb": [
        128,
        135,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:28",
      "brandId": "cxc",
      "reference": "28",
      "name": "Medium Light Eggplant",
      "hex": "#8178a0",
      "rgb": [
        129,
        120,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3777",
      "brandId": "cxc",
      "reference": "3777",
      "name": "Terra Cotta very dark",
      "hex": "#822529",
      "rgb": [
        130,
        37,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:208",
      "brandId": "cxc",
      "reference": "208",
      "name": "Lavender very dark",
      "hex": "#824596",
      "rgb": [
        130,
        69,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:370",
      "brandId": "cxc",
      "reference": "370",
      "name": "Mustard medium",
      "hex": "#826e3d",
      "rgb": [
        130,
        110,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3817",
      "brandId": "cxc",
      "reference": "3817",
      "name": "Celadon Green light",
      "hex": "#82ab96",
      "rgb": [
        130,
        171,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:503",
      "brandId": "cxc",
      "reference": "503",
      "name": "Blue Green medium",
      "hex": "#839c8b",
      "rgb": [
        131,
        156,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3721",
      "brandId": "cxc",
      "reference": "3721",
      "name": "Shell Pink dark",
      "hex": "#85303a",
      "rgb": [
        133,
        48,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3840",
      "brandId": "cxc",
      "reference": "3840",
      "name": "Lavender Blue light",
      "hex": "#85a3ce",
      "rgb": [
        133,
        163,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:907",
      "brandId": "cxc",
      "reference": "907",
      "name": "Parrot Green light",
      "hex": "#87a623",
      "rgb": [
        135,
        166,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:827",
      "brandId": "cxc",
      "reference": "827",
      "name": "Blue very light",
      "hex": "#87b4d0",
      "rgb": [
        135,
        180,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:164",
      "brandId": "cxc",
      "reference": "164",
      "name": "Forest Green light",
      "hex": "#87bf78",
      "rgb": [
        135,
        191,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:498",
      "brandId": "cxc",
      "reference": "498",
      "name": "Christmas Red dark",
      "hex": "#880025",
      "rgb": [
        136,
        0,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:355",
      "brandId": "cxc",
      "reference": "355",
      "name": "Terra Cotta dark",
      "hex": "#882e2c",
      "rgb": [
        136,
        46,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:33",
      "brandId": "cxc",
      "reference": "33",
      "name": "Fuchsia",
      "hex": "#884b8e",
      "rgb": [
        136,
        75,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:927",
      "brandId": "cxc",
      "reference": "927",
      "name": "Grey Green light",
      "hex": "#889a97",
      "rgb": [
        136,
        154,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:816",
      "brandId": "cxc",
      "reference": "816",
      "name": "Garnet",
      "hex": "#89132c",
      "rgb": [
        137,
        19,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3364",
      "brandId": "cxc",
      "reference": "3364",
      "name": "Pine Green",
      "hex": "#89965f",
      "rgb": [
        137,
        150,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:30",
      "brandId": "cxc",
      "reference": "30",
      "name": "Medium Light Blueberry",
      "hex": "#8a89b0",
      "rgb": [
        138,
        137,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3053",
      "brandId": "cxc",
      "reference": "3053",
      "name": "Green Grey",
      "hex": "#8b9669",
      "rgb": [
        139,
        150,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:564",
      "brandId": "cxc",
      "reference": "564",
      "name": "Jade very light",
      "hex": "#8bc9a3",
      "rgb": [
        139,
        201,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:780",
      "brandId": "cxc",
      "reference": "780",
      "name": "Topaz ultra very dark",
      "hex": "#8c4a23",
      "rgb": [
        140,
        74,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:642",
      "brandId": "cxc",
      "reference": "642",
      "name": "Beige Grey dark",
      "hex": "#8c7d63",
      "rgb": [
        140,
        125,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3813",
      "brandId": "cxc",
      "reference": "3813",
      "name": "Blue Green light",
      "hex": "#8cac9d",
      "rgb": [
        140,
        172,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:167",
      "brandId": "cxc",
      "reference": "167",
      "name": "Yellow Beige very dark",
      "hex": "#8d643a",
      "rgb": [
        141,
        100,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3861",
      "brandId": "cxc",
      "reference": "3861",
      "name": "Cocoa light",
      "hex": "#8d6c6a",
      "rgb": [
        141,
        108,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:471",
      "brandId": "cxc",
      "reference": "471",
      "name": "Avocado Green very light",
      "hex": "#8d9d54",
      "rgb": [
        141,
        157,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:966",
      "brandId": "cxc",
      "reference": "966",
      "name": "Baby Green medium",
      "hex": "#8dbf8e",
      "rgb": [
        141,
        191,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:420",
      "brandId": "cxc",
      "reference": "420",
      "name": "Hazelnut Brown dark",
      "hex": "#8e6034",
      "rgb": [
        142,
        96,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:523",
      "brandId": "cxc",
      "reference": "523",
      "name": "Fern Green light",
      "hex": "#8e9773",
      "rgb": [
        142,
        151,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:800",
      "brandId": "cxc",
      "reference": "800",
      "name": "Delft Blue pale",
      "hex": "#8eb2d4",
      "rgb": [
        142,
        178,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3325",
      "brandId": "cxc",
      "reference": "3325",
      "name": "Baby Blue light",
      "hex": "#8eb8d8",
      "rgb": [
        142,
        184,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3761",
      "brandId": "cxc",
      "reference": "3761",
      "name": "Sky Blue light",
      "hex": "#8ec4d8",
      "rgb": [
        142,
        196,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:371",
      "brandId": "cxc",
      "reference": "371",
      "name": "Mustard",
      "hex": "#8f7a47",
      "rgb": [
        143,
        122,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:03",
      "brandId": "cxc",
      "reference": "03",
      "name": "Medium Tin",
      "hex": "#908f90",
      "rgb": [
        144,
        143,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:150",
      "brandId": "cxc",
      "reference": "150",
      "name": "Dusty Rose ultra very dark",
      "hex": "#911238",
      "rgb": [
        145,
        18,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:917",
      "brandId": "cxc",
      "reference": "917",
      "name": "Plum medium",
      "hex": "#911b5b",
      "rgb": [
        145,
        27,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:919",
      "brandId": "cxc",
      "reference": "919",
      "name": "Red Copper",
      "hex": "#912920",
      "rgb": [
        145,
        41,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:22",
      "brandId": "cxc",
      "reference": "22",
      "name": "Alizarin",
      "hex": "#922a29",
      "rgb": [
        146,
        42,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:553",
      "brandId": "cxc",
      "reference": "553",
      "name": "Violet",
      "hex": "#924f92",
      "rgb": [
        146,
        79,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3863",
      "brandId": "cxc",
      "reference": "3863",
      "name": "Mocha Beige medium",
      "hex": "#92694f",
      "rgb": [
        146,
        105,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:341",
      "brandId": "cxc",
      "reference": "341",
      "name": "Blue Violet light",
      "hex": "#929ecb",
      "rgb": [
        146,
        158,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3772",
      "brandId": "cxc",
      "reference": "3772",
      "name": "Desert Sand very dark",
      "hex": "#935a4b",
      "rgb": [
        147,
        90,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3023",
      "brandId": "cxc",
      "reference": "3023",
      "name": "Brown Grey light",
      "hex": "#938d76",
      "rgb": [
        147,
        141,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:157",
      "brandId": "cxc",
      "reference": "157",
      "name": "Cornflower Blue very light",
      "hex": "#95abca",
      "rgb": [
        149,
        171,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:813",
      "brandId": "cxc",
      "reference": "813",
      "name": "Blue light",
      "hex": "#95b2c9",
      "rgb": [
        149,
        178,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3811",
      "brandId": "cxc",
      "reference": "3811",
      "name": "Turquoise very light",
      "hex": "#95c5c6",
      "rgb": [
        149,
        197,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3042",
      "brandId": "cxc",
      "reference": "3042",
      "name": "Antique Violet light",
      "hex": "#967c8d",
      "rgb": [
        150,
        124,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3032",
      "brandId": "cxc",
      "reference": "3032",
      "name": "Mocha Brown medium",
      "hex": "#968669",
      "rgb": [
        150,
        134,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:159",
      "brandId": "cxc",
      "reference": "159",
      "name": "Grey Blue light",
      "hex": "#97a6c5",
      "rgb": [
        151,
        166,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:955",
      "brandId": "cxc",
      "reference": "955",
      "name": "Nile Green light",
      "hex": "#97dca8",
      "rgb": [
        151,
        220,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:733",
      "brandId": "cxc",
      "reference": "733",
      "name": "Olive Green medium",
      "hex": "#988630",
      "rgb": [
        152,
        134,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:648",
      "brandId": "cxc",
      "reference": "648",
      "name": "Beaver Grey light",
      "hex": "#98988b",
      "rgb": [
        152,
        152,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:13",
      "brandId": "cxc",
      "reference": "13",
      "name": "Medium Light Nile Green",
      "hex": "#98c29c",
      "rgb": [
        152,
        194,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3722",
      "brandId": "cxc",
      "reference": "3722",
      "name": "Shell Pink medium",
      "hex": "#99444d",
      "rgb": [
        153,
        68,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:301",
      "brandId": "cxc",
      "reference": "301",
      "name": "Mahogany medium",
      "hex": "#994725",
      "rgb": [
        153,
        71,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:612",
      "brandId": "cxc",
      "reference": "612",
      "name": "Drab Brown light",
      "hex": "#99815a",
      "rgb": [
        153,
        129,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:304",
      "brandId": "cxc",
      "reference": "304",
      "name": "Christmas Red medium",
      "hex": "#9a0029",
      "rgb": [
        154,
        0,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:832",
      "brandId": "cxc",
      "reference": "832",
      "name": "Golden Olive",
      "hex": "#9a762c",
      "rgb": [
        154,
        118,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:524",
      "brandId": "cxc",
      "reference": "524",
      "name": "Fern Green very light",
      "hex": "#9aa284",
      "rgb": [
        154,
        162,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:841",
      "brandId": "cxc",
      "reference": "841",
      "name": "Beige Brown light",
      "hex": "#9b7863",
      "rgb": [
        155,
        120,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3830",
      "brandId": "cxc",
      "reference": "3830",
      "name": "Terra Cotta",
      "hex": "#9c3a36",
      "rgb": [
        156,
        58,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3826",
      "brandId": "cxc",
      "reference": "3826",
      "name": "Golden Brown",
      "hex": "#9c4d25",
      "rgb": [
        156,
        77,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3752",
      "brandId": "cxc",
      "reference": "3752",
      "name": "Antique Blue very light",
      "hex": "#9db1bd",
      "rgb": [
        157,
        177,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3350",
      "brandId": "cxc",
      "reference": "3350",
      "name": "Dusty Rose ultra dark",
      "hex": "#9e2946",
      "rgb": [
        158,
        41,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3045",
      "brandId": "cxc",
      "reference": "3045",
      "name": "Yellow Beige dark",
      "hex": "#9f7646",
      "rgb": [
        159,
        118,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:452",
      "brandId": "cxc",
      "reference": "452",
      "name": "Shell Grey medium",
      "hex": "#9f8b8b",
      "rgb": [
        159,
        139,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:415",
      "brandId": "cxc",
      "reference": "415",
      "name": "Pearl Grey",
      "hex": "#9fa6b1",
      "rgb": [
        159,
        166,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3841",
      "brandId": "cxc",
      "reference": "3841",
      "name": "Baby Blue pale",
      "hex": "#9fbcce",
      "rgb": [
        159,
        188,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:166",
      "brandId": "cxc",
      "reference": "166",
      "name": "Moss Green medium light",
      "hex": "#a19f20",
      "rgb": [
        161,
        159,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:781",
      "brandId": "cxc",
      "reference": "781",
      "name": "Topaz Very Dark",
      "hex": "#a25f1f",
      "rgb": [
        162,
        95,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3836",
      "brandId": "cxc",
      "reference": "3836",
      "name": "Grape light",
      "hex": "#a26c90",
      "rgb": [
        162,
        108,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:162",
      "brandId": "cxc",
      "reference": "162",
      "name": "Blue ultra very light",
      "hex": "#a2c1d0",
      "rgb": [
        162,
        193,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:435",
      "brandId": "cxc",
      "reference": "435",
      "name": "Brown very light",
      "hex": "#a36134",
      "rgb": [
        163,
        97,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:372",
      "brandId": "cxc",
      "reference": "372",
      "name": "Mustard light",
      "hex": "#a39361",
      "rgb": [
        163,
        147,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3013",
      "brandId": "cxc",
      "reference": "3013",
      "name": "Khaki Green light",
      "hex": "#a39f6a",
      "rgb": [
        163,
        159,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3348",
      "brandId": "cxc",
      "reference": "3348",
      "name": "Yellow Green light",
      "hex": "#a3b86a",
      "rgb": [
        163,
        184,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:920",
      "brandId": "cxc",
      "reference": "920",
      "name": "Copper medium",
      "hex": "#a43d25",
      "rgb": [
        164,
        61,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3829",
      "brandId": "cxc",
      "reference": "3829",
      "name": "Old Gold very dark",
      "hex": "#a46c2e",
      "rgb": [
        164,
        108,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:817",
      "brandId": "cxc",
      "reference": "817",
      "name": "Coral Red very dark",
      "hex": "#a60d1b",
      "rgb": [
        166,
        13,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:326",
      "brandId": "cxc",
      "reference": "326",
      "name": "Rose very deep",
      "hex": "#a61238",
      "rgb": [
        166,
        18,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:347",
      "brandId": "cxc",
      "reference": "347",
      "name": "Salmon very dark",
      "hex": "#a62030",
      "rgb": [
        166,
        32,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:209",
      "brandId": "cxc",
      "reference": "209",
      "name": "Lavender dark",
      "hex": "#a66cb3",
      "rgb": [
        166,
        108,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:680",
      "brandId": "cxc",
      "reference": "680",
      "name": "Old Gold dark",
      "hex": "#a67334",
      "rgb": [
        166,
        115,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3828",
      "brandId": "cxc",
      "reference": "3828",
      "name": "Hazelnut Brown",
      "hex": "#a67946",
      "rgb": [
        166,
        121,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:828",
      "brandId": "cxc",
      "reference": "828",
      "name": "Blue ultra very light",
      "hex": "#a6c9d4",
      "rgb": [
        166,
        201,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:718",
      "brandId": "cxc",
      "reference": "718",
      "name": "Plum",
      "hex": "#a7206f",
      "rgb": [
        167,
        32,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3831",
      "brandId": "cxc",
      "reference": "3831",
      "name": "Raspberry dark",
      "hex": "#a8203a",
      "rgb": [
        168,
        32,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:02",
      "brandId": "cxc",
      "reference": "02",
      "name": "Tin",
      "hex": "#ababab",
      "rgb": [
        171,
        171,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:168",
      "brandId": "cxc",
      "reference": "168",
      "name": "Pewter very light",
      "hex": "#abb3b7",
      "rgb": [
        171,
        179,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:928",
      "brandId": "cxc",
      "reference": "928",
      "name": "Grey Green very light",
      "hex": "#abb5b1",
      "rgb": [
        171,
        181,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:321",
      "brandId": "cxc",
      "reference": "321",
      "name": "Christmas Red",
      "hex": "#ac0025",
      "rgb": [
        172,
        0,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:782",
      "brandId": "cxc",
      "reference": "782",
      "name": "Topaz dark (781)",
      "hex": "#ac6520",
      "rgb": [
        172,
        101,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3782",
      "brandId": "cxc",
      "reference": "3782",
      "name": "Mocha Brown light",
      "hex": "#ac9278",
      "rgb": [
        172,
        146,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:613",
      "brandId": "cxc",
      "reference": "613",
      "name": "Drab Brown very light",
      "hex": "#ac966d",
      "rgb": [
        172,
        150,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:504",
      "brandId": "cxc",
      "reference": "504",
      "name": "Blue Green Very Light",
      "hex": "#acdac1",
      "rgb": [
        172,
        218,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:309",
      "brandId": "cxc",
      "reference": "309",
      "name": "Rose deep",
      "hex": "#ad203e",
      "rgb": [
        173,
        32,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:356",
      "brandId": "cxc",
      "reference": "356",
      "name": "Terra Cotta medium",
      "hex": "#ad4f45",
      "rgb": [
        173,
        79,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3747",
      "brandId": "cxc",
      "reference": "3747",
      "name": "Blue Violet very light",
      "hex": "#adbadf",
      "rgb": [
        173,
        186,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:747",
      "brandId": "cxc",
      "reference": "747",
      "name": "Sky Blue very light",
      "hex": "#addbe1",
      "rgb": [
        173,
        219,
        225
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:600",
      "brandId": "cxc",
      "reference": "600",
      "name": "Cranberry very dark",
      "hex": "#af0047",
      "rgb": [
        175,
        0,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:316",
      "brandId": "cxc",
      "reference": "316",
      "name": "Antique Mauve medium",
      "hex": "#af6a7f",
      "rgb": [
        175,
        106,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:833",
      "brandId": "cxc",
      "reference": "833",
      "name": "Golden Olive light",
      "hex": "#b08d3e",
      "rgb": [
        176,
        141,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:734",
      "brandId": "cxc",
      "reference": "734",
      "name": "Olive Green light",
      "hex": "#b09d47",
      "rgb": [
        176,
        157,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:16",
      "brandId": "cxc",
      "reference": "16",
      "name": "Light Chartreuse",
      "hex": "#b0b56a",
      "rgb": [
        176,
        181,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3687",
      "brandId": "cxc",
      "reference": "3687",
      "name": "Mauve",
      "hex": "#b13d64",
      "rgb": [
        177,
        61,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:407",
      "brandId": "cxc",
      "reference": "407",
      "name": "Clay Brown (3773)",
      "hex": "#b17260",
      "rgb": [
        177,
        114,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3864",
      "brandId": "cxc",
      "reference": "3864",
      "name": "Mocha Beige light",
      "hex": "#b1896f",
      "rgb": [
        177,
        137,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3753",
      "brandId": "cxc",
      "reference": "3753",
      "name": "Antique Blue ultra very light",
      "hex": "#b1c6d7",
      "rgb": [
        177,
        198,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3859",
      "brandId": "cxc",
      "reference": "3859",
      "name": "Rosewood light",
      "hex": "#b26d5c",
      "rgb": [
        178,
        109,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:223",
      "brandId": "cxc",
      "reference": "223",
      "name": "Shell Pink light",
      "hex": "#b35c65",
      "rgb": [
        179,
        92,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:06",
      "brandId": "cxc",
      "reference": "06",
      "name": "Medium Light Driftwood",
      "hex": "#b4a293",
      "rgb": [
        180,
        162,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:775",
      "brandId": "cxc",
      "reference": "775",
      "name": "Baby Blue very light",
      "hex": "#b4cfdb",
      "rgb": [
        180,
        207,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3064",
      "brandId": "cxc",
      "reference": "3064",
      "name": "Desert Sand",
      "hex": "#b87359",
      "rgb": [
        184,
        115,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3819",
      "brandId": "cxc",
      "reference": "3819",
      "name": "Moss Green light",
      "hex": "#b8b738",
      "rgb": [
        184,
        183,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:436",
      "brandId": "cxc",
      "reference": "436",
      "name": "Tan",
      "hex": "#b97c4a",
      "rgb": [
        185,
        124,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3024",
      "brandId": "cxc",
      "reference": "3024",
      "name": "Brown Grey very light",
      "hex": "#b9b09f",
      "rgb": [
        185,
        176,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3804",
      "brandId": "cxc",
      "reference": "3804",
      "name": "Cyclamen Pink dark",
      "hex": "#ba1861",
      "rgb": [
        186,
        24,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:644",
      "brandId": "cxc",
      "reference": "644",
      "name": "Beige Grey medium",
      "hex": "#bab094",
      "rgb": [
        186,
        176,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3743",
      "brandId": "cxc",
      "reference": "3743",
      "name": "Antique Violet very light",
      "hex": "#bba9b8",
      "rgb": [
        187,
        169,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:05",
      "brandId": "cxc",
      "reference": "05",
      "name": "Light Driftwood",
      "hex": "#bbafa5",
      "rgb": [
        187,
        175,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:26",
      "brandId": "cxc",
      "reference": "26",
      "name": "Pale Lavender",
      "hex": "#bbb0d1",
      "rgb": [
        187,
        176,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:472",
      "brandId": "cxc",
      "reference": "472",
      "name": "Avocado Green ultra light",
      "hex": "#bbbb60",
      "rgb": [
        187,
        187,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:921",
      "brandId": "cxc",
      "reference": "921",
      "name": "Copper",
      "hex": "#bc4d2e",
      "rgb": [
        188,
        77,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:422",
      "brandId": "cxc",
      "reference": "422",
      "name": "Hazelnut Brown light",
      "hex": "#bc935b",
      "rgb": [
        188,
        147,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:349",
      "brandId": "cxc",
      "reference": "349",
      "name": "Coral dark",
      "hex": "#bd1c29",
      "rgb": [
        189,
        28,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3776",
      "brandId": "cxc",
      "reference": "3776",
      "name": "Mahogany light",
      "hex": "#bd5f36",
      "rgb": [
        189,
        95,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:210",
      "brandId": "cxc",
      "reference": "210",
      "name": "Lavender medium",
      "hex": "#be91cd",
      "rgb": [
        190,
        145,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3607",
      "brandId": "cxc",
      "reference": "3607",
      "name": "Plum light",
      "hex": "#bf3d8f",
      "rgb": [
        191,
        61,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:842",
      "brandId": "cxc",
      "reference": "842",
      "name": "Beige Brown very light",
      "hex": "#bf9f87",
      "rgb": [
        191,
        159,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:453",
      "brandId": "cxc",
      "reference": "453",
      "name": "Shell Grey light",
      "hex": "#bfada6",
      "rgb": [
        191,
        173,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:21",
      "brandId": "cxc",
      "reference": "21",
      "name": "Light Alizarin",
      "hex": "#c0614d",
      "rgb": [
        192,
        97,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3731",
      "brandId": "cxc",
      "reference": "3731",
      "name": "Dusty Rose very dark",
      "hex": "#c1405f",
      "rgb": [
        193,
        64,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3328",
      "brandId": "cxc",
      "reference": "3328",
      "name": "Salmon dark",
      "hex": "#c1424b",
      "rgb": [
        193,
        66,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3778",
      "brandId": "cxc",
      "reference": "3778",
      "name": "Terra Cotta light",
      "hex": "#c1695a",
      "rgb": [
        193,
        105,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:369",
      "brandId": "cxc",
      "reference": "369",
      "name": "Pistachio Green very light",
      "hex": "#c1d49d",
      "rgb": [
        193,
        212,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:729",
      "brandId": "cxc",
      "reference": "729",
      "name": "Old Gold medium",
      "hex": "#c28940",
      "rgb": [
        194,
        137,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3072",
      "brandId": "cxc",
      "reference": "3072",
      "name": "Beaver Grey very light",
      "hex": "#c2c6be",
      "rgb": [
        194,
        198,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:772",
      "brandId": "cxc",
      "reference": "772",
      "name": "Yellow Green very light",
      "hex": "#c2da97",
      "rgb": [
        194,
        218,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3852",
      "brandId": "cxc",
      "reference": "3852",
      "name": "Straw very dark",
      "hex": "#c3801b",
      "rgb": [
        195,
        128,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:976",
      "brandId": "cxc",
      "reference": "976",
      "name": "Golden Brown medium",
      "hex": "#c46a2c",
      "rgb": [
        196,
        106,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:554",
      "brandId": "cxc",
      "reference": "554",
      "name": "Violet light",
      "hex": "#c48bc3",
      "rgb": [
        196,
        139,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:762",
      "brandId": "cxc",
      "reference": "762",
      "name": "Pearl Grey very light",
      "hex": "#c4c5ce",
      "rgb": [
        196,
        197,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3046",
      "brandId": "cxc",
      "reference": "3046",
      "name": "Yellow Beige medium",
      "hex": "#c5a966",
      "rgb": [
        197,
        169,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:01",
      "brandId": "cxc",
      "reference": "01",
      "name": "White Tin",
      "hex": "#c5c5c5",
      "rgb": [
        197,
        197,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:601",
      "brandId": "cxc",
      "reference": "601",
      "name": "Cranberry dark",
      "hex": "#c61b57",
      "rgb": [
        198,
        27,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:900",
      "brandId": "cxc",
      "reference": "900",
      "name": "Burnt Orange dark",
      "hex": "#c63423",
      "rgb": [
        198,
        52,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3832",
      "brandId": "cxc",
      "reference": "3832",
      "name": "Raspberry medium",
      "hex": "#c63850",
      "rgb": [
        198,
        56,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:834",
      "brandId": "cxc",
      "reference": "834",
      "name": "Golden Olive very light",
      "hex": "#c7a550",
      "rgb": [
        199,
        165,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:666",
      "brandId": "cxc",
      "reference": "666",
      "name": "Christmas Red bright",
      "hex": "#c90023",
      "rgb": [
        201,
        0,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3727",
      "brandId": "cxc",
      "reference": "3727",
      "name": "Antique Mauve light",
      "hex": "#c9899c",
      "rgb": [
        201,
        137,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:778",
      "brandId": "cxc",
      "reference": "778",
      "name": "Antique Mauve very light",
      "hex": "#c9949e",
      "rgb": [
        201,
        148,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3805",
      "brandId": "cxc",
      "reference": "3805",
      "name": "Cyclamen Pink",
      "hex": "#cc2b73",
      "rgb": [
        204,
        43,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:152",
      "brandId": "cxc",
      "reference": "152",
      "name": "Shell Pink medium light",
      "hex": "#cc8285",
      "rgb": [
        204,
        130,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:19",
      "brandId": "cxc",
      "reference": "19",
      "name": "Medium Light Autumn Gold",
      "hex": "#cc9c52",
      "rgb": [
        204,
        156,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:165",
      "brandId": "cxc",
      "reference": "165",
      "name": "Moss Green very light",
      "hex": "#cdc965",
      "rgb": [
        205,
        201,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:15",
      "brandId": "cxc",
      "reference": "15",
      "name": "Apple Green",
      "hex": "#cdd684",
      "rgb": [
        205,
        214,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:10",
      "brandId": "cxc",
      "reference": "10",
      "name": "Very Light Tender Green",
      "hex": "#ceceb8",
      "rgb": [
        206,
        206,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:14",
      "brandId": "cxc",
      "reference": "14",
      "name": "Pale Apple Green",
      "hex": "#ced194",
      "rgb": [
        206,
        209,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3833",
      "brandId": "cxc",
      "reference": "3833",
      "name": "Raspberry light",
      "hex": "#cf556a",
      "rgb": [
        207,
        85,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3712",
      "brandId": "cxc",
      "reference": "3712",
      "name": "Salmon medium",
      "hex": "#cf575c",
      "rgb": [
        207,
        87,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3773",
      "brandId": "cxc",
      "reference": "3773",
      "name": "Desert Sand Medium",
      "hex": "#cf866d",
      "rgb": [
        207,
        134,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:12",
      "brandId": "cxc",
      "reference": "12",
      "name": "Tender Green",
      "hex": "#cfc662",
      "rgb": [
        207,
        198,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:783",
      "brandId": "cxc",
      "reference": "783",
      "name": "Topaz medium",
      "hex": "#d0842c",
      "rgb": [
        208,
        132,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:25",
      "brandId": "cxc",
      "reference": "25",
      "name": "Ultra Light Lavender",
      "hex": "#d0cadb",
      "rgb": [
        208,
        202,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3853",
      "brandId": "cxc",
      "reference": "3853",
      "name": "Autumn Gold dark",
      "hex": "#d1642c",
      "rgb": [
        209,
        100,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3688",
      "brandId": "cxc",
      "reference": "3688",
      "name": "Mauve medium",
      "hex": "#d16987",
      "rgb": [
        209,
        105,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:437",
      "brandId": "cxc",
      "reference": "437",
      "name": "Tan light",
      "hex": "#d19c6a",
      "rgb": [
        209,
        156,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:153",
      "brandId": "cxc",
      "reference": "153",
      "name": "Violet very light",
      "hex": "#d19ec4",
      "rgb": [
        209,
        158,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:720",
      "brandId": "cxc",
      "reference": "720",
      "name": "Orange Spice dark",
      "hex": "#d2421b",
      "rgb": [
        210,
        66,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3033",
      "brandId": "cxc",
      "reference": "3033",
      "name": "Mocha Brown very light",
      "hex": "#d2bda6",
      "rgb": [
        210,
        189,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:350",
      "brandId": "cxc",
      "reference": "350",
      "name": "Coral medium",
      "hex": "#d43434",
      "rgb": [
        212,
        52,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:335",
      "brandId": "cxc",
      "reference": "335",
      "name": "Rose",
      "hex": "#d44464",
      "rgb": [
        212,
        68,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:224",
      "brandId": "cxc",
      "reference": "224",
      "name": "Shell Pink very light",
      "hex": "#d48f8b",
      "rgb": [
        212,
        143,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:738",
      "brandId": "cxc",
      "reference": "738",
      "name": "Tan very light",
      "hex": "#d5a978",
      "rgb": [
        213,
        169,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:17",
      "brandId": "cxc",
      "reference": "17",
      "name": "Light Yellow Plum",
      "hex": "#d5c551",
      "rgb": [
        213,
        197,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3820",
      "brandId": "cxc",
      "reference": "3820",
      "name": "Straw dark",
      "hex": "#d6962b",
      "rgb": [
        214,
        150,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:211",
      "brandId": "cxc",
      "reference": "211",
      "name": "Lavender light",
      "hex": "#d6b5e3",
      "rgb": [
        214,
        181,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:602",
      "brandId": "cxc",
      "reference": "602",
      "name": "Cranberry medium",
      "hex": "#d7306d",
      "rgb": [
        215,
        48,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:922",
      "brandId": "cxc",
      "reference": "922",
      "name": "Copper light",
      "hex": "#d7633a",
      "rgb": [
        215,
        99,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3608",
      "brandId": "cxc",
      "reference": "3608",
      "name": "Plum very light",
      "hex": "#d770ad",
      "rgb": [
        215,
        112,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:961",
      "brandId": "cxc",
      "reference": "961",
      "name": "Dusty Rose dark",
      "hex": "#d94b6f",
      "rgb": [
        217,
        75,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:18",
      "brandId": "cxc",
      "reference": "18",
      "name": "Yellow Plum",
      "hex": "#d9bf4a",
      "rgb": [
        217,
        191,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:27",
      "brandId": "cxc",
      "reference": "27",
      "name": "White Violet",
      "hex": "#d9d4d8",
      "rgb": [
        217,
        212,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:758",
      "brandId": "cxc",
      "reference": "758",
      "name": "Terra Cotta very light",
      "hex": "#db917a",
      "rgb": [
        219,
        145,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3047",
      "brandId": "cxc",
      "reference": "3047",
      "name": "Yellow Beige light",
      "hex": "#dbc991",
      "rgb": [
        219,
        201,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3866",
      "brandId": "cxc",
      "reference": "3866",
      "name": "Mocha Brown ultra very light",
      "hex": "#ddd1be",
      "rgb": [
        221,
        209,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3756",
      "brandId": "cxc",
      "reference": "3756",
      "name": "Baby Blue ultra very light",
      "hex": "#ddedf3",
      "rgb": [
        221,
        237,
        243
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3771",
      "brandId": "cxc",
      "reference": "3771",
      "name": "Terra Cotta ultra very light",
      "hex": "#df9b7b",
      "rgb": [
        223,
        155,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:950",
      "brandId": "cxc",
      "reference": "950",
      "name": "Desert Sand light",
      "hex": "#dfac93",
      "rgb": [
        223,
        172,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3801",
      "brandId": "cxc",
      "reference": "3801",
      "name": "Christmas Red light",
      "hex": "#e02338",
      "rgb": [
        224,
        35,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:351",
      "brandId": "cxc",
      "reference": "351",
      "name": "Coral",
      "hex": "#e04d46",
      "rgb": [
        224,
        77,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3733",
      "brandId": "cxc",
      "reference": "3733",
      "name": "Dusty Rose",
      "hex": "#e06c85",
      "rgb": [
        224,
        108,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:822",
      "brandId": "cxc",
      "reference": "822",
      "name": "Beige Grey light",
      "hex": "#e0d6ba",
      "rgb": [
        224,
        214,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:24",
      "brandId": "cxc",
      "reference": "24",
      "name": "White Lavender",
      "hex": "#e0d9e4",
      "rgb": [
        224,
        217,
        228
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:11",
      "brandId": "cxc",
      "reference": "11",
      "name": "Light Tender Green",
      "hex": "#e0dc84",
      "rgb": [
        224,
        220,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3827",
      "brandId": "cxc",
      "reference": "3827",
      "name": "Golden Brown pale",
      "hex": "#e19858",
      "rgb": [
        225,
        152,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3821",
      "brandId": "cxc",
      "reference": "3821",
      "name": "Straw",
      "hex": "#e3b044",
      "rgb": [
        227,
        176,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3806",
      "brandId": "cxc",
      "reference": "3806",
      "name": "Cyclamen Pink light",
      "hex": "#e45592",
      "rgb": [
        228,
        85,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:962",
      "brandId": "cxc",
      "reference": "962",
      "name": "Dusty Rose medium",
      "hex": "#e46486",
      "rgb": [
        228,
        100,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:760",
      "brandId": "cxc",
      "reference": "760",
      "name": "Salmon",
      "hex": "#e5787f",
      "rgb": [
        229,
        120,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3609",
      "brandId": "cxc",
      "reference": "3609",
      "name": "Plum ultra light",
      "hex": "#e591ce",
      "rgb": [
        229,
        145,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3856",
      "brandId": "cxc",
      "reference": "3856",
      "name": "Mahogany ultra very light",
      "hex": "#e5a472",
      "rgb": [
        229,
        164,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:543",
      "brandId": "cxc",
      "reference": "543",
      "name": "Beige Brown ultra very light",
      "hex": "#e5c7ad",
      "rgb": [
        229,
        199,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:977",
      "brandId": "cxc",
      "reference": "977",
      "name": "Golden Brown light",
      "hex": "#e6833d",
      "rgb": [
        230,
        131,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:676",
      "brandId": "cxc",
      "reference": "676",
      "name": "Old Gold light",
      "hex": "#e6b469",
      "rgb": [
        230,
        180,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3354",
      "brandId": "cxc",
      "reference": "3354",
      "name": "Dusty Rose light",
      "hex": "#e7899e",
      "rgb": [
        231,
        137,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:606",
      "brandId": "cxc",
      "reference": "606",
      "name": "Burnt Orange-Red",
      "hex": "#e81820",
      "rgb": [
        232,
        24,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:402",
      "brandId": "cxc",
      "reference": "402",
      "name": "Mahogany very light",
      "hex": "#e8895b",
      "rgb": [
        232,
        137,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3779",
      "brandId": "cxc",
      "reference": "3779",
      "name": "Terra Cotta ultra very light",
      "hex": "#e8a492",
      "rgb": [
        232,
        164,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:23",
      "brandId": "cxc",
      "reference": "23",
      "name": "Apple Blossom",
      "hex": "#e8dadf",
      "rgb": [
        232,
        218,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:603",
      "brandId": "cxc",
      "reference": "603",
      "name": "Cranberry",
      "hex": "#e94f8c",
      "rgb": [
        233,
        79,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3774",
      "brandId": "cxc",
      "reference": "3774",
      "name": "Desert Sand very light",
      "hex": "#e9bea6",
      "rgb": [
        233,
        190,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:677",
      "brandId": "cxc",
      "reference": "677",
      "name": "Old Gold very light",
      "hex": "#eacf8e",
      "rgb": [
        234,
        207,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:899",
      "brandId": "cxc",
      "reference": "899",
      "name": "Rose medium",
      "hex": "#eb6682",
      "rgb": [
        235,
        102,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:739",
      "brandId": "cxc",
      "reference": "739",
      "name": "Tan ultra very light",
      "hex": "#edcda6",
      "rgb": [
        237,
        205,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:ECRU",
      "brandId": "cxc",
      "reference": "ECRU",
      "name": "Ecru",
      "hex": "#eddec4",
      "rgb": [
        237,
        222,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3705",
      "brandId": "cxc",
      "reference": "3705",
      "name": "Melon dark",
      "hex": "#ee3a4d",
      "rgb": [
        238,
        58,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:945",
      "brandId": "cxc",
      "reference": "945",
      "name": "Tawny medium",
      "hex": "#eeb28f",
      "rgb": [
        238,
        178,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:891",
      "brandId": "cxc",
      "reference": "891",
      "name": "Carnation dark",
      "hex": "#ef2c46",
      "rgb": [
        239,
        44,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:728",
      "brandId": "cxc",
      "reference": "728",
      "name": "Golden Yellow",
      "hex": "#efad3d",
      "rgb": [
        239,
        173,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:444",
      "brandId": "cxc",
      "reference": "444",
      "name": "Lemon dark",
      "hex": "#f0b900",
      "rgb": [
        240,
        185,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3822",
      "brandId": "cxc",
      "reference": "3822",
      "name": "Straw light",
      "hex": "#f0c65f",
      "rgb": [
        240,
        198,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:721",
      "brandId": "cxc",
      "reference": "721",
      "name": "Orange Spice medium",
      "hex": "#f25c2c",
      "rgb": [
        242,
        92,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:352",
      "brandId": "cxc",
      "reference": "352",
      "name": "Coral light",
      "hex": "#f27365",
      "rgb": [
        242,
        115,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3854",
      "brandId": "cxc",
      "reference": "3854",
      "name": "Autumn Gold medium",
      "hex": "#f29347",
      "rgb": [
        242,
        147,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:151",
      "brandId": "cxc",
      "reference": "151",
      "name": "Dusty Rose very light",
      "hex": "#f2a8ba",
      "rgb": [
        242,
        168,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:712",
      "brandId": "cxc",
      "reference": "712",
      "name": "Cream",
      "hex": "#f3e8d2",
      "rgb": [
        243,
        232,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:892",
      "brandId": "cxc",
      "reference": "892",
      "name": "Carnation medium",
      "hex": "#f43853",
      "rgb": [
        244,
        56,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:754",
      "brandId": "cxc",
      "reference": "754",
      "name": "Peach light",
      "hex": "#f4b096",
      "rgb": [
        244,
        176,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:946",
      "brandId": "cxc",
      "reference": "946",
      "name": "Burnt Orange medium",
      "hex": "#f53d1c",
      "rgb": [
        245,
        61,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:761",
      "brandId": "cxc",
      "reference": "761",
      "name": "Salmon light",
      "hex": "#f5a3a8",
      "rgb": [
        245,
        163,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3689",
      "brandId": "cxc",
      "reference": "3689",
      "name": "Mauve light",
      "hex": "#f5acc2",
      "rgb": [
        245,
        172,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:225",
      "brandId": "cxc",
      "reference": "225",
      "name": "Shell Pink ultra very light",
      "hex": "#f5c4bd",
      "rgb": [
        245,
        196,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:604",
      "brandId": "cxc",
      "reference": "604",
      "name": "Cranberry light",
      "hex": "#f67aad",
      "rgb": [
        246,
        122,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3326",
      "brandId": "cxc",
      "reference": "3326",
      "name": "Rose light (776)",
      "hex": "#f793a6",
      "rgb": [
        247,
        147,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:951",
      "brandId": "cxc",
      "reference": "951",
      "name": "Tawny light",
      "hex": "#f7cea9",
      "rgb": [
        247,
        206,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:20",
      "brandId": "cxc",
      "reference": "20",
      "name": "Shrimp",
      "hex": "#f7d1b3",
      "rgb": [
        247,
        209,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:445",
      "brandId": "cxc",
      "reference": "445",
      "name": "Lemon light",
      "hex": "#f7f57a",
      "rgb": [
        247,
        245,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3865",
      "brandId": "cxc",
      "reference": "3865",
      "name": "Winter White",
      "hex": "#f7f7f0",
      "rgb": [
        247,
        247,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:956",
      "brandId": "cxc",
      "reference": "956",
      "name": "Geranium",
      "hex": "#f94472",
      "rgb": [
        249,
        68,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3855",
      "brandId": "cxc",
      "reference": "3855",
      "name": "Autumn Gold light",
      "hex": "#f9c170",
      "rgb": [
        249,
        193,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3078",
      "brandId": "cxc",
      "reference": "3078",
      "name": "Golden Yellow very light",
      "hex": "#faeb97",
      "rgb": [
        250,
        235,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:746",
      "brandId": "cxc",
      "reference": "746",
      "name": "Off White",
      "hex": "#faf1c7",
      "rgb": [
        250,
        241,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:B5200",
      "brandId": "cxc",
      "reference": "B5200",
      "name": "Snow White",
      "hex": "#fafaff",
      "rgb": [
        250,
        250,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:893",
      "brandId": "cxc",
      "reference": "893",
      "name": "Carnation light",
      "hex": "#fb4d6d",
      "rgb": [
        251,
        77,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:307",
      "brandId": "cxc",
      "reference": "307",
      "name": "Lemon",
      "hex": "#fbde18",
      "rgb": [
        251,
        222,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:971",
      "brandId": "cxc",
      "reference": "971",
      "name": "Pumpkin",
      "hex": "#fc670d",
      "rgb": [
        252,
        103,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:776",
      "brandId": "cxc",
      "reference": "776",
      "name": "Pink Medium",
      "hex": "#fca8ad",
      "rgb": [
        252,
        168,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:725",
      "brandId": "cxc",
      "reference": "725",
      "name": "Topaz",
      "hex": "#fcba40",
      "rgb": [
        252,
        186,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:BLANC",
      "brandId": "cxc",
      "reference": "BLANC",
      "name": "White",
      "hex": "#fcfcfc",
      "rgb": [
        252,
        252,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:948",
      "brandId": "cxc",
      "reference": "948",
      "name": "Peach very light",
      "hex": "#fdd5c1",
      "rgb": [
        253,
        213,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3716",
      "brandId": "cxc",
      "reference": "3716",
      "name": "Dusty Rose very light",
      "hex": "#fe97af",
      "rgb": [
        254,
        151,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:605",
      "brandId": "cxc",
      "reference": "605",
      "name": "Cranberry very light",
      "hex": "#fe98c1",
      "rgb": [
        254,
        152,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:353",
      "brandId": "cxc",
      "reference": "353",
      "name": "Peach",
      "hex": "#fea693",
      "rgb": [
        254,
        166,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3823",
      "brandId": "cxc",
      "reference": "3823",
      "name": "Yellow ultra pale",
      "hex": "#feedb4",
      "rgb": [
        254,
        237,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:608",
      "brandId": "cxc",
      "reference": "608",
      "name": "Burnt Orange",
      "hex": "#ff4225",
      "rgb": [
        255,
        66,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:947",
      "brandId": "cxc",
      "reference": "947",
      "name": "Burnt Orange",
      "hex": "#ff4a1b",
      "rgb": [
        255,
        74,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3706",
      "brandId": "cxc",
      "reference": "3706",
      "name": "Melon medium",
      "hex": "#ff6175",
      "rgb": [
        255,
        97,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:970",
      "brandId": "cxc",
      "reference": "970",
      "name": "Pumpkin light",
      "hex": "#ff6624",
      "rgb": [
        255,
        102,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3340",
      "brandId": "cxc",
      "reference": "3340",
      "name": "Apricot medium",
      "hex": "#ff6647",
      "rgb": [
        255,
        102,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:740",
      "brandId": "cxc",
      "reference": "740",
      "name": "Tangerine (971)",
      "hex": "#ff6c1b",
      "rgb": [
        255,
        108,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:894",
      "brandId": "cxc",
      "reference": "894",
      "name": "Carnation very light",
      "hex": "#ff7c9a",
      "rgb": [
        255,
        124,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:957",
      "brandId": "cxc",
      "reference": "957",
      "name": "Geranium pale",
      "hex": "#ff7ca2",
      "rgb": [
        255,
        124,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3341",
      "brandId": "cxc",
      "reference": "3341",
      "name": "Apricot",
      "hex": "#ff8166",
      "rgb": [
        255,
        129,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:722",
      "brandId": "cxc",
      "reference": "722",
      "name": "Orange Spice light",
      "hex": "#ff824a",
      "rgb": [
        255,
        130,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:741",
      "brandId": "cxc",
      "reference": "741",
      "name": "Tangerine medium",
      "hex": "#ff8820",
      "rgb": [
        255,
        136,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3708",
      "brandId": "cxc",
      "reference": "3708",
      "name": "Melon light",
      "hex": "#ff889e",
      "rgb": [
        255,
        136,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3825",
      "brandId": "cxc",
      "reference": "3825",
      "name": "Pumpkin pale",
      "hex": "#ff9a63",
      "rgb": [
        255,
        154,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:972",
      "brandId": "cxc",
      "reference": "972",
      "name": "Canary deep",
      "hex": "#ffa400",
      "rgb": [
        255,
        164,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:742",
      "brandId": "cxc",
      "reference": "742",
      "name": "Tangerine light",
      "hex": "#ffa523",
      "rgb": [
        255,
        165,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3824",
      "brandId": "cxc",
      "reference": "3824",
      "name": "Apricot light",
      "hex": "#ffa58d",
      "rgb": [
        255,
        165,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:963",
      "brandId": "cxc",
      "reference": "963",
      "name": "Dusty Rose ultra very light",
      "hex": "#ffbac4",
      "rgb": [
        255,
        186,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:967",
      "brandId": "cxc",
      "reference": "967",
      "name": "Apricot very light",
      "hex": "#ffbea9",
      "rgb": [
        255,
        190,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3713",
      "brandId": "cxc",
      "reference": "3713",
      "name": "Salmon very light",
      "hex": "#ffc7c7",
      "rgb": [
        255,
        199,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:743",
      "brandId": "cxc",
      "reference": "743",
      "name": "Yellow medium",
      "hex": "#ffc847",
      "rgb": [
        255,
        200,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:973",
      "brandId": "cxc",
      "reference": "973",
      "name": "Canary bright",
      "hex": "#ffcf00",
      "rgb": [
        255,
        207,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:818",
      "brandId": "cxc",
      "reference": "818",
      "name": "Baby Pink",
      "hex": "#ffd0d2",
      "rgb": [
        255,
        208,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:726",
      "brandId": "cxc",
      "reference": "726",
      "name": "Topaz light",
      "hex": "#ffd447",
      "rgb": [
        255,
        212,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:744",
      "brandId": "cxc",
      "reference": "744",
      "name": "Yellow pale",
      "hex": "#ffde7a",
      "rgb": [
        255,
        222,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:819",
      "brandId": "cxc",
      "reference": "819",
      "name": "Baby Pink light",
      "hex": "#ffdeda",
      "rgb": [
        255,
        222,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:745",
      "brandId": "cxc",
      "reference": "745",
      "name": "Yellow light pale",
      "hex": "#ffdf89",
      "rgb": [
        255,
        223,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:727",
      "brandId": "cxc",
      "reference": "727",
      "name": "Topaz very light",
      "hex": "#ffe471",
      "rgb": [
        255,
        228,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "cxc:3770",
      "brandId": "cxc",
      "reference": "3770",
      "name": "Tawny very light",
      "hex": "#ffe6c9",
      "rgb": [
        255,
        230,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3808",
      "brandId": "dmc",
      "reference": "3808",
      "name": "Turquoise ultra very dark",
      "hex": "#004757",
      "rgb": [
        0,
        71,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3818",
      "brandId": "dmc",
      "reference": "3818",
      "name": "Emerald Green ultra very dark",
      "hex": "#004f36",
      "rgb": [
        0,
        79,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3847",
      "brandId": "dmc",
      "reference": "3847",
      "name": "Teal Green dark",
      "hex": "#00504d",
      "rgb": [
        0,
        80,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3765",
      "brandId": "dmc",
      "reference": "3765",
      "name": "Very Dark Peacock Blue",
      "hex": "#005879",
      "rgb": [
        0,
        88,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:699",
      "brandId": "dmc",
      "reference": "699",
      "name": "Christmas Green",
      "hex": "#005f3d",
      "rgb": [
        0,
        95,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:909",
      "brandId": "dmc",
      "reference": "909",
      "name": "Emerald Green very dark",
      "hex": "#006540",
      "rgb": [
        0,
        101,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:995",
      "brandId": "dmc",
      "reference": "995",
      "name": "Electric Blue dark",
      "hex": "#006fbc",
      "rgb": [
        0,
        111,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:700",
      "brandId": "dmc",
      "reference": "700",
      "name": "Christmas Green bright",
      "hex": "#00703e",
      "rgb": [
        0,
        112,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:910",
      "brandId": "dmc",
      "reference": "910",
      "name": "Emerald Green dark",
      "hex": "#007a4b",
      "rgb": [
        0,
        122,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3843",
      "brandId": "dmc",
      "reference": "3843",
      "name": "Electric Blue",
      "hex": "#0081c7",
      "rgb": [
        0,
        129,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3850",
      "brandId": "dmc",
      "reference": "3850",
      "name": "Bright Green dark",
      "hex": "#00856b",
      "rgb": [
        0,
        133,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:911",
      "brandId": "dmc",
      "reference": "911",
      "name": "Emerald Green medium",
      "hex": "#008853",
      "rgb": [
        0,
        136,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3812",
      "brandId": "dmc",
      "reference": "3812",
      "name": "Sea Green very dark",
      "hex": "#00887c",
      "rgb": [
        0,
        136,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3844",
      "brandId": "dmc",
      "reference": "3844",
      "name": "Bright Turquoise dark",
      "hex": "#0089b2",
      "rgb": [
        0,
        137,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:943",
      "brandId": "dmc",
      "reference": "943",
      "name": "Aquamarine medium",
      "hex": "#008f79",
      "rgb": [
        0,
        143,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:996",
      "brandId": "dmc",
      "reference": "996",
      "name": "Electric Blue medium",
      "hex": "#0097e1",
      "rgb": [
        0,
        151,
        225
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:958",
      "brandId": "dmc",
      "reference": "958",
      "name": "Sea Green dark",
      "hex": "#009887",
      "rgb": [
        0,
        152,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3845",
      "brandId": "dmc",
      "reference": "3845",
      "name": "Bright Turquoise medium",
      "hex": "#009bbe",
      "rgb": [
        0,
        155,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3851",
      "brandId": "dmc",
      "reference": "3851",
      "name": "Bright Green light",
      "hex": "#009f82",
      "rgb": [
        0,
        159,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3846",
      "brandId": "dmc",
      "reference": "3846",
      "name": "Bright Turquoise light",
      "hex": "#00afd1",
      "rgb": [
        0,
        175,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:310",
      "brandId": "dmc",
      "reference": "310",
      "name": "Black",
      "hex": "#0c0c0c",
      "rgb": [
        12,
        12,
        12
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3842",
      "brandId": "dmc",
      "reference": "3842",
      "name": "Wedgewood dark",
      "hex": "#0d3e6b",
      "rgb": [
        13,
        62,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:991",
      "brandId": "dmc",
      "reference": "991",
      "name": "Aquamarine dark",
      "hex": "#0d5850",
      "rgb": [
        13,
        88,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3814",
      "brandId": "dmc",
      "reference": "3814",
      "name": "Aquamarine",
      "hex": "#0d7163",
      "rgb": [
        13,
        113,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:701",
      "brandId": "dmc",
      "reference": "701",
      "name": "Christmas Green light",
      "hex": "#0d7338",
      "rgb": [
        13,
        115,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3809",
      "brandId": "dmc",
      "reference": "3809",
      "name": "Turquoise very dark",
      "hex": "#135c6d",
      "rgb": [
        19,
        92,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3848",
      "brandId": "dmc",
      "reference": "3848",
      "name": "Teal Green medium",
      "hex": "#186d6a",
      "rgb": [
        24,
        109,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:939",
      "brandId": "dmc",
      "reference": "939",
      "name": "Navy Blue very dark",
      "hex": "#1b1b2c",
      "rgb": [
        27,
        27,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:890",
      "brandId": "dmc",
      "reference": "890",
      "name": "Pistachio Green ultra dark",
      "hex": "#1b3623",
      "rgb": [
        27,
        54,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:824",
      "brandId": "dmc",
      "reference": "824",
      "name": "Blue very dark",
      "hex": "#1b3e71",
      "rgb": [
        27,
        62,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:825",
      "brandId": "dmc",
      "reference": "825",
      "name": "Blue dark",
      "hex": "#1b4f86",
      "rgb": [
        27,
        79,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:806",
      "brandId": "dmc",
      "reference": "806",
      "name": "Peacock Blue Dark",
      "hex": "#1d6c87",
      "rgb": [
        29,
        108,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:820",
      "brandId": "dmc",
      "reference": "820",
      "name": "Royal Blue very dark",
      "hex": "#202063",
      "rgb": [
        32,
        32,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:823",
      "brandId": "dmc",
      "reference": "823",
      "name": "Navy Blue dark",
      "hex": "#20233a",
      "rgb": [
        32,
        35,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:336",
      "brandId": "dmc",
      "reference": "336",
      "name": "Navy Blue",
      "hex": "#202c4f",
      "rgb": [
        32,
        44,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:311",
      "brandId": "dmc",
      "reference": "311",
      "name": "Navy Blue medium",
      "hex": "#203050",
      "rgb": [
        32,
        48,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:803",
      "brandId": "dmc",
      "reference": "803",
      "name": "Baby Blue ultra very dark",
      "hex": "#203660",
      "rgb": [
        32,
        54,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3750",
      "brandId": "dmc",
      "reference": "3750",
      "name": "Antique Blue very dark",
      "hex": "#23384f",
      "rgb": [
        35,
        56,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:312",
      "brandId": "dmc",
      "reference": "312",
      "name": "Navy Blue light",
      "hex": "#23426f",
      "rgb": [
        35,
        66,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:517",
      "brandId": "dmc",
      "reference": "517",
      "name": "Wedgewood dark",
      "hex": "#236391",
      "rgb": [
        35,
        99,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:796",
      "brandId": "dmc",
      "reference": "796",
      "name": "Royal Blue dark",
      "hex": "#242b70",
      "rgb": [
        36,
        43,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:895",
      "brandId": "dmc",
      "reference": "895",
      "name": "Hunter Green very dark",
      "hex": "#253d25",
      "rgb": [
        37,
        61,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:500",
      "brandId": "dmc",
      "reference": "500",
      "name": "Blue Green very dark",
      "hex": "#253d36",
      "rgb": [
        37,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:319",
      "brandId": "dmc",
      "reference": "319",
      "name": "Pistachio Green very dark",
      "hex": "#25402c",
      "rgb": [
        37,
        64,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:986",
      "brandId": "dmc",
      "reference": "986",
      "name": "Forest Green very dark",
      "hex": "#25502c",
      "rgb": [
        37,
        80,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:797",
      "brandId": "dmc",
      "reference": "797",
      "name": "Royal Blue",
      "hex": "#293a7c",
      "rgb": [
        41,
        58,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:924",
      "brandId": "dmc",
      "reference": "924",
      "name": "Grey Green very dark",
      "hex": "#294247",
      "rgb": [
        41,
        66,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:561",
      "brandId": "dmc",
      "reference": "561",
      "name": "Jade very dark",
      "hex": "#295544",
      "rgb": [
        41,
        85,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3371",
      "brandId": "dmc",
      "reference": "3371",
      "name": "Black Brown",
      "hex": "#2b2421",
      "rgb": [
        43,
        36,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:505",
      "brandId": "dmc",
      "reference": "505",
      "name": "Jade Green",
      "hex": "#2c6142",
      "rgb": [
        44,
        97,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3760",
      "brandId": "dmc",
      "reference": "3760",
      "name": "Wedgewood (806)",
      "hex": "#2c6f99",
      "rgb": [
        44,
        111,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:791",
      "brandId": "dmc",
      "reference": "791",
      "name": "Cornflower Blue very dark",
      "hex": "#2e2960",
      "rgb": [
        46,
        41,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:934",
      "brandId": "dmc",
      "reference": "934",
      "name": "Black Avocado Green",
      "hex": "#2e3425",
      "rgb": [
        46,
        52,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:158",
      "brandId": "dmc",
      "reference": "158",
      "name": "Cornflower Blue medium",
      "hex": "#303065",
      "rgb": [
        48,
        48,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3799",
      "brandId": "dmc",
      "reference": "3799",
      "name": "Pewter Grey very dark",
      "hex": "#303438",
      "rgb": [
        48,
        52,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:930",
      "brandId": "dmc",
      "reference": "930",
      "name": "Antique Blue dark",
      "hex": "#30465a",
      "rgb": [
        48,
        70,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:826",
      "brandId": "dmc",
      "reference": "826",
      "name": "Blue medium",
      "hex": "#306ba1",
      "rgb": [
        48,
        107,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:912",
      "brandId": "dmc",
      "reference": "912",
      "name": "Emerald Green light",
      "hex": "#309c66",
      "rgb": [
        48,
        156,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:959",
      "brandId": "dmc",
      "reference": "959",
      "name": "Sea Green medium",
      "hex": "#30ad9d",
      "rgb": [
        48,
        173,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3345",
      "brandId": "dmc",
      "reference": "3345",
      "name": "Hunter Green dark",
      "hex": "#344a25",
      "rgb": [
        52,
        74,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:904",
      "brandId": "dmc",
      "reference": "904",
      "name": "Parrot Green very dark",
      "hex": "#345f25",
      "rgb": [
        52,
        95,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3810",
      "brandId": "dmc",
      "reference": "3810",
      "name": "Turquoise dark",
      "hex": "#347b8c",
      "rgb": [
        52,
        123,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:702",
      "brandId": "dmc",
      "reference": "702",
      "name": "Kelly Green",
      "hex": "#34853e",
      "rgb": [
        52,
        133,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:935",
      "brandId": "dmc",
      "reference": "935",
      "name": "Avocado Green dark",
      "hex": "#363d2c",
      "rgb": [
        54,
        61,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:501",
      "brandId": "dmc",
      "reference": "501",
      "name": "Blue Green dark",
      "hex": "#36544a",
      "rgb": [
        54,
        84,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:992",
      "brandId": "dmc",
      "reference": "992",
      "name": "Aquamarine medium",
      "hex": "#369380",
      "rgb": [
        54,
        147,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:154",
      "brandId": "dmc",
      "reference": "154",
      "name": "Grape very dark",
      "hex": "#38172b",
      "rgb": [
        56,
        23,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3815",
      "brandId": "dmc",
      "reference": "3815",
      "name": "Celadon Green dark",
      "hex": "#386a57",
      "rgb": [
        56,
        106,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:792",
      "brandId": "dmc",
      "reference": "792",
      "name": "Cornflower Blue dark",
      "hex": "#3a3e82",
      "rgb": [
        58,
        62,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:520",
      "brandId": "dmc",
      "reference": "520",
      "name": "Fern Green dark",
      "hex": "#3a4734",
      "rgb": [
        58,
        71,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:562",
      "brandId": "dmc",
      "reference": "562",
      "name": "Jade medium",
      "hex": "#3a7c5a",
      "rgb": [
        58,
        124,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:938",
      "brandId": "dmc",
      "reference": "938",
      "name": "Coffee Brown ultra dark",
      "hex": "#3d2923",
      "rgb": [
        61,
        41,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:844",
      "brandId": "dmc",
      "reference": "844",
      "name": "Beaver Grey ultra dark",
      "hex": "#3d3d36",
      "rgb": [
        61,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:413",
      "brandId": "dmc",
      "reference": "413",
      "name": "Pewter Grey dark",
      "hex": "#3d4247",
      "rgb": [
        61,
        66,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:798",
      "brandId": "dmc",
      "reference": "798",
      "name": "Delft Blue dark",
      "hex": "#3d5fa3",
      "rgb": [
        61,
        95,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:905",
      "brandId": "dmc",
      "reference": "905",
      "name": "Parrot Green dark",
      "hex": "#3d7123",
      "rgb": [
        61,
        113,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:518",
      "brandId": "dmc",
      "reference": "518",
      "name": "Wedgewood light",
      "hex": "#3d84a4",
      "rgb": [
        61,
        132,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:367",
      "brandId": "dmc",
      "reference": "367",
      "name": "Pistachio Green dark",
      "hex": "#406647",
      "rgb": [
        64,
        102,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:322",
      "brandId": "dmc",
      "reference": "322",
      "name": "Baby Blue dark",
      "hex": "#40669b",
      "rgb": [
        64,
        102,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3031",
      "brandId": "dmc",
      "reference": "3031",
      "name": "Mocha Brown very dark",
      "hex": "#422e25",
      "rgb": [
        66,
        46,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:936",
      "brandId": "dmc",
      "reference": "936",
      "name": "Avocado Green very dark",
      "hex": "#424423",
      "rgb": [
        66,
        68,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3362",
      "brandId": "dmc",
      "reference": "3362",
      "name": "Pine Green dark",
      "hex": "#424a33",
      "rgb": [
        66,
        74,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3768",
      "brandId": "dmc",
      "reference": "3768",
      "name": "Grey Green dark",
      "hex": "#425b61",
      "rgb": [
        66,
        91,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:987",
      "brandId": "dmc",
      "reference": "987",
      "name": "Forest Green dark",
      "hex": "#42663a",
      "rgb": [
        66,
        102,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:163",
      "brandId": "dmc",
      "reference": "163",
      "name": "Celadon Green medium",
      "hex": "#44715b",
      "rgb": [
        68,
        113,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3849",
      "brandId": "dmc",
      "reference": "3849",
      "name": "Teal Green light",
      "hex": "#44918d",
      "rgb": [
        68,
        145,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:838",
      "brandId": "dmc",
      "reference": "838",
      "name": "Beige Brown very dark",
      "hex": "#453029",
      "rgb": [
        69,
        48,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3021",
      "brandId": "dmc",
      "reference": "3021",
      "name": "Brown Grey very dark",
      "hex": "#46382e",
      "rgb": [
        70,
        56,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3051",
      "brandId": "dmc",
      "reference": "3051",
      "name": "Green Grey dark",
      "hex": "#464d2e",
      "rgb": [
        70,
        77,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:937",
      "brandId": "dmc",
      "reference": "937",
      "name": "Avocado Green medium",
      "hex": "#465429",
      "rgb": [
        70,
        84,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:550",
      "brandId": "dmc",
      "reference": "550",
      "name": "Violet very dark",
      "hex": "#47184b",
      "rgb": [
        71,
        24,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3807",
      "brandId": "dmc",
      "reference": "3807",
      "name": "Cornflower Blue",
      "hex": "#47548f",
      "rgb": [
        71,
        84,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:9",
      "brandId": "dmc",
      "reference": "9",
      "name": "Very Dark Cocoa",
      "hex": "#483837",
      "rgb": [
        72,
        56,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:29",
      "brandId": "dmc",
      "reference": "29",
      "name": "Eggplant",
      "hex": "#493c5e",
      "rgb": [
        73,
        60,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:898",
      "brandId": "dmc",
      "reference": "898",
      "name": "Coffee Brown very dark",
      "hex": "#4a2e23",
      "rgb": [
        74,
        46,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3838",
      "brandId": "dmc",
      "reference": "3838",
      "name": "Lavender Blue dark",
      "hex": "#4a5ca6",
      "rgb": [
        74,
        92,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:334",
      "brandId": "dmc",
      "reference": "334",
      "name": "Baby Blue medium",
      "hex": "#4a75a6",
      "rgb": [
        74,
        117,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:535",
      "brandId": "dmc",
      "reference": "535",
      "name": "Ash Grey very light",
      "hex": "#4b4b46",
      "rgb": [
        75,
        75,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3346",
      "brandId": "dmc",
      "reference": "3346",
      "name": "Hunter Green",
      "hex": "#4d6130",
      "rgb": [
        77,
        97,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:597",
      "brandId": "dmc",
      "reference": "597",
      "name": "Turquoise",
      "hex": "#4d929f",
      "rgb": [
        77,
        146,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:913",
      "brandId": "dmc",
      "reference": "913",
      "name": "Nile Green medium",
      "hex": "#4daf78",
      "rgb": [
        77,
        175,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:645",
      "brandId": "dmc",
      "reference": "645",
      "name": "Beaver Grey very dark",
      "hex": "#4e5847",
      "rgb": [
        78,
        88,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:333",
      "brandId": "dmc",
      "reference": "333",
      "name": "Blue Violet very dark",
      "hex": "#4f3687",
      "rgb": [
        79,
        54,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:317",
      "brandId": "dmc",
      "reference": "317",
      "name": "Pewter Grey",
      "hex": "#4f5460",
      "rgb": [
        79,
        84,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:161",
      "brandId": "dmc",
      "reference": "161",
      "name": "Grey Blue",
      "hex": "#4f5c85",
      "rgb": [
        79,
        92,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3781",
      "brandId": "dmc",
      "reference": "3781",
      "name": "Mocha Brown dark",
      "hex": "#503d2e",
      "rgb": [
        80,
        61,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3787",
      "brandId": "dmc",
      "reference": "3787",
      "name": "Brown Grey dark",
      "hex": "#50473d",
      "rgb": [
        80,
        71,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:931",
      "brandId": "dmc",
      "reference": "931",
      "name": "Antique Blue medium",
      "hex": "#536a82",
      "rgb": [
        83,
        106,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:799",
      "brandId": "dmc",
      "reference": "799",
      "name": "Delft Blue medium",
      "hex": "#537bb5",
      "rgb": [
        83,
        123,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3816",
      "brandId": "dmc",
      "reference": "3816",
      "name": "Celadon Green",
      "hex": "#53836f",
      "rgb": [
        83,
        131,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:779",
      "brandId": "dmc",
      "reference": "779",
      "name": "Cocoa dark",
      "hex": "#543836",
      "rgb": [
        84,
        56,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:793",
      "brandId": "dmc",
      "reference": "793",
      "name": "Cornflower Blue medium",
      "hex": "#546497",
      "rgb": [
        84,
        100,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:502",
      "brandId": "dmc",
      "reference": "502",
      "name": "Blue Green",
      "hex": "#547565",
      "rgb": [
        84,
        117,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:839",
      "brandId": "dmc",
      "reference": "839",
      "name": "Beige Brown dark",
      "hex": "#553d34",
      "rgb": [
        85,
        61,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:993",
      "brandId": "dmc",
      "reference": "993",
      "name": "Aquamarine light",
      "hex": "#55ab90",
      "rgb": [
        85,
        171,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:32",
      "brandId": "dmc",
      "reference": "32",
      "name": "Dark Blueberry",
      "hex": "#565385",
      "rgb": [
        86,
        83,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3857",
      "brandId": "dmc",
      "reference": "3857",
      "name": "Rosewood dark",
      "hex": "#572523",
      "rgb": [
        87,
        37,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:801",
      "brandId": "dmc",
      "reference": "801",
      "name": "Coffee Brown dark",
      "hex": "#573324",
      "rgb": [
        87,
        51,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:730",
      "brandId": "dmc",
      "reference": "730",
      "name": "Olive Green very dark",
      "hex": "#574d20",
      "rgb": [
        87,
        77,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:469",
      "brandId": "dmc",
      "reference": "469",
      "name": "Avocado Green",
      "hex": "#575f23",
      "rgb": [
        87,
        95,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:35",
      "brandId": "dmc",
      "reference": "35",
      "name": "Very Dark Fuchsia",
      "hex": "#58274b",
      "rgb": [
        88,
        39,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3766",
      "brandId": "dmc",
      "reference": "3766",
      "name": "Peacock Blue light",
      "hex": "#58a2b9",
      "rgb": [
        88,
        162,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:320",
      "brandId": "dmc",
      "reference": "320",
      "name": "Pistachio Green medium",
      "hex": "#5a7f5a",
      "rgb": [
        90,
        127,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:988",
      "brandId": "dmc",
      "reference": "988",
      "name": "Forest Green medium",
      "hex": "#5a8044",
      "rgb": [
        90,
        128,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:906",
      "brandId": "dmc",
      "reference": "906",
      "name": "Parrot Green medium",
      "hex": "#5a8b23",
      "rgb": [
        90,
        139,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:814",
      "brandId": "dmc",
      "reference": "814",
      "name": "Garnet dark",
      "hex": "#5b1325",
      "rgb": [
        91,
        19,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:902",
      "brandId": "dmc",
      "reference": "902",
      "name": "Garnet very dark",
      "hex": "#5b202e",
      "rgb": [
        91,
        32,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3834",
      "brandId": "dmc",
      "reference": "3834",
      "name": "Grape dark",
      "hex": "#5b294a",
      "rgb": [
        91,
        41,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3363",
      "brandId": "dmc",
      "reference": "3363",
      "name": "Pine Green medium",
      "hex": "#5b6b4a",
      "rgb": [
        91,
        107,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3839",
      "brandId": "dmc",
      "reference": "3839",
      "name": "Lavender Blue medium",
      "hex": "#5b70ae",
      "rgb": [
        91,
        112,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3740",
      "brandId": "dmc",
      "reference": "3740",
      "name": "Antique Violet dark",
      "hex": "#5c3e4d",
      "rgb": [
        92,
        62,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3011",
      "brandId": "dmc",
      "reference": "3011",
      "name": "Khaki Green dark",
      "hex": "#5c5830",
      "rgb": [
        92,
        88,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:580",
      "brandId": "dmc",
      "reference": "580",
      "name": "Moss Green dark",
      "hex": "#5c5f20",
      "rgb": [
        92,
        95,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:809",
      "brandId": "dmc",
      "reference": "809",
      "name": "Delft Blue",
      "hex": "#5c92bb",
      "rgb": [
        92,
        146,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:327",
      "brandId": "dmc",
      "reference": "327",
      "name": "Violet",
      "hex": "#5e2e5e",
      "rgb": [
        94,
        46,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:829",
      "brandId": "dmc",
      "reference": "829",
      "name": "Golden Olive very dark",
      "hex": "#5f4220",
      "rgb": [
        95,
        66,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3802",
      "brandId": "dmc",
      "reference": "3802",
      "name": "Antique Mauve very dark",
      "hex": "#602c36",
      "rgb": [
        96,
        44,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:610",
      "brandId": "dmc",
      "reference": "610",
      "name": "Drab Brown dark",
      "hex": "#604a30",
      "rgb": [
        96,
        74,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3746",
      "brandId": "dmc",
      "reference": "3746",
      "name": "Blue Violet dark",
      "hex": "#604f9f",
      "rgb": [
        96,
        79,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:703",
      "brandId": "dmc",
      "reference": "703",
      "name": "Chartreuse",
      "hex": "#60a746",
      "rgb": [
        96,
        167,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3790",
      "brandId": "dmc",
      "reference": "3790",
      "name": "Beige Grey ultra dark",
      "hex": "#614d3d",
      "rgb": [
        97,
        77,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:926",
      "brandId": "dmc",
      "reference": "926",
      "name": "Grey Green medium",
      "hex": "#617878",
      "rgb": [
        97,
        120,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:300",
      "brandId": "dmc",
      "reference": "300",
      "name": "Mahogany very dark",
      "hex": "#632e20",
      "rgb": [
        99,
        46,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:433",
      "brandId": "dmc",
      "reference": "433",
      "name": "Brown medium",
      "hex": "#643823",
      "rgb": [
        100,
        56,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:414",
      "brandId": "dmc",
      "reference": "414",
      "name": "Steel Grey dark",
      "hex": "#646b78",
      "rgb": [
        100,
        107,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:31",
      "brandId": "dmc",
      "reference": "31",
      "name": "Blueberry",
      "hex": "#65629d",
      "rgb": [
        101,
        98,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:160",
      "brandId": "dmc",
      "reference": "160",
      "name": "Grey Blue medium",
      "hex": "#66759c",
      "rgb": [
        102,
        117,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:4",
      "brandId": "dmc",
      "reference": "4",
      "name": "Dark Tin",
      "hex": "#676464",
      "rgb": [
        103,
        100,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:830",
      "brandId": "dmc",
      "reference": "830",
      "name": "Golden Olive dark",
      "hex": "#694b23",
      "rgb": [
        105,
        75,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:8",
      "brandId": "dmc",
      "reference": "8",
      "name": "Dark Driftwood",
      "hex": "#695b50",
      "rgb": [
        105,
        91,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:732",
      "brandId": "dmc",
      "reference": "732",
      "name": "Olive Green (731)",
      "hex": "#695c20",
      "rgb": [
        105,
        92,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:646",
      "brandId": "dmc",
      "reference": "646",
      "name": "Beaver Grey dark",
      "hex": "#696359",
      "rgb": [
        105,
        99,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3755",
      "brandId": "dmc",
      "reference": "3755",
      "name": "Baby Blue",
      "hex": "#6998c4",
      "rgb": [
        105,
        152,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3685",
      "brandId": "dmc",
      "reference": "3685",
      "name": "Mauve dark",
      "hex": "#6a1836",
      "rgb": [
        106,
        24,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:470",
      "brandId": "dmc",
      "reference": "470",
      "name": "Avocado Green light",
      "hex": "#6a7830",
      "rgb": [
        106,
        120,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:731",
      "brandId": "dmc",
      "reference": "731",
      "name": "Olive Green Dark",
      "hex": "#6b580b",
      "rgb": [
        107,
        88,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3347",
      "brandId": "dmc",
      "reference": "3347",
      "name": "Yellow Green medium",
      "hex": "#6b834a",
      "rgb": [
        107,
        131,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3837",
      "brandId": "dmc",
      "reference": "3837",
      "name": "Lavender ultra dark",
      "hex": "#6c3681",
      "rgb": [
        108,
        54,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:989",
      "brandId": "dmc",
      "reference": "989",
      "name": "Forest Green",
      "hex": "#6c9254",
      "rgb": [
        108,
        146,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:954",
      "brandId": "dmc",
      "reference": "954",
      "name": "Nile Green",
      "hex": "#6cbe87",
      "rgb": [
        108,
        190,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:221",
      "brandId": "dmc",
      "reference": "221",
      "name": "Shell Pink very dark",
      "hex": "#6d2329",
      "rgb": [
        109,
        35,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:807",
      "brandId": "dmc",
      "reference": "807",
      "name": "Peacock Blue dark",
      "hex": "#6d9dc7",
      "rgb": [
        109,
        157,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:563",
      "brandId": "dmc",
      "reference": "563",
      "name": "Jade light",
      "hex": "#6db18c",
      "rgb": [
        109,
        177,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:315",
      "brandId": "dmc",
      "reference": "315",
      "name": "Antique Mauve dark",
      "hex": "#6f3842",
      "rgb": [
        111,
        56,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3860",
      "brandId": "dmc",
      "reference": "3860",
      "name": "Cocoa",
      "hex": "#6f4f4b",
      "rgb": [
        111,
        79,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:815",
      "brandId": "dmc",
      "reference": "815",
      "name": "Garnet medium",
      "hex": "#700d23",
      "rgb": [
        112,
        13,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:869",
      "brandId": "dmc",
      "reference": "869",
      "name": "Hazelnut Brown very dark",
      "hex": "#704725",
      "rgb": [
        112,
        71,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:611",
      "brandId": "dmc",
      "reference": "611",
      "name": "Drab Brown",
      "hex": "#705a3d",
      "rgb": [
        112,
        90,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:169",
      "brandId": "dmc",
      "reference": "169",
      "name": "Pewter light",
      "hex": "#707a7a",
      "rgb": [
        112,
        122,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:794",
      "brandId": "dmc",
      "reference": "794",
      "name": "Cornflower Blue light",
      "hex": "#708ab8",
      "rgb": [
        112,
        138,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3835",
      "brandId": "dmc",
      "reference": "3835",
      "name": "Grape medium",
      "hex": "#714061",
      "rgb": [
        113,
        64,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3052",
      "brandId": "dmc",
      "reference": "3052",
      "name": "Green Grey medium",
      "hex": "#717c54",
      "rgb": [
        113,
        124,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:632",
      "brandId": "dmc",
      "reference": "632",
      "name": "Desert Sand ultra very dark",
      "hex": "#723d34",
      "rgb": [
        114,
        61,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3041",
      "brandId": "dmc",
      "reference": "3041",
      "name": "Antique Violet medium",
      "hex": "#725465",
      "rgb": [
        114,
        84,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:640",
      "brandId": "dmc",
      "reference": "640",
      "name": "Beige Grey very dark",
      "hex": "#72644f",
      "rgb": [
        114,
        100,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:522",
      "brandId": "dmc",
      "reference": "522",
      "name": "Fern Green",
      "hex": "#727d5f",
      "rgb": [
        114,
        125,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3022",
      "brandId": "dmc",
      "reference": "3022",
      "name": "Brown Grey medium",
      "hex": "#73725f",
      "rgb": [
        115,
        114,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:156",
      "brandId": "dmc",
      "reference": "156",
      "name": "Blue Violet medium light",
      "hex": "#737db3",
      "rgb": [
        115,
        125,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:7",
      "brandId": "dmc",
      "reference": "7",
      "name": "Driftwood",
      "hex": "#746256",
      "rgb": [
        116,
        98,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:400",
      "brandId": "dmc",
      "reference": "400",
      "name": "Mahogany dark",
      "hex": "#753321",
      "rgb": [
        117,
        51,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3858",
      "brandId": "dmc",
      "reference": "3858",
      "name": "Rosewood medium",
      "hex": "#753d36",
      "rgb": [
        117,
        61,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:932",
      "brandId": "dmc",
      "reference": "932",
      "name": "Antique Blue light",
      "hex": "#758fa6",
      "rgb": [
        117,
        143,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:964",
      "brandId": "dmc",
      "reference": "964",
      "name": "Sea Green light",
      "hex": "#75cdc1",
      "rgb": [
        117,
        205,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:915",
      "brandId": "dmc",
      "reference": "915",
      "name": "Plum dark",
      "hex": "#76003d",
      "rgb": [
        118,
        0,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:155",
      "brandId": "dmc",
      "reference": "155",
      "name": "Blue Violet medium dark",
      "hex": "#7665ab",
      "rgb": [
        118,
        101,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:777",
      "brandId": "dmc",
      "reference": "777",
      "name": "Raspberry very dark",
      "hex": "#780d2c",
      "rgb": [
        120,
        13,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:831",
      "brandId": "dmc",
      "reference": "831",
      "name": "Golden Olive medium",
      "hex": "#785c25",
      "rgb": [
        120,
        92,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:704",
      "brandId": "dmc",
      "reference": "704",
      "name": "Chartreuse bright",
      "hex": "#78ad44",
      "rgb": [
        120,
        173,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:519",
      "brandId": "dmc",
      "reference": "519",
      "name": "Sky Blue",
      "hex": "#78b1c8",
      "rgb": [
        120,
        177,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:975",
      "brandId": "dmc",
      "reference": "975",
      "name": "Golden Brown dark",
      "hex": "#793a20",
      "rgb": [
        121,
        58,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:581",
      "brandId": "dmc",
      "reference": "581",
      "name": "Moss Green",
      "hex": "#797b29",
      "rgb": [
        121,
        123,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:34",
      "brandId": "dmc",
      "reference": "34",
      "name": "Dark Fuchsia",
      "hex": "#7a3070",
      "rgb": [
        122,
        48,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:451",
      "brandId": "dmc",
      "reference": "451",
      "name": "Shell Grey dark",
      "hex": "#7a6c6c",
      "rgb": [
        122,
        108,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:598",
      "brandId": "dmc",
      "reference": "598",
      "name": "Turquoise light",
      "hex": "#7ab2b5",
      "rgb": [
        122,
        178,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3803",
      "brandId": "dmc",
      "reference": "3803",
      "name": "Mauve medium",
      "hex": "#7b2544",
      "rgb": [
        123,
        37,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:918",
      "brandId": "dmc",
      "reference": "918",
      "name": "Red Copper dark",
      "hex": "#7b2e23",
      "rgb": [
        123,
        46,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:552",
      "brandId": "dmc",
      "reference": "552",
      "name": "Violet medium",
      "hex": "#7b3881",
      "rgb": [
        123,
        56,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:368",
      "brandId": "dmc",
      "reference": "368",
      "name": "Pistachio Green light",
      "hex": "#7ba476",
      "rgb": [
        123,
        164,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3862",
      "brandId": "dmc",
      "reference": "3862",
      "name": "Mocha Beige dark",
      "hex": "#7c553e",
      "rgb": [
        124,
        85,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:340",
      "brandId": "dmc",
      "reference": "340",
      "name": "Blue Violet medium",
      "hex": "#7c76be",
      "rgb": [
        124,
        118,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3012",
      "brandId": "dmc",
      "reference": "3012",
      "name": "Khaki Green medium",
      "hex": "#7d7340",
      "rgb": [
        125,
        115,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:647",
      "brandId": "dmc",
      "reference": "647",
      "name": "Beaver Grey medium",
      "hex": "#7d7b70",
      "rgb": [
        125,
        123,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:840",
      "brandId": "dmc",
      "reference": "840",
      "name": "Beige Brown medium",
      "hex": "#7f5c4a",
      "rgb": [
        127,
        92,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:434",
      "brandId": "dmc",
      "reference": "434",
      "name": "Brown light",
      "hex": "#804625",
      "rgb": [
        128,
        70,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3726",
      "brandId": "dmc",
      "reference": "3726",
      "name": "Antique Mauve dark",
      "hex": "#804653",
      "rgb": [
        128,
        70,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:318",
      "brandId": "dmc",
      "reference": "318",
      "name": "Steel Grey light",
      "hex": "#808796",
      "rgb": [
        128,
        135,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:28",
      "brandId": "dmc",
      "reference": "28",
      "name": "Medium Light Eggplant",
      "hex": "#8178a0",
      "rgb": [
        129,
        120,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3777",
      "brandId": "dmc",
      "reference": "3777",
      "name": "Terra Cotta very dark",
      "hex": "#822529",
      "rgb": [
        130,
        37,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:208",
      "brandId": "dmc",
      "reference": "208",
      "name": "Lavender very dark",
      "hex": "#824596",
      "rgb": [
        130,
        69,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:370",
      "brandId": "dmc",
      "reference": "370",
      "name": "Mustard medium",
      "hex": "#826e3d",
      "rgb": [
        130,
        110,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3817",
      "brandId": "dmc",
      "reference": "3817",
      "name": "Celadon Green light",
      "hex": "#82ab96",
      "rgb": [
        130,
        171,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:503",
      "brandId": "dmc",
      "reference": "503",
      "name": "Blue Green medium",
      "hex": "#839c8b",
      "rgb": [
        131,
        156,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3721",
      "brandId": "dmc",
      "reference": "3721",
      "name": "Shell Pink dark",
      "hex": "#85303a",
      "rgb": [
        133,
        48,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3840",
      "brandId": "dmc",
      "reference": "3840",
      "name": "Lavender Blue light",
      "hex": "#85a3ce",
      "rgb": [
        133,
        163,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:907",
      "brandId": "dmc",
      "reference": "907",
      "name": "Parrot Green light",
      "hex": "#87a623",
      "rgb": [
        135,
        166,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:827",
      "brandId": "dmc",
      "reference": "827",
      "name": "Blue very light",
      "hex": "#87b4d0",
      "rgb": [
        135,
        180,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:164",
      "brandId": "dmc",
      "reference": "164",
      "name": "Forest Green light",
      "hex": "#87bf78",
      "rgb": [
        135,
        191,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:498",
      "brandId": "dmc",
      "reference": "498",
      "name": "Christmas Red dark",
      "hex": "#880025",
      "rgb": [
        136,
        0,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:355",
      "brandId": "dmc",
      "reference": "355",
      "name": "Terra Cotta dark",
      "hex": "#882e2c",
      "rgb": [
        136,
        46,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:33",
      "brandId": "dmc",
      "reference": "33",
      "name": "Fuchsia",
      "hex": "#884b8e",
      "rgb": [
        136,
        75,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:927",
      "brandId": "dmc",
      "reference": "927",
      "name": "Grey Green light",
      "hex": "#889a97",
      "rgb": [
        136,
        154,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:816",
      "brandId": "dmc",
      "reference": "816",
      "name": "Garnet",
      "hex": "#89132c",
      "rgb": [
        137,
        19,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3364",
      "brandId": "dmc",
      "reference": "3364",
      "name": "Pine Green",
      "hex": "#89965f",
      "rgb": [
        137,
        150,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:30",
      "brandId": "dmc",
      "reference": "30",
      "name": "Medium Light Blueberry",
      "hex": "#8a89b0",
      "rgb": [
        138,
        137,
        176
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3053",
      "brandId": "dmc",
      "reference": "3053",
      "name": "Green Grey",
      "hex": "#8b9669",
      "rgb": [
        139,
        150,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:564",
      "brandId": "dmc",
      "reference": "564",
      "name": "Jade very light",
      "hex": "#8bc9a3",
      "rgb": [
        139,
        201,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:780",
      "brandId": "dmc",
      "reference": "780",
      "name": "Topaz ultra very dark",
      "hex": "#8c4a23",
      "rgb": [
        140,
        74,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:642",
      "brandId": "dmc",
      "reference": "642",
      "name": "Beige Grey dark",
      "hex": "#8c7d63",
      "rgb": [
        140,
        125,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3813",
      "brandId": "dmc",
      "reference": "3813",
      "name": "Blue Green light",
      "hex": "#8cac9d",
      "rgb": [
        140,
        172,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:167",
      "brandId": "dmc",
      "reference": "167",
      "name": "Yellow Beige very dark",
      "hex": "#8d643a",
      "rgb": [
        141,
        100,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3861",
      "brandId": "dmc",
      "reference": "3861",
      "name": "Cocoa light",
      "hex": "#8d6c6a",
      "rgb": [
        141,
        108,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:471",
      "brandId": "dmc",
      "reference": "471",
      "name": "Avocado Green very light",
      "hex": "#8d9d54",
      "rgb": [
        141,
        157,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:966",
      "brandId": "dmc",
      "reference": "966",
      "name": "Baby Green medium",
      "hex": "#8dbf8e",
      "rgb": [
        141,
        191,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:420",
      "brandId": "dmc",
      "reference": "420",
      "name": "Hazelnut Brown dark",
      "hex": "#8e6034",
      "rgb": [
        142,
        96,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:523",
      "brandId": "dmc",
      "reference": "523",
      "name": "Fern Green light",
      "hex": "#8e9773",
      "rgb": [
        142,
        151,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:800",
      "brandId": "dmc",
      "reference": "800",
      "name": "Delft Blue pale",
      "hex": "#8eb2d4",
      "rgb": [
        142,
        178,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3325",
      "brandId": "dmc",
      "reference": "3325",
      "name": "Baby Blue light",
      "hex": "#8eb8d8",
      "rgb": [
        142,
        184,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3761",
      "brandId": "dmc",
      "reference": "3761",
      "name": "Sky Blue light",
      "hex": "#8ec4d8",
      "rgb": [
        142,
        196,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:371",
      "brandId": "dmc",
      "reference": "371",
      "name": "Mustard",
      "hex": "#8f7a47",
      "rgb": [
        143,
        122,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3",
      "brandId": "dmc",
      "reference": "3",
      "name": "Medium Tin",
      "hex": "#908f90",
      "rgb": [
        144,
        143,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:150",
      "brandId": "dmc",
      "reference": "150",
      "name": "Dusty Rose ultra very dark",
      "hex": "#911238",
      "rgb": [
        145,
        18,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:917",
      "brandId": "dmc",
      "reference": "917",
      "name": "Plum medium",
      "hex": "#911b5b",
      "rgb": [
        145,
        27,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:919",
      "brandId": "dmc",
      "reference": "919",
      "name": "Red Copper",
      "hex": "#912920",
      "rgb": [
        145,
        41,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:22",
      "brandId": "dmc",
      "reference": "22",
      "name": "Alizarin",
      "hex": "#922a29",
      "rgb": [
        146,
        42,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:553",
      "brandId": "dmc",
      "reference": "553",
      "name": "Violet",
      "hex": "#924f92",
      "rgb": [
        146,
        79,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3863",
      "brandId": "dmc",
      "reference": "3863",
      "name": "Mocha Beige medium",
      "hex": "#92694f",
      "rgb": [
        146,
        105,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:341",
      "brandId": "dmc",
      "reference": "341",
      "name": "Blue Violet light",
      "hex": "#929ecb",
      "rgb": [
        146,
        158,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3772",
      "brandId": "dmc",
      "reference": "3772",
      "name": "Desert Sand very dark",
      "hex": "#935a4b",
      "rgb": [
        147,
        90,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3023",
      "brandId": "dmc",
      "reference": "3023",
      "name": "Brown Grey light",
      "hex": "#938d76",
      "rgb": [
        147,
        141,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:157",
      "brandId": "dmc",
      "reference": "157",
      "name": "Cornflower Blue very light",
      "hex": "#95abca",
      "rgb": [
        149,
        171,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:813",
      "brandId": "dmc",
      "reference": "813",
      "name": "Blue light",
      "hex": "#95b2c9",
      "rgb": [
        149,
        178,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3811",
      "brandId": "dmc",
      "reference": "3811",
      "name": "Turquoise very light",
      "hex": "#95c5c6",
      "rgb": [
        149,
        197,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3042",
      "brandId": "dmc",
      "reference": "3042",
      "name": "Antique Violet light",
      "hex": "#967c8d",
      "rgb": [
        150,
        124,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3032",
      "brandId": "dmc",
      "reference": "3032",
      "name": "Mocha Brown medium",
      "hex": "#968669",
      "rgb": [
        150,
        134,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:159",
      "brandId": "dmc",
      "reference": "159",
      "name": "Grey Blue light",
      "hex": "#97a6c5",
      "rgb": [
        151,
        166,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:955",
      "brandId": "dmc",
      "reference": "955",
      "name": "Nile Green light",
      "hex": "#97dca8",
      "rgb": [
        151,
        220,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:733",
      "brandId": "dmc",
      "reference": "733",
      "name": "Olive Green medium",
      "hex": "#988630",
      "rgb": [
        152,
        134,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:648",
      "brandId": "dmc",
      "reference": "648",
      "name": "Beaver Grey light",
      "hex": "#98988b",
      "rgb": [
        152,
        152,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:13",
      "brandId": "dmc",
      "reference": "13",
      "name": "Medium Light Nile Green",
      "hex": "#98c29c",
      "rgb": [
        152,
        194,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3722",
      "brandId": "dmc",
      "reference": "3722",
      "name": "Shell Pink medium",
      "hex": "#99444d",
      "rgb": [
        153,
        68,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:301",
      "brandId": "dmc",
      "reference": "301",
      "name": "Mahogany medium",
      "hex": "#994725",
      "rgb": [
        153,
        71,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:612",
      "brandId": "dmc",
      "reference": "612",
      "name": "Drab Brown light",
      "hex": "#99815a",
      "rgb": [
        153,
        129,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:304",
      "brandId": "dmc",
      "reference": "304",
      "name": "Christmas Red medium",
      "hex": "#9a0029",
      "rgb": [
        154,
        0,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:832",
      "brandId": "dmc",
      "reference": "832",
      "name": "Golden Olive",
      "hex": "#9a762c",
      "rgb": [
        154,
        118,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:524",
      "brandId": "dmc",
      "reference": "524",
      "name": "Fern Green very light",
      "hex": "#9aa284",
      "rgb": [
        154,
        162,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:841",
      "brandId": "dmc",
      "reference": "841",
      "name": "Beige Brown light",
      "hex": "#9b7863",
      "rgb": [
        155,
        120,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3830",
      "brandId": "dmc",
      "reference": "3830",
      "name": "Terra Cotta",
      "hex": "#9c3a36",
      "rgb": [
        156,
        58,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3826",
      "brandId": "dmc",
      "reference": "3826",
      "name": "Golden Brown",
      "hex": "#9c4d25",
      "rgb": [
        156,
        77,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3752",
      "brandId": "dmc",
      "reference": "3752",
      "name": "Antique Blue very light",
      "hex": "#9db1bd",
      "rgb": [
        157,
        177,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3350",
      "brandId": "dmc",
      "reference": "3350",
      "name": "Dusty Rose ultra dark",
      "hex": "#9e2946",
      "rgb": [
        158,
        41,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3045",
      "brandId": "dmc",
      "reference": "3045",
      "name": "Yellow Beige dark",
      "hex": "#9f7646",
      "rgb": [
        159,
        118,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:452",
      "brandId": "dmc",
      "reference": "452",
      "name": "Shell Grey medium",
      "hex": "#9f8b8b",
      "rgb": [
        159,
        139,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:415",
      "brandId": "dmc",
      "reference": "415",
      "name": "Pearl Grey",
      "hex": "#9fa6b1",
      "rgb": [
        159,
        166,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3841",
      "brandId": "dmc",
      "reference": "3841",
      "name": "Baby Blue pale",
      "hex": "#9fbcce",
      "rgb": [
        159,
        188,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:166",
      "brandId": "dmc",
      "reference": "166",
      "name": "Moss Green medium light",
      "hex": "#a19f20",
      "rgb": [
        161,
        159,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:781",
      "brandId": "dmc",
      "reference": "781",
      "name": "Topaz Very Dark",
      "hex": "#a25f1f",
      "rgb": [
        162,
        95,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3836",
      "brandId": "dmc",
      "reference": "3836",
      "name": "Grape light",
      "hex": "#a26c90",
      "rgb": [
        162,
        108,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:162",
      "brandId": "dmc",
      "reference": "162",
      "name": "Blue ultra very light",
      "hex": "#a2c1d0",
      "rgb": [
        162,
        193,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:435",
      "brandId": "dmc",
      "reference": "435",
      "name": "Brown very light",
      "hex": "#a36134",
      "rgb": [
        163,
        97,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:372",
      "brandId": "dmc",
      "reference": "372",
      "name": "Mustard light",
      "hex": "#a39361",
      "rgb": [
        163,
        147,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3013",
      "brandId": "dmc",
      "reference": "3013",
      "name": "Khaki Green light",
      "hex": "#a39f6a",
      "rgb": [
        163,
        159,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3348",
      "brandId": "dmc",
      "reference": "3348",
      "name": "Yellow Green light",
      "hex": "#a3b86a",
      "rgb": [
        163,
        184,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:920",
      "brandId": "dmc",
      "reference": "920",
      "name": "Copper medium",
      "hex": "#a43d25",
      "rgb": [
        164,
        61,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3829",
      "brandId": "dmc",
      "reference": "3829",
      "name": "Old Gold very dark",
      "hex": "#a46c2e",
      "rgb": [
        164,
        108,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:817",
      "brandId": "dmc",
      "reference": "817",
      "name": "Coral Red very dark",
      "hex": "#a60d1b",
      "rgb": [
        166,
        13,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:326",
      "brandId": "dmc",
      "reference": "326",
      "name": "Rose very deep",
      "hex": "#a61238",
      "rgb": [
        166,
        18,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:347",
      "brandId": "dmc",
      "reference": "347",
      "name": "Salmon very dark",
      "hex": "#a62030",
      "rgb": [
        166,
        32,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:209",
      "brandId": "dmc",
      "reference": "209",
      "name": "Lavender dark",
      "hex": "#a66cb3",
      "rgb": [
        166,
        108,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:680",
      "brandId": "dmc",
      "reference": "680",
      "name": "Old Gold dark",
      "hex": "#a67334",
      "rgb": [
        166,
        115,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3828",
      "brandId": "dmc",
      "reference": "3828",
      "name": "Hazelnut Brown",
      "hex": "#a67946",
      "rgb": [
        166,
        121,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:828",
      "brandId": "dmc",
      "reference": "828",
      "name": "Blue ultra very light",
      "hex": "#a6c9d4",
      "rgb": [
        166,
        201,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:718",
      "brandId": "dmc",
      "reference": "718",
      "name": "Plum",
      "hex": "#a7206f",
      "rgb": [
        167,
        32,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3831",
      "brandId": "dmc",
      "reference": "3831",
      "name": "Raspberry dark",
      "hex": "#a8203a",
      "rgb": [
        168,
        32,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:2",
      "brandId": "dmc",
      "reference": "2",
      "name": "Tin",
      "hex": "#ababab",
      "rgb": [
        171,
        171,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:168",
      "brandId": "dmc",
      "reference": "168",
      "name": "Pewter very light",
      "hex": "#abb3b7",
      "rgb": [
        171,
        179,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:928",
      "brandId": "dmc",
      "reference": "928",
      "name": "Grey Green very light",
      "hex": "#abb5b1",
      "rgb": [
        171,
        181,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:321",
      "brandId": "dmc",
      "reference": "321",
      "name": "Christmas Red",
      "hex": "#ac0025",
      "rgb": [
        172,
        0,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:782",
      "brandId": "dmc",
      "reference": "782",
      "name": "Topaz dark (781)",
      "hex": "#ac6520",
      "rgb": [
        172,
        101,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3782",
      "brandId": "dmc",
      "reference": "3782",
      "name": "Mocha Brown light",
      "hex": "#ac9278",
      "rgb": [
        172,
        146,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:613",
      "brandId": "dmc",
      "reference": "613",
      "name": "Drab Brown very light",
      "hex": "#ac966d",
      "rgb": [
        172,
        150,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:504",
      "brandId": "dmc",
      "reference": "504",
      "name": "Blue Green Very Light",
      "hex": "#acdac1",
      "rgb": [
        172,
        218,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:309",
      "brandId": "dmc",
      "reference": "309",
      "name": "Rose deep",
      "hex": "#ad203e",
      "rgb": [
        173,
        32,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:356",
      "brandId": "dmc",
      "reference": "356",
      "name": "Terra Cotta medium",
      "hex": "#ad4f45",
      "rgb": [
        173,
        79,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3747",
      "brandId": "dmc",
      "reference": "3747",
      "name": "Blue Violet very light",
      "hex": "#adbadf",
      "rgb": [
        173,
        186,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:747",
      "brandId": "dmc",
      "reference": "747",
      "name": "Sky Blue very light",
      "hex": "#addbe1",
      "rgb": [
        173,
        219,
        225
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:600",
      "brandId": "dmc",
      "reference": "600",
      "name": "Cranberry very dark",
      "hex": "#af0047",
      "rgb": [
        175,
        0,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:316",
      "brandId": "dmc",
      "reference": "316",
      "name": "Antique Mauve medium",
      "hex": "#af6a7f",
      "rgb": [
        175,
        106,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:833",
      "brandId": "dmc",
      "reference": "833",
      "name": "Golden Olive light",
      "hex": "#b08d3e",
      "rgb": [
        176,
        141,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:734",
      "brandId": "dmc",
      "reference": "734",
      "name": "Olive Green light",
      "hex": "#b09d47",
      "rgb": [
        176,
        157,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:16",
      "brandId": "dmc",
      "reference": "16",
      "name": "Light Chartreuse",
      "hex": "#b0b56a",
      "rgb": [
        176,
        181,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3687",
      "brandId": "dmc",
      "reference": "3687",
      "name": "Mauve",
      "hex": "#b13d64",
      "rgb": [
        177,
        61,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:407",
      "brandId": "dmc",
      "reference": "407",
      "name": "Clay Brown (3773)",
      "hex": "#b17260",
      "rgb": [
        177,
        114,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3864",
      "brandId": "dmc",
      "reference": "3864",
      "name": "Mocha Beige light",
      "hex": "#b1896f",
      "rgb": [
        177,
        137,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3753",
      "brandId": "dmc",
      "reference": "3753",
      "name": "Antique Blue ultra very light",
      "hex": "#b1c6d7",
      "rgb": [
        177,
        198,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3859",
      "brandId": "dmc",
      "reference": "3859",
      "name": "Rosewood light",
      "hex": "#b26d5c",
      "rgb": [
        178,
        109,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:223",
      "brandId": "dmc",
      "reference": "223",
      "name": "Shell Pink light",
      "hex": "#b35c65",
      "rgb": [
        179,
        92,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:6",
      "brandId": "dmc",
      "reference": "6",
      "name": "Medium Light Driftwood",
      "hex": "#b4a293",
      "rgb": [
        180,
        162,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:775",
      "brandId": "dmc",
      "reference": "775",
      "name": "Baby Blue very light",
      "hex": "#b4cfdb",
      "rgb": [
        180,
        207,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3064",
      "brandId": "dmc",
      "reference": "3064",
      "name": "Desert Sand",
      "hex": "#b87359",
      "rgb": [
        184,
        115,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3819",
      "brandId": "dmc",
      "reference": "3819",
      "name": "Moss Green light",
      "hex": "#b8b738",
      "rgb": [
        184,
        183,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:436",
      "brandId": "dmc",
      "reference": "436",
      "name": "Tan",
      "hex": "#b97c4a",
      "rgb": [
        185,
        124,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3024",
      "brandId": "dmc",
      "reference": "3024",
      "name": "Brown Grey very light",
      "hex": "#b9b09f",
      "rgb": [
        185,
        176,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3804",
      "brandId": "dmc",
      "reference": "3804",
      "name": "Cyclamen Pink dark",
      "hex": "#ba1861",
      "rgb": [
        186,
        24,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:644",
      "brandId": "dmc",
      "reference": "644",
      "name": "Beige Grey medium",
      "hex": "#bab094",
      "rgb": [
        186,
        176,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3743",
      "brandId": "dmc",
      "reference": "3743",
      "name": "Antique Violet very light",
      "hex": "#bba9b8",
      "rgb": [
        187,
        169,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:5",
      "brandId": "dmc",
      "reference": "5",
      "name": "Light Driftwood",
      "hex": "#bbafa5",
      "rgb": [
        187,
        175,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:26",
      "brandId": "dmc",
      "reference": "26",
      "name": "Pale Lavender",
      "hex": "#bbb0d1",
      "rgb": [
        187,
        176,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:472",
      "brandId": "dmc",
      "reference": "472",
      "name": "Avocado Green ultra light",
      "hex": "#bbbb60",
      "rgb": [
        187,
        187,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:921",
      "brandId": "dmc",
      "reference": "921",
      "name": "Copper",
      "hex": "#bc4d2e",
      "rgb": [
        188,
        77,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:422",
      "brandId": "dmc",
      "reference": "422",
      "name": "Hazelnut Brown light",
      "hex": "#bc935b",
      "rgb": [
        188,
        147,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:349",
      "brandId": "dmc",
      "reference": "349",
      "name": "Coral dark",
      "hex": "#bd1c29",
      "rgb": [
        189,
        28,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3776",
      "brandId": "dmc",
      "reference": "3776",
      "name": "Mahogany light",
      "hex": "#bd5f36",
      "rgb": [
        189,
        95,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:210",
      "brandId": "dmc",
      "reference": "210",
      "name": "Lavender medium",
      "hex": "#be91cd",
      "rgb": [
        190,
        145,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3607",
      "brandId": "dmc",
      "reference": "3607",
      "name": "Plum light",
      "hex": "#bf3d8f",
      "rgb": [
        191,
        61,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:842",
      "brandId": "dmc",
      "reference": "842",
      "name": "Beige Brown very light",
      "hex": "#bf9f87",
      "rgb": [
        191,
        159,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:453",
      "brandId": "dmc",
      "reference": "453",
      "name": "Shell Grey light",
      "hex": "#bfada6",
      "rgb": [
        191,
        173,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:21",
      "brandId": "dmc",
      "reference": "21",
      "name": "Light Alizarin",
      "hex": "#c0614d",
      "rgb": [
        192,
        97,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3731",
      "brandId": "dmc",
      "reference": "3731",
      "name": "Dusty Rose very dark",
      "hex": "#c1405f",
      "rgb": [
        193,
        64,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3328",
      "brandId": "dmc",
      "reference": "3328",
      "name": "Salmon dark",
      "hex": "#c1424b",
      "rgb": [
        193,
        66,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3778",
      "brandId": "dmc",
      "reference": "3778",
      "name": "Terra Cotta light",
      "hex": "#c1695a",
      "rgb": [
        193,
        105,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:369",
      "brandId": "dmc",
      "reference": "369",
      "name": "Pistachio Green very light",
      "hex": "#c1d49d",
      "rgb": [
        193,
        212,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:729",
      "brandId": "dmc",
      "reference": "729",
      "name": "Old Gold medium",
      "hex": "#c28940",
      "rgb": [
        194,
        137,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3072",
      "brandId": "dmc",
      "reference": "3072",
      "name": "Beaver Grey very light",
      "hex": "#c2c6be",
      "rgb": [
        194,
        198,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:772",
      "brandId": "dmc",
      "reference": "772",
      "name": "Yellow Green very light",
      "hex": "#c2da97",
      "rgb": [
        194,
        218,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3852",
      "brandId": "dmc",
      "reference": "3852",
      "name": "Straw very dark",
      "hex": "#c3801b",
      "rgb": [
        195,
        128,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:976",
      "brandId": "dmc",
      "reference": "976",
      "name": "Golden Brown medium",
      "hex": "#c46a2c",
      "rgb": [
        196,
        106,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:554",
      "brandId": "dmc",
      "reference": "554",
      "name": "Violet light",
      "hex": "#c48bc3",
      "rgb": [
        196,
        139,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:762",
      "brandId": "dmc",
      "reference": "762",
      "name": "Pearl Grey very light",
      "hex": "#c4c5ce",
      "rgb": [
        196,
        197,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3046",
      "brandId": "dmc",
      "reference": "3046",
      "name": "Yellow Beige medium",
      "hex": "#c5a966",
      "rgb": [
        197,
        169,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:1",
      "brandId": "dmc",
      "reference": "1",
      "name": "White Tin",
      "hex": "#c5c5c5",
      "rgb": [
        197,
        197,
        197
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:601",
      "brandId": "dmc",
      "reference": "601",
      "name": "Cranberry dark",
      "hex": "#c61b57",
      "rgb": [
        198,
        27,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:900",
      "brandId": "dmc",
      "reference": "900",
      "name": "Burnt Orange dark",
      "hex": "#c63423",
      "rgb": [
        198,
        52,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3832",
      "brandId": "dmc",
      "reference": "3832",
      "name": "Raspberry medium",
      "hex": "#c63850",
      "rgb": [
        198,
        56,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:834",
      "brandId": "dmc",
      "reference": "834",
      "name": "Golden Olive very light",
      "hex": "#c7a550",
      "rgb": [
        199,
        165,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:666",
      "brandId": "dmc",
      "reference": "666",
      "name": "Christmas Red bright",
      "hex": "#c90023",
      "rgb": [
        201,
        0,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3727",
      "brandId": "dmc",
      "reference": "3727",
      "name": "Antique Mauve light",
      "hex": "#c9899c",
      "rgb": [
        201,
        137,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:778",
      "brandId": "dmc",
      "reference": "778",
      "name": "Antique Mauve very light",
      "hex": "#c9949e",
      "rgb": [
        201,
        148,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3805",
      "brandId": "dmc",
      "reference": "3805",
      "name": "Cyclamen Pink",
      "hex": "#cc2b73",
      "rgb": [
        204,
        43,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:152",
      "brandId": "dmc",
      "reference": "152",
      "name": "Shell Pink medium light",
      "hex": "#cc8285",
      "rgb": [
        204,
        130,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:19",
      "brandId": "dmc",
      "reference": "19",
      "name": "Medium Light Autumn Gold",
      "hex": "#cc9c52",
      "rgb": [
        204,
        156,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:165",
      "brandId": "dmc",
      "reference": "165",
      "name": "Moss Green very light",
      "hex": "#cdc965",
      "rgb": [
        205,
        201,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:15",
      "brandId": "dmc",
      "reference": "15",
      "name": "Apple Green",
      "hex": "#cdd684",
      "rgb": [
        205,
        214,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:10",
      "brandId": "dmc",
      "reference": "10",
      "name": "Very Light Tender Green",
      "hex": "#ceceb8",
      "rgb": [
        206,
        206,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:14",
      "brandId": "dmc",
      "reference": "14",
      "name": "Pale Apple Green",
      "hex": "#ced194",
      "rgb": [
        206,
        209,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3833",
      "brandId": "dmc",
      "reference": "3833",
      "name": "Raspberry light",
      "hex": "#cf556a",
      "rgb": [
        207,
        85,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3712",
      "brandId": "dmc",
      "reference": "3712",
      "name": "Salmon medium",
      "hex": "#cf575c",
      "rgb": [
        207,
        87,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3773",
      "brandId": "dmc",
      "reference": "3773",
      "name": "Desert Sand Medium",
      "hex": "#cf866d",
      "rgb": [
        207,
        134,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:12",
      "brandId": "dmc",
      "reference": "12",
      "name": "Tender Green",
      "hex": "#cfc662",
      "rgb": [
        207,
        198,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:783",
      "brandId": "dmc",
      "reference": "783",
      "name": "Topaz medium",
      "hex": "#d0842c",
      "rgb": [
        208,
        132,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:25",
      "brandId": "dmc",
      "reference": "25",
      "name": "Ultra Light Lavender",
      "hex": "#d0cadb",
      "rgb": [
        208,
        202,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3853",
      "brandId": "dmc",
      "reference": "3853",
      "name": "Autumn Gold dark",
      "hex": "#d1642c",
      "rgb": [
        209,
        100,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3688",
      "brandId": "dmc",
      "reference": "3688",
      "name": "Mauve medium",
      "hex": "#d16987",
      "rgb": [
        209,
        105,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:437",
      "brandId": "dmc",
      "reference": "437",
      "name": "Tan light",
      "hex": "#d19c6a",
      "rgb": [
        209,
        156,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:153",
      "brandId": "dmc",
      "reference": "153",
      "name": "Violet very light",
      "hex": "#d19ec4",
      "rgb": [
        209,
        158,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:720",
      "brandId": "dmc",
      "reference": "720",
      "name": "Orange Spice dark",
      "hex": "#d2421b",
      "rgb": [
        210,
        66,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3033",
      "brandId": "dmc",
      "reference": "3033",
      "name": "Mocha Brown very light",
      "hex": "#d2bda6",
      "rgb": [
        210,
        189,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:350",
      "brandId": "dmc",
      "reference": "350",
      "name": "Coral medium",
      "hex": "#d43434",
      "rgb": [
        212,
        52,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:335",
      "brandId": "dmc",
      "reference": "335",
      "name": "Rose",
      "hex": "#d44464",
      "rgb": [
        212,
        68,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:224",
      "brandId": "dmc",
      "reference": "224",
      "name": "Shell Pink very light",
      "hex": "#d48f8b",
      "rgb": [
        212,
        143,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:738",
      "brandId": "dmc",
      "reference": "738",
      "name": "Tan very light",
      "hex": "#d5a978",
      "rgb": [
        213,
        169,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:17",
      "brandId": "dmc",
      "reference": "17",
      "name": "Light Yellow Plum",
      "hex": "#d5c551",
      "rgb": [
        213,
        197,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3820",
      "brandId": "dmc",
      "reference": "3820",
      "name": "Straw dark",
      "hex": "#d6962b",
      "rgb": [
        214,
        150,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:211",
      "brandId": "dmc",
      "reference": "211",
      "name": "Lavender light",
      "hex": "#d6b5e3",
      "rgb": [
        214,
        181,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:602",
      "brandId": "dmc",
      "reference": "602",
      "name": "Cranberry medium",
      "hex": "#d7306d",
      "rgb": [
        215,
        48,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:922",
      "brandId": "dmc",
      "reference": "922",
      "name": "Copper light",
      "hex": "#d7633a",
      "rgb": [
        215,
        99,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3608",
      "brandId": "dmc",
      "reference": "3608",
      "name": "Plum very light",
      "hex": "#d770ad",
      "rgb": [
        215,
        112,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:961",
      "brandId": "dmc",
      "reference": "961",
      "name": "Dusty Rose dark",
      "hex": "#d94b6f",
      "rgb": [
        217,
        75,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:18",
      "brandId": "dmc",
      "reference": "18",
      "name": "Yellow Plum",
      "hex": "#d9bf4a",
      "rgb": [
        217,
        191,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:27",
      "brandId": "dmc",
      "reference": "27",
      "name": "White Violet",
      "hex": "#d9d4d8",
      "rgb": [
        217,
        212,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:758",
      "brandId": "dmc",
      "reference": "758",
      "name": "Terra Cotta very light",
      "hex": "#db917a",
      "rgb": [
        219,
        145,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3047",
      "brandId": "dmc",
      "reference": "3047",
      "name": "Yellow Beige light",
      "hex": "#dbc991",
      "rgb": [
        219,
        201,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3866",
      "brandId": "dmc",
      "reference": "3866",
      "name": "Mocha Brown ultra very light",
      "hex": "#ddd1be",
      "rgb": [
        221,
        209,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3756",
      "brandId": "dmc",
      "reference": "3756",
      "name": "Baby Blue ultra very light",
      "hex": "#ddedf3",
      "rgb": [
        221,
        237,
        243
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3771",
      "brandId": "dmc",
      "reference": "3771",
      "name": "Terra Cotta ultra very light",
      "hex": "#df9b7b",
      "rgb": [
        223,
        155,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:950",
      "brandId": "dmc",
      "reference": "950",
      "name": "Desert Sand light",
      "hex": "#dfac93",
      "rgb": [
        223,
        172,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3801",
      "brandId": "dmc",
      "reference": "3801",
      "name": "Christmas Red light",
      "hex": "#e02338",
      "rgb": [
        224,
        35,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:351",
      "brandId": "dmc",
      "reference": "351",
      "name": "Coral",
      "hex": "#e04d46",
      "rgb": [
        224,
        77,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3733",
      "brandId": "dmc",
      "reference": "3733",
      "name": "Dusty Rose",
      "hex": "#e06c85",
      "rgb": [
        224,
        108,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:822",
      "brandId": "dmc",
      "reference": "822",
      "name": "Beige Grey light",
      "hex": "#e0d6ba",
      "rgb": [
        224,
        214,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:24",
      "brandId": "dmc",
      "reference": "24",
      "name": "White Lavender",
      "hex": "#e0d9e4",
      "rgb": [
        224,
        217,
        228
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:11",
      "brandId": "dmc",
      "reference": "11",
      "name": "Light Tender Green",
      "hex": "#e0dc84",
      "rgb": [
        224,
        220,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3827",
      "brandId": "dmc",
      "reference": "3827",
      "name": "Golden Brown pale",
      "hex": "#e19858",
      "rgb": [
        225,
        152,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3821",
      "brandId": "dmc",
      "reference": "3821",
      "name": "Straw",
      "hex": "#e3b044",
      "rgb": [
        227,
        176,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3806",
      "brandId": "dmc",
      "reference": "3806",
      "name": "Cyclamen Pink light",
      "hex": "#e45592",
      "rgb": [
        228,
        85,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:962",
      "brandId": "dmc",
      "reference": "962",
      "name": "Dusty Rose medium",
      "hex": "#e46486",
      "rgb": [
        228,
        100,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:760",
      "brandId": "dmc",
      "reference": "760",
      "name": "Salmon",
      "hex": "#e5787f",
      "rgb": [
        229,
        120,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3609",
      "brandId": "dmc",
      "reference": "3609",
      "name": "Plum ultra light",
      "hex": "#e591ce",
      "rgb": [
        229,
        145,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3856",
      "brandId": "dmc",
      "reference": "3856",
      "name": "Mahogany ultra very light",
      "hex": "#e5a472",
      "rgb": [
        229,
        164,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:543",
      "brandId": "dmc",
      "reference": "543",
      "name": "Beige Brown ultra very light",
      "hex": "#e5c7ad",
      "rgb": [
        229,
        199,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:977",
      "brandId": "dmc",
      "reference": "977",
      "name": "Golden Brown light",
      "hex": "#e6833d",
      "rgb": [
        230,
        131,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:676",
      "brandId": "dmc",
      "reference": "676",
      "name": "Old Gold light",
      "hex": "#e6b469",
      "rgb": [
        230,
        180,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3354",
      "brandId": "dmc",
      "reference": "3354",
      "name": "Dusty Rose light",
      "hex": "#e7899e",
      "rgb": [
        231,
        137,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:606",
      "brandId": "dmc",
      "reference": "606",
      "name": "Burnt Orange-Red",
      "hex": "#e81820",
      "rgb": [
        232,
        24,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:402",
      "brandId": "dmc",
      "reference": "402",
      "name": "Mahogany very light",
      "hex": "#e8895b",
      "rgb": [
        232,
        137,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3779",
      "brandId": "dmc",
      "reference": "3779",
      "name": "Terra Cotta ultra very light",
      "hex": "#e8a492",
      "rgb": [
        232,
        164,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:23",
      "brandId": "dmc",
      "reference": "23",
      "name": "Apple Blossom",
      "hex": "#e8dadf",
      "rgb": [
        232,
        218,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:603",
      "brandId": "dmc",
      "reference": "603",
      "name": "Cranberry",
      "hex": "#e94f8c",
      "rgb": [
        233,
        79,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3774",
      "brandId": "dmc",
      "reference": "3774",
      "name": "Desert Sand very light",
      "hex": "#e9bea6",
      "rgb": [
        233,
        190,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:677",
      "brandId": "dmc",
      "reference": "677",
      "name": "Old Gold very light",
      "hex": "#eacf8e",
      "rgb": [
        234,
        207,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:899",
      "brandId": "dmc",
      "reference": "899",
      "name": "Rose medium",
      "hex": "#eb6682",
      "rgb": [
        235,
        102,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:739",
      "brandId": "dmc",
      "reference": "739",
      "name": "Tan ultra very light",
      "hex": "#edcda6",
      "rgb": [
        237,
        205,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:ECRU",
      "brandId": "dmc",
      "reference": "ECRU",
      "name": "Ecru",
      "hex": "#eddec4",
      "rgb": [
        237,
        222,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3705",
      "brandId": "dmc",
      "reference": "3705",
      "name": "Melon dark",
      "hex": "#ee3a4d",
      "rgb": [
        238,
        58,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:945",
      "brandId": "dmc",
      "reference": "945",
      "name": "Tawny medium",
      "hex": "#eeb28f",
      "rgb": [
        238,
        178,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:891",
      "brandId": "dmc",
      "reference": "891",
      "name": "Carnation dark",
      "hex": "#ef2c46",
      "rgb": [
        239,
        44,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:728",
      "brandId": "dmc",
      "reference": "728",
      "name": "Golden Yellow",
      "hex": "#efad3d",
      "rgb": [
        239,
        173,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:444",
      "brandId": "dmc",
      "reference": "444",
      "name": "Lemon dark",
      "hex": "#f0b900",
      "rgb": [
        240,
        185,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3822",
      "brandId": "dmc",
      "reference": "3822",
      "name": "Straw light",
      "hex": "#f0c65f",
      "rgb": [
        240,
        198,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:721",
      "brandId": "dmc",
      "reference": "721",
      "name": "Orange Spice medium",
      "hex": "#f25c2c",
      "rgb": [
        242,
        92,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:352",
      "brandId": "dmc",
      "reference": "352",
      "name": "Coral light",
      "hex": "#f27365",
      "rgb": [
        242,
        115,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3854",
      "brandId": "dmc",
      "reference": "3854",
      "name": "Autumn Gold medium",
      "hex": "#f29347",
      "rgb": [
        242,
        147,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:151",
      "brandId": "dmc",
      "reference": "151",
      "name": "Dusty Rose very light",
      "hex": "#f2a8ba",
      "rgb": [
        242,
        168,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:712",
      "brandId": "dmc",
      "reference": "712",
      "name": "Cream",
      "hex": "#f3e8d2",
      "rgb": [
        243,
        232,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:892",
      "brandId": "dmc",
      "reference": "892",
      "name": "Carnation medium",
      "hex": "#f43853",
      "rgb": [
        244,
        56,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:754",
      "brandId": "dmc",
      "reference": "754",
      "name": "Peach light",
      "hex": "#f4b096",
      "rgb": [
        244,
        176,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:946",
      "brandId": "dmc",
      "reference": "946",
      "name": "Burnt Orange medium",
      "hex": "#f53d1c",
      "rgb": [
        245,
        61,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:761",
      "brandId": "dmc",
      "reference": "761",
      "name": "Salmon light",
      "hex": "#f5a3a8",
      "rgb": [
        245,
        163,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3689",
      "brandId": "dmc",
      "reference": "3689",
      "name": "Mauve light",
      "hex": "#f5acc2",
      "rgb": [
        245,
        172,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:225",
      "brandId": "dmc",
      "reference": "225",
      "name": "Shell Pink ultra very light",
      "hex": "#f5c4bd",
      "rgb": [
        245,
        196,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:604",
      "brandId": "dmc",
      "reference": "604",
      "name": "Cranberry light",
      "hex": "#f67aad",
      "rgb": [
        246,
        122,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3326",
      "brandId": "dmc",
      "reference": "3326",
      "name": "Rose light (776)",
      "hex": "#f793a6",
      "rgb": [
        247,
        147,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:951",
      "brandId": "dmc",
      "reference": "951",
      "name": "Tawny light",
      "hex": "#f7cea9",
      "rgb": [
        247,
        206,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:20",
      "brandId": "dmc",
      "reference": "20",
      "name": "Shrimp",
      "hex": "#f7d1b3",
      "rgb": [
        247,
        209,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:445",
      "brandId": "dmc",
      "reference": "445",
      "name": "Lemon light",
      "hex": "#f7f57a",
      "rgb": [
        247,
        245,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3865",
      "brandId": "dmc",
      "reference": "3865",
      "name": "Winter White",
      "hex": "#f7f7f0",
      "rgb": [
        247,
        247,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:956",
      "brandId": "dmc",
      "reference": "956",
      "name": "Geranium",
      "hex": "#f94472",
      "rgb": [
        249,
        68,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3855",
      "brandId": "dmc",
      "reference": "3855",
      "name": "Autumn Gold light",
      "hex": "#f9c170",
      "rgb": [
        249,
        193,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3078",
      "brandId": "dmc",
      "reference": "3078",
      "name": "Golden Yellow very light",
      "hex": "#faeb97",
      "rgb": [
        250,
        235,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:746",
      "brandId": "dmc",
      "reference": "746",
      "name": "Off White",
      "hex": "#faf1c7",
      "rgb": [
        250,
        241,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:B5200",
      "brandId": "dmc",
      "reference": "B5200",
      "name": "Snow White",
      "hex": "#fafaff",
      "rgb": [
        250,
        250,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:893",
      "brandId": "dmc",
      "reference": "893",
      "name": "Carnation light",
      "hex": "#fb4d6d",
      "rgb": [
        251,
        77,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:307",
      "brandId": "dmc",
      "reference": "307",
      "name": "Lemon",
      "hex": "#fbde18",
      "rgb": [
        251,
        222,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:971",
      "brandId": "dmc",
      "reference": "971",
      "name": "Pumpkin",
      "hex": "#fc670d",
      "rgb": [
        252,
        103,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:776",
      "brandId": "dmc",
      "reference": "776",
      "name": "Pink Medium",
      "hex": "#fca8ad",
      "rgb": [
        252,
        168,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:725",
      "brandId": "dmc",
      "reference": "725",
      "name": "Topaz",
      "hex": "#fcba40",
      "rgb": [
        252,
        186,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:BLANC",
      "brandId": "dmc",
      "reference": "BLANC",
      "name": "White",
      "hex": "#fcfcfc",
      "rgb": [
        252,
        252,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:948",
      "brandId": "dmc",
      "reference": "948",
      "name": "Peach very light",
      "hex": "#fdd5c1",
      "rgb": [
        253,
        213,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3716",
      "brandId": "dmc",
      "reference": "3716",
      "name": "Dusty Rose very light",
      "hex": "#fe97af",
      "rgb": [
        254,
        151,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:605",
      "brandId": "dmc",
      "reference": "605",
      "name": "Cranberry very light",
      "hex": "#fe98c1",
      "rgb": [
        254,
        152,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:353",
      "brandId": "dmc",
      "reference": "353",
      "name": "Peach",
      "hex": "#fea693",
      "rgb": [
        254,
        166,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3823",
      "brandId": "dmc",
      "reference": "3823",
      "name": "Yellow ultra pale",
      "hex": "#feedb4",
      "rgb": [
        254,
        237,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:608",
      "brandId": "dmc",
      "reference": "608",
      "name": "Burnt Orange",
      "hex": "#ff4225",
      "rgb": [
        255,
        66,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:947",
      "brandId": "dmc",
      "reference": "947",
      "name": "Burnt Orange",
      "hex": "#ff4a1b",
      "rgb": [
        255,
        74,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3706",
      "brandId": "dmc",
      "reference": "3706",
      "name": "Melon medium",
      "hex": "#ff6175",
      "rgb": [
        255,
        97,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:970",
      "brandId": "dmc",
      "reference": "970",
      "name": "Pumpkin light",
      "hex": "#ff6624",
      "rgb": [
        255,
        102,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3340",
      "brandId": "dmc",
      "reference": "3340",
      "name": "Apricot medium",
      "hex": "#ff6647",
      "rgb": [
        255,
        102,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:740",
      "brandId": "dmc",
      "reference": "740",
      "name": "Tangerine (971)",
      "hex": "#ff6c1b",
      "rgb": [
        255,
        108,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:894",
      "brandId": "dmc",
      "reference": "894",
      "name": "Carnation very light",
      "hex": "#ff7c9a",
      "rgb": [
        255,
        124,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:957",
      "brandId": "dmc",
      "reference": "957",
      "name": "Geranium pale",
      "hex": "#ff7ca2",
      "rgb": [
        255,
        124,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3341",
      "brandId": "dmc",
      "reference": "3341",
      "name": "Apricot",
      "hex": "#ff8166",
      "rgb": [
        255,
        129,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:722",
      "brandId": "dmc",
      "reference": "722",
      "name": "Orange Spice light",
      "hex": "#ff824a",
      "rgb": [
        255,
        130,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:741",
      "brandId": "dmc",
      "reference": "741",
      "name": "Tangerine medium",
      "hex": "#ff8820",
      "rgb": [
        255,
        136,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3708",
      "brandId": "dmc",
      "reference": "3708",
      "name": "Melon light",
      "hex": "#ff889e",
      "rgb": [
        255,
        136,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3825",
      "brandId": "dmc",
      "reference": "3825",
      "name": "Pumpkin pale",
      "hex": "#ff9a63",
      "rgb": [
        255,
        154,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:972",
      "brandId": "dmc",
      "reference": "972",
      "name": "Canary deep",
      "hex": "#ffa400",
      "rgb": [
        255,
        164,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:742",
      "brandId": "dmc",
      "reference": "742",
      "name": "Tangerine light",
      "hex": "#ffa523",
      "rgb": [
        255,
        165,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3824",
      "brandId": "dmc",
      "reference": "3824",
      "name": "Apricot light",
      "hex": "#ffa58d",
      "rgb": [
        255,
        165,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:963",
      "brandId": "dmc",
      "reference": "963",
      "name": "Dusty Rose ultra very light",
      "hex": "#ffbac4",
      "rgb": [
        255,
        186,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:967",
      "brandId": "dmc",
      "reference": "967",
      "name": "Apricot very light",
      "hex": "#ffbea9",
      "rgb": [
        255,
        190,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3713",
      "brandId": "dmc",
      "reference": "3713",
      "name": "Salmon very light",
      "hex": "#ffc7c7",
      "rgb": [
        255,
        199,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:743",
      "brandId": "dmc",
      "reference": "743",
      "name": "Yellow medium",
      "hex": "#ffc847",
      "rgb": [
        255,
        200,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:973",
      "brandId": "dmc",
      "reference": "973",
      "name": "Canary bright",
      "hex": "#ffcf00",
      "rgb": [
        255,
        207,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:818",
      "brandId": "dmc",
      "reference": "818",
      "name": "Baby Pink",
      "hex": "#ffd0d2",
      "rgb": [
        255,
        208,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:726",
      "brandId": "dmc",
      "reference": "726",
      "name": "Topaz light",
      "hex": "#ffd447",
      "rgb": [
        255,
        212,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:744",
      "brandId": "dmc",
      "reference": "744",
      "name": "Yellow pale",
      "hex": "#ffde7a",
      "rgb": [
        255,
        222,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:819",
      "brandId": "dmc",
      "reference": "819",
      "name": "Baby Pink light",
      "hex": "#ffdeda",
      "rgb": [
        255,
        222,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:745",
      "brandId": "dmc",
      "reference": "745",
      "name": "Yellow light pale",
      "hex": "#ffdf89",
      "rgb": [
        255,
        223,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:727",
      "brandId": "dmc",
      "reference": "727",
      "name": "Topaz very light",
      "hex": "#ffe471",
      "rgb": [
        255,
        228,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "dmc:3770",
      "brandId": "dmc",
      "reference": "3770",
      "name": "Tawny very light",
      "hex": "#ffe6c9",
      "rgb": [
        255,
        230,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7",
      "brandId": "finca",
      "reference": "7",
      "name": "Black",
      "hex": "#000000",
      "rgb": [
        0,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4323",
      "brandId": "finca",
      "reference": "4323",
      "name": "Blue Green very dark",
      "hex": "#044d33",
      "rgb": [
        4,
        77,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4652",
      "brandId": "finca",
      "reference": "4652",
      "name": "Christmas Green",
      "hex": "#056517",
      "rgb": [
        5,
        101,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3411",
      "brandId": "finca",
      "reference": "3411",
      "name": "Royal Blue very dark",
      "hex": "#0e365c",
      "rgb": [
        14,
        54,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3405",
      "brandId": "finca",
      "reference": "3405",
      "name": "Royal Blue dark",
      "hex": "#11416d",
      "rgb": [
        17,
        65,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4402",
      "brandId": "finca",
      "reference": "4402",
      "name": "Emerald Green very dark",
      "hex": "#156f49",
      "rgb": [
        21,
        111,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4646",
      "brandId": "finca",
      "reference": "4646",
      "name": "Emerald Green medium",
      "hex": "#189065",
      "rgb": [
        24,
        144,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4396",
      "brandId": "finca",
      "reference": "4396",
      "name": "Emerald Green light",
      "hex": "#1b9d6b",
      "rgb": [
        27,
        157,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3319",
      "brandId": "finca",
      "reference": "3319",
      "name": "Navy Blue medium",
      "hex": "#1c5066",
      "rgb": [
        28,
        80,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8083",
      "brandId": "finca",
      "reference": "8083",
      "name": "Black Brown",
      "hex": "#1e1108",
      "rgb": [
        30,
        17,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4485",
      "brandId": "finca",
      "reference": "4485",
      "name": "Pistachio Green very dark",
      "hex": "#205f2e",
      "rgb": [
        32,
        95,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3327",
      "brandId": "finca",
      "reference": "3327",
      "name": "Navy Blue dark",
      "hex": "#213063",
      "rgb": [
        33,
        48,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3822",
      "brandId": "finca",
      "reference": "3822",
      "name": "Electric Blue dark",
      "hex": "#2696b6",
      "rgb": [
        38,
        150,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2720",
      "brandId": "finca",
      "reference": "2720",
      "name": "",
      "hex": "#282448",
      "rgb": [
        40,
        36,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4368",
      "brandId": "finca",
      "reference": "4368",
      "name": "",
      "hex": "#2d6153",
      "rgb": [
        45,
        97,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3810",
      "brandId": "finca",
      "reference": "3810",
      "name": "Electric Blue medium",
      "hex": "#30c2ec",
      "rgb": [
        48,
        194,
        236
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3670",
      "brandId": "finca",
      "reference": "3670",
      "name": "Turquoise ultra very dark",
      "hex": "#366970",
      "rgb": [
        54,
        105,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4231",
      "brandId": "finca",
      "reference": "4231",
      "name": "Blue Green dark",
      "hex": "#396f52",
      "rgb": [
        57,
        111,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2711",
      "brandId": "finca",
      "reference": "2711",
      "name": "",
      "hex": "#3a3365",
      "rgb": [
        58,
        51,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3494",
      "brandId": "finca",
      "reference": "3494",
      "name": "Wedgewood dark",
      "hex": "#3b768f",
      "rgb": [
        59,
        118,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4074",
      "brandId": "finca",
      "reference": "4074",
      "name": "Aquamarine medium",
      "hex": "#3d9384",
      "rgb": [
        61,
        147,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3574",
      "brandId": "finca",
      "reference": "3574",
      "name": "Peacock Blue dark",
      "hex": "#3d95a5",
      "rgb": [
        61,
        149,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4741",
      "brandId": "finca",
      "reference": "4741",
      "name": "",
      "hex": "#3e6236",
      "rgb": [
        62,
        98,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4059",
      "brandId": "finca",
      "reference": "4059",
      "name": "Sea Green dark",
      "hex": "#3eb6a1",
      "rgb": [
        62,
        182,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4643",
      "brandId": "finca",
      "reference": "4643",
      "name": "Christmas Green light",
      "hex": "#3f8f29",
      "rgb": [
        63,
        143,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8756",
      "brandId": "finca",
      "reference": "8756",
      "name": "Pewter Grey very dark",
      "hex": "#424242",
      "rgb": [
        66,
        66,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3151",
      "brandId": "finca",
      "reference": "3151",
      "name": "Antique Blue dark",
      "hex": "#455c71",
      "rgb": [
        69,
        92,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3324",
      "brandId": "finca",
      "reference": "3324",
      "name": "Cornflower Blue very dark",
      "hex": "#464563",
      "rgb": [
        70,
        69,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3664",
      "brandId": "finca",
      "reference": "3664",
      "name": "Turquoise dark",
      "hex": "#488e9a",
      "rgb": [
        72,
        142,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8080",
      "brandId": "finca",
      "reference": "8080",
      "name": "Coffee Brown very dark",
      "hex": "#492a13",
      "rgb": [
        73,
        42,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4823",
      "brandId": "finca",
      "reference": "4823",
      "name": "Avocado Green very dark",
      "hex": "#4c5826",
      "rgb": [
        76,
        88,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3483",
      "brandId": "finca",
      "reference": "3483",
      "name": "Wedgewood light",
      "hex": "#4f93a7",
      "rgb": [
        79,
        147,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4350",
      "brandId": "finca",
      "reference": "4350",
      "name": "Jade medium",
      "hex": "#53976a",
      "rgb": [
        83,
        151,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4906",
      "brandId": "finca",
      "reference": "4906",
      "name": "Parrot Green very dark",
      "hex": "#557822",
      "rgb": [
        85,
        120,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8749",
      "brandId": "finca",
      "reference": "8749",
      "name": "Pewter Grey dark",
      "hex": "#565656",
      "rgb": [
        86,
        86,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3745",
      "brandId": "finca",
      "reference": "3745",
      "name": "Grey Green very dark",
      "hex": "#566a6a",
      "rgb": [
        86,
        106,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4561",
      "brandId": "finca",
      "reference": "4561",
      "name": "Forest Green dark",
      "hex": "#587141",
      "rgb": [
        88,
        113,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8171",
      "brandId": "finca",
      "reference": "8171",
      "name": "Beige Brown very dark",
      "hex": "#594937",
      "rgb": [
        89,
        73,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3396",
      "brandId": "finca",
      "reference": "3396",
      "name": "Baby Blue dark",
      "hex": "#5a8fb8",
      "rgb": [
        90,
        143,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4228",
      "brandId": "finca",
      "reference": "4228",
      "name": "Blue Green",
      "hex": "#5b9071",
      "rgb": [
        91,
        144,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3654",
      "brandId": "finca",
      "reference": "3654",
      "name": "Turquoise",
      "hex": "#5ba3b3",
      "rgb": [
        91,
        163,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2635",
      "brandId": "finca",
      "reference": "2635",
      "name": "Violet very dark",
      "hex": "#5c184e",
      "rgb": [
        92,
        24,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2699",
      "brandId": "finca",
      "reference": "2699",
      "name": "Blue Violet very dark",
      "hex": "#5c5478",
      "rgb": [
        92,
        84,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8785",
      "brandId": "finca",
      "reference": "8785",
      "name": "",
      "hex": "#616267",
      "rgb": [
        97,
        98,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4565",
      "brandId": "finca",
      "reference": "4565",
      "name": "Parrot Green dark",
      "hex": "#628a28",
      "rgb": [
        98,
        138,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2627",
      "brandId": "finca",
      "reference": "2627",
      "name": "Violet very dark",
      "hex": "#633666",
      "rgb": [
        99,
        54,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8589",
      "brandId": "finca",
      "reference": "8589",
      "name": "Ash Grey very light",
      "hex": "#636458",
      "rgb": [
        99,
        100,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3560",
      "brandId": "finca",
      "reference": "3560",
      "name": "Peacock Blue",
      "hex": "#64abba",
      "rgb": [
        100,
        171,
        186
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3739",
      "brandId": "finca",
      "reference": "3739",
      "name": "Grey Green dark",
      "hex": "#657f7f",
      "rgb": [
        101,
        127,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5156",
      "brandId": "finca",
      "reference": "5156",
      "name": "Fern Green dark",
      "hex": "#666d4f",
      "rgb": [
        102,
        109,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8159",
      "brandId": "finca",
      "reference": "8159",
      "name": "Beige Brown dark",
      "hex": "#675541",
      "rgb": [
        103,
        85,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4478",
      "brandId": "finca",
      "reference": "4478",
      "name": "Pistachio Green medium",
      "hex": "#69885a",
      "rgb": [
        105,
        136,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3229",
      "brandId": "finca",
      "reference": "3229",
      "name": "Blue medium",
      "hex": "#6b9ebf",
      "rgb": [
        107,
        158,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8705",
      "brandId": "finca",
      "reference": "8705",
      "name": "Pewter Grey",
      "hex": "#6c6c6c",
      "rgb": [
        108,
        108,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4394",
      "brandId": "finca",
      "reference": "4394",
      "name": "Nile Green medium",
      "hex": "#6dab77",
      "rgb": [
        109,
        171,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8492",
      "brandId": "finca",
      "reference": "8492",
      "name": "Beaver Grey very dark",
      "hex": "#6e655c",
      "rgb": [
        110,
        101,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7656",
      "brandId": "finca",
      "reference": "7656",
      "name": "Mahogany very dark",
      "hex": "#6f2f00",
      "rgb": [
        111,
        47,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3400",
      "brandId": "finca",
      "reference": "3400",
      "name": "Cornflower Blue medium",
      "hex": "#707da2",
      "rgb": [
        112,
        125,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4817",
      "brandId": "finca",
      "reference": "4817",
      "name": "Avocado Green",
      "hex": "#72843c",
      "rgb": [
        114,
        132,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8026",
      "brandId": "finca",
      "reference": "8026",
      "name": "",
      "hex": "#765951",
      "rgb": [
        118,
        89,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8327",
      "brandId": "finca",
      "reference": "8327",
      "name": "Drab Brown dark",
      "hex": "#796047",
      "rgb": [
        121,
        96,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8075",
      "brandId": "finca",
      "reference": "8075",
      "name": "Brown medium",
      "hex": "#7a451f",
      "rgb": [
        122,
        69,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4723",
      "brandId": "finca",
      "reference": "4723",
      "name": "",
      "hex": "#7b9648",
      "rgb": [
        123,
        150,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4636",
      "brandId": "finca",
      "reference": "4636",
      "name": "Chartreuse",
      "hex": "#7bb547",
      "rgb": [
        123,
        181,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3476",
      "brandId": "finca",
      "reference": "3476",
      "name": "Sky Blue",
      "hex": "#7eb1c8",
      "rgb": [
        126,
        177,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4730",
      "brandId": "finca",
      "reference": "4730",
      "name": "Parrot Green medium",
      "hex": "#7fb335",
      "rgb": [
        127,
        179,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2123",
      "brandId": "finca",
      "reference": "2123",
      "name": "Antique Mauve dark",
      "hex": "#814952",
      "rgb": [
        129,
        73,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2415",
      "brandId": "finca",
      "reference": "2415",
      "name": "Plum dark",
      "hex": "#820043",
      "rgb": [
        130,
        0,
        67
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2171",
      "brandId": "finca",
      "reference": "2171",
      "name": "Garnet very dark",
      "hex": "#822637",
      "rgb": [
        130,
        38,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5236",
      "brandId": "finca",
      "reference": "5236",
      "name": "Olive Green very dark",
      "hex": "#827b30",
      "rgb": [
        130,
        123,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2615",
      "brandId": "finca",
      "reference": "2615",
      "name": "Lavender very dark",
      "hex": "#835b8b",
      "rgb": [
        131,
        91,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7408",
      "brandId": "finca",
      "reference": "7408",
      "name": "Hazel Nut Brown very dark",
      "hex": "#835e39",
      "rgb": [
        131,
        94,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8487",
      "brandId": "finca",
      "reference": "8487",
      "name": "Beige Grey very dark",
      "hex": "#857b61",
      "rgb": [
        133,
        123,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1915",
      "brandId": "finca",
      "reference": "1915",
      "name": "Garnet medium",
      "hex": "#87071f",
      "rgb": [
        135,
        7,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7962",
      "brandId": "finca",
      "reference": "7962",
      "name": "Desert Sand ultra very dark",
      "hex": "#875539",
      "rgb": [
        135,
        85,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8574",
      "brandId": "finca",
      "reference": "8574",
      "name": "Beaver Grey dark",
      "hex": "#877d73",
      "rgb": [
        135,
        125,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1996",
      "brandId": "finca",
      "reference": "1996",
      "name": "Shell Pink very dark",
      "hex": "#883e43",
      "rgb": [
        136,
        62,
        67
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7066",
      "brandId": "finca",
      "reference": "7066",
      "name": "Golden Olive dark",
      "hex": "#8d784b",
      "rgb": [
        141,
        120,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3139",
      "brandId": "finca",
      "reference": "3139",
      "name": "Cornflower Blue light",
      "hex": "#8f9cc1",
      "rgb": [
        143,
        156,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4388",
      "brandId": "finca",
      "reference": "4388",
      "name": "Jade light",
      "hex": "#8fc098",
      "rgb": [
        143,
        192,
        152
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8742",
      "brandId": "finca",
      "reference": "8742",
      "name": "Shell Grey dark",
      "hex": "#917b73",
      "rgb": [
        145,
        123,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3219",
      "brandId": "finca",
      "reference": "3219",
      "name": "",
      "hex": "#92b3d6",
      "rgb": [
        146,
        179,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3312",
      "brandId": "finca",
      "reference": "3312",
      "name": "Baby Blue",
      "hex": "#92b4ce",
      "rgb": [
        146,
        180,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8688",
      "brandId": "finca",
      "reference": "8688",
      "name": "",
      "hex": "#9393a6",
      "rgb": [
        147,
        147,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8620",
      "brandId": "finca",
      "reference": "8620",
      "name": "Antique Violet medium",
      "hex": "#956f7c",
      "rgb": [
        149,
        111,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8320",
      "brandId": "finca",
      "reference": "8320",
      "name": "Drab Brown",
      "hex": "#967656",
      "rgb": [
        150,
        118,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5151",
      "brandId": "finca",
      "reference": "5151",
      "name": "Fern Green",
      "hex": "#969e7e",
      "rgb": [
        150,
        158,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8072",
      "brandId": "finca",
      "reference": "8072",
      "name": "Brown light",
      "hex": "#985e33",
      "rgb": [
        152,
        94,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3733",
      "brandId": "finca",
      "reference": "3733",
      "name": "Grey Green medium",
      "hex": "#98aeae",
      "rgb": [
        152,
        174,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8157",
      "brandId": "finca",
      "reference": "8157",
      "name": "Beige Brown medium",
      "hex": "#9a7c5c",
      "rgb": [
        154,
        124,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2110",
      "brandId": "finca",
      "reference": "2110",
      "name": "Antique Mauve dark",
      "hex": "#9b5b66",
      "rgb": [
        155,
        91,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2406",
      "brandId": "finca",
      "reference": "2406",
      "name": "Plum",
      "hex": "#9c2462",
      "rgb": [
        156,
        36,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7073",
      "brandId": "finca",
      "reference": "7073",
      "name": "Hazel Nut Brown dark",
      "hex": "#a07042",
      "rgb": [
        160,
        112,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1984",
      "brandId": "finca",
      "reference": "1984",
      "name": "Shell Pink dark",
      "hex": "#a14b51",
      "rgb": [
        161,
        75,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3223",
      "brandId": "finca",
      "reference": "3223",
      "name": "Blue light",
      "hex": "#a1c2d7",
      "rgb": [
        161,
        194,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1072",
      "brandId": "finca",
      "reference": "1072",
      "name": "Topaz very dark",
      "hex": "#a26d20",
      "rgb": [
        162,
        109,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7580",
      "brandId": "finca",
      "reference": "7580",
      "name": "Red Copper",
      "hex": "#a64510",
      "rgb": [
        166,
        69,
        16
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8728",
      "brandId": "finca",
      "reference": "8728",
      "name": "",
      "hex": "#a6a6a8",
      "rgb": [
        166,
        166,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5229",
      "brandId": "finca",
      "reference": "5229",
      "name": "Khaki Green medium",
      "hex": "#a6a75d",
      "rgb": [
        166,
        167,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4472",
      "brandId": "finca",
      "reference": "4472",
      "name": "Pistachio Green light",
      "hex": "#a6c298",
      "rgb": [
        166,
        194,
        152
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4812",
      "brandId": "finca",
      "reference": "4812",
      "name": "Moss Green",
      "hex": "#a7ae38",
      "rgb": [
        167,
        174,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4379",
      "brandId": "finca",
      "reference": "4379",
      "name": "Jade very light",
      "hex": "#a7cdaf",
      "rgb": [
        167,
        205,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4048",
      "brandId": "finca",
      "reference": "4048",
      "name": "Sea Green light",
      "hex": "#a9e2d8",
      "rgb": [
        169,
        226,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2246",
      "brandId": "finca",
      "reference": "2246",
      "name": "Mauve medium",
      "hex": "#ab3357",
      "rgb": [
        171,
        51,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8779",
      "brandId": "finca",
      "reference": "8779",
      "name": "Steel Grey light",
      "hex": "#ababab",
      "rgb": [
        171,
        171,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5140",
      "brandId": "finca",
      "reference": "5140",
      "name": "Fern Green light",
      "hex": "#abb197",
      "rgb": [
        171,
        177,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3556",
      "brandId": "finca",
      "reference": "3556",
      "name": "Sky Blue light",
      "hex": "#acd8e2",
      "rgb": [
        172,
        216,
        226
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7731",
      "brandId": "finca",
      "reference": "7731",
      "name": "Golden Brown",
      "hex": "#ad7239",
      "rgb": [
        173,
        114,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8017",
      "brandId": "finca",
      "reference": "8017",
      "name": "",
      "hex": "#ae8d82",
      "rgb": [
        174,
        141,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4885",
      "brandId": "finca",
      "reference": "4885",
      "name": "Avocado Green very light",
      "hex": "#aebf79",
      "rgb": [
        174,
        191,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8567",
      "brandId": "finca",
      "reference": "8567",
      "name": "Beaver Grey medium",
      "hex": "#b0a69c",
      "rgb": [
        176,
        166,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1667",
      "brandId": "finca",
      "reference": "1667",
      "name": "Rose very deep",
      "hex": "#b33b4b",
      "rgb": [
        179,
        59,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7740",
      "brandId": "finca",
      "reference": "7740",
      "name": "Mahogany medium",
      "hex": "#b35f2b",
      "rgb": [
        179,
        95,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1906",
      "brandId": "finca",
      "reference": "1906",
      "name": "Christmas Red medium",
      "hex": "#b71f33",
      "rgb": [
        183,
        31,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2098",
      "brandId": "finca",
      "reference": "2098",
      "name": "Antique Mauve medium",
      "hex": "#b7737f",
      "rgb": [
        183,
        115,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8605",
      "brandId": "finca",
      "reference": "8605",
      "name": "Antique Violet light",
      "hex": "#b79da7",
      "rgb": [
        183,
        157,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8069",
      "brandId": "finca",
      "reference": "8069",
      "name": "Brown very light",
      "hex": "#b87748",
      "rgb": [
        184,
        119,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1661",
      "brandId": "finca",
      "reference": "1661",
      "name": "Rose deep",
      "hex": "#ba4a4a",
      "rgb": [
        186,
        74,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7944",
      "brandId": "finca",
      "reference": "7944",
      "name": "Desert Sand dark",
      "hex": "#bb8161",
      "rgb": [
        187,
        129,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2165",
      "brandId": "finca",
      "reference": "2165",
      "name": "Dusty Rose ultra dark",
      "hex": "#bc4365",
      "rgb": [
        188,
        67,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7155",
      "brandId": "finca",
      "reference": "7155",
      "name": "Old Gold dark",
      "hex": "#bc8d0e",
      "rgb": [
        188,
        141,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7392",
      "brandId": "finca",
      "reference": "7392",
      "name": "Yellow Beige dark",
      "hex": "#bc966a",
      "rgb": [
        188,
        150,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8310",
      "brandId": "finca",
      "reference": "8310",
      "name": "Drab Brown light",
      "hex": "#bc9a78",
      "rgb": [
        188,
        154,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8562",
      "brandId": "finca",
      "reference": "8562",
      "name": "Beaver Grey light",
      "hex": "#bcb4ac",
      "rgb": [
        188,
        180,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1166",
      "brandId": "finca",
      "reference": "1166",
      "name": "",
      "hex": "#bd2108",
      "rgb": [
        189,
        33,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7057",
      "brandId": "finca",
      "reference": "7057",
      "name": "Golden Olive",
      "hex": "#bd9b51",
      "rgb": [
        189,
        155,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3721",
      "brandId": "finca",
      "reference": "3721",
      "name": "Grey Green light",
      "hex": "#bdcbcb",
      "rgb": [
        189,
        203,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3802",
      "brandId": "finca",
      "reference": "3802",
      "name": "Blue very light",
      "hex": "#bddded",
      "rgb": [
        189,
        221,
        237
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1490",
      "brandId": "finca",
      "reference": "1490",
      "name": "Salmon very dark",
      "hex": "#bf2d2d",
      "rgb": [
        191,
        45,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8599",
      "brandId": "finca",
      "reference": "8599",
      "name": "Shell Grey medium",
      "hex": "#c0b3ae",
      "rgb": [
        192,
        179,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3305",
      "brandId": "finca",
      "reference": "3305",
      "name": "Delft Blue pale",
      "hex": "#c0ccde",
      "rgb": [
        192,
        204,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7726",
      "brandId": "finca",
      "reference": "7726",
      "name": "Golden Brown medium",
      "hex": "#c28142",
      "rgb": [
        194,
        129,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4218",
      "brandId": "finca",
      "reference": "4218",
      "name": "Blue Green light",
      "hex": "#c4decc",
      "rgb": [
        196,
        222,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2402",
      "brandId": "finca",
      "reference": "2402",
      "name": "Plum light",
      "hex": "#c54989",
      "rgb": [
        197,
        73,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7813",
      "brandId": "finca",
      "reference": "7813",
      "name": "Terra Cotta medium",
      "hex": "#c56a5b",
      "rgb": [
        197,
        106,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7644",
      "brandId": "finca",
      "reference": "7644",
      "name": "Copper",
      "hex": "#c66218",
      "rgb": [
        198,
        98,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7386",
      "brandId": "finca",
      "reference": "7386",
      "name": "Hazel Nut Brown light",
      "hex": "#c69f7b",
      "rgb": [
        198,
        159,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1902",
      "brandId": "finca",
      "reference": "1902",
      "name": "Christmas Red",
      "hex": "#c72b3b",
      "rgb": [
        199,
        43,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7046",
      "brandId": "finca",
      "reference": "7046",
      "name": "Golden Olive light",
      "hex": "#c8ab6c",
      "rgb": [
        200,
        171,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2240",
      "brandId": "finca",
      "reference": "2240",
      "name": "Mauve",
      "hex": "#c96b70",
      "rgb": [
        201,
        107,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1981",
      "brandId": "finca",
      "reference": "1981",
      "name": "Shell Pink light",
      "hex": "#cc847c",
      "rgb": [
        204,
        132,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:5224",
      "brandId": "finca",
      "reference": "5224",
      "name": "Mustard light",
      "hex": "#ccb784",
      "rgb": [
        204,
        183,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1068",
      "brandId": "finca",
      "reference": "1068",
      "name": "Topaz medium",
      "hex": "#ce9124",
      "rgb": [
        206,
        145,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1344",
      "brandId": "finca",
      "reference": "1344",
      "name": "Burnt Orange dark",
      "hex": "#d15807",
      "rgb": [
        209,
        88,
        7
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2606",
      "brandId": "finca",
      "reference": "2606",
      "name": "Lavender medium",
      "hex": "#d29fc3",
      "rgb": [
        210,
        159,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8773",
      "brandId": "finca",
      "reference": "8773",
      "name": "Pearl Grey",
      "hex": "#d3d3d6",
      "rgb": [
        211,
        211,
        214
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8145",
      "brandId": "finca",
      "reference": "8145",
      "name": "Shell Grey light",
      "hex": "#d7cecb",
      "rgb": [
        215,
        206,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4799",
      "brandId": "finca",
      "reference": "4799",
      "name": "Avocado Green ultra",
      "hex": "#d8e498",
      "rgb": [
        216,
        228,
        152
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8683",
      "brandId": "finca",
      "reference": "8683",
      "name": "Baby Blue very light",
      "hex": "#d9ebf1",
      "rgb": [
        217,
        235,
        241
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2159",
      "brandId": "finca",
      "reference": "2159",
      "name": "Dusty Rose very dark",
      "hex": "#da6783",
      "rgb": [
        218,
        103,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3132",
      "brandId": "finca",
      "reference": "3132",
      "name": "Antique Blue ultra very light",
      "hex": "#dbe2e9",
      "rgb": [
        219,
        226,
        233
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8475",
      "brandId": "finca",
      "reference": "8475",
      "name": "Beige Grey medium",
      "hex": "#ddd8cb",
      "rgb": [
        221,
        216,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1040",
      "brandId": "finca",
      "reference": "1040",
      "name": "Straw dark",
      "hex": "#dfb65f",
      "rgb": [
        223,
        182,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:9",
      "brandId": "finca",
      "reference": "9",
      "name": "",
      "hex": "#dfca78",
      "rgb": [
        223,
        202,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1485",
      "brandId": "finca",
      "reference": "1485",
      "name": "Coral medium",
      "hex": "#e04848",
      "rgb": [
        224,
        72,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2333",
      "brandId": "finca",
      "reference": "2333",
      "name": "Cranberry medium",
      "hex": "#e24874",
      "rgb": [
        226,
        72,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2687",
      "brandId": "finca",
      "reference": "2687",
      "name": "Lavender light",
      "hex": "#e3cbe3",
      "rgb": [
        227,
        203,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3",
      "brandId": "finca",
      "reference": "3",
      "name": "",
      "hex": "#e3ded1",
      "rgb": [
        227,
        222,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8060",
      "brandId": "finca",
      "reference": "8060",
      "name": "Tan light",
      "hex": "#e4bb8e",
      "rgb": [
        228,
        187,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4550",
      "brandId": "finca",
      "reference": "4550",
      "name": "Yellow Green very light",
      "hex": "#e4ecd4",
      "rgb": [
        228,
        236,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7574",
      "brandId": "finca",
      "reference": "7574",
      "name": "Orange Spice dark",
      "hex": "#e55c1f",
      "rgb": [
        229,
        92,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3639",
      "brandId": "finca",
      "reference": "3639",
      "name": "Sky Blue very light",
      "hex": "#e5fcfd",
      "rgb": [
        229,
        252,
        253
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2232",
      "brandId": "finca",
      "reference": "2232",
      "name": "Mauve medium",
      "hex": "#e7a9ac",
      "rgb": [
        231,
        169,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2397",
      "brandId": "finca",
      "reference": "2397",
      "name": "Plum very light",
      "hex": "#ea9cc4",
      "rgb": [
        234,
        156,
        196
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1975",
      "brandId": "finca",
      "reference": "1975",
      "name": "Shell Pink very light",
      "hex": "#ebb7af",
      "rgb": [
        235,
        183,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2390",
      "brandId": "finca",
      "reference": "2390",
      "name": "",
      "hex": "#ecc5da",
      "rgb": [
        236,
        197,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7139",
      "brandId": "finca",
      "reference": "7139",
      "name": "Pearl Grey very light",
      "hex": "#ececec",
      "rgb": [
        236,
        236,
        236
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8767",
      "brandId": "finca",
      "reference": "8767",
      "name": "Pearl Grey very light",
      "hex": "#ececec",
      "rgb": [
        236,
        236,
        236
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1735",
      "brandId": "finca",
      "reference": "1735",
      "name": "",
      "hex": "#ed5c68",
      "rgb": [
        237,
        92,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1314",
      "brandId": "finca",
      "reference": "1314",
      "name": "",
      "hex": "#ed6a4d",
      "rgb": [
        237,
        106,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1000",
      "brandId": "finca",
      "reference": "1000",
      "name": "",
      "hex": "#ededea",
      "rgb": [
        237,
        237,
        234
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1651",
      "brandId": "finca",
      "reference": "1651",
      "name": "Rose",
      "hex": "#ee546e",
      "rgb": [
        238,
        84,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7806",
      "brandId": "finca",
      "reference": "7806",
      "name": "Terra Cotta very light",
      "hex": "#eeaa9b",
      "rgb": [
        238,
        170,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:6",
      "brandId": "finca",
      "reference": "6",
      "name": "",
      "hex": "#eee9b5",
      "rgb": [
        238,
        233,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3299",
      "brandId": "finca",
      "reference": "3299",
      "name": "Baby Blue ultra very light",
      "hex": "#eefcfc",
      "rgb": [
        238,
        252,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1721",
      "brandId": "finca",
      "reference": "1721",
      "name": "",
      "hex": "#f0d7de",
      "rgb": [
        240,
        215,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7567",
      "brandId": "finca",
      "reference": "7567",
      "name": "Orange Spice medium",
      "hex": "#f27842",
      "rgb": [
        242,
        120,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:8140",
      "brandId": "finca",
      "reference": "8140",
      "name": "Beige Brown ultra very light",
      "hex": "#f2e3ce",
      "rgb": [
        242,
        227,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1010",
      "brandId": "finca",
      "reference": "1010",
      "name": "Straw",
      "hex": "#f3ce75",
      "rgb": [
        243,
        206,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2394",
      "brandId": "finca",
      "reference": "2394",
      "name": "Plum ultra light",
      "hex": "#f4aed7",
      "rgb": [
        244,
        174,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7636",
      "brandId": "finca",
      "reference": "7636",
      "name": "Mahogany very light",
      "hex": "#f7a777",
      "rgb": [
        247,
        167,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7720",
      "brandId": "finca",
      "reference": "7720",
      "name": "Golden Brown pale",
      "hex": "#f7bb77",
      "rgb": [
        247,
        187,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1301",
      "brandId": "finca",
      "reference": "1301",
      "name": "Peach light",
      "hex": "#f7cbbf",
      "rgb": [
        247,
        203,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:4000",
      "brandId": "finca",
      "reference": "4000",
      "name": "Tan ultra very light",
      "hex": "#f8e4c8",
      "rgb": [
        248,
        228,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1140",
      "brandId": "finca",
      "reference": "1140",
      "name": "",
      "hex": "#f9af53",
      "rgb": [
        249,
        175,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1163",
      "brandId": "finca",
      "reference": "1163",
      "name": "Burnt Orange-Red",
      "hex": "#fa3203",
      "rgb": [
        250,
        50,
        3
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2147",
      "brandId": "finca",
      "reference": "2147",
      "name": "Mauve light",
      "hex": "#fbbfc2",
      "rgb": [
        251,
        191,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1",
      "brandId": "finca",
      "reference": "1",
      "name": "White",
      "hex": "#fbffff",
      "rgb": [
        251,
        255,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1742",
      "brandId": "finca",
      "reference": "1742",
      "name": "Carnation light",
      "hex": "#fc90a2",
      "rgb": [
        252,
        144,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1307",
      "brandId": "finca",
      "reference": "1307",
      "name": "Apricot",
      "hex": "#fcab98",
      "rgb": [
        252,
        171,
        152
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1645",
      "brandId": "finca",
      "reference": "1645",
      "name": "Pink medium",
      "hex": "#fcb0b9",
      "rgb": [
        252,
        176,
        185
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7128",
      "brandId": "finca",
      "reference": "7128",
      "name": "Off White",
      "hex": "#fcfcee",
      "rgb": [
        252,
        252,
        238
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1325",
      "brandId": "finca",
      "reference": "1325",
      "name": "Burnt Orange",
      "hex": "#fd5d35",
      "rgb": [
        253,
        93,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1474",
      "brandId": "finca",
      "reference": "1474",
      "name": "Coral light",
      "hex": "#fd9c97",
      "rgb": [
        253,
        156,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1222",
      "brandId": "finca",
      "reference": "1222",
      "name": "Lemon",
      "hex": "#fded54",
      "rgb": [
        253,
        237,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1214",
      "brandId": "finca",
      "reference": "1214",
      "name": "Golden Yellow very light",
      "hex": "#fdf9cd",
      "rgb": [
        253,
        249,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1468",
      "brandId": "finca",
      "reference": "1468",
      "name": "Peach",
      "hex": "#fed7cc",
      "rgb": [
        254,
        215,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1895",
      "brandId": "finca",
      "reference": "1895",
      "name": "Carnation dark",
      "hex": "#ff5773",
      "rgb": [
        255,
        87,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1889",
      "brandId": "finca",
      "reference": "1889",
      "name": "Carnation medium",
      "hex": "#ff798c",
      "rgb": [
        255,
        121,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1237",
      "brandId": "finca",
      "reference": "1237",
      "name": "Tangerine",
      "hex": "#ff8b00",
      "rgb": [
        255,
        139,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1152",
      "brandId": "finca",
      "reference": "1152",
      "name": "Tangerine medium",
      "hex": "#ffa32b",
      "rgb": [
        255,
        163,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2323",
      "brandId": "finca",
      "reference": "2323",
      "name": "Cranberry",
      "hex": "#ffa4be",
      "rgb": [
        255,
        164,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2314",
      "brandId": "finca",
      "reference": "2314",
      "name": "Cranberry light",
      "hex": "#ffb0be",
      "rgb": [
        255,
        176,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1729",
      "brandId": "finca",
      "reference": "1729",
      "name": "Carnation very light",
      "hex": "#ffb2bb",
      "rgb": [
        255,
        178,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1232",
      "brandId": "finca",
      "reference": "1232",
      "name": "Tangerine light",
      "hex": "#ffbf57",
      "rgb": [
        255,
        191,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:2307",
      "brandId": "finca",
      "reference": "2307",
      "name": "Cranberry very light",
      "hex": "#ffc0cd",
      "rgb": [
        255,
        192,
        205
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1062",
      "brandId": "finca",
      "reference": "1062",
      "name": "Topaz",
      "hex": "#ffc840",
      "rgb": [
        255,
        200,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1227",
      "brandId": "finca",
      "reference": "1227",
      "name": "Lemon dark",
      "hex": "#ffd600",
      "rgb": [
        255,
        214,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1724",
      "brandId": "finca",
      "reference": "1724",
      "name": "Dusty Rose ultra very light",
      "hex": "#ffd7d7",
      "rgb": [
        255,
        215,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1969",
      "brandId": "finca",
      "reference": "1969",
      "name": "Shell Pink ultra very light",
      "hex": "#ffdfd7",
      "rgb": [
        255,
        223,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1637",
      "brandId": "finca",
      "reference": "1637",
      "name": "Baby Pink",
      "hex": "#ffdfd9",
      "rgb": [
        255,
        223,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1137",
      "brandId": "finca",
      "reference": "1137",
      "name": "Yellow pale",
      "hex": "#ffe793",
      "rgb": [
        255,
        231,
        147
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1134",
      "brandId": "finca",
      "reference": "1134",
      "name": "Yellow light pale",
      "hex": "#ffe9ad",
      "rgb": [
        255,
        233,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:7933",
      "brandId": "finca",
      "reference": "7933",
      "name": "Tawny very light",
      "hex": "#ffeee3",
      "rgb": [
        255,
        238,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1464",
      "brandId": "finca",
      "reference": "1464",
      "name": "Baby Pink light",
      "hex": "#ffeeeb",
      "rgb": [
        255,
        238,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1220",
      "brandId": "finca",
      "reference": "1220",
      "name": "Topaz very light",
      "hex": "#fff1af",
      "rgb": [
        255,
        241,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1217",
      "brandId": "finca",
      "reference": "1217",
      "name": "Lemon light",
      "hex": "#fffb8b",
      "rgb": [
        255,
        251,
        139
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:3000",
      "brandId": "finca",
      "reference": "3000",
      "name": "Cream",
      "hex": "#fffbef",
      "rgb": [
        255,
        251,
        239
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "finca:1211",
      "brandId": "finca",
      "reference": "1211",
      "name": "Yellow ultra pale",
      "hex": "#fffde3",
      "rgb": [
        255,
        253,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2004",
      "brandId": "madeira",
      "reference": "2004",
      "name": "Black Brown",
      "hex": "#000000",
      "rgb": [
        0,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2400",
      "brandId": "madeira",
      "reference": "2400",
      "name": "Black",
      "hex": "#000000",
      "rgb": [
        0,
        0,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:914",
      "brandId": "madeira",
      "reference": "914",
      "name": "Royal Blue VY DK",
      "hex": "#00014a",
      "rgb": [
        0,
        1,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:913",
      "brandId": "madeira",
      "reference": "913",
      "name": "Royal Blue DK",
      "hex": "#000153",
      "rgb": [
        0,
        1,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1009",
      "brandId": "madeira",
      "reference": "1009",
      "name": "Navy Blue VY DK",
      "hex": "#001520",
      "rgb": [
        0,
        21,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1007",
      "brandId": "madeira",
      "reference": "1007",
      "name": "Navy Blue Med DK",
      "hex": "#001e30",
      "rgb": [
        0,
        30,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1102",
      "brandId": "madeira",
      "reference": "1102",
      "name": "Electric Blue DK",
      "hex": "#0062be",
      "rgb": [
        0,
        98,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1008",
      "brandId": "madeira",
      "reference": "1008",
      "name": "Navy Blue DK",
      "hex": "#011a29",
      "rgb": [
        1,
        26,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2705",
      "brandId": "madeira",
      "reference": "2705",
      "name": "Misty Turquoise Med",
      "hex": "#01644b",
      "rgb": [
        1,
        100,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1304",
      "brandId": "madeira",
      "reference": "1304",
      "name": "Christmas Green Brig",
      "hex": "#043f26",
      "rgb": [
        4,
        63,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1303",
      "brandId": "madeira",
      "reference": "1303",
      "name": "Christmas Green DK",
      "hex": "#054c2d",
      "rgb": [
        5,
        76,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1302",
      "brandId": "madeira",
      "reference": "1302",
      "name": "Emerald Green DK",
      "hex": "#065b37",
      "rgb": [
        6,
        91,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1301",
      "brandId": "madeira",
      "reference": "1301",
      "name": "Emerald Green",
      "hex": "#06663d",
      "rgb": [
        6,
        102,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1314",
      "brandId": "madeira",
      "reference": "1314",
      "name": "Pistachio Green Ultr",
      "hex": "#072500",
      "rgb": [
        7,
        37,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2704",
      "brandId": "madeira",
      "reference": "2704",
      "name": "Christmas Green DK",
      "hex": "#0a6d31",
      "rgb": [
        10,
        109,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1006",
      "brandId": "madeira",
      "reference": "1006",
      "name": "Antique Blue VY DK",
      "hex": "#0b2838",
      "rgb": [
        11,
        40,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1010",
      "brandId": "madeira",
      "reference": "1010",
      "name": "Blue VY DK",
      "hex": "#0b3740",
      "rgb": [
        11,
        55,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1305",
      "brandId": "madeira",
      "reference": "1305",
      "name": "Christmas Green Med",
      "hex": "#0b6f45",
      "rgb": [
        11,
        111,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2706",
      "brandId": "madeira",
      "reference": "2706",
      "name": "Misty Turquoise DK",
      "hex": "#0e9472",
      "rgb": [
        14,
        148,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:904",
      "brandId": "madeira",
      "reference": "904",
      "name": "Cornflower Blue VY D",
      "hex": "#112040",
      "rgb": [
        17,
        32,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1514",
      "brandId": "madeira",
      "reference": "1514",
      "name": "Grey Green DK",
      "hex": "#123600",
      "rgb": [
        18,
        54,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1713",
      "brandId": "madeira",
      "reference": "1713",
      "name": "Blue Black",
      "hex": "#131819",
      "rgb": [
        19,
        24,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2701",
      "brandId": "madeira",
      "reference": "2701",
      "name": "Blue Violet DK",
      "hex": "#141635",
      "rgb": [
        20,
        22,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1705",
      "brandId": "madeira",
      "reference": "1705",
      "name": "Sea Foam Green Ultra",
      "hex": "#14301f",
      "rgb": [
        20,
        48,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1506",
      "brandId": "madeira",
      "reference": "1506",
      "name": "Fern Green VY DK",
      "hex": "#151b08",
      "rgb": [
        21,
        27,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1706",
      "brandId": "madeira",
      "reference": "1706",
      "name": "Blue Grey DK",
      "hex": "#163b37",
      "rgb": [
        22,
        59,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1204",
      "brandId": "madeira",
      "reference": "1204",
      "name": "Turquoise Ultra VY D",
      "hex": "#164530",
      "rgb": [
        22,
        69,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1505",
      "brandId": "madeira",
      "reference": "1505",
      "name": "Fern Green Ultra VY",
      "hex": "#171f06",
      "rgb": [
        23,
        31,
        6
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1306",
      "brandId": "madeira",
      "reference": "1306",
      "name": "Chartreuse",
      "hex": "#18a449",
      "rgb": [
        24,
        164,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1011",
      "brandId": "madeira",
      "reference": "1011",
      "name": "Blue DK",
      "hex": "#1b4c57",
      "rgb": [
        27,
        76,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1205",
      "brandId": "madeira",
      "reference": "1205",
      "name": "Blue Green",
      "hex": "#1c3726",
      "rgb": [
        28,
        55,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1108",
      "brandId": "madeira",
      "reference": "1108",
      "name": "Misty Blue DK",
      "hex": "#1c635f",
      "rgb": [
        28,
        99,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1109",
      "brandId": "madeira",
      "reference": "1109",
      "name": "Misty Blue Med",
      "hex": "#1c7a77",
      "rgb": [
        28,
        122,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1313",
      "brandId": "madeira",
      "reference": "1313",
      "name": "Pistachio Green VY D",
      "hex": "#1d3112",
      "rgb": [
        29,
        49,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1107",
      "brandId": "madeira",
      "reference": "1107",
      "name": "Wedgewood DK",
      "hex": "#1d4149",
      "rgb": [
        29,
        65,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1307",
      "brandId": "madeira",
      "reference": "1307",
      "name": "Chartreuse LT",
      "hex": "#1dc458",
      "rgb": [
        29,
        196,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1203",
      "brandId": "madeira",
      "reference": "1203",
      "name": "Turquoise VY DK",
      "hex": "#1e6045",
      "rgb": [
        30,
        96,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1110",
      "brandId": "madeira",
      "reference": "1110",
      "name": "Misty Blue Med LT",
      "hex": "#1f8a86",
      "rgb": [
        31,
        138,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2003",
      "brandId": "madeira",
      "reference": "2003",
      "name": "Brown DK",
      "hex": "#201b16",
      "rgb": [
        32,
        27,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1405",
      "brandId": "madeira",
      "reference": "1405",
      "name": "Hunter Green DK",
      "hex": "#233117",
      "rgb": [
        35,
        49,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:905",
      "brandId": "madeira",
      "reference": "905",
      "name": "Cornflower Blue DK",
      "hex": "#23355b",
      "rgb": [
        35,
        53,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1904",
      "brandId": "madeira",
      "reference": "1904",
      "name": "Beige Grey Ultra VY",
      "hex": "#251e16",
      "rgb": [
        37,
        30,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1810",
      "brandId": "madeira",
      "reference": "1810",
      "name": "Shell Grey Ultra VY",
      "hex": "#282220",
      "rgb": [
        40,
        34,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1507",
      "brandId": "madeira",
      "reference": "1507",
      "name": "Fern Green DK",
      "hex": "#29290b",
      "rgb": [
        41,
        41,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1811",
      "brandId": "madeira",
      "reference": "1811",
      "name": "Beaver Grey DK",
      "hex": "#292f27",
      "rgb": [
        41,
        47,
        39
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1114",
      "brandId": "madeira",
      "reference": "1114",
      "name": "Turquoise Med DK",
      "hex": "#29856c",
      "rgb": [
        41,
        133,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1005",
      "brandId": "madeira",
      "reference": "1005",
      "name": "Antique Blue DK",
      "hex": "#2c4552",
      "rgb": [
        44,
        69,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2505",
      "brandId": "madeira",
      "reference": "2505",
      "name": "Wedgewood VY DK",
      "hex": "#2c6779",
      "rgb": [
        44,
        103,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1206",
      "brandId": "madeira",
      "reference": "1206",
      "name": "Jade DK",
      "hex": "#2d6444",
      "rgb": [
        45,
        100,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1508",
      "brandId": "madeira",
      "reference": "1508",
      "name": "Fern Green Med",
      "hex": "#2e2e17",
      "rgb": [
        46,
        46,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2006",
      "brandId": "madeira",
      "reference": "2006",
      "name": "Tan Ultra VY DK",
      "hex": "#2f1c05",
      "rgb": [
        47,
        28,
        5
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1712",
      "brandId": "madeira",
      "reference": "1712",
      "name": "Dusty Blue DK",
      "hex": "#2f3c3f",
      "rgb": [
        47,
        60,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:912",
      "brandId": "madeira",
      "reference": "912",
      "name": "Royal Blue Med",
      "hex": "#2f4c6b",
      "rgb": [
        47,
        76,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1601",
      "brandId": "madeira",
      "reference": "1601",
      "name": "Laurel Green DK",
      "hex": "#303a28",
      "rgb": [
        48,
        58,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1214",
      "brandId": "madeira",
      "reference": "1214",
      "name": "Leaf Green VY DK",
      "hex": "#308652",
      "rgb": [
        48,
        134,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1404",
      "brandId": "madeira",
      "reference": "1404",
      "name": "Hunter Green VY DK",
      "hex": "#31461f",
      "rgb": [
        49,
        70,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1413",
      "brandId": "madeira",
      "reference": "1413",
      "name": "Forest Green VY DK",
      "hex": "#314a00",
      "rgb": [
        49,
        74,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2005",
      "brandId": "madeira",
      "reference": "2005",
      "name": "Chocolate",
      "hex": "#331d04",
      "rgb": [
        51,
        29,
        4
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1406",
      "brandId": "madeira",
      "reference": "1406",
      "name": "Hunter Green Med",
      "hex": "#33421b",
      "rgb": [
        51,
        66,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:903",
      "brandId": "madeira",
      "reference": "903",
      "name": "Blue Violet Med",
      "hex": "#340e53",
      "rgb": [
        52,
        14,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2507",
      "brandId": "madeira",
      "reference": "2507",
      "name": "Misty Green DK",
      "hex": "#347a72",
      "rgb": [
        52,
        122,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1905",
      "brandId": "madeira",
      "reference": "1905",
      "name": "Beige Grey VY DK",
      "hex": "#362d25",
      "rgb": [
        54,
        45,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1812",
      "brandId": "madeira",
      "reference": "1812",
      "name": "Beaver Grey Med",
      "hex": "#363e36",
      "rgb": [
        54,
        62,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:906",
      "brandId": "madeira",
      "reference": "906",
      "name": "Cornflower Blue Med",
      "hex": "#36476c",
      "rgb": [
        54,
        71,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1704",
      "brandId": "madeira",
      "reference": "1704",
      "name": "Sea Foam Green DK",
      "hex": "#365341",
      "rgb": [
        54,
        83,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1809",
      "brandId": "madeira",
      "reference": "1809",
      "name": "Shell Grey VY DK",
      "hex": "#38302e",
      "rgb": [
        56,
        48,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1012",
      "brandId": "madeira",
      "reference": "1012",
      "name": "Blue Med",
      "hex": "#3a7380",
      "rgb": [
        58,
        115,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1202",
      "brandId": "madeira",
      "reference": "1202",
      "name": "Turquoise DK",
      "hex": "#3a8062",
      "rgb": [
        58,
        128,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1602",
      "brandId": "madeira",
      "reference": "1602",
      "name": "Laurel Green Med",
      "hex": "#3c4b2e",
      "rgb": [
        60,
        75,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1004",
      "brandId": "madeira",
      "reference": "1004",
      "name": "Antique Blue Med",
      "hex": "#3c5c6e",
      "rgb": [
        60,
        92,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1914",
      "brandId": "madeira",
      "reference": "1914",
      "name": "Beige Brown Ultra VY",
      "hex": "#3d2518",
      "rgb": [
        61,
        37,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1312",
      "brandId": "madeira",
      "reference": "1312",
      "name": "Pistachio Green DK",
      "hex": "#3e5531",
      "rgb": [
        62,
        85,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1714",
      "brandId": "madeira",
      "reference": "1714",
      "name": "Steel Grey DK",
      "hex": "#3f3f41",
      "rgb": [
        63,
        63,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1504",
      "brandId": "madeira",
      "reference": "1504",
      "name": "Avocado Green Med",
      "hex": "#3f4a09",
      "rgb": [
        63,
        74,
        9
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1213",
      "brandId": "madeira",
      "reference": "1213",
      "name": "Leaf Green DK",
      "hex": "#3fa468",
      "rgb": [
        63,
        164,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:714",
      "brandId": "madeira",
      "reference": "714",
      "name": "Violet VY DK",
      "hex": "#421335",
      "rgb": [
        66,
        19,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1614",
      "brandId": "madeira",
      "reference": "1614",
      "name": "Sage Green DK",
      "hex": "#423d11",
      "rgb": [
        66,
        61,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1412",
      "brandId": "madeira",
      "reference": "1412",
      "name": "Forest Green DK",
      "hex": "#425102",
      "rgb": [
        66,
        81,
        2
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:911",
      "brandId": "madeira",
      "reference": "911",
      "name": "Delft DK",
      "hex": "#42648a",
      "rgb": [
        66,
        100,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1707",
      "brandId": "madeira",
      "reference": "1707",
      "name": "Blue Grey Med",
      "hex": "#465653",
      "rgb": [
        70,
        86,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1608",
      "brandId": "madeira",
      "reference": "1608",
      "name": "Green DK",
      "hex": "#474500",
      "rgb": [
        71,
        69,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1003",
      "brandId": "madeira",
      "reference": "1003",
      "name": "Antique Blue",
      "hex": "#486f84",
      "rgb": [
        72,
        111,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1703",
      "brandId": "madeira",
      "reference": "1703",
      "name": "Sea Foam Green Med",
      "hex": "#496d57",
      "rgb": [
        73,
        109,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2007",
      "brandId": "madeira",
      "reference": "2007",
      "name": "Tan VY DK",
      "hex": "#4a2c09",
      "rgb": [
        74,
        44,
        9
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1613",
      "brandId": "madeira",
      "reference": "1613",
      "name": "Sage Green Med",
      "hex": "#4b460d",
      "rgb": [
        75,
        70,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2506",
      "brandId": "madeira",
      "reference": "2506",
      "name": "Misty Green Bright",
      "hex": "#4b8895",
      "rgb": [
        75,
        136,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1207",
      "brandId": "madeira",
      "reference": "1207",
      "name": "Jade Med",
      "hex": "#4c9a6b",
      "rgb": [
        76,
        154,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1503",
      "brandId": "madeira",
      "reference": "1503",
      "name": "Avocado Green Med LT",
      "hex": "#4d5815",
      "rgb": [
        77,
        88,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1513",
      "brandId": "madeira",
      "reference": "1513",
      "name": "Grey Green Med",
      "hex": "#4d5848",
      "rgb": [
        77,
        88,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1913",
      "brandId": "madeira",
      "reference": "1913",
      "name": "Beige Brown VY DK",
      "hex": "#4e3426",
      "rgb": [
        78,
        52,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1106",
      "brandId": "madeira",
      "reference": "1106",
      "name": "Wedgewood Med",
      "hex": "#4e757d",
      "rgb": [
        78,
        117,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1103",
      "brandId": "madeira",
      "reference": "1103",
      "name": "Electric Blue Med",
      "hex": "#4ea7f2",
      "rgb": [
        78,
        167,
        242
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1403",
      "brandId": "madeira",
      "reference": "1403",
      "name": "Green",
      "hex": "#507034",
      "rgb": [
        80,
        112,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:806",
      "brandId": "madeira",
      "reference": "806",
      "name": "Antique Violet DK",
      "hex": "#513842",
      "rgb": [
        81,
        56,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1407",
      "brandId": "madeira",
      "reference": "1407",
      "name": "Hunter Green",
      "hex": "#516a2d",
      "rgb": [
        81,
        106,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1013",
      "brandId": "madeira",
      "reference": "1013",
      "name": "Blue",
      "hex": "#5194a3",
      "rgb": [
        81,
        148,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:805",
      "brandId": "madeira",
      "reference": "805",
      "name": "Purple",
      "hex": "#52034a",
      "rgb": [
        82,
        3,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1813",
      "brandId": "madeira",
      "reference": "1813",
      "name": "Beaver Grey LT",
      "hex": "#525a51",
      "rgb": [
        82,
        90,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2106",
      "brandId": "madeira",
      "reference": "2106",
      "name": "Drab Brown VY DK",
      "hex": "#55381c",
      "rgb": [
        85,
        56,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1801",
      "brandId": "madeira",
      "reference": "1801",
      "name": "Steel Grey Med",
      "hex": "#555252",
      "rgb": [
        85,
        82,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1711",
      "brandId": "madeira",
      "reference": "1711",
      "name": "Dusty Blue Med",
      "hex": "#55666a",
      "rgb": [
        85,
        102,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2113",
      "brandId": "madeira",
      "reference": "2113",
      "name": "Hazelnut Brown VY DK",
      "hex": "#57370b",
      "rgb": [
        87,
        55,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:705",
      "brandId": "madeira",
      "reference": "705",
      "name": "Mauve VY DK",
      "hex": "#58052a",
      "rgb": [
        88,
        5,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:601",
      "brandId": "madeira",
      "reference": "601",
      "name": "Plum VY DK",
      "hex": "#58082c",
      "rgb": [
        88,
        8,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1612",
      "brandId": "madeira",
      "reference": "1612",
      "name": "Sage Green",
      "hex": "#595317",
      "rgb": [
        89,
        83,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1411",
      "brandId": "madeira",
      "reference": "1411",
      "name": "Forest Green Med",
      "hex": "#596c03",
      "rgb": [
        89,
        108,
        3
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1212",
      "brandId": "madeira",
      "reference": "1212",
      "name": "Leaf Green Med",
      "hex": "#59b67e",
      "rgb": [
        89,
        182,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1903",
      "brandId": "madeira",
      "reference": "1903",
      "name": "Beige Grey DK",
      "hex": "#5a4f44",
      "rgb": [
        90,
        79,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1201",
      "brandId": "madeira",
      "reference": "1201",
      "name": "Turquoise Med",
      "hex": "#5a997e",
      "rgb": [
        90,
        153,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:810",
      "brandId": "madeira",
      "reference": "810",
      "name": "Antique Mauve DK",
      "hex": "#5b3039",
      "rgb": [
        91,
        48,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:902",
      "brandId": "madeira",
      "reference": "902",
      "name": "Blue Violet LT",
      "hex": "#5c588e",
      "rgb": [
        92,
        88,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2114",
      "brandId": "madeira",
      "reference": "2114",
      "name": "Avocado VY DK",
      "hex": "#5d3c0f",
      "rgb": [
        93,
        60,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1509",
      "brandId": "madeira",
      "reference": "1509",
      "name": "Fern Green LT",
      "hex": "#5e6040",
      "rgb": [
        94,
        96,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2112",
      "brandId": "madeira",
      "reference": "2112",
      "name": "Avocado DK",
      "hex": "#5f4b29",
      "rgb": [
        95,
        75,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1607",
      "brandId": "madeira",
      "reference": "1607",
      "name": "Khaki Green DK",
      "hex": "#5f5833",
      "rgb": [
        95,
        88,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1502",
      "brandId": "madeira",
      "reference": "1502",
      "name": "Avocado Green LT",
      "hex": "#5f6b1d",
      "rgb": [
        95,
        107,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1311",
      "brandId": "madeira",
      "reference": "1311",
      "name": "Pistachio Green Med",
      "hex": "#5f7f4d",
      "rgb": [
        95,
        127,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:514",
      "brandId": "madeira",
      "reference": "514",
      "name": "Garnet VY DK",
      "hex": "#60151c",
      "rgb": [
        96,
        21,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:811",
      "brandId": "madeira",
      "reference": "811",
      "name": "Shell Pink Med DK",
      "hex": "#610013",
      "rgb": [
        97,
        0,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2304",
      "brandId": "madeira",
      "reference": "2304",
      "name": "Mahogany DK",
      "hex": "#613514",
      "rgb": [
        97,
        53,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2603",
      "brandId": "madeira",
      "reference": "2603",
      "name": "Nile Green LT",
      "hex": "#61683a",
      "rgb": [
        97,
        104,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:910",
      "brandId": "madeira",
      "reference": "910",
      "name": "Delft Med",
      "hex": "#6186af",
      "rgb": [
        97,
        134,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1111",
      "brandId": "madeira",
      "reference": "1111",
      "name": "Misty Blue LT",
      "hex": "#61a7a5",
      "rgb": [
        97,
        167,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2709",
      "brandId": "madeira",
      "reference": "2709",
      "name": "Antique Lavender LT",
      "hex": "#63336d",
      "rgb": [
        99,
        51,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2008",
      "brandId": "madeira",
      "reference": "2008",
      "name": "Tan DK",
      "hex": "#633d0e",
      "rgb": [
        99,
        61,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1603",
      "brandId": "madeira",
      "reference": "1603",
      "name": "Laurel Green LT",
      "hex": "#677f4f",
      "rgb": [
        103,
        127,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2607",
      "brandId": "madeira",
      "reference": "2607",
      "name": "Antique Plum VY DK",
      "hex": "#68181c",
      "rgb": [
        104,
        24,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1105",
      "brandId": "madeira",
      "reference": "1105",
      "name": "Wedgewood LT",
      "hex": "#689faa",
      "rgb": [
        104,
        159,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2105",
      "brandId": "madeira",
      "reference": "2105",
      "name": "Hazelnut Brown DK",
      "hex": "#6a4b2c",
      "rgb": [
        106,
        75,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1113",
      "brandId": "madeira",
      "reference": "1113",
      "name": "Turquoise LT",
      "hex": "#6ad4b6",
      "rgb": [
        106,
        212,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:513",
      "brandId": "madeira",
      "reference": "513",
      "name": "Garnet DK",
      "hex": "#6b171f",
      "rgb": [
        107,
        23,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2311",
      "brandId": "madeira",
      "reference": "2311",
      "name": "Peach Flesh VY DK",
      "hex": "#6b3523",
      "rgb": [
        107,
        53,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2107",
      "brandId": "madeira",
      "reference": "2107",
      "name": "Drab Brown DK",
      "hex": "#6c4f34",
      "rgb": [
        108,
        79,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1211",
      "brandId": "madeira",
      "reference": "1211",
      "name": "Leaf Green LT",
      "hex": "#6cc690",
      "rgb": [
        108,
        198,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1808",
      "brandId": "madeira",
      "reference": "1808",
      "name": "Shell Grey DK",
      "hex": "#6d605d",
      "rgb": [
        109,
        96,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2305",
      "brandId": "madeira",
      "reference": "2305",
      "name": "Mahogany Med",
      "hex": "#6e350f",
      "rgb": [
        110,
        53,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2201",
      "brandId": "madeira",
      "reference": "2201",
      "name": "Old Gold DK",
      "hex": "#6e5522",
      "rgb": [
        110,
        85,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1402",
      "brandId": "madeira",
      "reference": "1402",
      "name": "Green LT",
      "hex": "#6e914f",
      "rgb": [
        110,
        145,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2508",
      "brandId": "madeira",
      "reference": "2508",
      "name": "Misty Green Med",
      "hex": "#6ea89e",
      "rgb": [
        110,
        168,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1609",
      "brandId": "madeira",
      "reference": "1609",
      "name": "Green Med",
      "hex": "#6f6c0e",
      "rgb": [
        111,
        108,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:602",
      "brandId": "madeira",
      "reference": "602",
      "name": "Plum DK",
      "hex": "#700f3b",
      "rgb": [
        112,
        15,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:314",
      "brandId": "madeira",
      "reference": "314",
      "name": "Copper VY DK",
      "hex": "#702a0f",
      "rgb": [
        112,
        42,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2303",
      "brandId": "madeira",
      "reference": "2303",
      "name": "Golden Brown Med",
      "hex": "#703d18",
      "rgb": [
        112,
        61,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1912",
      "brandId": "madeira",
      "reference": "1912",
      "name": "Beige Brown DK",
      "hex": "#705242",
      "rgb": [
        112,
        82,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1802",
      "brandId": "madeira",
      "reference": "1802",
      "name": "Steel Grey LT",
      "hex": "#706d6c",
      "rgb": [
        112,
        109,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2614",
      "brandId": "madeira",
      "reference": "2614",
      "name": "Dusty Violet VY DK",
      "hex": "#713653",
      "rgb": [
        113,
        54,
        83
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:807",
      "brandId": "madeira",
      "reference": "807",
      "name": "Antique Violet LT",
      "hex": "#715761",
      "rgb": [
        113,
        87,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2111",
      "brandId": "madeira",
      "reference": "2111",
      "name": "Avocado Med",
      "hex": "#715c38",
      "rgb": [
        113,
        92,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1510",
      "brandId": "madeira",
      "reference": "1510",
      "name": "Fern Green VY LT",
      "hex": "#737551",
      "rgb": [
        115,
        117,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1408",
      "brandId": "madeira",
      "reference": "1408",
      "name": "Hunter Green LT",
      "hex": "#739345",
      "rgb": [
        115,
        147,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:713",
      "brandId": "madeira",
      "reference": "713",
      "name": "Violet DK",
      "hex": "#743462",
      "rgb": [
        116,
        52,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1310",
      "brandId": "madeira",
      "reference": "1310",
      "name": "Pistachio Green LT",
      "hex": "#749461",
      "rgb": [
        116,
        148,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:401",
      "brandId": "madeira",
      "reference": "401",
      "name": "Terracotta",
      "hex": "#752e2c",
      "rgb": [
        117,
        46,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2002",
      "brandId": "madeira",
      "reference": "2002",
      "name": "Mocha Brown Med",
      "hex": "#756450",
      "rgb": [
        117,
        100,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1702",
      "brandId": "madeira",
      "reference": "1702",
      "name": "Sea Foam Green",
      "hex": "#779783",
      "rgb": [
        119,
        151,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:512",
      "brandId": "madeira",
      "reference": "512",
      "name": "Garnet Med",
      "hex": "#78141e",
      "rgb": [
        120,
        20,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1512",
      "brandId": "madeira",
      "reference": "1512",
      "name": "Grey Green LT",
      "hex": "#788570",
      "rgb": [
        120,
        133,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2009",
      "brandId": "madeira",
      "reference": "2009",
      "name": "Tan Med DK",
      "hex": "#7a4b12",
      "rgb": [
        122,
        75,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:706",
      "brandId": "madeira",
      "reference": "706",
      "name": "Mauve DK",
      "hex": "#7b2358",
      "rgb": [
        123,
        35,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2710",
      "brandId": "madeira",
      "reference": "2710",
      "name": "Antique Lavender Med",
      "hex": "#7c4586",
      "rgb": [
        124,
        69,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1902",
      "brandId": "madeira",
      "reference": "1902",
      "name": "Beige Grey Med",
      "hex": "#7e746b",
      "rgb": [
        126,
        116,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1002",
      "brandId": "madeira",
      "reference": "1002",
      "name": "Antique Blue LT",
      "hex": "#7ea5bb",
      "rgb": [
        126,
        165,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2104",
      "brandId": "madeira",
      "reference": "2104",
      "name": "Hazelnut Brown Med",
      "hex": "#7f5b37",
      "rgb": [
        127,
        91,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2214",
      "brandId": "madeira",
      "reference": "2214",
      "name": "Topaz Ultra VY DK",
      "hex": "#805104",
      "rgb": [
        128,
        81,
        4
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1708",
      "brandId": "madeira",
      "reference": "1708",
      "name": "Blue Grey LT",
      "hex": "#808b8a",
      "rgb": [
        128,
        139,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2110",
      "brandId": "madeira",
      "reference": "2110",
      "name": "Avocado LT",
      "hex": "#816942",
      "rgb": [
        129,
        105,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:511",
      "brandId": "madeira",
      "reference": "511",
      "name": "Garnet",
      "hex": "#820023",
      "rgb": [
        130,
        0,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:804",
      "brandId": "madeira",
      "reference": "804",
      "name": "Lavender VY DK",
      "hex": "#825392",
      "rgb": [
        130,
        83,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1906",
      "brandId": "madeira",
      "reference": "1906",
      "name": "Beige Grey",
      "hex": "#826e5d",
      "rgb": [
        130,
        110,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:509",
      "brandId": "madeira",
      "reference": "509",
      "name": "Red DK",
      "hex": "#830c34",
      "rgb": [
        131,
        12,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:907",
      "brandId": "madeira",
      "reference": "907",
      "name": "Cornflower Blue LT",
      "hex": "#8499c2",
      "rgb": [
        132,
        153,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1410",
      "brandId": "madeira",
      "reference": "1410",
      "name": "Forest Green LT",
      "hex": "#849e11",
      "rgb": [
        132,
        158,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:313",
      "brandId": "madeira",
      "reference": "313",
      "name": "Copper DK",
      "hex": "#853113",
      "rgb": [
        133,
        49,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1710",
      "brandId": "madeira",
      "reference": "1710",
      "name": "Dusty Blue LT",
      "hex": "#859a9f",
      "rgb": [
        133,
        154,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:603",
      "brandId": "madeira",
      "reference": "603",
      "name": "Plum Med",
      "hex": "#881448",
      "rgb": [
        136,
        20,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2702",
      "brandId": "madeira",
      "reference": "2702",
      "name": "Blue Violet VY DK",
      "hex": "#888bb8",
      "rgb": [
        136,
        139,
        184
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1401",
      "brandId": "madeira",
      "reference": "1401",
      "name": "Green VY LT",
      "hex": "#88ab68",
      "rgb": [
        136,
        171,
        104
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2608",
      "brandId": "madeira",
      "reference": "2608",
      "name": "Antique Plum DK",
      "hex": "#89263e",
      "rgb": [
        137,
        38,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2202",
      "brandId": "madeira",
      "reference": "2202",
      "name": "Old Gold Med",
      "hex": "#896723",
      "rgb": [
        137,
        103,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1308",
      "brandId": "madeira",
      "reference": "1308",
      "name": "Yellow Green",
      "hex": "#89b92e",
      "rgb": [
        137,
        185,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1209",
      "brandId": "madeira",
      "reference": "1209",
      "name": "Yellow Green Ultra V",
      "hex": "#89dfa4",
      "rgb": [
        137,
        223,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:809",
      "brandId": "madeira",
      "reference": "809",
      "name": "Antique Mauve Med",
      "hex": "#8a5d66",
      "rgb": [
        138,
        93,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1606",
      "brandId": "madeira",
      "reference": "1606",
      "name": "Khaki Green Med",
      "hex": "#8a7c30",
      "rgb": [
        138,
        124,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2108",
      "brandId": "madeira",
      "reference": "2108",
      "name": "Drab Brown Med",
      "hex": "#8c6f52",
      "rgb": [
        140,
        111,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1807",
      "brandId": "madeira",
      "reference": "1807",
      "name": "Shell Grey Med",
      "hex": "#8c7b79",
      "rgb": [
        140,
        123,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1611",
      "brandId": "madeira",
      "reference": "1611",
      "name": "Sage Green LT",
      "hex": "#8c8923",
      "rgb": [
        140,
        137,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1911",
      "brandId": "madeira",
      "reference": "1911",
      "name": "Beige Brown Med",
      "hex": "#8d6957",
      "rgb": [
        141,
        105,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:704",
      "brandId": "madeira",
      "reference": "704",
      "name": "Cerise VY DK",
      "hex": "#8e014a",
      "rgb": [
        142,
        1,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:909",
      "brandId": "madeira",
      "reference": "909",
      "name": "Delft",
      "hex": "#8eb2db",
      "rgb": [
        142,
        178,
        219
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2606",
      "brandId": "madeira",
      "reference": "2606",
      "name": "Peach Ultra VY DK",
      "hex": "#8f222a",
      "rgb": [
        143,
        34,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1112",
      "brandId": "madeira",
      "reference": "1112",
      "name": "Turquoise VY LT",
      "hex": "#8fe9d0",
      "rgb": [
        143,
        233,
        208
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2213",
      "brandId": "madeira",
      "reference": "2213",
      "name": "Topaz VY DK",
      "hex": "#905c05",
      "rgb": [
        144,
        92,
        5
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:508",
      "brandId": "madeira",
      "reference": "508",
      "name": "Red Med DK",
      "hex": "#911733",
      "rgb": [
        145,
        23,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:510",
      "brandId": "madeira",
      "reference": "510",
      "name": "Christmas Red",
      "hex": "#92002e",
      "rgb": [
        146,
        0,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1501",
      "brandId": "madeira",
      "reference": "1501",
      "name": "Avocado Green VY LT",
      "hex": "#929f4b",
      "rgb": [
        146,
        159,
        75
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2010",
      "brandId": "madeira",
      "reference": "2010",
      "name": "Tan Med",
      "hex": "#935d23",
      "rgb": [
        147,
        93,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:712",
      "brandId": "madeira",
      "reference": "712",
      "name": "Violet Med",
      "hex": "#95447e",
      "rgb": [
        149,
        68,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:407",
      "brandId": "madeira",
      "reference": "407",
      "name": "Salmon VY DK",
      "hex": "#971929",
      "rgb": [
        151,
        25,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:312",
      "brandId": "madeira",
      "reference": "312",
      "name": "Copper Med DK",
      "hex": "#973915",
      "rgb": [
        151,
        57,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:211",
      "brandId": "madeira",
      "reference": "211",
      "name": "Christmas Red Bright",
      "hex": "#991629",
      "rgb": [
        153,
        22,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2501",
      "brandId": "madeira",
      "reference": "2501",
      "name": "Bright Terracotta DK",
      "hex": "#992a20",
      "rgb": [
        153,
        42,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1814",
      "brandId": "madeira",
      "reference": "1814",
      "name": "Beaver Grey VY LT",
      "hex": "#99a197",
      "rgb": [
        153,
        161,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2103",
      "brandId": "madeira",
      "reference": "2103",
      "name": "Hazelnut Brown LT",
      "hex": "#9a714a",
      "rgb": [
        154,
        113,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1014",
      "brandId": "madeira",
      "reference": "1014",
      "name": "Blue LT",
      "hex": "#9bc3cc",
      "rgb": [
        155,
        195,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:402",
      "brandId": "madeira",
      "reference": "402",
      "name": "Terracotta Med LT",
      "hex": "#9c4e40",
      "rgb": [
        156,
        78,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:908",
      "brandId": "madeira",
      "reference": "908",
      "name": "Blue Ultra VY LT",
      "hex": "#9cc1c3",
      "rgb": [
        156,
        193,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2714",
      "brandId": "madeira",
      "reference": "2714",
      "name": "Pink Purple DK",
      "hex": "#9d3c71",
      "rgb": [
        157,
        60,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:812",
      "brandId": "madeira",
      "reference": "812",
      "name": "Shell Pink Med",
      "hex": "#9d5864",
      "rgb": [
        157,
        88,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1210",
      "brandId": "madeira",
      "reference": "1210",
      "name": "Leaf Green VY LT",
      "hex": "#9df6c1",
      "rgb": [
        157,
        246,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1709",
      "brandId": "madeira",
      "reference": "1709",
      "name": "Blue Grey VY LT",
      "hex": "#a0a19f",
      "rgb": [
        160,
        161,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:604",
      "brandId": "madeira",
      "reference": "604",
      "name": "Plum",
      "hex": "#a21c58",
      "rgb": [
        162,
        28,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2310",
      "brandId": "madeira",
      "reference": "2310",
      "name": "Flesh DK",
      "hex": "#a2624d",
      "rgb": [
        162,
        98,
        77
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2613",
      "brandId": "madeira",
      "reference": "2613",
      "name": "Dusty Violet DK",
      "hex": "#a2728a",
      "rgb": [
        162,
        114,
        138
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1409",
      "brandId": "madeira",
      "reference": "1409",
      "name": "Forest Green VY LT",
      "hex": "#a2c078",
      "rgb": [
        162,
        192,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:703",
      "brandId": "madeira",
      "reference": "703",
      "name": "Cerise DK",
      "hex": "#a30156",
      "rgb": [
        163,
        1,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:507",
      "brandId": "madeira",
      "reference": "507",
      "name": "Red",
      "hex": "#a32541",
      "rgb": [
        163,
        37,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2602",
      "brandId": "madeira",
      "reference": "2602",
      "name": "Coffee Brown LT",
      "hex": "#a35137",
      "rgb": [
        163,
        81,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1511",
      "brandId": "madeira",
      "reference": "1511",
      "name": "Grey Green VY LT",
      "hex": "#a3b49b",
      "rgb": [
        163,
        180,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1208",
      "brandId": "madeira",
      "reference": "1208",
      "name": "Jade LT",
      "hex": "#a3ffc7",
      "rgb": [
        163,
        255,
        199
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2210",
      "brandId": "madeira",
      "reference": "2210",
      "name": "Gold DK",
      "hex": "#a47302",
      "rgb": [
        164,
        115,
        2
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1803",
      "brandId": "madeira",
      "reference": "1803",
      "name": "Steel Grey VY LT",
      "hex": "#a49f9e",
      "rgb": [
        164,
        159,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1001",
      "brandId": "madeira",
      "reference": "1001",
      "name": "Antique Blue VY LT",
      "hex": "#a4c6d8",
      "rgb": [
        164,
        198,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:212",
      "brandId": "madeira",
      "reference": "212",
      "name": "Christmas Red DK",
      "hex": "#a5010d",
      "rgb": [
        165,
        1,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:707",
      "brandId": "madeira",
      "reference": "707",
      "name": "Mauve Med DK",
      "hex": "#a53675",
      "rgb": [
        165,
        54,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2306",
      "brandId": "madeira",
      "reference": "2306",
      "name": "Mahogany LT",
      "hex": "#a56033",
      "rgb": [
        165,
        96,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2109",
      "brandId": "madeira",
      "reference": "2109",
      "name": "Drab Brown LT",
      "hex": "#a68e75",
      "rgb": [
        166,
        142,
        117
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2312",
      "brandId": "madeira",
      "reference": "2312",
      "name": "Peach Flesh Med",
      "hex": "#aa6f50",
      "rgb": [
        170,
        111,
        80
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1604",
      "brandId": "madeira",
      "reference": "1604",
      "name": "Laurel Green VY LT",
      "hex": "#aad381",
      "rgb": [
        170,
        211,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2609",
      "brandId": "madeira",
      "reference": "2609",
      "name": "Antique Plum Med",
      "hex": "#ab3851",
      "rgb": [
        171,
        56,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:210",
      "brandId": "madeira",
      "reference": "210",
      "name": "Christmas Red LT",
      "hex": "#ac172d",
      "rgb": [
        172,
        23,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2102",
      "brandId": "madeira",
      "reference": "2102",
      "name": "Hazelnut Brown VY LT",
      "hex": "#ac845e",
      "rgb": [
        172,
        132,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1901",
      "brandId": "madeira",
      "reference": "1901",
      "name": "Beige Grey LT",
      "hex": "#aca194",
      "rgb": [
        172,
        161,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:803",
      "brandId": "madeira",
      "reference": "803",
      "name": "Lavender DK",
      "hex": "#ad7dbd",
      "rgb": [
        173,
        125,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:311",
      "brandId": "madeira",
      "reference": "311",
      "name": "Copper Med",
      "hex": "#ae471f",
      "rgb": [
        174,
        71,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1805",
      "brandId": "madeira",
      "reference": "1805",
      "name": "Grey Green Ultra VY",
      "hex": "#aeb3af",
      "rgb": [
        174,
        179,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2211",
      "brandId": "madeira",
      "reference": "2211",
      "name": "Topaz Med DK",
      "hex": "#af720d",
      "rgb": [
        175,
        114,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2011",
      "brandId": "madeira",
      "reference": "2011",
      "name": "Tan",
      "hex": "#b17329",
      "rgb": [
        177,
        115,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1104",
      "brandId": "madeira",
      "reference": "1104",
      "name": "Wedgewood Ultra VY L",
      "hex": "#b1f0e0",
      "rgb": [
        177,
        240,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1610",
      "brandId": "madeira",
      "reference": "1610",
      "name": "Sage Green VY LT",
      "hex": "#b2af3d",
      "rgb": [
        178,
        175,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2711",
      "brandId": "madeira",
      "reference": "2711",
      "name": "Antique Lavender DK",
      "hex": "#b48fbc",
      "rgb": [
        180,
        143,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2212",
      "brandId": "madeira",
      "reference": "2212",
      "name": "Topaz DK",
      "hex": "#b5750d",
      "rgb": [
        181,
        117,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2203",
      "brandId": "madeira",
      "reference": "2203",
      "name": "Old Gold",
      "hex": "#b58a2e",
      "rgb": [
        181,
        138,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:506",
      "brandId": "madeira",
      "reference": "506",
      "name": "Baby Pink VY DK",
      "hex": "#b8405b",
      "rgb": [
        184,
        64,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1910",
      "brandId": "madeira",
      "reference": "1910",
      "name": "Beige Brown LT",
      "hex": "#bb9784",
      "rgb": [
        187,
        151,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1701",
      "brandId": "madeira",
      "reference": "1701",
      "name": "Sea Foam Green LT",
      "hex": "#bcd9c6",
      "rgb": [
        188,
        217,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:208",
      "brandId": "madeira",
      "reference": "208",
      "name": "Orange DK",
      "hex": "#bd3a03",
      "rgb": [
        189,
        58,
        3
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1414",
      "brandId": "madeira",
      "reference": "1414",
      "name": "Avocado Green Pale",
      "hex": "#bdb959",
      "rgb": [
        189,
        185,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1605",
      "brandId": "madeira",
      "reference": "1605",
      "name": "Khaki Green LT",
      "hex": "#beb16e",
      "rgb": [
        190,
        177,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:406",
      "brandId": "madeira",
      "reference": "406",
      "name": "Salmon DK",
      "hex": "#bf4e59",
      "rgb": [
        191,
        78,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:213",
      "brandId": "madeira",
      "reference": "213",
      "name": "Coral DK",
      "hex": "#c0232e",
      "rgb": [
        192,
        35,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2302",
      "brandId": "madeira",
      "reference": "2302",
      "name": "Golden Brown LT",
      "hex": "#c0753e",
      "rgb": [
        192,
        117,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2604",
      "brandId": "madeira",
      "reference": "2604",
      "name": "Nile Green DK",
      "hex": "#c0bf9e",
      "rgb": [
        192,
        191,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:702",
      "brandId": "madeira",
      "reference": "702",
      "name": "Cerise",
      "hex": "#c10064",
      "rgb": [
        193,
        0,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:310",
      "brandId": "madeira",
      "reference": "310",
      "name": "Copper Med LT",
      "hex": "#c25b34",
      "rgb": [
        194,
        91,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:711",
      "brandId": "madeira",
      "reference": "711",
      "name": "Violet LT",
      "hex": "#c26dab",
      "rgb": [
        194,
        109,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1806",
      "brandId": "madeira",
      "reference": "1806",
      "name": "Shell Grey LT",
      "hex": "#c2aeac",
      "rgb": [
        194,
        174,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2502",
      "brandId": "madeira",
      "reference": "2502",
      "name": "Bright Terracotta Me",
      "hex": "#c3463b",
      "rgb": [
        195,
        70,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:802",
      "brandId": "madeira",
      "reference": "802",
      "name": "Lavender LT",
      "hex": "#c399d2",
      "rgb": [
        195,
        153,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:209",
      "brandId": "madeira",
      "reference": "209",
      "name": "Orange VY DK",
      "hex": "#c41b35",
      "rgb": [
        196,
        27,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2209",
      "brandId": "madeira",
      "reference": "2209",
      "name": "Gold Med",
      "hex": "#c4921f",
      "rgb": [
        196,
        146,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2204",
      "brandId": "madeira",
      "reference": "2204",
      "name": "Old Gold LT",
      "hex": "#c59c47",
      "rgb": [
        197,
        156,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:708",
      "brandId": "madeira",
      "reference": "708",
      "name": "Mauve Med",
      "hex": "#c64297",
      "rgb": [
        198,
        66,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:610",
      "brandId": "madeira",
      "reference": "610",
      "name": "Dusty Rose VY DK",
      "hex": "#c84f89",
      "rgb": [
        200,
        79,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:505",
      "brandId": "madeira",
      "reference": "505",
      "name": "Baby Pink DK",
      "hex": "#c95770",
      "rgb": [
        201,
        87,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1907",
      "brandId": "madeira",
      "reference": "1907",
      "name": "Beige Grey Med LT",
      "hex": "#c9af9a",
      "rgb": [
        201,
        175,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:813",
      "brandId": "madeira",
      "reference": "813",
      "name": "Shell Pink",
      "hex": "#ca8591",
      "rgb": [
        202,
        133,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1101",
      "brandId": "madeira",
      "reference": "1101",
      "name": "Blue VY LT",
      "hex": "#cae8eb",
      "rgb": [
        202,
        232,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2612",
      "brandId": "madeira",
      "reference": "2612",
      "name": "Dusty Violet Med",
      "hex": "#cca1b6",
      "rgb": [
        204,
        161,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2001",
      "brandId": "madeira",
      "reference": "2001",
      "name": "Mocha Brown LT",
      "hex": "#cdb8a1",
      "rgb": [
        205,
        184,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2504",
      "brandId": "madeira",
      "reference": "2504",
      "name": "Wedgewood VY LT",
      "hex": "#cdd7d9",
      "rgb": [
        205,
        215,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2601",
      "brandId": "madeira",
      "reference": "2601",
      "name": "Coffee Brown VY LT",
      "hex": "#ce8d78",
      "rgb": [
        206,
        141,
        120
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2206",
      "brandId": "madeira",
      "reference": "2206",
      "name": "Avocado VY LT",
      "hex": "#ceb471",
      "rgb": [
        206,
        180,
        113
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:901",
      "brandId": "madeira",
      "reference": "901",
      "name": "Blue Violet VY LT",
      "hex": "#cfccfc",
      "rgb": [
        207,
        204,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:709",
      "brandId": "madeira",
      "reference": "709",
      "name": "Mauve LT",
      "hex": "#d064aa",
      "rgb": [
        208,
        100,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1309",
      "brandId": "madeira",
      "reference": "1309",
      "name": "Pistachio Green VY L",
      "hex": "#d0fab6",
      "rgb": [
        208,
        250,
        182
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1804",
      "brandId": "madeira",
      "reference": "1804",
      "name": "Pearl Grey VY LT",
      "hex": "#d1cdcc",
      "rgb": [
        209,
        205,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:605",
      "brandId": "madeira",
      "reference": "605",
      "name": "Plum LT",
      "hex": "#d26d9d",
      "rgb": [
        210,
        109,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:609",
      "brandId": "madeira",
      "reference": "609",
      "name": "Dusty Rose DK",
      "hex": "#d3689b",
      "rgb": [
        211,
        104,
        155
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2012",
      "brandId": "madeira",
      "reference": "2012",
      "name": "Tan LT",
      "hex": "#d49b56",
      "rgb": [
        212,
        155,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:309",
      "brandId": "madeira",
      "reference": "309",
      "name": "Copper LT",
      "hex": "#d86236",
      "rgb": [
        216,
        98,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:403",
      "brandId": "madeira",
      "reference": "403",
      "name": "Terracotta LT",
      "hex": "#d99082",
      "rgb": [
        217,
        144,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:206",
      "brandId": "madeira",
      "reference": "206",
      "name": "Orange Red",
      "hex": "#db5313",
      "rgb": [
        219,
        83,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:405",
      "brandId": "madeira",
      "reference": "405",
      "name": "Salmon Med",
      "hex": "#db7781",
      "rgb": [
        219,
        119,
        129
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:410",
      "brandId": "madeira",
      "reference": "410",
      "name": "Rose DK",
      "hex": "#dd3359",
      "rgb": [
        221,
        51,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:411",
      "brandId": "madeira",
      "reference": "411",
      "name": "Pink VY DK",
      "hex": "#dd4264",
      "rgb": [
        221,
        66,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:808",
      "brandId": "madeira",
      "reference": "808",
      "name": "Antique Mauve LT",
      "hex": "#debbc6",
      "rgb": [
        222,
        187,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2703",
      "brandId": "madeira",
      "reference": "2703",
      "name": "Yellow Green LT",
      "hex": "#ded76d",
      "rgb": [
        222,
        215,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2510",
      "brandId": "madeira",
      "reference": "2510",
      "name": "Golden Yellow DK",
      "hex": "#dfb467",
      "rgb": [
        223,
        180,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:207",
      "brandId": "madeira",
      "reference": "207",
      "name": "Orange",
      "hex": "#e04e08",
      "rgb": [
        224,
        78,
        8
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2713",
      "brandId": "madeira",
      "reference": "2713",
      "name": "Pink Purple Med",
      "hex": "#e088ad",
      "rgb": [
        224,
        136,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1909",
      "brandId": "madeira",
      "reference": "1909",
      "name": "Beige Brown VY LT",
      "hex": "#e0c5b7",
      "rgb": [
        224,
        197,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:701",
      "brandId": "madeira",
      "reference": "701",
      "name": "Cerise LT",
      "hex": "#e1157f",
      "rgb": [
        225,
        21,
        127
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:710",
      "brandId": "madeira",
      "reference": "710",
      "name": "Mauve VY LT",
      "hex": "#e28cc9",
      "rgb": [
        226,
        140,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2013",
      "brandId": "madeira",
      "reference": "2013",
      "name": "Tan VY LT",
      "hex": "#e2ad72",
      "rgb": [
        226,
        173,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2611",
      "brandId": "madeira",
      "reference": "2611",
      "name": "Dusty Violet LT",
      "hex": "#e4bfc9",
      "rgb": [
        228,
        191,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2313",
      "brandId": "madeira",
      "reference": "2313",
      "name": "Peach Flesh",
      "hex": "#e5ab8c",
      "rgb": [
        229,
        171,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:412",
      "brandId": "madeira",
      "reference": "412",
      "name": "Pink DK",
      "hex": "#e84b6e",
      "rgb": [
        232,
        75,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:303",
      "brandId": "madeira",
      "reference": "303",
      "name": "Coral",
      "hex": "#e87e6f",
      "rgb": [
        232,
        126,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2610",
      "brandId": "madeira",
      "reference": "2610",
      "name": "Antique Plum LT",
      "hex": "#e89aa7",
      "rgb": [
        232,
        154,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2208",
      "brandId": "madeira",
      "reference": "2208",
      "name": "Gold LT",
      "hex": "#e8bf5f",
      "rgb": [
        232,
        191,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:1908",
      "brandId": "madeira",
      "reference": "1908",
      "name": "Beige Brown Ultra VY",
      "hex": "#e9e0cc",
      "rgb": [
        233,
        224,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:301",
      "brandId": "madeira",
      "reference": "301",
      "name": "Peach Med",
      "hex": "#ea795c",
      "rgb": [
        234,
        121,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2514",
      "brandId": "madeira",
      "reference": "2514",
      "name": "Golden Brown Med",
      "hex": "#ea8d30",
      "rgb": [
        234,
        141,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:413",
      "brandId": "madeira",
      "reference": "413",
      "name": "Pink Med",
      "hex": "#ec6684",
      "rgb": [
        236,
        102,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:107",
      "brandId": "madeira",
      "reference": "107",
      "name": "Topaz Med",
      "hex": "#eca500",
      "rgb": [
        236,
        165,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:414",
      "brandId": "madeira",
      "reference": "414",
      "name": "Pink",
      "hex": "#ee859d",
      "rgb": [
        238,
        133,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:801",
      "brandId": "madeira",
      "reference": "801",
      "name": "Lavender VY LT",
      "hex": "#eec3fc",
      "rgb": [
        238,
        195,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:214",
      "brandId": "madeira",
      "reference": "214",
      "name": "Coral Med",
      "hex": "#ef4e5a",
      "rgb": [
        239,
        78,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:606",
      "brandId": "madeira",
      "reference": "606",
      "name": "Plum VY LT",
      "hex": "#ef90bd",
      "rgb": [
        239,
        144,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:504",
      "brandId": "madeira",
      "reference": "504",
      "name": "Baby Pink Med",
      "hex": "#f18aa1",
      "rgb": [
        241,
        138,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2301",
      "brandId": "madeira",
      "reference": "2301",
      "name": "Golden Brown VY LT",
      "hex": "#f1a46c",
      "rgb": [
        241,
        164,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:611",
      "brandId": "madeira",
      "reference": "611",
      "name": "Rose Med DK",
      "hex": "#f24999",
      "rgb": [
        242,
        73,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:409",
      "brandId": "madeira",
      "reference": "409",
      "name": "Rose Med",
      "hex": "#f35c7e",
      "rgb": [
        243,
        92,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:205",
      "brandId": "madeira",
      "reference": "205",
      "name": "Tangerine VY DK",
      "hex": "#f3631e",
      "rgb": [
        243,
        99,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:308",
      "brandId": "madeira",
      "reference": "308",
      "name": "Copper VY LT",
      "hex": "#f37747",
      "rgb": [
        243,
        119,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:114",
      "brandId": "madeira",
      "reference": "114",
      "name": "Yellow DK",
      "hex": "#f3a618",
      "rgb": [
        243,
        166,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:404",
      "brandId": "madeira",
      "reference": "404",
      "name": "Salmon LT",
      "hex": "#f4a5ad",
      "rgb": [
        244,
        165,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2309",
      "brandId": "madeira",
      "reference": "2309",
      "name": "Flesh Med",
      "hex": "#f4ae89",
      "rgb": [
        244,
        174,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2014",
      "brandId": "madeira",
      "reference": "2014",
      "name": "Tan Ultra VY LT",
      "hex": "#f4c99c",
      "rgb": [
        244,
        201,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:108",
      "brandId": "madeira",
      "reference": "108",
      "name": "Topaz LT",
      "hex": "#f4d007",
      "rgb": [
        244,
        208,
        7
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:9999",
      "brandId": "madeira",
      "reference": "9999",
      "name": "Ecru",
      "hex": "#f4e6ca",
      "rgb": [
        244,
        230,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:105",
      "brandId": "madeira",
      "reference": "105",
      "name": "Lemon VY DK",
      "hex": "#f5c900",
      "rgb": [
        245,
        201,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:501",
      "brandId": "madeira",
      "reference": "501",
      "name": "Baby Pink VY LT",
      "hex": "#f5d4d8",
      "rgb": [
        245,
        212,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:109",
      "brandId": "madeira",
      "reference": "109",
      "name": "Topaz VY LT",
      "hex": "#f6da3e",
      "rgb": [
        246,
        218,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2205",
      "brandId": "madeira",
      "reference": "2205",
      "name": "Old Gold VY LT",
      "hex": "#f6de9f",
      "rgb": [
        246,
        222,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:110",
      "brandId": "madeira",
      "reference": "110",
      "name": "Topaz Ultra VY LT",
      "hex": "#f6e37b",
      "rgb": [
        246,
        227,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:204",
      "brandId": "madeira",
      "reference": "204",
      "name": "Tangerine DK",
      "hex": "#f7722a",
      "rgb": [
        247,
        114,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:103",
      "brandId": "madeira",
      "reference": "103",
      "name": "Lemon Med",
      "hex": "#f8ef7d",
      "rgb": [
        248,
        239,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:111",
      "brandId": "madeira",
      "reference": "111",
      "name": "Yellow VY LT",
      "hex": "#f8f1cc",
      "rgb": [
        248,
        241,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:113",
      "brandId": "madeira",
      "reference": "113",
      "name": "Yellow Med",
      "hex": "#f9c345",
      "rgb": [
        249,
        195,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:112",
      "brandId": "madeira",
      "reference": "112",
      "name": "Yellow LT",
      "hex": "#f9eb8c",
      "rgb": [
        249,
        235,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:201",
      "brandId": "madeira",
      "reference": "201",
      "name": "Tangerine LT",
      "hex": "#fa8d52",
      "rgb": [
        250,
        141,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:106",
      "brandId": "madeira",
      "reference": "106",
      "name": "Canary Yellow Bright",
      "hex": "#fabe20",
      "rgb": [
        250,
        190,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:203",
      "brandId": "madeira",
      "reference": "203",
      "name": "Tangerine Med",
      "hex": "#fb7a34",
      "rgb": [
        251,
        122,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:104",
      "brandId": "madeira",
      "reference": "104",
      "name": "Lemon DK",
      "hex": "#fbd628",
      "rgb": [
        251,
        214,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2707",
      "brandId": "madeira",
      "reference": "2707",
      "name": "Bright Pink LT",
      "hex": "#fc8090",
      "rgb": [
        252,
        128,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:612",
      "brandId": "madeira",
      "reference": "612",
      "name": "Rose Med LT",
      "hex": "#fc86bf",
      "rgb": [
        252,
        134,
        191
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:302",
      "brandId": "madeira",
      "reference": "302",
      "name": "Peach LT",
      "hex": "#fc9279",
      "rgb": [
        252,
        146,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2307",
      "brandId": "madeira",
      "reference": "2307",
      "name": "Mahogany VY LT",
      "hex": "#fca56c",
      "rgb": [
        252,
        165,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:814",
      "brandId": "madeira",
      "reference": "814",
      "name": "Shell Pink LT",
      "hex": "#fcc4ce",
      "rgb": [
        252,
        196,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2708",
      "brandId": "madeira",
      "reference": "2708",
      "name": "Bright Pink Med",
      "hex": "#fd475e",
      "rgb": [
        253,
        71,
        94
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:408",
      "brandId": "madeira",
      "reference": "408",
      "name": "Rose",
      "hex": "#fd85a0",
      "rgb": [
        253,
        133,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:614",
      "brandId": "madeira",
      "reference": "614",
      "name": "Rose VY LT",
      "hex": "#fd94d1",
      "rgb": [
        253,
        148,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2513",
      "brandId": "madeira",
      "reference": "2513",
      "name": "Golden Brown Bright",
      "hex": "#fda761",
      "rgb": [
        253,
        167,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2509",
      "brandId": "madeira",
      "reference": "2509",
      "name": "Golden Yellow Bright",
      "hex": "#fdb85c",
      "rgb": [
        253,
        184,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:306",
      "brandId": "madeira",
      "reference": "306",
      "name": "Coral Ultra VY LT",
      "hex": "#fdd1ca",
      "rgb": [
        253,
        209,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:102",
      "brandId": "madeira",
      "reference": "102",
      "name": "Lemon LT",
      "hex": "#fdfbad",
      "rgb": [
        253,
        251,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:202",
      "brandId": "madeira",
      "reference": "202",
      "name": "Tangerine",
      "hex": "#ff803d",
      "rgb": [
        255,
        128,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:307",
      "brandId": "madeira",
      "reference": "307",
      "name": "Copper Ultra VY LT",
      "hex": "#ff8457",
      "rgb": [
        255,
        132,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:304",
      "brandId": "madeira",
      "reference": "304",
      "name": "Coral LT",
      "hex": "#ffa497",
      "rgb": [
        255,
        164,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:613",
      "brandId": "madeira",
      "reference": "613",
      "name": "Rose LT",
      "hex": "#ffa4d7",
      "rgb": [
        255,
        164,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2503",
      "brandId": "madeira",
      "reference": "2503",
      "name": "Bright Terracotta LT",
      "hex": "#ffa792",
      "rgb": [
        255,
        167,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:607",
      "brandId": "madeira",
      "reference": "607",
      "name": "Plum Ultra VY LT",
      "hex": "#ffabd2",
      "rgb": [
        255,
        171,
        210
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2605",
      "brandId": "madeira",
      "reference": "2605",
      "name": "Peach VY LT",
      "hex": "#ffad99",
      "rgb": [
        255,
        173,
        153
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:503",
      "brandId": "madeira",
      "reference": "503",
      "name": "Baby Pink Med LT",
      "hex": "#ffafbb",
      "rgb": [
        255,
        175,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:305",
      "brandId": "madeira",
      "reference": "305",
      "name": "Coral VY LT",
      "hex": "#ffbeb5",
      "rgb": [
        255,
        190,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2712",
      "brandId": "madeira",
      "reference": "2712",
      "name": "Pink Purple LT",
      "hex": "#ffbfd9",
      "rgb": [
        255,
        191,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:608",
      "brandId": "madeira",
      "reference": "608",
      "name": "Plum VY Pale",
      "hex": "#ffc3df",
      "rgb": [
        255,
        195,
        223
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:502",
      "brandId": "madeira",
      "reference": "502",
      "name": "Baby Pink LT",
      "hex": "#ffc4ce",
      "rgb": [
        255,
        196,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2308",
      "brandId": "madeira",
      "reference": "2308",
      "name": "Flesh LT",
      "hex": "#ffc9ae",
      "rgb": [
        255,
        201,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2512",
      "brandId": "madeira",
      "reference": "2512",
      "name": "Golden Brown LT",
      "hex": "#ffdda4",
      "rgb": [
        255,
        221,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2207",
      "brandId": "madeira",
      "reference": "2207",
      "name": "Gold VY LT",
      "hex": "#ffe2a0",
      "rgb": [
        255,
        226,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2511",
      "brandId": "madeira",
      "reference": "2511",
      "name": "Golden Yellow LT",
      "hex": "#fff1b4",
      "rgb": [
        255,
        241,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:2101",
      "brandId": "madeira",
      "reference": "2101",
      "name": "Cream",
      "hex": "#fff4e0",
      "rgb": [
        255,
        244,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:101",
      "brandId": "madeira",
      "reference": "101",
      "name": "Lemon VY LT",
      "hex": "#ffffd9",
      "rgb": [
        255,
        255,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "madeira:9998",
      "brandId": "madeira",
      "reference": "9998",
      "name": "White",
      "hex": "#ffffff",
      "rgb": [
        255,
        255,
        255
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45053",
      "brandId": "sullivans",
      "reference": "45053",
      "name": "Black",
      "hex": "#030303",
      "rgb": [
        3,
        3,
        3
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45222",
      "brandId": "sullivans",
      "reference": "45222",
      "name": "Royal Blue Very Dark",
      "hex": "#040849",
      "rgb": [
        4,
        8,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45281",
      "brandId": "sullivans",
      "reference": "45281",
      "name": "Navy Blue Very Dark",
      "hex": "#080219",
      "rgb": [
        8,
        2,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45224",
      "brandId": "sullivans",
      "reference": "45224",
      "name": "Navy Blue Dark",
      "hex": "#0b092b",
      "rgb": [
        11,
        9,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45206",
      "brandId": "sullivans",
      "reference": "45206",
      "name": "Royal Blue Dark",
      "hex": "#0b165c",
      "rgb": [
        11,
        22,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45243",
      "brandId": "sullivans",
      "reference": "45243",
      "name": "Pistachio Green Ultra Dark",
      "hex": "#0d200d",
      "rgb": [
        13,
        32,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45415",
      "brandId": "sullivans",
      "reference": "45415",
      "name": "Emerald Green Ultra Dark",
      "hex": "#0d4016",
      "rgb": [
        13,
        64,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45109",
      "brandId": "sullivans",
      "reference": "45109",
      "name": "Blue Green Very Dark",
      "hex": "#0e1b18",
      "rgb": [
        14,
        27,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45225",
      "brandId": "sullivans",
      "reference": "45225",
      "name": "Blue Very Dark",
      "hex": "#112c65",
      "rgb": [
        17,
        44,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45442",
      "brandId": "sullivans",
      "reference": "45442",
      "name": "Bright Turquoise Dark",
      "hex": "#1182bc",
      "rgb": [
        17,
        130,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45314",
      "brandId": "sullivans",
      "reference": "45314",
      "name": "Electric Blue Dark",
      "hex": "#126dce",
      "rgb": [
        18,
        109,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45494",
      "brandId": "sullivans",
      "reference": "45494",
      "name": "Baby Blue Ultra Very Dark",
      "hex": "#132755",
      "rgb": [
        19,
        39,
        85
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45054",
      "brandId": "sullivans",
      "reference": "45054",
      "name": "Navy Blue Medium",
      "hex": "#132b4f",
      "rgb": [
        19,
        43,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45440",
      "brandId": "sullivans",
      "reference": "45440",
      "name": "Wedgewood Dark",
      "hex": "#13376e",
      "rgb": [
        19,
        55,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45405",
      "brandId": "sullivans",
      "reference": "45405",
      "name": "Turquoise Ultra Very Dark",
      "hex": "#133b4c",
      "rgb": [
        19,
        59,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45375",
      "brandId": "sullivans",
      "reference": "45375",
      "name": "Antique Blue Very Dark",
      "hex": "#142540",
      "rgb": [
        20,
        37,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45257",
      "brandId": "sullivans",
      "reference": "45257",
      "name": "Emerald Green Very Dark",
      "hex": "#15621d",
      "rgb": [
        21,
        98,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45159",
      "brandId": "sullivans",
      "reference": "45159",
      "name": "Christmas Green",
      "hex": "#165b1b",
      "rgb": [
        22,
        91,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45202",
      "brandId": "sullivans",
      "reference": "45202",
      "name": "Cornflower Blue Very Dark",
      "hex": "#17195d",
      "rgb": [
        23,
        25,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45069",
      "brandId": "sullivans",
      "reference": "45069",
      "name": "Navy Blue",
      "hex": "#17204a",
      "rgb": [
        23,
        32,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45445",
      "brandId": "sullivans",
      "reference": "45445",
      "name": "Teal Green Dark",
      "hex": "#174e46",
      "rgb": [
        23,
        78,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45060",
      "brandId": "sullivans",
      "reference": "45060",
      "name": "Pistachio Green Very Dark",
      "hex": "#18301b",
      "rgb": [
        24,
        48,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45351",
      "brandId": "sullivans",
      "reference": "45351",
      "name": "Black Brown",
      "hex": "#190a07",
      "rgb": [
        25,
        10,
        7
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45441",
      "brandId": "sullivans",
      "reference": "45441",
      "name": "Electric Blue",
      "hex": "#1a7cd7",
      "rgb": [
        26,
        124,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45207",
      "brandId": "sullivans",
      "reference": "45207",
      "name": "Royal Blue",
      "hex": "#1b2a74",
      "rgb": [
        27,
        42,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45276",
      "brandId": "sullivans",
      "reference": "45276",
      "name": "Black Avocado Green",
      "hex": "#1c1c11",
      "rgb": [
        28,
        28,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45269",
      "brandId": "sullivans",
      "reference": "45269",
      "name": "Grey Green Very Dark",
      "hex": "#1c3038",
      "rgb": [
        28,
        48,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45055",
      "brandId": "sullivans",
      "reference": "45055",
      "name": "Navy Blue Light",
      "hex": "#1c3566",
      "rgb": [
        28,
        53,
        102
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45307",
      "brandId": "sullivans",
      "reference": "45307",
      "name": "Forest Green Very Dark",
      "hex": "#1d3b17",
      "rgb": [
        29,
        59,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45226",
      "brandId": "sullivans",
      "reference": "45226",
      "name": "Blue Dark",
      "hex": "#1d407c",
      "rgb": [
        29,
        64,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45311",
      "brandId": "sullivans",
      "reference": "45311",
      "name": "Aquamarine Dark",
      "hex": "#1e5f49",
      "rgb": [
        30,
        95,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45473",
      "brandId": "sullivans",
      "reference": "45473",
      "name": "Cornflower Blue Medium Dark",
      "hex": "#1f2565",
      "rgb": [
        31,
        37,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45248",
      "brandId": "sullivans",
      "reference": "45248",
      "name": "Hunter Green Very Dark",
      "hex": "#1f391b",
      "rgb": [
        31,
        57,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45406",
      "brandId": "sullivans",
      "reference": "45406",
      "name": "Turquoise Very Dark",
      "hex": "#21576b",
      "rgb": [
        33,
        87,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45114",
      "brandId": "sullivans",
      "reference": "45114",
      "name": "Wedgewood Dark",
      "hex": "#224e89",
      "rgb": [
        34,
        78,
        137
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45382",
      "brandId": "sullivans",
      "reference": "45382",
      "name": "Very Dark Peacock Blue",
      "hex": "#225485",
      "rgb": [
        34,
        84,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45342",
      "brandId": "sullivans",
      "reference": "45342",
      "name": "Hunter Green Dark",
      "hex": "#23330f",
      "rgb": [
        35,
        51,
        15
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45443",
      "brandId": "sullivans",
      "reference": "45443",
      "name": "Bright Turquoise Medium",
      "hex": "#25a9d8",
      "rgb": [
        37,
        169,
        216
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45397",
      "brandId": "sullivans",
      "reference": "45397",
      "name": "Pewter Grey Very Dark",
      "hex": "#262724",
      "rgb": [
        38,
        39,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45273",
      "brandId": "sullivans",
      "reference": "45273",
      "name": "Antique Blue Dark",
      "hex": "#273949",
      "rgb": [
        39,
        57,
        73
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45127",
      "brandId": "sullivans",
      "reference": "45127",
      "name": "Jade Very Dark",
      "hex": "#274e3e",
      "rgb": [
        39,
        78,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45258",
      "brandId": "sullivans",
      "reference": "45258",
      "name": "Emerald Green Dark",
      "hex": "#27772f",
      "rgb": [
        39,
        119,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45448",
      "brandId": "sullivans",
      "reference": "45448",
      "name": "Bright Green Dark",
      "hex": "#278654",
      "rgb": [
        39,
        134,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45469",
      "brandId": "sullivans",
      "reference": "45469",
      "name": "Grape Very Dark",
      "hex": "#28041b",
      "rgb": [
        40,
        4,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45428",
      "brandId": "sullivans",
      "reference": "45428",
      "name": "Brown Grey Very Dark",
      "hex": "#282117",
      "rgb": [
        40,
        33,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45160",
      "brandId": "sullivans",
      "reference": "45160",
      "name": "Christmas Green Bright",
      "hex": "#287326",
      "rgb": [
        40,
        115,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45409",
      "brandId": "sullivans",
      "reference": "45409",
      "name": "Sea Green Very Dark",
      "hex": "#288e70",
      "rgb": [
        40,
        142,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45277",
      "brandId": "sullivans",
      "reference": "45277",
      "name": "Avocado Green Dark",
      "hex": "#292c1a",
      "rgb": [
        41,
        44,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45203",
      "brandId": "sullivans",
      "reference": "45203",
      "name": "Cornflower Blue Dark",
      "hex": "#2a3586",
      "rgb": [
        42,
        53,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45253",
      "brandId": "sullivans",
      "reference": "45253",
      "name": "Parrot Green Very Dark",
      "hex": "#2d4714",
      "rgb": [
        45,
        71,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45208",
      "brandId": "sullivans",
      "reference": "45208",
      "name": "Delft Blue Dark",
      "hex": "#2d5095",
      "rgb": [
        45,
        80,
        149
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45490",
      "brandId": "sullivans",
      "reference": "45490",
      "name": "Jade Green",
      "hex": "#2e5d38",
      "rgb": [
        46,
        93,
        56
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45411",
      "brandId": "sullivans",
      "reference": "45411",
      "name": "Aquamarine",
      "hex": "#2f7863",
      "rgb": [
        47,
        120,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45280",
      "brandId": "sullivans",
      "reference": "45280",
      "name": "Coffee Brown Ultra Dark",
      "hex": "#30100c",
      "rgb": [
        48,
        16,
        12
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45446",
      "brandId": "sullivans",
      "reference": "45446",
      "name": "Teal Green Medium",
      "hex": "#30736a",
      "rgb": [
        48,
        115,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45282",
      "brandId": "sullivans",
      "reference": "45282",
      "name": "Aquamarine Medium",
      "hex": "#30956c",
      "rgb": [
        48,
        149,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45323",
      "brandId": "sullivans",
      "reference": "45323",
      "name": "Mocha Brown Very Dark",
      "hex": "#321b11",
      "rgb": [
        50,
        27,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45066",
      "brandId": "sullivans",
      "reference": "45066",
      "name": "Blue Violet Very Dark",
      "hex": "#322984",
      "rgb": [
        50,
        41,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45089",
      "brandId": "sullivans",
      "reference": "45089",
      "name": "Pewter Grey Dark",
      "hex": "#323737",
      "rgb": [
        50,
        55,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45236",
      "brandId": "sullivans",
      "reference": "45236",
      "name": "Beige Brown Very Dark",
      "hex": "#331a14",
      "rgb": [
        51,
        26,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45110",
      "brandId": "sullivans",
      "reference": "45110",
      "name": "Blue Green Dark",
      "hex": "#344d46",
      "rgb": [
        52,
        77,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45117",
      "brandId": "sullivans",
      "reference": "45117",
      "name": "Fern Green Dark",
      "hex": "#35442e",
      "rgb": [
        53,
        68,
        46
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45241",
      "brandId": "sullivans",
      "reference": "45241",
      "name": "Beaver Grey Ultra Dark",
      "hex": "#362f2a",
      "rgb": [
        54,
        47,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45278",
      "brandId": "sullivans",
      "reference": "45278",
      "name": "Avocado Green Very Dark",
      "hex": "#36371a",
      "rgb": [
        54,
        55,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45123",
      "brandId": "sullivans",
      "reference": "45123",
      "name": "Violet Very Dark",
      "hex": "#37073f",
      "rgb": [
        55,
        7,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45259",
      "brandId": "sullivans",
      "reference": "45259",
      "name": "Emerald Green Medium",
      "hex": "#389346",
      "rgb": [
        56,
        147,
        70
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45161",
      "brandId": "sullivans",
      "reference": "45161",
      "name": "Christmas Green Light",
      "hex": "#39822c",
      "rgb": [
        57,
        130,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45249",
      "brandId": "sullivans",
      "reference": "45249",
      "name": "Coffee Brown Very Dark",
      "hex": "#3a150d",
      "rgb": [
        58,
        21,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45331",
      "brandId": "sullivans",
      "reference": "45331",
      "name": "Green Grey Dark",
      "hex": "#3b3e1c",
      "rgb": [
        59,
        62,
        28
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45380",
      "brandId": "sullivans",
      "reference": "45380",
      "name": "Wedgewood",
      "hex": "#3b71a1",
      "rgb": [
        59,
        113,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45308",
      "brandId": "sullivans",
      "reference": "45308",
      "name": "Forest Green Dark",
      "hex": "#3c552c",
      "rgb": [
        60,
        85,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45407",
      "brandId": "sullivans",
      "reference": "45407",
      "name": "Turquoise Dark",
      "hex": "#3c798e",
      "rgb": [
        60,
        121,
        142
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45404",
      "brandId": "sullivans",
      "reference": "45404",
      "name": "Cornflower Blue",
      "hex": "#3d4687",
      "rgb": [
        61,
        70,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45080",
      "brandId": "sullivans",
      "reference": "45080",
      "name": "Pistachio Green Dark",
      "hex": "#3d5f3a",
      "rgb": [
        61,
        95,
        58
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45254",
      "brandId": "sullivans",
      "reference": "45254",
      "name": "Parrot Green Dark",
      "hex": "#3e6515",
      "rgb": [
        62,
        101,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45412",
      "brandId": "sullivans",
      "reference": "45412",
      "name": "Celadon Green Dark",
      "hex": "#3e6a4e",
      "rgb": [
        62,
        106,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45279",
      "brandId": "sullivans",
      "reference": "45279",
      "name": "Avocado Green Medium",
      "hex": "#3f4c17",
      "rgb": [
        63,
        76,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45227",
      "brandId": "sullivans",
      "reference": "45227",
      "name": "Blue Medium",
      "hex": "#3f6aa5",
      "rgb": [
        63,
        106,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45384",
      "brandId": "sullivans",
      "reference": "45384",
      "name": "Grey Green Dark",
      "hex": "#404e58",
      "rgb": [
        64,
        78,
        88
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45393",
      "brandId": "sullivans",
      "reference": "45393",
      "name": "Mocha Brown Dark",
      "hex": "#412b1f",
      "rgb": [
        65,
        43,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45121",
      "brandId": "sullivans",
      "reference": "45121",
      "name": "Ash Grey Very Light",
      "hex": "#413f3e",
      "rgb": [
        65,
        63,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45478",
      "brandId": "sullivans",
      "reference": "45478",
      "name": "Celadon Green Medium",
      "hex": "#426b57",
      "rgb": [
        66,
        107,
        87
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45315",
      "brandId": "sullivans",
      "reference": "45315",
      "name": "Electric Blue Medium",
      "hex": "#42a4eb",
      "rgb": [
        66,
        164,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45435",
      "brandId": "sullivans",
      "reference": "45435",
      "name": "Lavender Ultra Dark",
      "hex": "#432076",
      "rgb": [
        67,
        32,
        118
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45348",
      "brandId": "sullivans",
      "reference": "45348",
      "name": "Pine Green Dark",
      "hex": "#434d32",
      "rgb": [
        67,
        77,
        50
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45237",
      "brandId": "sullivans",
      "reference": "45237",
      "name": "Beige Brown Dark",
      "hex": "#44291f",
      "rgb": [
        68,
        41,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45065",
      "brandId": "sullivans",
      "reference": "45065",
      "name": "Violet",
      "hex": "#45204f",
      "rgb": [
        69,
        32,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45436",
      "brandId": "sullivans",
      "reference": "45436",
      "name": "Lavender Blue Dark",
      "hex": "#455da8",
      "rgb": [
        69,
        93,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45444",
      "brandId": "sullivans",
      "reference": "45444",
      "name": "Bright Turquoise Light",
      "hex": "#45c7eb",
      "rgb": [
        69,
        199,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45395",
      "brandId": "sullivans",
      "reference": "45395",
      "name": "Brown Grey Dark",
      "hex": "#464331",
      "rgb": [
        70,
        67,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45373",
      "brandId": "sullivans",
      "reference": "45373",
      "name": "Blue Violet Dark",
      "hex": "#4849a1",
      "rgb": [
        72,
        73,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45104",
      "brandId": "sullivans",
      "reference": "45104",
      "name": "Avocado Green",
      "hex": "#484a1d",
      "rgb": [
        72,
        74,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45058",
      "brandId": "sullivans",
      "reference": "45058",
      "name": "Pewter Grey",
      "hex": "#484c56",
      "rgb": [
        72,
        76,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45115",
      "brandId": "sullivans",
      "reference": "45115",
      "name": "Wedgewood Light",
      "hex": "#4883a7",
      "rgb": [
        72,
        131,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45174",
      "brandId": "sullivans",
      "reference": "45174",
      "name": "Olive Green Very Dark",
      "hex": "#493b0d",
      "rgb": [
        73,
        59,
        13
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45476",
      "brandId": "sullivans",
      "reference": "45476",
      "name": "Grey Blue",
      "hex": "#49527a",
      "rgb": [
        73,
        82,
        122
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45211",
      "brandId": "sullivans",
      "reference": "45211",
      "name": "Coffee Brown Dark",
      "hex": "#4a1e10",
      "rgb": [
        74,
        30,
        16
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45343",
      "brandId": "sullivans",
      "reference": "45343",
      "name": "Hunter Green",
      "hex": "#4a5825",
      "rgb": [
        74,
        88,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45063",
      "brandId": "sullivans",
      "reference": "45063",
      "name": "Baby Blue Dark",
      "hex": "#4a6ca1",
      "rgb": [
        74,
        108,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45255",
      "brandId": "sullivans",
      "reference": "45255",
      "name": "Parrot Green Medium",
      "hex": "#4b7e16",
      "rgb": [
        75,
        126,
        22
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45128",
      "brandId": "sullivans",
      "reference": "45128",
      "name": "Jade Medium",
      "hex": "#4b8256",
      "rgb": [
        75,
        130,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45048",
      "brandId": "sullivans",
      "reference": "45048",
      "name": "Mahogany Very Dark",
      "hex": "#4d110b",
      "rgb": [
        77,
        17,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45131",
      "brandId": "sullivans",
      "reference": "45131",
      "name": "Moss Green Dark",
      "hex": "#4d5315",
      "rgb": [
        77,
        83,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45274",
      "brandId": "sullivans",
      "reference": "45274",
      "name": "Antique Blue Medium",
      "hex": "#4d6786",
      "rgb": [
        77,
        103,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45162",
      "brandId": "sullivans",
      "reference": "45162",
      "name": "Kelly Green",
      "hex": "#4d9336",
      "rgb": [
        77,
        147,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45449",
      "brandId": "sullivans",
      "reference": "45449",
      "name": "Bright Green Light",
      "hex": "#4db088",
      "rgb": [
        77,
        176,
        136
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45151",
      "brandId": "sullivans",
      "reference": "45151",
      "name": "Beaver Grey Very Dark",
      "hex": "#4e4945",
      "rgb": [
        78,
        73,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45212",
      "brandId": "sullivans",
      "reference": "45212",
      "name": "Peacock Blue Dark",
      "hex": "#4e90ac",
      "rgb": [
        78,
        144,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45216",
      "brandId": "sullivans",
      "reference": "45216",
      "name": "Garnet Dark",
      "hex": "#500212",
      "rgb": [
        80,
        2,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45432",
      "brandId": "sullivans",
      "reference": "45432",
      "name": "Grape Dark",
      "hex": "#50183f",
      "rgb": [
        80,
        24,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45493",
      "brandId": "sullivans",
      "reference": "45493",
      "name": "Cocoa Dark",
      "hex": "#512f2c",
      "rgb": [
        81,
        47,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45067",
      "brandId": "sullivans",
      "reference": "45067",
      "name": "Baby Blue Medium",
      "hex": "#517bad",
      "rgb": [
        81,
        123,
        173
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45260",
      "brandId": "sullivans",
      "reference": "45260",
      "name": "Emerald Green Light",
      "hex": "#51a361",
      "rgb": [
        81,
        163,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45371",
      "brandId": "sullivans",
      "reference": "45371",
      "name": "Antique Violet Dark",
      "hex": "#52303f",
      "rgb": [
        82,
        48,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45447",
      "brandId": "sullivans",
      "reference": "45447",
      "name": "Teal Green Light",
      "hex": "#529890",
      "rgb": [
        82,
        152,
        144
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45293",
      "brandId": "sullivans",
      "reference": "45293",
      "name": "Sea Green Dark",
      "hex": "#53b091",
      "rgb": [
        83,
        176,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45316",
      "brandId": "sullivans",
      "reference": "45316",
      "name": "Khaki Green Dark",
      "hex": "#544822",
      "rgb": [
        84,
        72,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45455",
      "brandId": "sullivans",
      "reference": "45455",
      "name": "Rosewood Dark",
      "hex": "#551411",
      "rgb": [
        85,
        20,
        17
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45124",
      "brandId": "sullivans",
      "reference": "45124",
      "name": "Violet Medium",
      "hex": "#552770",
      "rgb": [
        85,
        39,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45204",
      "brandId": "sullivans",
      "reference": "45204",
      "name": "Cornflower Blue Medium",
      "hex": "#566a9c",
      "rgb": [
        86,
        106,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45111",
      "brandId": "sullivans",
      "reference": "45111",
      "name": "Blue Green",
      "hex": "#567469",
      "rgb": [
        86,
        116,
        105
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45209",
      "brandId": "sullivans",
      "reference": "45209",
      "name": "Delft Blue Medium",
      "hex": "#567db2",
      "rgb": [
        86,
        125,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45252",
      "brandId": "sullivans",
      "reference": "45252",
      "name": "Garnet Very Dark",
      "hex": "#57071f",
      "rgb": [
        87,
        7,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45231",
      "brandId": "sullivans",
      "reference": "45231",
      "name": "Golden Olive Dark",
      "hex": "#583714",
      "rgb": [
        88,
        55,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45061",
      "brandId": "sullivans",
      "reference": "45061",
      "name": "Pistachio Green Medium",
      "hex": "#587c54",
      "rgb": [
        88,
        124,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45349",
      "brandId": "sullivans",
      "reference": "45349",
      "name": "Pine Green Medium",
      "hex": "#596242",
      "rgb": [
        89,
        98,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45133",
      "brandId": "sullivans",
      "reference": "45133",
      "name": "Turquoise",
      "hex": "#5993a7",
      "rgb": [
        89,
        147,
        167
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45309",
      "brandId": "sullivans",
      "reference": "45309",
      "name": "Forest Green Medium",
      "hex": "#5c7641",
      "rgb": [
        92,
        118,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45437",
      "brandId": "sullivans",
      "reference": "45437",
      "name": "Lavender Blue Medium",
      "hex": "#5d79bc",
      "rgb": [
        93,
        121,
        188
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45094",
      "brandId": "sullivans",
      "reference": "45094",
      "name": "Brown Medium",
      "hex": "#5e2510",
      "rgb": [
        94,
        37,
        16
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45399",
      "brandId": "sullivans",
      "reference": "45399",
      "name": "Antique Mauve Very Dark",
      "hex": "#5f1428",
      "rgb": [
        95,
        20,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45230",
      "brandId": "sullivans",
      "reference": "45230",
      "name": "Golden Olive Very Dark",
      "hex": "#5f3312",
      "rgb": [
        95,
        51,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45344",
      "brandId": "sullivans",
      "reference": "45344",
      "name": "Yellow Green Medium",
      "hex": "#5f6e34",
      "rgb": [
        95,
        110,
        52
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45213",
      "brandId": "sullivans",
      "reference": "45213",
      "name": "Peacock Blue",
      "hex": "#5f9ea5",
      "rgb": [
        95,
        158,
        165
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45458",
      "brandId": "sullivans",
      "reference": "45458",
      "name": "Cocoa",
      "hex": "#603c3b",
      "rgb": [
        96,
        60,
        59
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45217",
      "brandId": "sullivans",
      "reference": "45217",
      "name": "Garnet Medium",
      "hex": "#610118",
      "rgb": [
        97,
        1,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45242",
      "brandId": "sullivans",
      "reference": "45242",
      "name": "Hazel Nut Brown Very Dark",
      "hex": "#613219",
      "rgb": [
        97,
        50,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45040",
      "brandId": "sullivans",
      "reference": "45040",
      "name": "Lavender Very Dark",
      "hex": "#613694",
      "rgb": [
        97,
        54,
        148
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45090",
      "brandId": "sullivans",
      "reference": "45090",
      "name": "Steel Grey Dark",
      "hex": "#616270",
      "rgb": [
        97,
        98,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45413",
      "brandId": "sullivans",
      "reference": "45413",
      "name": "Celadon Green",
      "hex": "#61947c",
      "rgb": [
        97,
        148,
        124
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45105",
      "brandId": "sullivans",
      "reference": "45105",
      "name": "Avocado Green Light",
      "hex": "#627422",
      "rgb": [
        98,
        116,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45143",
      "brandId": "sullivans",
      "reference": "45143",
      "name": "Drab Brown Dark",
      "hex": "#644724",
      "rgb": [
        100,
        71,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45144",
      "brandId": "sullivans",
      "reference": "45144",
      "name": "Drab Brown",
      "hex": "#644930",
      "rgb": [
        100,
        73,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45175",
      "brandId": "sullivans",
      "reference": "45175",
      "name": "Olive Green Dark",
      "hex": "#645312",
      "rgb": [
        100,
        83,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45176",
      "brandId": "sullivans",
      "reference": "45176",
      "name": "Olive Green",
      "hex": "#645312",
      "rgb": [
        100,
        83,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45270",
      "brandId": "sullivans",
      "reference": "45270",
      "name": "Grey Green Medium",
      "hex": "#647874",
      "rgb": [
        100,
        120,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45294",
      "brandId": "sullivans",
      "reference": "45294",
      "name": "Sea Green Medium",
      "hex": "#64c3a6",
      "rgb": [
        100,
        195,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45056",
      "brandId": "sullivans",
      "reference": "45056",
      "name": "Antique Mauve Dark",
      "hex": "#672433",
      "rgb": [
        103,
        36,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45215",
      "brandId": "sullivans",
      "reference": "45215",
      "name": "Blue Light",
      "hex": "#6795c2",
      "rgb": [
        103,
        149,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45355",
      "brandId": "sullivans",
      "reference": "45355",
      "name": "Mauve Dark",
      "hex": "#680720",
      "rgb": [
        104,
        7,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45125",
      "brandId": "sullivans",
      "reference": "45125",
      "name": "Violet",
      "hex": "#683c87",
      "rgb": [
        104,
        60,
        135
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45147",
      "brandId": "sullivans",
      "reference": "45147",
      "name": "Desert Sand Ultra Very Dark",
      "hex": "#692825",
      "rgb": [
        105,
        40,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45326",
      "brandId": "sullivans",
      "reference": "45326",
      "name": "Antique Violet Medium",
      "hex": "#6a485d",
      "rgb": [
        106,
        72,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45070",
      "brandId": "sullivans",
      "reference": "45070",
      "name": "Blue Violet Medium",
      "hex": "#6a70c0",
      "rgb": [
        106,
        112,
        192
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45475",
      "brandId": "sullivans",
      "reference": "45475",
      "name": "Grey Blue Medium",
      "hex": "#6a76a0",
      "rgb": [
        106,
        118,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45304",
      "brandId": "sullivans",
      "reference": "45304",
      "name": "Golden Brown Dark",
      "hex": "#6b1e12",
      "rgb": [
        107,
        30,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45470",
      "brandId": "sullivans",
      "reference": "45470",
      "name": "Blue Violet Medium Dark",
      "hex": "#6b67bd",
      "rgb": [
        107,
        103,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45261",
      "brandId": "sullivans",
      "reference": "45261",
      "name": "Nile Green Medium",
      "hex": "#6bb874",
      "rgb": [
        107,
        184,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45086",
      "brandId": "sullivans",
      "reference": "45086",
      "name": "Mahogany Dark",
      "hex": "#6c160b",
      "rgb": [
        108,
        22,
        11
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45163",
      "brandId": "sullivans",
      "reference": "45163",
      "name": "Chartreuse",
      "hex": "#6da73d",
      "rgb": [
        109,
        167,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45312",
      "brandId": "sullivans",
      "reference": "45312",
      "name": "Aquamarine Light",
      "hex": "#6eb49a",
      "rgb": [
        110,
        180,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45313",
      "brandId": "sullivans",
      "reference": "45313",
      "name": "Aquamarine Very Light",
      "hex": "#6eb49a",
      "rgb": [
        110,
        180,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45148",
      "brandId": "sullivans",
      "reference": "45148",
      "name": "Beige Grey Very Dark",
      "hex": "#6f634c",
      "rgb": [
        111,
        99,
        76
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45132",
      "brandId": "sullivans",
      "reference": "45132",
      "name": "Moss Green",
      "hex": "#6f7720",
      "rgb": [
        111,
        119,
        32
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45152",
      "brandId": "sullivans",
      "reference": "45152",
      "name": "Beaver Grey Dark",
      "hex": "#706a59",
      "rgb": [
        112,
        106,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45310",
      "brandId": "sullivans",
      "reference": "45310",
      "name": "Forest Green",
      "hex": "#708d52",
      "rgb": [
        112,
        141,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45332",
      "brandId": "sullivans",
      "reference": "45332",
      "name": "Green Grey Medium",
      "hex": "#72764e",
      "rgb": [
        114,
        118,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45262",
      "brandId": "sullivans",
      "reference": "45262",
      "name": "Plum Dark",
      "hex": "#730123",
      "rgb": [
        115,
        1,
        35
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45456",
      "brandId": "sullivans",
      "reference": "45456",
      "name": "Rosewood Medium",
      "hex": "#732325",
      "rgb": [
        115,
        35,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45484",
      "brandId": "sullivans",
      "reference": "45484",
      "name": "Pewter Light",
      "hex": "#737c79",
      "rgb": [
        115,
        124,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45396",
      "brandId": "sullivans",
      "reference": "45396",
      "name": "Beige Grey Ultra Dark",
      "hex": "#745740",
      "rgb": [
        116,
        87,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45205",
      "brandId": "sullivans",
      "reference": "45205",
      "name": "Cornflower Blue Light",
      "hex": "#7493c0",
      "rgb": [
        116,
        147,
        192
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45044",
      "brandId": "sullivans",
      "reference": "45044",
      "name": "Shell Pink Very Dark",
      "hex": "#751019",
      "rgb": [
        117,
        16,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45232",
      "brandId": "sullivans",
      "reference": "45232",
      "name": "Golden Olive Medium",
      "hex": "#754e1a",
      "rgb": [
        117,
        78,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45112",
      "brandId": "sullivans",
      "reference": "45112",
      "name": "Blue Green Medium",
      "hex": "#759b91",
      "rgb": [
        117,
        155,
        145
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45317",
      "brandId": "sullivans",
      "reference": "45317",
      "name": "Khaki Green Medium",
      "hex": "#766837",
      "rgb": [
        118,
        104,
        55
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45471",
      "brandId": "sullivans",
      "reference": "45471",
      "name": "Blue Violet Medium Light",
      "hex": "#7687c2",
      "rgb": [
        118,
        135,
        194
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45214",
      "brandId": "sullivans",
      "reference": "45214",
      "name": "Delft Blue",
      "hex": "#769ad1",
      "rgb": [
        118,
        154,
        209
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45095",
      "brandId": "sullivans",
      "reference": "45095",
      "name": "Brown Light",
      "hex": "#772c17",
      "rgb": [
        119,
        44,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45433",
      "brandId": "sullivans",
      "reference": "45433",
      "name": "Grape Medium",
      "hex": "#773e6e",
      "rgb": [
        119,
        62,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45238",
      "brandId": "sullivans",
      "reference": "45238",
      "name": "Beige Brown Medium",
      "hex": "#785347",
      "rgb": [
        120,
        83,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45350",
      "brandId": "sullivans",
      "reference": "45350",
      "name": "Pine Green",
      "hex": "#787f4e",
      "rgb": [
        120,
        127,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45378",
      "brandId": "sullivans",
      "reference": "45378",
      "name": "Baby Blue",
      "hex": "#78a4d3",
      "rgb": [
        120,
        164,
        211
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45460",
      "brandId": "sullivans",
      "reference": "45460",
      "name": "Mocha Beige Dark",
      "hex": "#7a4931",
      "rgb": [
        122,
        73,
        49
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45116",
      "brandId": "sullivans",
      "reference": "45116",
      "name": "Sky Blue",
      "hex": "#7aadce",
      "rgb": [
        122,
        173,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45390",
      "brandId": "sullivans",
      "reference": "45390",
      "name": "Terra Cotta Very Dark",
      "hex": "#7b0913",
      "rgb": [
        123,
        9,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45275",
      "brandId": "sullivans",
      "reference": "45275",
      "name": "Antique Blue Light",
      "hex": "#7b92aa",
      "rgb": [
        123,
        146,
        170
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45492",
      "brandId": "sullivans",
      "reference": "45492",
      "name": "Raspberry Very Dark",
      "hex": "#7d041a",
      "rgb": [
        125,
        4,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45101",
      "brandId": "sullivans",
      "reference": "45101",
      "name": "Shell Grey Dark",
      "hex": "#7d6160",
      "rgb": [
        125,
        97,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45320",
      "brandId": "sullivans",
      "reference": "45320",
      "name": "Brown Grey Medium",
      "hex": "#7d7c61",
      "rgb": [
        125,
        124,
        97
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45164",
      "brandId": "sullivans",
      "reference": "45164",
      "name": "Chartreuse Bright",
      "hex": "#7dac36",
      "rgb": [
        125,
        172,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45383",
      "brandId": "sullivans",
      "reference": "45383",
      "name": "Peacock Blue Light",
      "hex": "#7ec2d4",
      "rgb": [
        126,
        194,
        212
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45264",
      "brandId": "sullivans",
      "reference": "45264",
      "name": "Red Copper Dark",
      "hex": "#7f1714",
      "rgb": [
        127,
        23,
        20
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45041",
      "brandId": "sullivans",
      "reference": "45041",
      "name": "Lavender Dark",
      "hex": "#7f5eac",
      "rgb": [
        127,
        94,
        172
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45106",
      "brandId": "sullivans",
      "reference": "45106",
      "name": "Avocado Green Very Light",
      "hex": "#7f803d",
      "rgb": [
        127,
        128,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45400",
      "brandId": "sullivans",
      "reference": "45400",
      "name": "Mauve Medium Dark",
      "hex": "#801639",
      "rgb": [
        128,
        22,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45081",
      "brandId": "sullivans",
      "reference": "45081",
      "name": "Pistachio Green Light",
      "hex": "#809e6b",
      "rgb": [
        128,
        158,
        107
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45129",
      "brandId": "sullivans",
      "reference": "45129",
      "name": "Jade Light",
      "hex": "#83ba97",
      "rgb": [
        131,
        186,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45092",
      "brandId": "sullivans",
      "reference": "45092",
      "name": "Hazel Nut Brown Dark",
      "hex": "#844728",
      "rgb": [
        132,
        71,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45324",
      "brandId": "sullivans",
      "reference": "45324",
      "name": "Mocha Brown Medium",
      "hex": "#847056",
      "rgb": [
        132,
        112,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45118",
      "brandId": "sullivans",
      "reference": "45118",
      "name": "Fern Green",
      "hex": "#848c70",
      "rgb": [
        132,
        140,
        112
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45482",
      "brandId": "sullivans",
      "reference": "45482",
      "name": "Yellow Beige Very Dark",
      "hex": "#854e2f",
      "rgb": [
        133,
        78,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45078",
      "brandId": "sullivans",
      "reference": "45078",
      "name": "Terra Cotta Dark",
      "hex": "#861417",
      "rgb": [
        134,
        20,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45198",
      "brandId": "sullivans",
      "reference": "45198",
      "name": "Topaz Ultra Very Dark",
      "hex": "#862f15",
      "rgb": [
        134,
        47,
        21
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45149",
      "brandId": "sullivans",
      "reference": "45149",
      "name": "Beige Grey Dark",
      "hex": "#897b63",
      "rgb": [
        137,
        123,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45289",
      "brandId": "sullivans",
      "reference": "45289",
      "name": "Nile Green",
      "hex": "#89d38f",
      "rgb": [
        137,
        211,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45365",
      "brandId": "sullivans",
      "reference": "45365",
      "name": "Shell Pink Dark",
      "hex": "#8a202a",
      "rgb": [
        138,
        32,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45134",
      "brandId": "sullivans",
      "reference": "45134",
      "name": "Turquoise Light",
      "hex": "#8ac1c8",
      "rgb": [
        138,
        193,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45265",
      "brandId": "sullivans",
      "reference": "45265",
      "name": "Red Copper",
      "hex": "#8b120e",
      "rgb": [
        139,
        18,
        14
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45083",
      "brandId": "sullivans",
      "reference": "45083",
      "name": "Mustard Medium",
      "hex": "#8b7245",
      "rgb": [
        139,
        114,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45367",
      "brandId": "sullivans",
      "reference": "45367",
      "name": "Antique Mauve Dark",
      "hex": "#8c3c4e",
      "rgb": [
        140,
        60,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45386",
      "brandId": "sullivans",
      "reference": "45386",
      "name": "Desert Sand Very Dark",
      "hex": "#8c433f",
      "rgb": [
        140,
        67,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45059",
      "brandId": "sullivans",
      "reference": "45059",
      "name": "Steel Grey Light",
      "hex": "#8c8c9e",
      "rgb": [
        140,
        140,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45071",
      "brandId": "sullivans",
      "reference": "45071",
      "name": "Blue Violet Light",
      "hex": "#8c9fce",
      "rgb": [
        140,
        159,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45233",
      "brandId": "sullivans",
      "reference": "45233",
      "name": "Golden Olive",
      "hex": "#8e5d21",
      "rgb": [
        142,
        93,
        33
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45333",
      "brandId": "sullivans",
      "reference": "45333",
      "name": "Green Grey",
      "hex": "#8e9664",
      "rgb": [
        142,
        150,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45218",
      "brandId": "sullivans",
      "reference": "45218",
      "name": "Garnet",
      "hex": "#8f0018",
      "rgb": [
        143,
        0,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45108",
      "brandId": "sullivans",
      "reference": "45108",
      "name": "Christmas Red Dark",
      "hex": "#8f011a",
      "rgb": [
        143,
        1,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45461",
      "brandId": "sullivans",
      "reference": "45461",
      "name": "Mocha Beige Medium",
      "hex": "#905f45",
      "rgb": [
        144,
        95,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45459",
      "brandId": "sullivans",
      "reference": "45459",
      "name": "Cocoa Light",
      "hex": "#906873",
      "rgb": [
        144,
        104,
        115
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45084",
      "brandId": "sullivans",
      "reference": "45084",
      "name": "Mustard",
      "hex": "#917541",
      "rgb": [
        145,
        117,
        65
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45153",
      "brandId": "sullivans",
      "reference": "45153",
      "name": "Beaver Grey Medium",
      "hex": "#91937b",
      "rgb": [
        145,
        147,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45414",
      "brandId": "sullivans",
      "reference": "45414",
      "name": "Celadon Green Light",
      "hex": "#91b5a6",
      "rgb": [
        145,
        181,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45337",
      "brandId": "sullivans",
      "reference": "45337",
      "name": "Baby Blue Light",
      "hex": "#91bde0",
      "rgb": [
        145,
        189,
        224
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45271",
      "brandId": "sullivans",
      "reference": "45271",
      "name": "Grey Green Light",
      "hex": "#93a69e",
      "rgb": [
        147,
        166,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45256",
      "brandId": "sullivans",
      "reference": "45256",
      "name": "Parrot Green Light",
      "hex": "#93b130",
      "rgb": [
        147,
        177,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45210",
      "brandId": "sullivans",
      "reference": "45210",
      "name": "Delft Blue Pale",
      "hex": "#93b9de",
      "rgb": [
        147,
        185,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45119",
      "brandId": "sullivans",
      "reference": "45119",
      "name": "Fern Green Light",
      "hex": "#959a7b",
      "rgb": [
        149,
        154,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45298",
      "brandId": "sullivans",
      "reference": "45298",
      "name": "Sea Green Light",
      "hex": "#96e5d7",
      "rgb": [
        150,
        229,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45426",
      "brandId": "sullivans",
      "reference": "45426",
      "name": "Old Gold Very Dark",
      "hex": "#974f24",
      "rgb": [
        151,
        79,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45327",
      "brandId": "sullivans",
      "reference": "45327",
      "name": "Antique Violet Light",
      "hex": "#97859c",
      "rgb": [
        151,
        133,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45438",
      "brandId": "sullivans",
      "reference": "45438",
      "name": "Lavender Blue Light",
      "hex": "#97b9e4",
      "rgb": [
        151,
        185,
        228
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45177",
      "brandId": "sullivans",
      "reference": "45177",
      "name": "Olive Green Medium",
      "hex": "#987b2a",
      "rgb": [
        152,
        123,
        42
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45472",
      "brandId": "sullivans",
      "reference": "45472",
      "name": "Cornflower Blue Very Light",
      "hex": "#98b3d9",
      "rgb": [
        152,
        179,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45321",
      "brandId": "sullivans",
      "reference": "45321",
      "name": "Brown Grey Light",
      "hex": "#9a937d",
      "rgb": [
        154,
        147,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45228",
      "brandId": "sullivans",
      "reference": "45228",
      "name": "Blue Very Light",
      "hex": "#9ac3e2",
      "rgb": [
        154,
        195,
        226
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45299",
      "brandId": "sullivans",
      "reference": "45299",
      "name": "Baby Green Medium",
      "hex": "#9bc79e",
      "rgb": [
        155,
        199,
        158
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45366",
      "brandId": "sullivans",
      "reference": "45366",
      "name": "Shell Pink Medium",
      "hex": "#9d333f",
      "rgb": [
        157,
        51,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45239",
      "brandId": "sullivans",
      "reference": "45239",
      "name": "Beige Brown Light",
      "hex": "#9d766a",
      "rgb": [
        157,
        118,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45328",
      "brandId": "sullivans",
      "reference": "45328",
      "name": "Yellow Beige Dark",
      "hex": "#9e6843",
      "rgb": [
        158,
        104,
        67
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45474",
      "brandId": "sullivans",
      "reference": "45474",
      "name": "Grey Blue Light",
      "hex": "#9ea3c8",
      "rgb": [
        158,
        163,
        200
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45376",
      "brandId": "sullivans",
      "reference": "45376",
      "name": "Antique Blue Very Light",
      "hex": "#9eb7cc",
      "rgb": [
        158,
        183,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45166",
      "brandId": "sullivans",
      "reference": "45166",
      "name": "Plum",
      "hex": "#9f0747",
      "rgb": [
        159,
        7,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45423",
      "brandId": "sullivans",
      "reference": "45423",
      "name": "Golden Brown",
      "hex": "#9f361e",
      "rgb": [
        159,
        54,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45199",
      "brandId": "sullivans",
      "reference": "45199",
      "name": "Topaz Very Dark",
      "hex": "#9f4d17",
      "rgb": [
        159,
        77,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45200",
      "brandId": "sullivans",
      "reference": "45200",
      "name": "Topaz Dark",
      "hex": "#9f4d17",
      "rgb": [
        159,
        77,
        23
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45158",
      "brandId": "sullivans",
      "reference": "45158",
      "name": "Old Gold Dark",
      "hex": "#9f5d2f",
      "rgb": [
        159,
        93,
        47
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45465",
      "brandId": "sullivans",
      "reference": "45465",
      "name": "Dusty Rose Ultra Very Dark",
      "hex": "#a00a28",
      "rgb": [
        160,
        10,
        40
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45425",
      "brandId": "sullivans",
      "reference": "45425",
      "name": "Hazel Nut Brown",
      "hex": "#a06a42",
      "rgb": [
        160,
        106,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45049",
      "brandId": "sullivans",
      "reference": "45049",
      "name": "Mahogany Medium",
      "hex": "#a1381d",
      "rgb": [
        161,
        56,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45096",
      "brandId": "sullivans",
      "reference": "45096",
      "name": "Brown Very Light",
      "hex": "#a25030",
      "rgb": [
        162,
        80,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45410",
      "brandId": "sullivans",
      "reference": "45410",
      "name": "Blue Green Light",
      "hex": "#a2beb3",
      "rgb": [
        162,
        190,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45045",
      "brandId": "sullivans",
      "reference": "45045",
      "name": "Shell Pink Light",
      "hex": "#a34256",
      "rgb": [
        163,
        66,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45130",
      "brandId": "sullivans",
      "reference": "45130",
      "name": "Jade Very Light",
      "hex": "#a3d4a8",
      "rgb": [
        163,
        212,
        168
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45318",
      "brandId": "sullivans",
      "reference": "45318",
      "name": "Khaki Green Light",
      "hex": "#a49865",
      "rgb": [
        164,
        152,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45381",
      "brandId": "sullivans",
      "reference": "45381",
      "name": "Sky Blue Light",
      "hex": "#a4dbe8",
      "rgb": [
        164,
        219,
        232
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45427",
      "brandId": "sullivans",
      "reference": "45427",
      "name": "Terra Cotta",
      "hex": "#a52929",
      "rgb": [
        165,
        41,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45479",
      "brandId": "sullivans",
      "reference": "45479",
      "name": "Forest Green Light",
      "hex": "#a5c98f",
      "rgb": [
        165,
        201,
        143
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45346",
      "brandId": "sullivans",
      "reference": "45346",
      "name": "Dusty Rose Ultra Dark",
      "hex": "#a6173d",
      "rgb": [
        166,
        23,
        61
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45102",
      "brandId": "sullivans",
      "reference": "45102",
      "name": "Shell Grey Medium",
      "hex": "#a68c8c",
      "rgb": [
        166,
        140,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45085",
      "brandId": "sullivans",
      "reference": "45085",
      "name": "Mustard Light",
      "hex": "#a69267",
      "rgb": [
        166,
        146,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45263",
      "brandId": "sullivans",
      "reference": "45263",
      "name": "Plum Medium",
      "hex": "#a71152",
      "rgb": [
        167,
        17,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45434",
      "brandId": "sullivans",
      "reference": "45434",
      "name": "Grape Light",
      "hex": "#a76e9c",
      "rgb": [
        167,
        110,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45145",
      "brandId": "sullivans",
      "reference": "45145",
      "name": "Drab Brown Light",
      "hex": "#a7875b",
      "rgb": [
        167,
        135,
        91
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45266",
      "brandId": "sullivans",
      "reference": "45266",
      "name": "Copper Medium",
      "hex": "#a8231a",
      "rgb": [
        168,
        35,
        26
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45408",
      "brandId": "sullivans",
      "reference": "45408",
      "name": "Turquoise Very Light",
      "hex": "#a8dade",
      "rgb": [
        168,
        218,
        222
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45234",
      "brandId": "sullivans",
      "reference": "45234",
      "name": "Golden Olive Light",
      "hex": "#a97736",
      "rgb": [
        169,
        119,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45042",
      "brandId": "sullivans",
      "reference": "45042",
      "name": "Lavender Medium",
      "hex": "#ac8fd7",
      "rgb": [
        172,
        143,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45120",
      "brandId": "sullivans",
      "reference": "45120",
      "name": "Fern Green Very Light",
      "hex": "#acaf8d",
      "rgb": [
        172,
        175,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45356",
      "brandId": "sullivans",
      "reference": "45356",
      "name": "Mauve",
      "hex": "#ad345f",
      "rgb": [
        173,
        52,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45079",
      "brandId": "sullivans",
      "reference": "45079",
      "name": "Terra Cotta Medium",
      "hex": "#ae3d3c",
      "rgb": [
        174,
        61,
        60
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45154",
      "brandId": "sullivans",
      "reference": "45154",
      "name": "Beaver Grey Light",
      "hex": "#aea696",
      "rgb": [
        174,
        166,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45481",
      "brandId": "sullivans",
      "reference": "45481",
      "name": "Moss Green Medium Light",
      "hex": "#aeab22",
      "rgb": [
        174,
        171,
        34
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45064",
      "brandId": "sullivans",
      "reference": "45064",
      "name": "Rose Very Deep",
      "hex": "#af0126",
      "rgb": [
        175,
        1,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45091",
      "brandId": "sullivans",
      "reference": "45091",
      "name": "Pearl Grey",
      "hex": "#afb3bb",
      "rgb": [
        175,
        179,
        187
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45394",
      "brandId": "sullivans",
      "reference": "45394",
      "name": "Mocha Brown Light",
      "hex": "#b09680",
      "rgb": [
        176,
        150,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45050",
      "brandId": "sullivans",
      "reference": "45050",
      "name": "Christmas Red Medium",
      "hex": "#b20125",
      "rgb": [
        178,
        1,
        37
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45113",
      "brandId": "sullivans",
      "reference": "45113",
      "name": "Blue Green Very Light",
      "hex": "#b2d4bd",
      "rgb": [
        178,
        212,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45290",
      "brandId": "sullivans",
      "reference": "45290",
      "name": "Nile Green Light",
      "hex": "#b2eeb5",
      "rgb": [
        178,
        238,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45052",
      "brandId": "sullivans",
      "reference": "45052",
      "name": "Rose Deep",
      "hex": "#b30e2c",
      "rgb": [
        179,
        14,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45088",
      "brandId": "sullivans",
      "reference": "45088",
      "name": "Clay Brown (3773)",
      "hex": "#b36862",
      "rgb": [
        179,
        104,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45387",
      "brandId": "sullivans",
      "reference": "45387",
      "name": "Desert Sand Medium",
      "hex": "#b36862",
      "rgb": [
        179,
        104,
        98
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45097",
      "brandId": "sullivans",
      "reference": "45097",
      "name": "Tan",
      "hex": "#b56944",
      "rgb": [
        181,
        105,
        68
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45126",
      "brandId": "sullivans",
      "reference": "45126",
      "name": "Violet Light",
      "hex": "#b581bd",
      "rgb": [
        181,
        129,
        189
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45439",
      "brandId": "sullivans",
      "reference": "45439",
      "name": "Baby Blue Pale",
      "hex": "#b5d6e5",
      "rgb": [
        181,
        214,
        229
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45345",
      "brandId": "sullivans",
      "reference": "45345",
      "name": "Yellow Green Light",
      "hex": "#b6b56d",
      "rgb": [
        182,
        181,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45457",
      "brandId": "sullivans",
      "reference": "45457",
      "name": "Rosewood Light",
      "hex": "#b75f52",
      "rgb": [
        183,
        95,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45057",
      "brandId": "sullivans",
      "reference": "45057",
      "name": "Antique Mauve Medium",
      "hex": "#b76186",
      "rgb": [
        183,
        97,
        134
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45334",
      "brandId": "sullivans",
      "reference": "45334",
      "name": "Desert Sand",
      "hex": "#b76459",
      "rgb": [
        183,
        100,
        89
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45178",
      "brandId": "sullivans",
      "reference": "45178",
      "name": "Olive Green Light",
      "hex": "#b79445",
      "rgb": [
        183,
        148,
        69
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45483",
      "brandId": "sullivans",
      "reference": "45483",
      "name": "Pewter Very Light",
      "hex": "#b7c1c3",
      "rgb": [
        183,
        193,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45229",
      "brandId": "sullivans",
      "reference": "45229",
      "name": "Blue Ultra Very Light",
      "hex": "#b9dde5",
      "rgb": [
        185,
        221,
        229
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45082",
      "brandId": "sullivans",
      "reference": "45082",
      "name": "Pistachio Green Very Light",
      "hex": "#bcd1a1",
      "rgb": [
        188,
        209,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45173",
      "brandId": "sullivans",
      "reference": "45173",
      "name": "Old Gold Medium",
      "hex": "#bd7236",
      "rgb": [
        189,
        114,
        54
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45107",
      "brandId": "sullivans",
      "reference": "45107",
      "name": "Avocado Green Ultra Light",
      "hex": "#bdb360",
      "rgb": [
        189,
        179,
        96
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45240",
      "brandId": "sullivans",
      "reference": "45240",
      "name": "Beige Brown Very Light",
      "hex": "#be988c",
      "rgb": [
        190,
        152,
        140
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45372",
      "brandId": "sullivans",
      "reference": "45372",
      "name": "Antique Violet Very Light",
      "hex": "#beb0c6",
      "rgb": [
        190,
        176,
        198
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45477",
      "brandId": "sullivans",
      "reference": "45477",
      "name": "Blue Ultra Very Light",
      "hex": "#bee0eb",
      "rgb": [
        190,
        224,
        235
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45219",
      "brandId": "sullivans",
      "reference": "45219",
      "name": "Coral Red Very Dark",
      "hex": "#bf0013",
      "rgb": [
        191,
        0,
        19
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45429",
      "brandId": "sullivans",
      "reference": "45429",
      "name": "Raspberry Dark",
      "hex": "#bf162c",
      "rgb": [
        191,
        22,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45135",
      "brandId": "sullivans",
      "reference": "45135",
      "name": "Cranberry Very Dark",
      "hex": "#c0043e",
      "rgb": [
        192,
        4,
        62
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45093",
      "brandId": "sullivans",
      "reference": "45093",
      "name": "Hazel Nut Brown Light",
      "hex": "#c08d65",
      "rgb": [
        192,
        141,
        101
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45462",
      "brandId": "sullivans",
      "reference": "45462",
      "name": "Mocha Beige Light",
      "hex": "#c1957b",
      "rgb": [
        193,
        149,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45352",
      "brandId": "sullivans",
      "reference": "45352",
      "name": "Plum Light",
      "hex": "#c22872",
      "rgb": [
        194,
        40,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45374",
      "brandId": "sullivans",
      "reference": "45374",
      "name": "Blue Violet Very Light",
      "hex": "#c4cce3",
      "rgb": [
        196,
        204,
        227
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45272",
      "brandId": "sullivans",
      "reference": "45272",
      "name": "Grey Green Very Light",
      "hex": "#c4cfc9",
      "rgb": [
        196,
        207,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45377",
      "brandId": "sullivans",
      "reference": "45377",
      "name": "Antique Blue Ultra Light",
      "hex": "#c4d8e4",
      "rgb": [
        196,
        216,
        228
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45073",
      "brandId": "sullivans",
      "reference": "45073",
      "name": "Coral Dark",
      "hex": "#c50018",
      "rgb": [
        197,
        0,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45062",
      "brandId": "sullivans",
      "reference": "45062",
      "name": "Christmas Red",
      "hex": "#c60018",
      "rgb": [
        198,
        0,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45450",
      "brandId": "sullivans",
      "reference": "45450",
      "name": "Straw Very Dark",
      "hex": "#c7671f",
      "rgb": [
        199,
        103,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45150",
      "brandId": "sullivans",
      "reference": "45150",
      "name": "Beige Grey Medium",
      "hex": "#c8bd9f",
      "rgb": [
        200,
        189,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45188",
      "brandId": "sullivans",
      "reference": "45188",
      "name": "Sky Blue Very Light",
      "hex": "#c8eff1",
      "rgb": [
        200,
        239,
        241
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45391",
      "brandId": "sullivans",
      "reference": "45391",
      "name": "Terra Cotta Light",
      "hex": "#c95551",
      "rgb": [
        201,
        85,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45201",
      "brandId": "sullivans",
      "reference": "45201",
      "name": "Topaz Medium",
      "hex": "#c96126",
      "rgb": [
        201,
        97,
        38
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45235",
      "brandId": "sullivans",
      "reference": "45235",
      "name": "Golden Olive Very Light",
      "hex": "#c99852",
      "rgb": [
        201,
        152,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45072",
      "brandId": "sullivans",
      "reference": "45072",
      "name": "Salmon Very Dark",
      "hex": "#ca1e29",
      "rgb": [
        202,
        30,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45305",
      "brandId": "sullivans",
      "reference": "45305",
      "name": "Golden Brown Medium",
      "hex": "#ca542d",
      "rgb": [
        202,
        84,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45357",
      "brandId": "sullivans",
      "reference": "45357",
      "name": "Mauve Medium",
      "hex": "#ca5884",
      "rgb": [
        202,
        88,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45195",
      "brandId": "sullivans",
      "reference": "45195",
      "name": "Baby Blue Very Light",
      "hex": "#cae2e8",
      "rgb": [
        202,
        226,
        232
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45368",
      "brandId": "sullivans",
      "reference": "45368",
      "name": "Antique Mauve Light",
      "hex": "#cb829d",
      "rgb": [
        203,
        130,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45251",
      "brandId": "sullivans",
      "reference": "45251",
      "name": "Burnt Orange Dark",
      "hex": "#cc0d18",
      "rgb": [
        204,
        13,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45389",
      "brandId": "sullivans",
      "reference": "45389",
      "name": "Mahogany Light",
      "hex": "#cc5030",
      "rgb": [
        204,
        80,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45329",
      "brandId": "sullivans",
      "reference": "45329",
      "name": "Yellow Beige Medium",
      "hex": "#cca46c",
      "rgb": [
        204,
        164,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45103",
      "brandId": "sullivans",
      "reference": "45103",
      "name": "Shell Grey Light",
      "hex": "#ccbab2",
      "rgb": [
        204,
        186,
        178
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45267",
      "brandId": "sullivans",
      "reference": "45267",
      "name": "Copper",
      "hex": "#cd3624",
      "rgb": [
        205,
        54,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45043",
      "brandId": "sullivans",
      "reference": "45043",
      "name": "Lavender Light",
      "hex": "#cdb8ea",
      "rgb": [
        205,
        184,
        234
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45467",
      "brandId": "sullivans",
      "reference": "45467",
      "name": "Shell Pink Medium Light",
      "hex": "#ce7885",
      "rgb": [
        206,
        120,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45322",
      "brandId": "sullivans",
      "reference": "45322",
      "name": "Brown Grey Very Light",
      "hex": "#cecebe",
      "rgb": [
        206,
        206,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45369",
      "brandId": "sullivans",
      "reference": "45369",
      "name": "Dusty Rose Very Dark",
      "hex": "#cf305d",
      "rgb": [
        207,
        48,
        93
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45401",
      "brandId": "sullivans",
      "reference": "45401",
      "name": "Cyclamen Pink Dark",
      "hex": "#d2165a",
      "rgb": [
        210,
        22,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45136",
      "brandId": "sullivans",
      "reference": "45136",
      "name": "Cranberry Dark",
      "hex": "#d30d4e",
      "rgb": [
        211,
        13,
        78
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45339",
      "brandId": "sullivans",
      "reference": "45339",
      "name": "Salmon Dark",
      "hex": "#d4363f",
      "rgb": [
        212,
        54,
        63
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45335",
      "brandId": "sullivans",
      "reference": "45335",
      "name": "Beaver Grey Very Light",
      "hex": "#d4d7c9",
      "rgb": [
        212,
        215,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45468",
      "brandId": "sullivans",
      "reference": "45468",
      "name": "Violet Very Light",
      "hex": "#d6aada",
      "rgb": [
        214,
        170,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45416",
      "brandId": "sullivans",
      "reference": "45416",
      "name": "Moss Green Light",
      "hex": "#d6d452",
      "rgb": [
        214,
        212,
        82
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45197",
      "brandId": "sullivans",
      "reference": "45197",
      "name": "Antique Mauve Very Light",
      "hex": "#d993a1",
      "rgb": [
        217,
        147,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45098",
      "brandId": "sullivans",
      "reference": "45098",
      "name": "Tan Light",
      "hex": "#da916a",
      "rgb": [
        218,
        145,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45325",
      "brandId": "sullivans",
      "reference": "45325",
      "name": "Mocha Brown Very Light",
      "hex": "#dac1af",
      "rgb": [
        218,
        193,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45146",
      "brandId": "sullivans",
      "reference": "45146",
      "name": "Drab Brown Very Light",
      "hex": "#dac9a6",
      "rgb": [
        218,
        201,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45417",
      "brandId": "sullivans",
      "reference": "45417",
      "name": "Straw Dark",
      "hex": "#db8b35",
      "rgb": [
        219,
        139,
        53
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45402",
      "brandId": "sullivans",
      "reference": "45402",
      "name": "Cyclamen Pink",
      "hex": "#dc276c",
      "rgb": [
        220,
        39,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45167",
      "brandId": "sullivans",
      "reference": "45167",
      "name": "Orange Spice Dark",
      "hex": "#dd2619",
      "rgb": [
        221,
        38,
        25
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45430",
      "brandId": "sullivans",
      "reference": "45430",
      "name": "Raspberry Medium",
      "hex": "#dd264a",
      "rgb": [
        221,
        38,
        74
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45179",
      "brandId": "sullivans",
      "reference": "45179",
      "name": "Tan Very Light",
      "hex": "#dfac7b",
      "rgb": [
        223,
        172,
        123
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45194",
      "brandId": "sullivans",
      "reference": "45194",
      "name": "Yellow Green Very Light",
      "hex": "#dfe9af",
      "rgb": [
        223,
        233,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45068",
      "brandId": "sullivans",
      "reference": "45068",
      "name": "Rose",
      "hex": "#e0315c",
      "rgb": [
        224,
        49,
        92
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45370",
      "brandId": "sullivans",
      "reference": "45370",
      "name": "Dusty Rose",
      "hex": "#e05c83",
      "rgb": [
        224,
        92,
        131
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45480",
      "brandId": "sullivans",
      "reference": "45480",
      "name": "Moss Green Very Light",
      "hex": "#e0d66d",
      "rgb": [
        224,
        214,
        109
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45074",
      "brandId": "sullivans",
      "reference": "45074",
      "name": "Coral Medium",
      "hex": "#e2251e",
      "rgb": [
        226,
        37,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45156",
      "brandId": "sullivans",
      "reference": "45156",
      "name": "Old Gold Light",
      "hex": "#e39f64",
      "rgb": [
        227,
        159,
        100
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45137",
      "brandId": "sullivans",
      "reference": "45137",
      "name": "Cranberry Medium",
      "hex": "#e4276a",
      "rgb": [
        228,
        39,
        106
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45295",
      "brandId": "sullivans",
      "reference": "45295",
      "name": "Dusty Rose Dark",
      "hex": "#e43f6e",
      "rgb": [
        228,
        63,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45046",
      "brandId": "sullivans",
      "reference": "45046",
      "name": "Shell Pink Very Light",
      "hex": "#e4989a",
      "rgb": [
        228,
        152,
        154
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45122",
      "brandId": "sullivans",
      "reference": "45122",
      "name": "Beige Brown Ultra Very Light",
      "hex": "#e5c5af",
      "rgb": [
        229,
        197,
        175
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45193",
      "brandId": "sullivans",
      "reference": "45193",
      "name": "Pearl Grey Very Light",
      "hex": "#e5e7e6",
      "rgb": [
        229,
        231,
        230
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45431",
      "brandId": "sullivans",
      "reference": "45431",
      "name": "Raspberry Light",
      "hex": "#e64a6e",
      "rgb": [
        230,
        74,
        110
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45362",
      "brandId": "sullivans",
      "reference": "45362",
      "name": "Salmon Medium",
      "hex": "#e64f5a",
      "rgb": [
        230,
        79,
        90
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45190",
      "brandId": "sullivans",
      "reference": "45190",
      "name": "Terra Cotta Very Light",
      "hex": "#e6887e",
      "rgb": [
        230,
        136,
        126
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45418",
      "brandId": "sullivans",
      "reference": "45418",
      "name": "Straw",
      "hex": "#e6a047",
      "rgb": [
        230,
        160,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45223",
      "brandId": "sullivans",
      "reference": "45223",
      "name": "Beige Grey Light",
      "hex": "#e6d9be",
      "rgb": [
        230,
        217,
        190
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45268",
      "brandId": "sullivans",
      "reference": "45268",
      "name": "Copper Light",
      "hex": "#e75339",
      "rgb": [
        231,
        83,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45353",
      "brandId": "sullivans",
      "reference": "45353",
      "name": "Plum Very Light",
      "hex": "#e773ae",
      "rgb": [
        231,
        115,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45330",
      "brandId": "sullivans",
      "reference": "45330",
      "name": "Yellow Beige Light",
      "hex": "#e7d19c",
      "rgb": [
        231,
        209,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45347",
      "brandId": "sullivans",
      "reference": "45347",
      "name": "Dusty Rose Light",
      "hex": "#e980a0",
      "rgb": [
        233,
        128,
        160
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45287",
      "brandId": "sullivans",
      "reference": "45287",
      "name": "Desert Sand Light",
      "hex": "#e9bca4",
      "rgb": [
        233,
        188,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45155",
      "brandId": "sullivans",
      "reference": "45155",
      "name": "Christmas Red Bright",
      "hex": "#ea0012",
      "rgb": [
        234,
        0,
        18
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45250",
      "brandId": "sullivans",
      "reference": "45250",
      "name": "Rose Medium",
      "hex": "#ea4d79",
      "rgb": [
        234,
        77,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45451",
      "brandId": "sullivans",
      "reference": "45451",
      "name": "Autumn Gold Dark",
      "hex": "#ea572c",
      "rgb": [
        234,
        87,
        44
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45306",
      "brandId": "sullivans",
      "reference": "45306",
      "name": "Golden Brown Light",
      "hex": "#ea7e51",
      "rgb": [
        234,
        126,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45296",
      "brandId": "sullivans",
      "reference": "45296",
      "name": "Dusty Rose Medium",
      "hex": "#eb6182",
      "rgb": [
        235,
        97,
        130
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45075",
      "brandId": "sullivans",
      "reference": "45075",
      "name": "Coral",
      "hex": "#ec3c2d",
      "rgb": [
        236,
        60,
        45
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45496",
      "brandId": "sullivans",
      "reference": "45496",
      "name": "Terra Cotta Ultra Very Light",
      "hex": "#ec9774",
      "rgb": [
        236,
        151,
        116
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45464",
      "brandId": "sullivans",
      "reference": "45464",
      "name": "Mocha Brown Ultra Light",
      "hex": "#ece3d9",
      "rgb": [
        236,
        227,
        217
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45424",
      "brandId": "sullivans",
      "reference": "45424",
      "name": "Golden Brown Pale",
      "hex": "#ed9163",
      "rgb": [
        237,
        145,
        99
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45283",
      "brandId": "sullivans",
      "reference": "45283",
      "name": "Tawny Medium",
      "hex": "#edc29f",
      "rgb": [
        237,
        194,
        159
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45379",
      "brandId": "sullivans",
      "reference": "45379",
      "name": "Baby Blue Ultra Light",
      "hex": "#eef1f0",
      "rgb": [
        238,
        241,
        240
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45284",
      "brandId": "sullivans",
      "reference": "45284",
      "name": "Burnt Orange Medium",
      "hex": "#ef1e1f",
      "rgb": [
        239,
        30,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45168",
      "brandId": "sullivans",
      "reference": "45168",
      "name": "Orange Spice Medium",
      "hex": "#ef4433",
      "rgb": [
        239,
        68,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45138",
      "brandId": "sullivans",
      "reference": "45138",
      "name": "Cranberry",
      "hex": "#ef5996",
      "rgb": [
        239,
        89,
        150
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45191",
      "brandId": "sullivans",
      "reference": "45191",
      "name": "Salmon",
      "hex": "#ef717d",
      "rgb": [
        239,
        113,
        125
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45087",
      "brandId": "sullivans",
      "reference": "45087",
      "name": "Mahogany Very Light",
      "hex": "#ef7a5f",
      "rgb": [
        239,
        122,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45491",
      "brandId": "sullivans",
      "reference": "45491",
      "name": "Golden Yellow",
      "hex": "#ef9a39",
      "rgb": [
        239,
        154,
        57
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45157",
      "brandId": "sullivans",
      "reference": "45157",
      "name": "Old Gold Very Light",
      "hex": "#efd39d",
      "rgb": [
        239,
        211,
        157
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45388",
      "brandId": "sullivans",
      "reference": "45388",
      "name": "Desert Sand Very Light",
      "hex": "#f0c5b7",
      "rgb": [
        240,
        197,
        183
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45403",
      "brandId": "sullivans",
      "reference": "45403",
      "name": "Cyclamen Pink Light",
      "hex": "#f168a2",
      "rgb": [
        241,
        104,
        162
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45392",
      "brandId": "sullivans",
      "reference": "45392",
      "name": "Terra Cotta Ultra Light",
      "hex": "#f1a39c",
      "rgb": [
        241,
        163,
        156
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45189",
      "brandId": "sullivans",
      "reference": "45189",
      "name": "Peach Light",
      "hex": "#f1a98d",
      "rgb": [
        241,
        169,
        141
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45454",
      "brandId": "sullivans",
      "reference": "45454",
      "name": "Mahogany Ultra Very Light",
      "hex": "#f1b285",
      "rgb": [
        241,
        178,
        133
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45398",
      "brandId": "sullivans",
      "reference": "45398",
      "name": "Christmas Red Light",
      "hex": "#f2122b",
      "rgb": [
        242,
        18,
        43
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45139",
      "brandId": "sullivans",
      "reference": "45139",
      "name": "Cranberry Light",
      "hex": "#f280b5",
      "rgb": [
        242,
        128,
        181
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45452",
      "brandId": "sullivans",
      "reference": "45452",
      "name": "Autumn Gold Medium",
      "hex": "#f28b56",
      "rgb": [
        242,
        139,
        86
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45354",
      "brandId": "sullivans",
      "reference": "45354",
      "name": "Plum Ultra Light",
      "hex": "#f29cd5",
      "rgb": [
        242,
        156,
        213
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45419",
      "brandId": "sullivans",
      "reference": "45419",
      "name": "Straw Light",
      "hex": "#f2c56c",
      "rgb": [
        242,
        197,
        108
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45288",
      "brandId": "sullivans",
      "reference": "45288",
      "name": "Tawny Light",
      "hex": "#f2d4b4",
      "rgb": [
        242,
        212,
        180
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45180",
      "brandId": "sullivans",
      "reference": "45180",
      "name": "Tan Ultra Very Light",
      "hex": "#f2dbae",
      "rgb": [
        242,
        219,
        174
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45000",
      "brandId": "sullivans",
      "reference": "45000",
      "name": "Ecru",
      "hex": "#f2e7c9",
      "rgb": [
        242,
        231,
        201
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45244",
      "brandId": "sullivans",
      "reference": "45244",
      "name": "Carnation Dark",
      "hex": "#f31048",
      "rgb": [
        243,
        16,
        72
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45047",
      "brandId": "sullivans",
      "reference": "45047",
      "name": "Shell Pink Ultra Very Light",
      "hex": "#f3cccf",
      "rgb": [
        243,
        204,
        207
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45141",
      "brandId": "sullivans",
      "reference": "45141",
      "name": "Burnt Orange-Red",
      "hex": "#f40118",
      "rgb": [
        244,
        1,
        24
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45246",
      "brandId": "sullivans",
      "reference": "45246",
      "name": "Carnation Light",
      "hex": "#f43767",
      "rgb": [
        244,
        55,
        103
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45169",
      "brandId": "sullivans",
      "reference": "45169",
      "name": "Orange Spice Light",
      "hex": "#f47054",
      "rgb": [
        244,
        112,
        84
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45076",
      "brandId": "sullivans",
      "reference": "45076",
      "name": "Coral Light",
      "hex": "#f4785f",
      "rgb": [
        244,
        120,
        95
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45196",
      "brandId": "sullivans",
      "reference": "45196",
      "name": "Pink Medium",
      "hex": "#f48ca9",
      "rgb": [
        244,
        140,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45338",
      "brandId": "sullivans",
      "reference": "45338",
      "name": "Rose Light",
      "hex": "#f48ca9",
      "rgb": [
        244,
        140,
        169
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45364",
      "brandId": "sullivans",
      "reference": "45364",
      "name": "Dusty Rose Very Light",
      "hex": "#f48fb3",
      "rgb": [
        244,
        143,
        179
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45170",
      "brandId": "sullivans",
      "reference": "45170",
      "name": "Topaz",
      "hex": "#f4a142",
      "rgb": [
        244,
        161,
        66
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45466",
      "brandId": "sullivans",
      "reference": "45466",
      "name": "Dusty Rose Very Light",
      "hex": "#f4abc1",
      "rgb": [
        244,
        171,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45286",
      "brandId": "sullivans",
      "reference": "45286",
      "name": "Peach Very Light",
      "hex": "#f4d8c1",
      "rgb": [
        244,
        216,
        193
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45245",
      "brandId": "sullivans",
      "reference": "45245",
      "name": "Carnation Medium",
      "hex": "#f5244f",
      "rgb": [
        245,
        36,
        79
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45359",
      "brandId": "sullivans",
      "reference": "45359",
      "name": "Melon Dark",
      "hex": "#f52540",
      "rgb": [
        245,
        37,
        64
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45291",
      "brandId": "sullivans",
      "reference": "45291",
      "name": "Geranium",
      "hex": "#f52d72",
      "rgb": [
        245,
        45,
        114
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45181",
      "brandId": "sullivans",
      "reference": "45181",
      "name": "Tangerine",
      "hex": "#f53d1e",
      "rgb": [
        245,
        61,
        30
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45340",
      "brandId": "sullivans",
      "reference": "45340",
      "name": "Apricot Medium",
      "hex": "#f54c47",
      "rgb": [
        245,
        76,
        71
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45360",
      "brandId": "sullivans",
      "reference": "45360",
      "name": "Melon Medium",
      "hex": "#f54e80",
      "rgb": [
        245,
        78,
        128
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45247",
      "brandId": "sullivans",
      "reference": "45247",
      "name": "Carnation Very Light",
      "hex": "#f570a3",
      "rgb": [
        245,
        112,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45292",
      "brandId": "sullivans",
      "reference": "45292",
      "name": "Geranium Pale",
      "hex": "#f572ab",
      "rgb": [
        245,
        114,
        171
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45361",
      "brandId": "sullivans",
      "reference": "45361",
      "name": "Melon Light",
      "hex": "#f573a6",
      "rgb": [
        245,
        115,
        166
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45302",
      "brandId": "sullivans",
      "reference": "45302",
      "name": "Canary Deep",
      "hex": "#f58324",
      "rgb": [
        245,
        131,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45140",
      "brandId": "sullivans",
      "reference": "45140",
      "name": "Cranberry Very Light",
      "hex": "#f5a1cb",
      "rgb": [
        245,
        161,
        203
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45192",
      "brandId": "sullivans",
      "reference": "45192",
      "name": "Salmon Light",
      "hex": "#f5a5b1",
      "rgb": [
        245,
        165,
        177
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45358",
      "brandId": "sullivans",
      "reference": "45358",
      "name": "Mauve Light",
      "hex": "#f5aeca",
      "rgb": [
        245,
        174,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45165",
      "brandId": "sullivans",
      "reference": "45165",
      "name": "Cream",
      "hex": "#f5ecce",
      "rgb": [
        245,
        236,
        206
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45300",
      "brandId": "sullivans",
      "reference": "45300",
      "name": "Pumpkin Light",
      "hex": "#f64430",
      "rgb": [
        246,
        68,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45182",
      "brandId": "sullivans",
      "reference": "45182",
      "name": "Tangerine Medium",
      "hex": "#f66b24",
      "rgb": [
        246,
        107,
        36
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45183",
      "brandId": "sullivans",
      "reference": "45183",
      "name": "Tangerine Light",
      "hex": "#f68b30",
      "rgb": [
        246,
        139,
        48
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45422",
      "brandId": "sullivans",
      "reference": "45422",
      "name": "Pumpkin Pale",
      "hex": "#f69277",
      "rgb": [
        246,
        146,
        119
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45077",
      "brandId": "sullivans",
      "reference": "45077",
      "name": "Peach",
      "hex": "#f6bea3",
      "rgb": [
        246,
        190,
        163
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45453",
      "brandId": "sullivans",
      "reference": "45453",
      "name": "Autumn Gold Light",
      "hex": "#f6c084",
      "rgb": [
        246,
        192,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45363",
      "brandId": "sullivans",
      "reference": "45363",
      "name": "Salmon Very Light",
      "hex": "#f6c3cc",
      "rgb": [
        246,
        195,
        204
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45285",
      "brandId": "sullivans",
      "reference": "45285",
      "name": "Burnt Orange",
      "hex": "#f71d1d",
      "rgb": [
        247,
        29,
        29
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45341",
      "brandId": "sullivans",
      "reference": "45341",
      "name": "Apricot",
      "hex": "#f7746f",
      "rgb": [
        247,
        116,
        111
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45421",
      "brandId": "sullivans",
      "reference": "45421",
      "name": "Apricot Light",
      "hex": "#f79c97",
      "rgb": [
        247,
        156,
        151
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45184",
      "brandId": "sullivans",
      "reference": "45184",
      "name": "Yellow Medium",
      "hex": "#f7b751",
      "rgb": [
        247,
        183,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45297",
      "brandId": "sullivans",
      "reference": "45297",
      "name": "Dusty Rose Ultra Very Light",
      "hex": "#f7c3d7",
      "rgb": [
        247,
        195,
        215
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45099",
      "brandId": "sullivans",
      "reference": "45099",
      "name": "Lemon Dark",
      "hex": "#f7c91b",
      "rgb": [
        247,
        201,
        27
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45220",
      "brandId": "sullivans",
      "reference": "45220",
      "name": "Baby Pink",
      "hex": "#f7d2dc",
      "rgb": [
        247,
        210,
        220
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45303",
      "brandId": "sullivans",
      "reference": "45303",
      "name": "Canary Bright",
      "hex": "#f7d529",
      "rgb": [
        247,
        213,
        41
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45142",
      "brandId": "sullivans",
      "reference": "45142",
      "name": "Burnt Orange",
      "hex": "#f80e1f",
      "rgb": [
        248,
        14,
        31
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45495",
      "brandId": "sullivans",
      "reference": "45495",
      "name": "Apricot Very Light",
      "hex": "#f8c4c3",
      "rgb": [
        248,
        196,
        195
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45171",
      "brandId": "sullivans",
      "reference": "45171",
      "name": "Topaz Light",
      "hex": "#f8d251",
      "rgb": [
        248,
        210,
        81
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45185",
      "brandId": "sullivans",
      "reference": "45185",
      "name": "Yellow Pale",
      "hex": "#f8d679",
      "rgb": [
        248,
        214,
        121
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45186",
      "brandId": "sullivans",
      "reference": "45186",
      "name": "Yellow Light Pale",
      "hex": "#f9e9a4",
      "rgb": [
        249,
        233,
        164
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45051",
      "brandId": "sullivans",
      "reference": "45051",
      "name": "Lemon",
      "hex": "#f9ee33",
      "rgb": [
        249,
        238,
        51
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45172",
      "brandId": "sullivans",
      "reference": "45172",
      "name": "Topaz Very Light",
      "hex": "#f9f084",
      "rgb": [
        249,
        240,
        132
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45385",
      "brandId": "sullivans",
      "reference": "45385",
      "name": "Tawny Very Light",
      "hex": "#f9f0e4",
      "rgb": [
        249,
        240,
        228
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45420",
      "brandId": "sullivans",
      "reference": "45420",
      "name": "Yellow Ultra Pale",
      "hex": "#f9f2ca",
      "rgb": [
        249,
        242,
        202
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45187",
      "brandId": "sullivans",
      "reference": "45187",
      "name": "Off White",
      "hex": "#f9f7da",
      "rgb": [
        249,
        247,
        218
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45301",
      "brandId": "sullivans",
      "reference": "45301",
      "name": "Pumpkin",
      "hex": "#fa8500",
      "rgb": [
        250,
        133,
        0
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45221",
      "brandId": "sullivans",
      "reference": "45221",
      "name": "Baby Pink Light",
      "hex": "#faf2e7",
      "rgb": [
        250,
        242,
        231
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45336",
      "brandId": "sullivans",
      "reference": "45336",
      "name": "Golden Yellow Very Light",
      "hex": "#faf5a1",
      "rgb": [
        250,
        245,
        161
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45463",
      "brandId": "sullivans",
      "reference": "45463",
      "name": "Winter White",
      "hex": "#fbfbfa",
      "rgb": [
        251,
        251,
        250
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45100",
      "brandId": "sullivans",
      "reference": "45100",
      "name": "Lemon Light",
      "hex": "#fbfd92",
      "rgb": [
        251,
        253,
        146
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45001",
      "brandId": "sullivans",
      "reference": "45001",
      "name": "White",
      "hex": "#fcfcfc",
      "rgb": [
        252,
        252,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    },
    {
      "id": "sullivans:45002",
      "brandId": "sullivans",
      "reference": "45002",
      "name": "Snow White",
      "hex": "#fcfcfc",
      "rgb": [
        252,
        252,
        252
      ],
      "provenance": "measured",
      "mappedFrom": null
    }
  ]
}
